import * as i0 from '@angular/core';
import { Injectable, Component, Input, Inject, EventEmitter, Output, Pipe, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { __awaiter } from 'tslib';
import { Subject, takeUntil, Observable } from 'rxjs';
import * as i1$2 from '@ng-bootstrap/ng-bootstrap';
import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { Color, Vector3, Matrix4, Object3D, Euler, PerspectiveCamera, CylinderBufferGeometry, BoxGeometry, MeshBasicMaterial, BackSide, NormalBlending, Mesh, EdgesGeometry, AdditiveBlending, ShaderMaterial, AnimationMixer, VectorKeyframeTrack, InterpolateSmooth, AnimationClip, LoopOnce, Group, PlaneBufferGeometry, CanvasTexture, Texture, LinearFilter } from 'three';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { DateTime } from 'luxon';
import { Auth, Storage, API, Cache } from 'aws-amplify';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import FileSaver from 'file-saver';
import levenshtein from 'js-levenshtein';
import InformationIcon from '@iconify-icons/mdi/information-outline';
import AccidentIcon from '@iconify-icons/mdi/alert';
import WordOrderIcon from '@iconify-icons/mdi/account-hard-hat';
import ReportingIcon from '@iconify-icons/mdi/file-document-outline';
import MaintenanceIcon from '@iconify-icons/mdi/tools';
import { first, debounceTime } from 'rxjs/operators';
import * as i1$3 from '@angular/platform-browser';
import { Observable as Observable$1 } from 'rxjs/internal/Observable';
import * as i3 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Md5 } from 'ts-md5/dist/md5';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import panzoom from 'panzoom';
import videojs from 'video.js';

class NgxSmarterplanCoreService {
    constructor() { }
}
NgxSmarterplanCoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NgxSmarterplanCoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class CsvExportComponent {
    constructor() {
        /** Header of the CSV, titles for each columns */
        this.headers = [];
        /** Array of each rows (array of array of string), if it's not set, then the function getRows() will be used */
        this.rowsInput = undefined;
        /** Function used to get rows if rowsInput is not set, call each time the user click on the button to generate the CSV file */
        this.getRows = undefined;
        /** Title of the file to download */
        this.title = "file";
        /** Label for the button to click */
        this.buttonLabel = "Export";
        /** Delimiter for the CSV */
        this.delimeter = ";";
    }
    onClickDownload() {
        return __awaiter(this, void 0, void 0, function* () {
            let rows = this.rowsInput;
            if (!rows) {
                rows = yield Promise.resolve(this.getRows());
            }
            const data = `data:text/csv;charset=utf-8,${this.headers.join(this.delimeter)}\n${rows
                .map((row) => 
            /** Clean each rows/cells */
            row
                .map((value) => value
                .replace(this.delimeter, " ")
                .replace("\n", " ")
                .replace("\r", " "))
                .join(this.delimeter))
                .join("\n")}`;
            /** Create a link to download the file */
            const link = document.createElement("a");
            link.setAttribute("href", encodeURI(data));
            link.setAttribute("download", `${this.title}.csv`);
            document.body.append(link);
            link.click();
            link.remove();
        });
    }
}
CsvExportComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CsvExportComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CsvExportComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: CsvExportComponent, selector: "lib-csv-export", inputs: { headers: "headers", rowsInput: "rowsInput", getRows: "getRows", title: "title", buttonLabel: "buttonLabel" }, ngImport: i0, template: "<span [style.cursor]=\"'pointer'\" (click)=\"onClickDownload()\" class=\"download-csv d-flex\">\n    <span class=\"iconify\" data-icon=\"mdi:file-download-outline\"></span>\n    {{ buttonLabel | translate}}\n</span>\n", styles: [".download-csv{color:var(--smarterplan-primary)}\n"], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CsvExportComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-csv-export', template: "<span [style.cursor]=\"'pointer'\" (click)=\"onClickDownload()\" class=\"download-csv d-flex\">\n    <span class=\"iconify\" data-icon=\"mdi:file-download-outline\"></span>\n    {{ buttonLabel | translate}}\n</span>\n", styles: [".download-csv{color:var(--smarterplan-primary)}\n"] }]
        }], propDecorators: { headers: [{
                type: Input
            }], rowsInput: [{
                type: Input
            }], getRows: [{
                type: Input
            }], title: [{
                type: Input
            }], buttonLabel: [{
                type: Input
            }] } });

var CameraMode;
(function (CameraMode) {
    CameraMode["DOLLHOUSE"] = "mode.dollhouse";
    CameraMode["FLOORPLAN"] = "mode.floorplan";
    CameraMode["INSIDE"] = "mode.inside";
    CameraMode["OUTSIDE"] = "mode.outside";
    CameraMode["TRANSITIONING"] = "mode.transitioning";
})(CameraMode || (CameraMode = {}));
var MattertagActionMode;
(function (MattertagActionMode) {
    MattertagActionMode["POSITION_TICKET"] = "positioning_ticket";
    MattertagActionMode["ADD_TICKET"] = "add_ticket";
    MattertagActionMode["ADD_OBJECT3D"] = "add_object3D";
    MattertagActionMode["POSITION_OBJECT3D"] = "positioning_object3D";
    MattertagActionMode["POSITION_EQUIPMENT"] = "positioning_equip";
    MattertagActionMode["ADD_EQUIPMENT"] = "add_equip";
    MattertagActionMode["POSITION_DATA"] = "positioning_feature";
    MattertagActionMode["ADD_DATA"] = "add_feature";
    MattertagActionMode["POSITION_DESK"] = "positioning_feature";
    MattertagActionMode["ADD_DESK"] = "add_desk";
    MattertagActionMode["POSITION_ROOM"] = "positioning_room";
    MattertagActionMode["ADD_ROOM"] = "add_room";
})(MattertagActionMode || (MattertagActionMode = {}));
var PoiType;
(function (PoiType) {
    PoiType["EQUIPMENT"] = "EQUIPMENT";
    PoiType["INFORMATION"] = "INFORMATION";
    PoiType["TICKET"] = "TICKET";
    PoiType["OBJECT3D"] = "OBJECT3D";
    PoiType["MEASURE"] = "MEASURE";
    PoiType["DATA"] = "DATA";
    PoiType["PEOPLE"] = "PEOPLE";
    PoiType["DESK"] = "DESK";
    PoiType["ROOM"] = "ROOM";
})(PoiType || (PoiType = {}));
var TicketPriority;
(function (TicketPriority) {
    TicketPriority["MINIMUM"] = "MINIMUM";
    TicketPriority["LOW"] = "LOW";
    TicketPriority["MEDIUM"] = "MEDIUM";
    TicketPriority["HIGH"] = "HIGH";
    TicketPriority["MAXIMUM"] = "MAXIMUM";
})(TicketPriority || (TicketPriority = {}));
var TagAction;
(function (TagAction) {
    TagAction["HOVER_ON"] = "hoverOn";
    TagAction["AUDIO_CLICK"] = "audioClick";
    TagAction["VIDEO_CLICK"] = "videoClick";
    TagAction["IMAGE_CLICK"] = "imageClick";
    TagAction["DOC_CLICK"] = "docClick";
    TagAction["CLOSE_MODAL"] = "closeModal";
    TagAction["NEXT_SLIDE"] = "nextSlide";
    TagAction["DETAIL_CLICK"] = "detailsClick";
    TagAction["TICKET_CLICK"] = "ticketClick";
    TagAction["YOUTUBE_CLICK"] = "youtubeClick";
})(TagAction || (TagAction = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["TO_BE_PROCESSED"] = "TO_BE_PROCESSED";
    TicketStatus["PLANNED"] = "PLANNED";
    TicketStatus["IN_PROGRESS"] = "IN_PROGRESS";
    TicketStatus["WAITING_FOR_VALIDATION"] = "WAITING_FOR_VALIDATION";
    TicketStatus["VALIDATED"] = "VALIDATED";
    TicketStatus["REJECTED"] = "REJECTED";
    TicketStatus["RESOLVED"] = "RESOLVED";
    TicketStatus["ARCHIVED"] = "ARCHIVED";
    TicketStatus["LATE"] = "LATE";
    TicketStatus["BLOCKED"] = "BLOCKED";
    TicketStatus["COMPLETED"] = "COMPLETED";
    TicketStatus["DELAYED"] = "DELAYED";
    TicketStatus["CANCELLED"] = "CANCELLED";
    TicketStatus["TO_REDO"] = "TO_REDO";
    TicketStatus["CREATED"] = "CREATED";
})(TicketStatus || (TicketStatus = {}));
var DomainType;
(function (DomainType) {
    DomainType["EQUIPMENT"] = "EQUIPMENT";
    DomainType["MISSION"] = "MISSION";
    DomainType["TICKET"] = "TICKET";
    DomainType["OBJECT3D"] = "OBJECT3D";
    DomainType["POI"] = "POI";
    DomainType["FEATURE"] = "FEATURE";
    DomainType["BOOKING"] = "BOOKING";
})(DomainType || (DomainType = {}));
var RoleStatus;
(function (RoleStatus) {
    RoleStatus["VISITOR"] = "VISITOR";
    RoleStatus["VISITOR_MUSEUM"] = "VISITOR_MUSEUM";
    RoleStatus["GUIDE_MUSEUM"] = "GUIDE_MUSEUM";
    RoleStatus["OCCUPANT"] = "OCCUPANT";
    RoleStatus["SERVICE"] = "SERVICE";
    RoleStatus["MANAGER"] = "MANAGER";
    RoleStatus["OWNER"] = "OWNER";
    RoleStatus["ADMIN"] = "ADMIN";
})(RoleStatus || (RoleStatus = {}));
var ProfileStatus;
(function (ProfileStatus) {
    ProfileStatus["WAITING_FOR_VALIDATION"] = "WAITING_FOR_VALIDATION";
    ProfileStatus["WAITING_FOR_ACTIVATION"] = "WAITING_FOR_ACTIVATION";
    ProfileStatus["ACTIVE"] = "ACTIVE";
    ProfileStatus["INACTIVE"] = "INACTIVE";
    ProfileStatus["BLOCKED"] = "BLOCKED";
})(ProfileStatus || (ProfileStatus = {}));
var LevelStatus;
(function (LevelStatus) {
    LevelStatus["MINIMUM"] = "MINIMUM";
    LevelStatus["LOW"] = "LOW";
    LevelStatus["MEDIUM"] = "MEDIUM";
    LevelStatus["HIGH"] = "HIGH";
    LevelStatus["MAXIMUM"] = "MAXIMUM";
})(LevelStatus || (LevelStatus = {}));
var PropertyType;
(function (PropertyType) {
    PropertyType["PROPERTY"] = "PROPERTY";
    PropertyType["VISIT"] = "VISIT";
    PropertyType["OCCUPANT"] = "OCCUPANT";
    PropertyType["SHARED"] = "SHARED";
})(PropertyType || (PropertyType = {}));
var SpaceStatus;
(function (SpaceStatus) {
    SpaceStatus["DPE_TO_VALIDATE"] = "DPE_TO_VALIDATE";
    SpaceStatus["DPE_VALIDATED"] = "DPE_VALIDATED";
    SpaceStatus["DPE_FETCH"] = "DPE_FETCH";
})(SpaceStatus || (SpaceStatus = {}));
var Locale;
(function (Locale) {
    Locale["FR"] = "FR";
    Locale["EN"] = "EN";
})(Locale || (Locale = {}));
var EmailStatus;
(function (EmailStatus) {
    EmailStatus["CREATION_TO_DELIVER"] = "CREATION_TO_DELIVER";
    EmailStatus["UPDATE_TO_DELIVER"] = "UPDATE_TO_DELIVER";
    EmailStatus["CANCELLATION_TO_DELIVER"] = "CANCELLATION_TO_DELIVER";
    EmailStatus["SENT"] = "SENT";
    EmailStatus["SOFT_BOUNCE"] = "SOFT_BOUNCE";
    EmailStatus["HARD_BOUNCE"] = "HARD_BOUNCE";
    EmailStatus["REJECTED"] = "REJECTED";
    EmailStatus["SATISFACTION_TO_DELIVER"] = "SATISFACTION_TO_DELIVER";
})(EmailStatus || (EmailStatus = {}));
var CaptureViewer;
(function (CaptureViewer) {
    CaptureViewer["CUPIX"] = "CUPIX";
    CaptureViewer["MATTERPORT"] = "MATTERPORT";
    CaptureViewer["SMARTERPLAN_V1"] = "SMARTERPLAN_V1";
})(CaptureViewer || (CaptureViewer = {}));
var InventoryStatus;
(function (InventoryStatus) {
    InventoryStatus["SUCCESS"] = "SUCCESS";
    InventoryStatus["ERROR"] = "ERROR";
    InventoryStatus["TO_RUN"] = "TO_RUN";
    InventoryStatus["TO_RUN_ONE_IMAGE"] = "TO_RUN_ONE_IMAGE";
    InventoryStatus["ERROR_FILE_OBJ_NOT_EXIST"] = "ERROR_FILE_OBJ_NOT_EXIST";
    InventoryStatus["ERROR_FILE_JSON_NOT_EXIST"] = "ERROR_FILE_JSON_NOT_EXIST";
    InventoryStatus["ERROR_FILE_MODEL_NOT_EXIST"] = "ERROR_FILE_MODEL_NOT_EXIST";
})(InventoryStatus || (InventoryStatus = {}));
var TypeNote;
(function (TypeNote) {
    TypeNote["CONTRACTUAL"] = "CONTRACTUAL";
    TypeNote["INFORMATION"] = "INFORMATION";
    TypeNote["TECHNICAL"] = "TECHNICAL";
    TypeNote["FINANCIAL"] = "FINANCIAL";
    TypeNote["OTHER"] = "OTHER";
    TypeNote["IMAGE"] = "IMAGE";
})(TypeNote || (TypeNote = {}));
var FeatureType;
(function (FeatureType) {
    FeatureType["DESK"] = "DESK";
    FeatureType["INDICATOR_TEMP"] = "INDICATOR_TEMP";
    FeatureType["INFORMATION"] = "INFORMATION";
    FeatureType["INDICATOR_CO2"] = "INDICATOR_CO2";
    FeatureType["PURCHASE"] = "PURCHASE";
})(FeatureType || (FeatureType = {}));
var TicketType;
(function (TicketType) {
    TicketType["REPORTING"] = "REPORTING";
    TicketType["REQUEST_FOR_INTERVENTION"] = "REQUEST_FOR_INTERVENTION";
    TicketType["REQUEST_FOR_MAINTENANCE"] = "REQUEST_FOR_MAINTENANCE";
    TicketType["WORK_ORDER"] = "WORK_ORDER";
    TicketType["INCIDENT"] = "INCIDENT";
    TicketType["INFORMATION"] = "INFORMATION";
})(TicketType || (TicketType = {}));
var EventType;
(function (EventType) {
    EventType["EQUIPMENT"] = "EQUIPMENT";
    EventType["COMMENT"] = "COMMENT";
    EventType["CONTRACTUAL_INTERVENTION"] = "CONTRACTUAL_INTERVENTION";
    EventType["NON_CONTRACTUAL_INTERVENTION"] = "NON_CONTRACTUAL_INTERVENTION";
    EventType["TICKET"] = "TICKET";
    EventType["OBJECT3D"] = "OBJECT3D";
    EventType["REPORTING"] = "REPORTING";
    EventType["REQUEST_FOR_INTERVENTION"] = "REQUEST_FOR_INTERVENTION";
    EventType["REQUEST_FOR_MAINTENANCE"] = "REQUEST_FOR_MAINTENANCE";
    EventType["WORK_ORDER"] = "WORK_ORDER";
    EventType["INCIDENT"] = "INCIDENT";
    EventType["MEASURE"] = "MEASURE";
    EventType["BOOKING"] = "BOOKING";
    EventType["BOOKING_SUBCRIPTION"] = "BOOKING_SUBCRIPTION";
})(EventType || (EventType = {}));
var EventStatus;
(function (EventStatus) {
    EventStatus["TO_BE_PROCESSED"] = "TO_BE_PROCESSED";
    EventStatus["PLANNED"] = "PLANNED";
    EventStatus["IN_PROGRESS"] = "IN_PROGRESS";
    EventStatus["WAITING_FOR_VALIDATION"] = "WAITING_FOR_VALIDATION";
    EventStatus["VALIDATED"] = "VALIDATED";
    EventStatus["REJECTED"] = "REJECTED";
    EventStatus["RESOLVED"] = "RESOLVED";
    EventStatus["ARCHIVED"] = "ARCHIVED";
    EventStatus["LATE"] = "LATE";
    EventStatus["BLOCKED"] = "BLOCKED";
    EventStatus["COMPLETED"] = "COMPLETED";
    EventStatus["DELAYED"] = "DELAYED";
    EventStatus["CANCELLED"] = "CANCELLED";
    EventStatus["TO_REDO"] = "TO_REDO";
    EventStatus["CREATED"] = "CREATED";
    EventStatus["LINKED_TO_EQUIPMENT"] = "LINKED_TO_EQUIPMENT";
    EventStatus["UNLINKED_FROM_EQUIPMENT"] = "UNLINKED_FROM_EQUIPMENT";
    EventStatus["EDITED"] = "EDITED";
    EventStatus["LINKED_TO_A_PARENT_TICKET"] = "LINKED_TO_A_PARENT_TICKET";
    EventStatus["WAITING_FOR_ACCEPTATION"] = "WAITING_FOR_ACCEPTATION";
    EventStatus["ACCEPTED"] = "ACCEPTED";
    EventStatus["REFUSED"] = "REFUSED";
    EventStatus["DOMAIN_UPDATED"] = "DOMAIN_UPDATED";
    EventStatus["DATES_UPDATED"] = "DATES_UPDATED";
    EventStatus["TICKET_CHILD_REMOVED"] = "TICKET_CHILD_REMOVED";
    EventStatus["TYPE_UPDATED"] = "TYPE_UPDATED";
    EventStatus["DATE_END_UPDATED"] = "DATE_END_UPDATED";
    EventStatus["DATE_START_UPDATED"] = "DATE_START_UPDATED";
    EventStatus["POSITION_SET"] = "POSITION_SET";
    EventStatus["POSITION_UPDATED"] = "POSITION_UPDATED";
    EventStatus["POSITION_REMOVED"] = "POSITION_REMOVED";
})(EventStatus || (EventStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["ERROR"] = "ERROR";
})(PaymentStatus || (PaymentStatus = {}));
var CommentType;
(function (CommentType) {
    CommentType["MEASURE"] = "MEASURE";
    CommentType["VIDEO"] = "VIDEO";
    CommentType["DOCUMENT"] = "DOCUMENT";
    CommentType["IMAGE"] = "IMAGE";
    CommentType["TEXT"] = "TEXT";
    CommentType["AUDIO"] = "AUDIO";
    CommentType["URL"] = "URL";
    CommentType["YOUTUBE"] = "YOUTUBE";
    CommentType["URL_SHOP"] = "URL_SHOP";
    CommentType["EMBED"] = "EMBED";
})(CommentType || (CommentType = {}));
var StatusEquipment;
(function (StatusEquipment) {
    StatusEquipment["TO_SETUP"] = "TO_SETUP";
    StatusEquipment["BROKEN"] = "BROKEN";
    StatusEquipment["UNINSTALLED"] = "UNINSTALLED";
    StatusEquipment["INCIDENT"] = "INCIDENT";
    StatusEquipment["IN_OPERATION"] = "IN_OPERATION";
    StatusEquipment["WAITING_FOR_REPAIR"] = "WAITING_FOR_REPAIR";
    StatusEquipment["DELETED"] = "DELETED";
    StatusEquipment["OUT_OF_ORDER"] = "OUT_OF_ORDER";
    StatusEquipment["TO_BE_REPLACED"] = "TO_BE_REPLACED";
})(StatusEquipment || (StatusEquipment = {}));
var ViewerInteractions;
(function (ViewerInteractions) {
    ViewerInteractions[ViewerInteractions["DEFAULT"] = 0] = "DEFAULT";
    ViewerInteractions[ViewerInteractions["ADDING"] = 1] = "ADDING";
    ViewerInteractions[ViewerInteractions["POSITIONING"] = 2] = "POSITIONING";
})(ViewerInteractions || (ViewerInteractions = {}));
class ProfileEntity {
    constructor(init) {
        Object.assign(this, init);
        this.metadata = init.metadata;
    }
    get metadata() {
        return JSON.stringify({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
        });
    }
    set metadata(m) {
        const d = JSON.parse(m);
        if (d) {
            this.firstName = d.firstName;
            this.lastName = d.lastName;
            this.email = d.email;
            this.phone = d.phone;
        }
    }
    get displayName() {
        if (this.pseudo) {
            return this.pseudo;
        }
        if (this.lastName.length > 0) {
            return `${this.firstName} ${this.lastName}`;
        }
        return this.email;
    }
}
var SpModule;
(function (SpModule) {
    SpModule["MUSEUM"] = "MUSEUM";
    SpModule["HOTEL"] = "HOTEL";
    SpModule["IMMO"] = "IMMO";
})(SpModule || (SpModule = {}));

/**
 * The base of all `SceneComponent` created with the sdk.
 * All properties of this class are always available to all components generated through the sdk.
 * These properties should all be considered reserved and should not be overwritten by the subclass.
 */
class SceneComponentPrivate {
}
class SceneComponent extends SceneComponentPrivate {
}
/**
 * The types of the Interaction events received from the registered `InteractionSelection`
 */
var ComponentInteractionType;
(function (ComponentInteractionType) {
    /** CLICK events */
    ComponentInteractionType["CLICK"] = "INTERACTION.CLICK";
    /** HOVER events */
    ComponentInteractionType["HOVER"] = "INTERACTION.HOVER";
    /** DRAG events (mousedown then move) */
    ComponentInteractionType["DRAG"] = "INTERACTION.DRAG";
    ComponentInteractionType["DRAG_BEGIN"] = "INTERACTION.DRAG_BEGIN";
    ComponentInteractionType["DRAG_END"] = "INTERACTION.DRAG_END";
    ComponentInteractionType["POINTER_MOVE"] = "INTERACTION.POINTER_MOVE";
    ComponentInteractionType["POINTER_BUTTON"] = "INTERACTION.POINTER_BUTTON";
    ComponentInteractionType["SCROLL"] = "INTERACTION.SCROLL";
    ComponentInteractionType["KEY"] = "INTERACTION.KEY";
    ComponentInteractionType["LONG_PRESS_START"] = "INTERACTION.LONG_PRESS_START";
    ComponentInteractionType["LONG_PRESS_END"] = "INTERACTION.LONG_PRESS_END";
    ComponentInteractionType["MULTI_SWIPE"] = "INTERACTION.MULTI_SWIPE";
    ComponentInteractionType["MULTI_SWIPE_END"] = "INTERACTION.MULTI_SWIPE_END";
    ComponentInteractionType["PINCH"] = "INTERACTION.PINCH";
    ComponentInteractionType["PINCH_END"] = "INTERACTION.PINCH_END";
    ComponentInteractionType["ROTATE"] = "INTERACTION.ROTATE";
    ComponentInteractionType["ROTATE_END"] = "INTERACTION.ROTATE_END";
})(ComponentInteractionType || (ComponentInteractionType = {}));
class ComponentOutputReserved {
}
class ComponentOut extends ComponentOutputReserved {
}
var PointerButton;
(function (PointerButton) {
    PointerButton[PointerButton["PRIMARY"] = 0] = "PRIMARY";
    PointerButton[PointerButton["MIDDLE"] = 1] = "MIDDLE";
    PointerButton[PointerButton["SECONDARY"] = 2] = "SECONDARY";
    PointerButton[PointerButton["BACK"] = 3] = "BACK";
    PointerButton[PointerButton["FORWARD"] = 4] = "FORWARD";
    PointerButton[PointerButton["COUNT"] = 5] = "COUNT";
})(PointerButton || (PointerButton = {}));
var PointerButtonMask;
(function (PointerButtonMask) {
    PointerButtonMask[PointerButtonMask["NONE"] = 0] = "NONE";
    PointerButtonMask[PointerButtonMask["PRIMARY"] = 1] = "PRIMARY";
    PointerButtonMask[PointerButtonMask["SECONDARY"] = 4] = "SECONDARY";
    PointerButtonMask[PointerButtonMask["MIDDLE"] = 2] = "MIDDLE";
    PointerButtonMask[PointerButtonMask["BACK"] = 8] = "BACK";
    PointerButtonMask[PointerButtonMask["FORWARD"] = 16] = "FORWARD";
    PointerButtonMask[PointerButtonMask["ALL"] = 31] = "ALL";
})(PointerButtonMask || (PointerButtonMask = {}));
var PointerDevice;
(function (PointerDevice) {
    PointerDevice["MOUSE"] = "mouse";
    PointerDevice["TOUCH"] = "touch";
    PointerDevice["PEN"] = "pen";
    PointerDevice["GAMEPAD"] = "gamepad";
})(PointerDevice || (PointerDevice = {}));
var KeyState;
(function (KeyState) {
    KeyState[KeyState["DOWN"] = 0] = "DOWN";
    KeyState[KeyState["PRESSED"] = 1] = "PRESSED";
    KeyState[KeyState["UP"] = 2] = "UP";
})(KeyState || (KeyState = {}));
var Keys;
(function (Keys) {
    Keys[Keys["ESCAPE"] = 27] = "ESCAPE";
    Keys[Keys["ZERO"] = 48] = "ZERO";
    Keys[Keys["ONE"] = 49] = "ONE";
    Keys[Keys["TWO"] = 50] = "TWO";
    Keys[Keys["THREE"] = 51] = "THREE";
    Keys[Keys["FOUR"] = 52] = "FOUR";
    Keys[Keys["FIVE"] = 53] = "FIVE";
    Keys[Keys["SIX"] = 54] = "SIX";
    Keys[Keys["SEVEN"] = 55] = "SEVEN";
    Keys[Keys["EIGHT"] = 56] = "EIGHT";
    Keys[Keys["NINE"] = 57] = "NINE";
    Keys[Keys["LEFTARROW"] = 37] = "LEFTARROW";
    Keys[Keys["UPARROW"] = 38] = "UPARROW";
    Keys[Keys["RIGHTARROW"] = 39] = "RIGHTARROW";
    Keys[Keys["DOWNARROW"] = 40] = "DOWNARROW";
    Keys[Keys["TAB"] = 9] = "TAB";
    Keys[Keys["A"] = 65] = "A";
    Keys[Keys["B"] = 66] = "B";
    Keys[Keys["C"] = 67] = "C";
    Keys[Keys["D"] = 68] = "D";
    Keys[Keys["E"] = 69] = "E";
    Keys[Keys["F"] = 70] = "F";
    Keys[Keys["G"] = 71] = "G";
    Keys[Keys["H"] = 72] = "H";
    Keys[Keys["I"] = 73] = "I";
    Keys[Keys["J"] = 74] = "J";
    Keys[Keys["K"] = 75] = "K";
    Keys[Keys["L"] = 76] = "L";
    Keys[Keys["M"] = 77] = "M";
    Keys[Keys["N"] = 78] = "N";
    Keys[Keys["O"] = 79] = "O";
    Keys[Keys["P"] = 80] = "P";
    Keys[Keys["Q"] = 81] = "Q";
    Keys[Keys["R"] = 82] = "R";
    Keys[Keys["S"] = 83] = "S";
    Keys[Keys["T"] = 84] = "T";
    Keys[Keys["U"] = 85] = "U";
    Keys[Keys["V"] = 86] = "V";
    Keys[Keys["W"] = 87] = "W";
    Keys[Keys["X"] = 88] = "X";
    Keys[Keys["Y"] = 89] = "Y";
    Keys[Keys["Z"] = 90] = "Z";
    Keys[Keys["SPACE"] = 32] = "SPACE";
    Keys[Keys["RETURN"] = 13] = "RETURN";
    Keys[Keys["DELETE"] = 46] = "DELETE";
    Keys[Keys["BACKSPACE"] = 8] = "BACKSPACE";
    Keys[Keys["SEMICOLON"] = 186] = "SEMICOLON";
    Keys[Keys["PLUSEQUALS"] = 187] = "PLUSEQUALS";
    Keys[Keys["DASHUNDERSCORE"] = 189] = "DASHUNDERSCORE";
    Keys[Keys["OPENBRACKET"] = 219] = "OPENBRACKET";
    Keys[Keys["SHIFT"] = 16] = "SHIFT";
    Keys[Keys["ALT"] = 18] = "ALT";
    Keys[Keys["CONTROL"] = 17] = "CONTROL";
})(Keys || (Keys = {}));

class SecurityCamera extends SceneComponent {
    constructor() {
        super(...arguments);
        this.root = null;
        this.pivot = null;
        this.box = null;
        this.edges = null;
        this.highlight = null;
        this.highlightUniforms = {
            color: { value: new Color() },
            projPosition: { value: new Vector3() },
            lightMatrix: { value: new Matrix4() },
        };
        this.inputs = {
            nearPlane: 0.1,
            farPlane: 4,
            horizontalFOV: 80,
            aspect: 16 / 9,
            localPosition: { x: 0, y: 0, z: 0 },
            localRotation: { x: 0, y: 0, z: 0 },
            color: 0xffffff,
            panPeriod: 20,
            panAngle: 180,
        };
        this.outputs = {};
    }
    onInit() {
        const THREE = this.context.three;
        this.root = new THREE.Object3D();
        this.pivot = new THREE.Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        this.root.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
        const euler = new THREE.Euler(this.inputs.localRotation.x * Math.PI / 180, this.inputs.localRotation.y * Math.PI / 180, this.inputs.localRotation.z * Math.PI / 180, 'YXZ');
        this.pivot.quaternion.setFromEuler(euler);
        const aspect = this.inputs.aspect;
        const DEG2RAD = Math.PI / 180;
        const RAD2DEG = 1 / DEG2RAD;
        const verticalFOV = 2 * Math.atan(1 / aspect * Math.tan(0.5 * this.inputs.horizontalFOV * DEG2RAD)) * RAD2DEG;
        this.projector = new THREE.PerspectiveCamera(verticalFOV, aspect, this.inputs.nearPlane, this.inputs.farPlane);
        // orientation of the projector is handled by the pivot
        this.pivot.add(this.projector);
        this.makeFrustumVisuals();
        this.pivot.add(this.box);
        this.pivot.add(this.edges);
        this.makeHighlight();
        // attach highighting to the mesh it represents
        // TODO (scene query): this is very brittle but is the only way to attach something to a room of the model
        this.outputs.objectRoot.parent.parent.add(this.highlight);
        // create the animation mixer to rotate the camera
        this.makeAnimation();
    }
    onTick(delta) {
        updateHighlightUniforms$1(this.projector, this.highlightUniforms);
        if (this.mixer) {
            this.mixer.update(delta / 1000);
        }
    }
    onDestroy() {
        if (this.highlight && this.highlight.parent) {
            this.highlight.parent.remove(this.highlight);
            this.highlight.material.dispose();
        }
        if (this.edges) {
            this.edges.geometry.dispose();
            this.edges.material.dispose();
        }
        if (this.box) {
            this.box.geometry.dispose();
            this.box.material.dispose();
        }
    }
    makeFrustumVisuals() {
        const THREE = this.context.three;
        if (this.box) {
            this.root.remove(this.box);
            this.box.material.dispose();
            this.box.geometry.dispose();
            this.box = null;
        }
        if (this.edges) {
            this.root.remove(this.edges);
            this.edges.material.dispose();
            this.edges.geometry.dispose();
            this.edges = null;
        }
        function edgesToCylinders(edgesGeometry, thickness) {
            const { position } = edgesGeometry.attributes;
            const { array, count } = position;
            const r = thickness / 2;
            const geoms = [];
            for (let i = 0; i < count * 3 - 1; i += 6) {
                const a = new THREE.Vector3(array[i], array[i + 1], array[i + 2]);
                const b = new THREE.Vector3(array[i + 3], array[i + 4], array[i + 5]);
                const vec = new THREE.Vector3().subVectors(b, a);
                const len = vec.length();
                const geom = new THREE.CylinderBufferGeometry(r, r, len, 8);
                geom.translate(0, len / 2, 0);
                geom.rotateX(Math.PI / 2);
                geom.lookAt(vec);
                geom.translate(a.x, a.y, a.z);
                geoms.push(geom);
            }
            // API to be updated in bundle - JSSDK-1222
            return THREE.mergeBufferGeometries(geoms);
        }
        const frustumLength = this.inputs.farPlane - this.inputs.nearPlane;
        const boxGeometry = new THREE.BoxGeometry(2, 2, frustumLength);
        const halfHAngle = this.inputs.horizontalFOV * 0.5 * Math.PI / 180;
        const nearHalfWidth = Math.tan(halfHAngle) * this.inputs.nearPlane;
        const farHalfWidth = Math.tan(halfHAngle) * this.inputs.farPlane;
        const nearHalfHeight = nearHalfWidth / this.inputs.aspect;
        const farHalfHeight = farHalfWidth / this.inputs.aspect;
        const positions = boxGeometry.getAttribute('position');
        for (let i = 0; i < positions.count; i++) {
            const vertexZ = positions.getZ(i);
            const vertexX = positions.getX(i);
            const vertexY = positions.getY(i);
            if (vertexZ > 0) {
                // back of the camera
                positions.setX(i, vertexX * nearHalfWidth);
                positions.setY(i, vertexY * nearHalfHeight);
            }
            else {
                // front of the camera
                positions.setX(i, vertexX * farHalfWidth);
                positions.setY(i, vertexY * farHalfHeight);
            }
            positions.setZ(i, vertexZ - 0.5 * frustumLength - this.inputs.nearPlane);
        }
        var boxMaterial = new THREE.MeshBasicMaterial({
            color: this.inputs.color,
            opacity: 0.05,
            transparent: true,
            side: THREE.BackSide,
            blending: THREE.NormalBlending,
            depthWrite: false,
        });
        this.box = new THREE.Mesh(boxGeometry, boxMaterial);
        const edgesGeometry = edgesToCylinders(new THREE.EdgesGeometry(boxGeometry), 0.015);
        this.edges = new THREE.Mesh(edgesGeometry, new THREE.MeshBasicMaterial({
            color: 0xffffff,
            opacity: 0.25,
            transparent: true,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
        }));
        const edgesGeometry2 = edgesToCylinders(new THREE.EdgesGeometry(boxGeometry), 0.06);
        const edges2 = new THREE.Mesh(edgesGeometry2, new THREE.MeshBasicMaterial({
            color: this.inputs.color,
            opacity: 0.05,
            transparent: true,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
        }));
        this.pivot.add(edges2);
    }
    makeHighlight() {
        const THREE = this.context.three;
        // TODO (scene query): this is very brittle and hardcoded but is the only way to get room geometries until we have a better way to query the scene graph
        const floorMesh = this.outputs.objectRoot.parent.parent.getObjectByName('FloorMesh:0');
        const roomMesh = floorMesh.children[0];
        updateHighlightUniforms$1(this.projector, this.highlightUniforms);
        this.highlightUniforms.color.value.setHex(this.inputs.color);
        const shader = new THREE.ShaderMaterial({
            polygonOffset: true,
            polygonOffsetUnits: -0.1,
            transparent: true,
            uniforms: this.highlightUniforms,
            vertexShader: vertexShader$1(),
            fragmentShader: fragmentShader$1(),
        });
        // a mesh to represent the "highlight"
        this.highlight = new THREE.Mesh(roomMesh.geometry, shader);
    }
    toggleViewFrustum() {
        this.highlight.visible = !this.highlight.visible;
        this.edges.visible = !this.edges.visible;
        this.pivot.visible = !this.pivot.visible;
    }
    makeAnimation() {
        const THREE = this.context.three;
        // preapply the initial rotation of the root so that panAngle is relative to it.
        // TODO: fix it!
        const rootRotation = this.context.root.quaternion;
        const yAxis = new THREE.Vector3(0, 1, 0);
        const frame0 = new THREE.Quaternion().setFromAxisAngle(yAxis, 0).premultiply(rootRotation);
        const frame1 = new THREE.Quaternion().setFromAxisAngle(yAxis, this.inputs.panAngle).premultiply(rootRotation);
        // a track that has delays at the start and end for 5% of the animation
        const track = new THREE.QuaternionKeyframeTrack('.quaternion', [
            0, this.inputs.panPeriod * 0.05, this.inputs.panPeriod * 0.95, this.inputs.panPeriod
        ], [
            frame0.x, frame0.y, frame0.z, frame0.w,
            frame0.x, frame0.y, frame0.z, frame0.w,
            frame1.x, frame1.y, frame1.z, frame1.w,
            frame1.x, frame1.y, frame1.z, frame1.w,
        ]);
        const clip = new THREE.AnimationClip('panning', this.inputs.panPeriod, [track]);
        // There is no api to change the rotation of the root, so we will use a private property to access the Object3D.
        // This will likely need to change in the future.
        this.mixer = new THREE.AnimationMixer(this.context.root.obj3D);
        const action = this.mixer.clipAction(clip);
        action.loop = THREE.LoopPingPong;
        action.play();
    }
}
function vertexShader$1() {
    return `
    uniform mat4 lightMatrix;

    varying vec4 vLightCoords;

    void main() {
      // create a UV region [0,1] x [0,1] to represent what the lightMatrix "sees"
      vLightCoords = lightMatrix *  modelMatrix * vec4(position, 1.0);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `;
}
function fragmentShader$1() {
    return `
    uniform vec3 color;

    varying vec4 vLightCoords;

    void main() {
      vec2 lightUV = vLightCoords.xy / vLightCoords.w;
      float inView = float(max(lightUV.x, lightUV.y) <= 1.0 && min(lightUV.x, lightUV.y) >= 0.0 && vLightCoords.z > 0.0);

      gl_FragColor = vec4(color, min(inView, 0.2));
    }
  `;
}
function updateHighlightUniforms$1(projector, uniforms) {
    projector.getWorldPosition(uniforms.projPosition.value);
    // similar to a shadow matrix, but we're using it as a "rectangular" spotlight
    // [lightBias] * [projection] * [viewMatrix]
    uniforms.lightMatrix.value.makeScale(0.5, 0.5, 0.5);
    uniforms.lightMatrix.value.setPosition(new Vector3(0.5, 0.5, 0.5));
    uniforms.lightMatrix.value.multiplyMatrices(uniforms.lightMatrix.value, projector.projectionMatrix);
    uniforms.lightMatrix.value.multiplyMatrices(uniforms.lightMatrix.value, projector.matrixWorldInverse);
}
const securityCameraType = 'mp.securityCamera';
const makeSecurityCamera = function () {
    return new SecurityCamera();
};

/**
 * This class is the extracted View Frustum Mesh from
 * SecurityCamera example
 */
class ViewFrustumMesh extends SceneComponent {
    constructor() {
        super(...arguments);
        this.root = null;
        this.pivot = null;
        this.box = null;
        this.edges = null;
        this.inputs = {
            "nearPlane": 0.1,
            "farPlane": 10,
            "horizontalFOV": 52,
            "aspect": 1.7777777777777777,
            "localPosition": {
                "x": 0,
                "y": 0.18,
                "z": -0.3
            },
            "localRotation": {
                "x": -15,
                "y": 0,
                "z": 0
            },
            "color": 65280,
            "panPeriod": 5,
            "panAngle": -45
        };
        this.highlight = null;
        this.highlightUniforms = {
            color: { value: new Color() },
            projPosition: { value: new Vector3() },
            lightMatrix: { value: new Matrix4() },
        };
        this.outputs = {};
    }
    onInit() {
        this.root = new Object3D();
        this.pivot = new Object3D();
        this.root.add(this.pivot);
        this.outputs.objectRoot = this.root;
        const euler = new Euler(this.inputs.localRotation.x * Math.PI / 180, this.inputs.localRotation.y * Math.PI / 180, this.inputs.localRotation.z * Math.PI / 180, 'YXZ');
        this.pivot.quaternion.setFromEuler(euler);
        this.makeFrustumVisuals();
        this.pivot.add(this.box);
        this.pivot.add(this.edges);
        const aspect = this.inputs.aspect;
        const DEG2RAD = Math.PI / 180;
        const RAD2DEG = 1 / DEG2RAD;
        const verticalFOV = 2 * Math.atan(1 / aspect * Math.tan(0.5 * this.inputs.horizontalFOV * DEG2RAD)) * RAD2DEG;
        this.projector = new PerspectiveCamera(verticalFOV, aspect, this.inputs.nearPlane, this.inputs.farPlane);
        this.pivot.add(this.projector);
        this.makeHighlight();
        this.context.scene.add(this.highlight);
    }
    onTickModified(delta, quaternion) {
        this.pivot.quaternion.set(quaternion.x, quaternion.y, quaternion.z, quaternion.w);
        updateHighlightUniforms(this.projector, this.highlightUniforms);
    }
    makeFrustumVisuals() {
        if (this.box) {
            this.root.remove(this.box);
            this.box.material.dispose();
            this.box.geometry.dispose();
            this.box = null;
        }
        if (this.edges) {
            this.root.remove(this.edges);
            this.edges.material.dispose();
            this.edges.geometry.dispose();
            this.edges = null;
        }
        function edgesToCylinders(edgesGeometry, thickness) {
            const { position } = edgesGeometry.attributes;
            const { array, count } = position;
            const r = thickness / 2;
            const geoms = [];
            for (let i = 0; i < count * 3 - 1; i += 6) {
                const a = new Vector3(array[i], array[i + 1], array[i + 2]);
                const b = new Vector3(array[i + 3], array[i + 4], array[i + 5]);
                const vec = new Vector3().subVectors(b, a);
                const len = vec.length();
                const geom = new CylinderBufferGeometry(r, r, len, 8);
                geom.translate(0, len / 2, 0);
                geom.rotateX(Math.PI / 2);
                geom.lookAt(vec);
                geom.translate(a.x, a.y, a.z);
                geoms.push(geom);
            }
            // API to be updated in bundle - JSSDK-1222
            return BufferGeometryUtils.mergeBufferGeometries(geoms);
        }
        const frustumLength = this.inputs.farPlane - this.inputs.nearPlane;
        const boxGeometry = new BoxGeometry(2, 2, frustumLength);
        const halfHAngle = this.inputs.horizontalFOV * 0.5 * Math.PI / 180;
        const nearHalfWidth = Math.tan(halfHAngle) * this.inputs.nearPlane;
        const farHalfWidth = Math.tan(halfHAngle) * this.inputs.farPlane;
        const nearHalfHeight = nearHalfWidth / this.inputs.aspect;
        const farHalfHeight = farHalfWidth / this.inputs.aspect;
        const positions = boxGeometry.getAttribute('position');
        for (let i = 0; i < positions.count; i++) {
            const vertexZ = positions.getZ(i);
            const vertexX = positions.getX(i);
            const vertexY = positions.getY(i);
            if (vertexZ > 0) {
                // back of the camera
                positions.setX(i, vertexX * nearHalfWidth);
                positions.setY(i, vertexY * nearHalfHeight);
            }
            else {
                // front of the camera
                positions.setX(i, vertexX * farHalfWidth);
                positions.setY(i, vertexY * farHalfHeight);
            }
            positions.setZ(i, vertexZ - 0.5 * frustumLength - this.inputs.nearPlane);
        }
        const boxMaterial = new MeshBasicMaterial({
            color: this.inputs.color,
            opacity: 0.35,
            transparent: true,
            side: BackSide,
            blending: NormalBlending,
            depthWrite: false,
        });
        this.box = new Mesh(boxGeometry, boxMaterial);
        const edgesGeometry = edgesToCylinders(new EdgesGeometry(boxGeometry), 0.015);
        this.edges = new Mesh(edgesGeometry, new MeshBasicMaterial({
            color: 0xffffff,
            opacity: 0.25,
            transparent: true,
            blending: AdditiveBlending,
            depthWrite: false,
        }));
        const edgesGeometry2 = edgesToCylinders(new EdgesGeometry(boxGeometry), 0.06);
        const edges2 = new Mesh(edgesGeometry2, new MeshBasicMaterial({
            color: this.inputs.color,
            opacity: 0.35,
            transparent: true,
            blending: AdditiveBlending,
            depthWrite: false,
        }));
        this.pivot.add(edges2);
    }
    makeHighlight() {
        let floorMesh = null;
        floorMesh = this.context.scene.getObjectByName('FloorMesh:0');
        const roomMesh = floorMesh.children[5];
        updateHighlightUniforms(this.projector, this.highlightUniforms);
        this.highlightUniforms.color.value.setHex(this.inputs.color);
        const shader = new ShaderMaterial({
            polygonOffset: true,
            polygonOffsetUnits: -0.1,
            transparent: true,
            uniforms: this.highlightUniforms,
            vertexShader: vertexShader(),
            fragmentShader: fragmentShader(),
        });
        // a mesh to represent the "highlight"
        this.highlight = new Mesh(roomMesh.geometry, shader);
    }
    onDestroy() {
        if (this.highlight && this.highlight.parent) {
            this.highlight.parent.remove(this.highlight);
            this.highlight.material.dispose();
        }
        if (this.edges) {
            this.edges.geometry.dispose();
            this.edges.material.dispose();
        }
        if (this.box) {
            this.box.geometry.dispose();
            this.box.material.dispose();
        }
    }
}
function vertexShader() {
    return `
    uniform mat4 lightMatrix;

    varying vec4 vLightCoords;

    void main() {
      // create a UV region [0,1] x [0,1] to represent what the lightMatrix "sees"
      vLightCoords = lightMatrix *  modelMatrix * vec4(position, 1.0);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `;
}
function fragmentShader() {
    return `
    uniform vec3 color;

    varying vec4 vLightCoords;

    void main() {
      vec2 lightUV = vLightCoords.xy / vLightCoords.w;
      float inView = float(max(lightUV.x, lightUV.y) <= 1.0 && min(lightUV.x, lightUV.y) >= 0.0 && vLightCoords.z > 0.0);

      gl_FragColor = vec4(color, min(inView, 0.2));
    }
  `;
}
function updateHighlightUniforms(projector, uniforms) {
    projector.getWorldPosition(uniforms.projPosition.value);
    // similar to a shadow matrix, but we're using it as a "rectangular" spotlight
    // [lightBias] * [projection] * [viewMatrix]
    uniforms.lightMatrix.value.makeScale(0.5, 0.5, 0.5);
    uniforms.lightMatrix.value.setPosition(new Vector3(0.5, 0.5, 0.5));
    uniforms.lightMatrix.value.multiplyMatrices(uniforms.lightMatrix.value, projector.projectionMatrix);
    uniforms.lightMatrix.value.multiplyMatrices(uniforms.lightMatrix.value, projector.matrixWorldInverse);
}
const ViewFrustumMeshType = 'mp.ViewFrustumMesh';
const makeViewFrustumMesh = function () {
    return new ViewFrustumMesh();
};

class ProfileService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    createProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateProfile(profile);
        });
    }
    getProfile(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetProfile(id);
        });
    }
    listCurrentProfiles() {
        return __awaiter(this, void 0, void 0, function* () {
            const profiles = (yield this.API.__proto__.ListProfiles()).items;
            return profiles.filter((p) => !p.deletedAt);
        });
    }
    updateProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            if (profile.id === undefined) {
                console.log(`an ID is required for update Profile`);
                return null;
            }
            return this.API.__proto__.UpdateProfile(profile);
        });
    }
    deleteProfile(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteProfile({ id: id });
        });
    }
    getProfileFromAWSID(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ProfilesByUserID(userID).then((results) => {
                if (results.items.length === 0) {
                    return null;
                }
                return results.items[0];
            });
        });
    }
    getUsersForMail(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ListProfiles({ metadata: { contains: mail } }).then((results) => {
                return results.items.filter((profile) => !profile.deletedAt);
            });
        });
    }
    getProfilesForStatus(status) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.API.__proto__.ListProfiles({
                status: { eq: status },
            })).items;
        });
    }
}
ProfileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ProfileService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
ProfileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ProfileService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ProfileService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class MissionService {
    constructor(
    // private affectationService: AffectationService,
    apiInjected) {
        this.currentMissionsUpdated = new Subject();
        this.API = apiInjected;
    }
    getMissionsFromUserID(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.MissionsByUser(userID).then((missions) => {
                return missions.items.filter((mis) => !mis.deletedAt);
            });
        });
    }
    getMissionsByOrderedOrganisation(orderedOrgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.MissionsByOrderedOrganisation(orderedOrgID).then((response) => response.items);
        });
    }
    getMissionsByOrganisation(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.MissionsByOrganisation(orgID).then((response) => response.items);
        });
    }
    create(mission) {
        return __awaiter(this, void 0, void 0, function* () {
            const updMission = yield this.API.__proto__.CreateMission(mission);
            console.log("Mission created", updMission);
            yield this.checkIfCurrentUserMissionChanged(updMission);
            return updMission;
        });
    }
    update(mission) {
        return __awaiter(this, void 0, void 0, function* () {
            const updMission = yield this.API.__proto__.UpdateMission(mission);
            console.log("Mission updated", updMission);
            yield this.checkIfCurrentUserMissionChanged(updMission);
            return updMission;
        });
    }
    assertRoleForUserInOrg(user, org, role) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getMissionsFromUserID(user.id).then((missions) => {
                if (missions) {
                    const misOrg = missions.filter((mis) => {
                        return mis.organisationID === org.id && mis.role === role;
                    });
                    return misOrg.length > 0;
                }
                return false;
            });
        });
    }
    getMissionsByOrderedOrganisationBySpace(ordOrgID, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.MissionsByOrderedOrganisationBySpace(ordOrgID, {
                eq: spaceID,
            }).then((mis) => mis.items);
        });
    }
    softDeleteMission(missionID) {
        return __awaiter(this, void 0, void 0, function* () {
            // const hardDelete = await this.canHardDeteleMission(mission.id);
            // if (hardDelete) {
            //     return this.hardDeleteMission(mission.id);
            // }
            console.log("Soft Deleting mission");
            const missionUpd = yield this.update({
                id: missionID,
                deletedAt: Date.now(),
            });
            yield this.checkIfCurrentUserMissionChanged(missionUpd);
            return missionUpd;
        });
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            const mis = yield this.API.__proto__.ListMissions();
            return mis.items.filter((m) => !m.deletedAt);
        });
    }
    // async canHardDeteleMission(missionID: string): Promise<boolean> {
    //     const events = (
    //         await this.API.ListEvents({ ownerID: { eq: missionID } })
    //     ).items;
    //     if (events.length > 0) {
    //         return false;
    //     }
    //     const comments = (
    //         await this.API.ListComments({ ownerID: { eq: missionID } })
    //     ).items;
    //     if (comments.length > 0) {
    //         return false;
    //     }
    //     const affectations =
    //         await this.affectationService.getAffectationsFromMissionID(
    //             missionID,
    //         );
    //     if (affectations.length > 0) {
    //         return false;
    //     }
    //     return true;
    // }
    hardDeleteMission(missionID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteMission({ id: missionID });
        });
    }
    getActivatedMissions(missions) {
        const activated = [];
        missions.map((mission) => __awaiter(this, void 0, void 0, function* () {
            const isActivated = mission.groups && mission.groups.includes(ProfileStatus.ACTIVE);
            if (isActivated) {
                activated.push(mission);
            }
        }));
        return activated;
    }
    getMissionsForZone(zoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.API.__proto__.MissionsByZone(zoneID)).items.filter((mis) => !mis.deletedAt);
        });
    }
    getMissionsForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.MissionsBySpace(spaceID).then((missions) => missions.items);
        });
    }
    activateMission(mis) {
        if (mis &&
            (!mis.groups || !mis.groups.includes(ProfileStatus.ACTIVE))) {
            const groups = mis.groups ? mis.groups : [];
            groups.push(ProfileStatus.ACTIVE);
            this.update({ id: mis.id, groups });
        }
    }
    getMissionsByTemplate(templateID) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.API.__proto__.MissionsByTemplate(templateID)).items.filter((mis) => !mis.deletedAt);
        });
    }
    getMission(missionID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetMission(missionID);
        });
    }
    getMissionsByZoneByRole(zoneID, role) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.API.__proto__.MissionsByZoneByRole(zoneID, { eq: role }, null, { deletedAt: { attributeExists: false } }, 200)).items;
        });
    }
    checkIfCurrentUserMissionChanged(changedMission) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentUserID === changedMission.userID) {
                this.currentMissionsUpdated.next(true);
            }
        });
    }
    instantMissionsOfCurrent(currentUserID) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentUserID = currentUserID;
            let missions = yield this.getMissionsFromUserID(currentUserID);
            /** Filter to keep only available missions */
            missions = missions.filter((mission) => {
                const hasExpired = dateHasExpired(mission.endDateTime);
                /** Update this.lastExpiredMission */
                if (hasExpired) {
                    const lastExpiredDate = this.lastExpiredMission
                        ? new Date(this.lastExpiredMission.endDateTime)
                        : null;
                    const dateExpired = new Date(mission.endDateTime);
                    if (!lastExpiredDate || dateExpired > lastExpiredDate) {
                        this.lastExpiredMission = mission;
                    }
                }
                return !hasExpired;
            });
            if (missions.some((mis) => mis.role === RoleStatus.VISITOR_MUSEUM) && missions.length > 0) {
                // workflow for VISITOR_MUSEUM
                return missions;
            }
            /** Keep only started missions */
            let nextMissionDate = null;
            missions = missions.filter((mission) => {
                const started = mission.startDateTime
                    ? dateHasExpired(mission.startDateTime)
                    : true;
                /** Update next mission to start */
                if (!started) {
                    const missionDate = new Date(mission.startDateTime);
                    if (!nextMissionDate || missionDate < nextMissionDate) {
                        this.nextMissionToStart = mission;
                        nextMissionDate = missionDate;
                    }
                }
                return started;
            });
            return missions.length > 0 ? missions : null;
        });
    }
    /**
     * Filters the missions that assisted to live of the visit (by comparing the realStartTime of VisitTemplate and connectedAt time)
     * @param template VisitTemplate
     * @param missions Mission[] missions for this visit
     * @returns Mission[] filtered missions
     */
    filterMissionsAssitedToLiveForTemplate(template, missions) {
        const visitStartTimestamp = template.realStartedAt;
        return missions.filter((mis) => {
            if (!mis.connectedToLiveAt) {
                return false;
            }
            if (mis.connectedToLiveAt.length === 0) {
                return false;
            }
            const lastConnectedAt = mis.connectedToLiveAt[mis.connectedToLiveAt.length - 1];
            const lastConnectedAtTimestamp = DateTime.fromISO(lastConnectedAt).toMillis();
            return lastConnectedAtTimestamp > visitStartTimestamp;
        });
    }
}
MissionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MissionService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
MissionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MissionService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MissionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class PropertyService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    createProperty(property) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateProperty(property);
        });
    }
    deleteProperty(propertyID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteProperty({ id: propertyID });
        });
    }
    getPropertiesForOrganisation(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.PropertiesByOrganisation(orgID).then((props) => props.items);
        });
    }
    listProperties() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.API.__proto__.ListProperties().then((props) => props.items);
            }
            catch (_a) {
                return this.API.__proto__.ListPropertys().then((props) => props.items);
            }
        });
    }
    listPropertiesForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return this.API.__proto__.ListProperties({ spaceID: { eq: spaceID } }).then((props) => props.items);
            }
            catch (_a) {
                return this.API.__proto__.ListPropertys({ spaceID: { eq: spaceID } }).then((props) => props.items);
            }
        });
    }
}
PropertyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertyService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
PropertyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertyService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PropertyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

/**
 * UserService handles user's lifecycle, from creation to deletion
 */
class BaseUserService {
    constructor(profileService, missionService, propertyService, router, location, ngZone, translate, spModuleInjected) {
        this.profileService = profileService;
        this.missionService = missionService;
        this.propertyService = propertyService;
        this.router = router;
        this.location = location;
        this.ngZone = ngZone;
        this.translate = translate;
        this.isChanged = new Subject();
        this.updating = false;
        this.managers = [
            RoleStatus.ADMIN,
            RoleStatus.MANAGER,
            RoleStatus.OWNER,
            RoleStatus.GUIDE_MUSEUM,
        ];
        this.cu = null;
        // this.checkConnectedAWSUser();
        this.missionService.currentMissionsUpdated.subscribe((data) => __awaiter(this, void 0, void 0, function* () {
            this.currentMissions =
                yield this.missionService.instantMissionsOfCurrent(this.cu.id);
            this.isChanged.next(true);
        }));
        this.spModule = spModuleInjected;
    }
    /**
     * Checks if AWS user is connected and assigng it to current user (this.cu)
    **/
    checkConnectedAWSUser() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cu) {
                // console.log("check AWS user");
                let cau = null;
                let user = null;
                try {
                    if (!this.updating) {
                        cau = yield Auth.currentAuthenticatedUser();
                        // console.log("connected", cau);
                        user = yield this.current(cau);
                        // console.log("current of userService", user);
                    }
                }
                catch (_a) { }
                if (!user && !this.updating) {
                    // console.log("no user in check connected aws user");
                    this.router.navigate(["auth"]);
                }
            }
        });
    }
    /**
     * createUser spawns a new User, along with:
     * - a proper AWSCognito signup
     * - a Profile entry holding the AWSCognito ID
     * - a Mission entry holding the Organisation ID
     *
     * @see 174
     * @see https://docs.amplify.aws/lib/auth/emailpassword/q/platform/js#sign-up
     * @todo wonder if we can mash together Profile, Mission and User entries
     * @param u User to be created
     */
    createUserAWSandProfile(u, prevalidated = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const attributes = {
                email: u.email.trim(),
                given_name: u.firstName,
                family_name: u.lastName,
                zoneinfo: "fr",
                locale: "fr",
                "custom:prevalidated": "false",
            };
            if (prevalidated) {
                attributes["custom:prevalidated"] = "true";
            }
            // AWSCognito
            const password = u.password ? u.password : "temporaryp";
            let error;
            try {
                const { userSub } = yield Auth.signUp({
                    username: u.email,
                    password,
                    attributes,
                    clientMetadata: {
                        phone: u.phone,
                    },
                });
                if (userSub) {
                    return this.createProfile(userSub, u);
                }
            }
            catch (error_) {
                switch (error_.code) {
                    case "InvalidPasswordException":
                        error = "auth.error.wrong_password";
                        break;
                    case "UserNotConfirmedException":
                        error = "auth.error.user_not_confirmed";
                        break;
                    case "InvalidParameterException":
                        error = "auth.error.invalid_parameter";
                        break;
                    default:
                        error = error_.message;
                }
                console.log(`AWS Sign UP error : ${error}`);
            }
            return Promise.reject(error);
        });
    }
    /**
     * - Creates AWS user in Cognito for Hotel User Pool Schema (only email is required)
     * - Creates Profile in DynamoDB
     *
     * @param u User to be created
     */
    createHotelUserAWSandProfile(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const attributes = {
                email: user.email.trim()
            };
            // AWSCognito
            const password = "temporaryp";
            let error;
            try {
                const { userSub } = yield Auth.signUp({
                    username: user.email.trim(),
                    password,
                    attributes,
                });
                if (userSub) {
                    return this.createProfile(userSub, user);
                }
            }
            catch (error_) {
                switch (error_.code) {
                    case "InvalidPasswordException":
                        error = "auth.error.wrong_password";
                        break;
                    case "UserNotConfirmedException":
                        error = "auth.error.user_not_confirmed";
                        break;
                    case "InvalidParameterException":
                        error = "auth.error.invalid_parameter";
                        break;
                    default:
                        error = error_.message;
                }
                console.log(`AWS Sign UP error : ${error}`);
            }
            return Promise.reject(error);
        });
    }
    createProfile(awsUserID, u) {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = yield this.profileService.createProfile({
                userID: awsUserID,
                metadata: JSON.stringify({
                    email: u.email,
                    phone: u.phone,
                    lastName: u.lastName,
                    firstName: u.firstName,
                }),
                status: ProfileStatus.WAITING_FOR_ACTIVATION,
            });
            return profile;
        });
    }
    currentOrganisation(spaceID = null) {
        if (this.cu) {
            if (!spaceID) {
                return this.currentMissions[0].organisation;
            }
            return this.currentMission(spaceID).organisation;
        }
        return null;
    }
    current(user, fastConnect = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.cu && !this.updating) {
                this.updating = true;
                this.cu = yield this.userFromAWSID(user.username);
                if (!this.cu && user.attributes.email) {
                    console.log(`No profile for userID 🔪 ${user.attributes.email}`);
                    // There's no profiles, profiles.items.length === 0
                    // It's maybe the 🤮 case where the profile has been saved with an email
                    // instead of an hashed id
                    // If found, we need to replace the id in both the Profile
                    const emailProfile = yield this.userFromAWSID(user.attributes.email);
                    if (emailProfile) {
                        console.log(`👏 doing the spacehip reversal email on ${user.attributes.email}`);
                        this.cu = yield this.userFromAWSID(user.username);
                    }
                }
                if (!this.cu) {
                    this.updating = false;
                    yield Auth.signOut();
                    return null;
                }
                const missions = yield this.missionService.instantMissionsOfCurrent(this.cu.id);
                this.currentMissions = missions;
                let okToLogin = true;
                if (!fastConnect && !this.hasManagerRoleInAnyMission()) {
                    // check access token if not Fast connect (fast connect is for the guest connection via link(/redirect?user=))
                    // checks visitors(museum or not), occupants, service
                    okToLogin = yield this.checkAccessToken(user.signInUserSession.accessToken.jwtToken);
                }
                if (!okToLogin) {
                    this.cu = null;
                    this.currentMissions = [];
                    this.updating = false;
                    yield Auth.signOut();
                    return null;
                }
                yield this.profileService.updateProfile({
                    id: this.cu.id,
                    lastConnectedAt: Date.now(),
                });
                if (!missions && this.location.path() !== "/no-mission") {
                    this.ngZone.run(() => {
                        this.router.navigate(["/no-mission"]);
                    });
                }
                // console.log("user is changed emitting");
                this.isChanged.next(true);
                this.updating = false;
            }
            return this.cu;
        });
    }
    userFromAWSID(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = yield this.profileService.getProfileFromAWSID(userId);
            if (profile) {
                return new ProfileEntity(profile);
            }
            return null;
        });
    }
    userFromUserID(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = yield this.profileService.getProfile(userID);
            return new ProfileEntity(profile);
        });
    }
    currentMission(spaceID) {
        const mission = this.getMissionForSpace(spaceID);
        return mission;
    }
    isManager(spaceID) {
        const mission = this.getMissionForSpace(spaceID);
        if (mission) {
            return this.managers.includes(mission.role);
        }
        return false;
    }
    isService(spaceID) {
        const mission = this.getMissionForSpace(spaceID);
        if (mission) {
            return mission.role === RoleStatus.SERVICE;
        }
        return false;
    }
    isAdmin(spaceID) {
        const mission = this.getMissionForSpace(spaceID);
        if (mission) {
            return mission.role === RoleStatus.ADMIN;
        }
        return false;
    }
    isSmarterPlan() {
        if (!this.currentMissions) {
            return false;
        }
        const spMissions = this.currentMissions.filter((m) => m.organisationID === "6e28201f-4679-4c29-9d2d-8a325f57cee9" &&
            this.managers.includes(m.role)); // ID of SmarterPlan
        return spMissions.length > 0;
    }
    isSPAdmin() {
        if (!this.currentMissions) {
            return false;
        }
        const spMissions = this.currentMissions.filter((m) => m.organisationID === "6e28201f-4679-4c29-9d2d-8a325f57cee9" &&
            m.role === RoleStatus.ADMIN); // ID of SmarterPlan
        return spMissions.length > 0;
    }
    getMissionForSpace(spaceID) {
        if (!this.currentMissions) {
            return null;
        }
        return this.currentMissions.find((m) => m.spaceID === spaceID);
    }
    hasManagerRoleInAnyMission() {
        if (!this.currentMissions) {
            return false;
        }
        return this.currentMissions.some((mis) => this.managers.includes(mis.role));
    }
    hasServiceRoleInAnyMission() {
        if (!this.currentMissions) {
            return false;
        }
        return this.currentMissions.some((mis) => mis.role === RoleStatus.SERVICE);
    }
    hasAdminRoleInAnyMission() {
        if (!this.currentMissions) {
            return false;
        }
        return this.currentMissions.some((mis) => mis.role === RoleStatus.ADMIN);
    }
    createOrUpdateMissionForOrgWithProperty(missionInput, orgID, create = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const mission = yield (create
                ? this.missionService.create(missionInput)
                : this.missionService.update(missionInput));
            if (this.managers.includes(mission.role) && mission.spaceID) {
                const properties = yield this.propertyService.getPropertiesForOrganisation(orgID);
                const propertySpaceIDs = properties.map((property_) => property_.spaceID);
                if (propertySpaceIDs.includes(mission.spaceID)) {
                    return mission;
                }
                // we delegate the rights of the space
                yield this.propertyService.createProperty({
                    spaceID: mission.spaceID,
                    organisationID: orgID,
                    type: PropertyType.SHARED,
                });
            }
            return mission;
        });
    }
    softDeleteUser(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            const missions = yield this.missionService.getMissionsFromUserID(userID);
            if (missions.length === 0) {
                yield this.profileService.updateProfile({ id: userID, deletedAt: Date.now() });
                console.log("Profile soft deleted");
            }
        });
    }
    /**
     * Checks if the Profile (by id) can be removed completely from the DB (no missions in the DB)
     * @param profileID
     * @returns boolean
     */
    canHardDeleteUser(profileID) {
        return __awaiter(this, void 0, void 0, function* () {
            const missions = (yield this.missionService.getMissionsFromUserID(profileID));
            return missions.length === 0;
        });
    }
    hardDeleteUser(userID) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleted = yield this.profileService.deleteProfile(userID);
            console.log("Profile hard deleted");
            return deleted;
        });
    }
    getManagerMissions() {
        if (!this.currentMissions) {
            return [];
        }
        return this.currentMissions.filter((mis) => this.managers.includes(mis.role));
    }
    getAvalableLevelsForCurrentUser() {
        if (!this.currentMissions) {
            return [LevelStatus.MINIMUM];
        }
        const levels = enumToArray(LevelStatus);
        const highestLevel = getHighestLevelForMissions(this.currentMissions);
        return levels.filter((level) => getLevelsBelow(highestLevel).includes(level));
    }
    getAvailableRolesForCurrentUser() {
        if (!this.currentMissions) {
            return [RoleStatus.VISITOR];
        }
        const roles = enumToArray(RoleStatus);
        const highestRole = getHighestRoleForMissions(this.currentMissions);
        return roles.filter((role) => getRolesBelowForManager(highestRole).includes(role));
    }
    /** Test if the user have the role given in parameter : "roleStatus" */
    isRole(roleStatus) {
        if (!this.currentMissions) {
            return false;
        }
        return this.currentMissions.some((m) => m.role === roleStatus);
    }
    isGuide(spaceID = null) {
        if (spaceID) {
            const mission = this.getMissionForSpace(spaceID);
            if (mission) {
                return mission.role === RoleStatus.GUIDE_MUSEUM;
            }
        }
        return this.isRole(RoleStatus.GUIDE_MUSEUM);
    }
    isMuseumVisitor(spaceID = null) {
        if (spaceID) {
            const mission = this.getMissionForSpace(spaceID);
            if (mission) {
                return mission.role === RoleStatus.VISITOR_MUSEUM;
            }
        }
        return this.isRole(RoleStatus.VISITOR_MUSEUM);
    }
    isOccupant() {
        return this.isRole(RoleStatus.OCCUPANT);
    }
    isVisitor(spaceID = null) {
        if (spaceID) {
            const mission = this.getMissionForSpace(spaceID);
            if (mission) {
                return mission.role === RoleStatus.VISITOR;
            }
        }
        return this.isRole(RoleStatus.VISITOR);
    }
    isMuseumUser(spaceID = null) {
        return this.isGuide(spaceID) || this.isMuseumVisitor(spaceID);
    }
    hasOnlyMuseumRole() {
        if (this.currentMissions) {
            return this.currentMissions.every((m) => m.role === RoleStatus.GUIDE_MUSEUM ||
                m.role === RoleStatus.VISITOR_MUSEUM);
        }
        return false;
    }
    profileForMail(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            const usersWithMail = yield this.profileService.getUsersForMail(mail);
            return usersWithMail.length > 0 ? usersWithMail[0] : null;
        });
    }
    currentOrderedOrgList() {
        if (!this.currentMissions) {
            return [];
        }
        const orderedOrgList = this.currentMissions.map((mis) => mis.orderedOrganisation);
        return filterUniqueArrayByID(orderedOrgList);
    }
    userHasAccessToAllZonesInSpace(spaceID) {
        const missionsForSpace = this.currentMissions.filter((mis) => mis.spaceID === spaceID);
        return missionsForSpace.some((mission) => !mission.zoneID || (mission.zone && !mission.zone.parentID));
    }
    logoutCurrentAndSignOutAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.profileService.updateProfile({
                id: this.cu.id,
                token: null,
            });
            this.cu = null;
            this.currentMissions = null;
            this.isChanged.next(false);
            yield Auth.signOut();
        });
    }
    logoutCurrentWihtoutAuth() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.profileService.updateProfile({
                id: this.cu.id,
                token: null,
            });
            this.cu = null;
            this.currentMissions = null;
            this.isChanged.next(false);
        });
    }
    checkAccessToken(jwtToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const now = DateTime.local();
            if (this.cu.token && this.cu.tokenExpiredAt > now.toMillis()) {
                // check token
                if (this.cu.token === jwtToken) {
                    // console.log("same aws token");
                    return true;
                }
                alert(this.translate.instant("auth.error.activeToken"));
                return false;
            }
            yield this.profileService.updateProfile({
                id: this.cu.id,
                tokenExpiredAt: now.plus({ minutes: 5 }).toMillis(),
                token: jwtToken,
                status: ProfileStatus.ACTIVE,
            });
            return true;
        });
    }
    clearUserToken(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.profileService.updateProfile({
                id: id,
                token: null,
            });
        });
    }
    updateCurrentUser(profile) {
        this.cu = new ProfileEntity(profile);
        this.isChanged.next(true);
    }
    getSpModule() {
        return this.spModule;
    }
}
BaseUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseUserService, deps: [{ token: ProfileService }, { token: MissionService }, { token: PropertyService }, { token: i1$1.Router }, { token: i5.Location }, { token: i0.NgZone }, { token: i1.TranslateService }, { token: 'SPModule' }], target: i0.ɵɵFactoryTarget.Injectable });
BaseUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseUserService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: ProfileService }, { type: MissionService }, { type: PropertyService }, { type: i1$1.Router }, { type: i5.Location }, { type: i0.NgZone }, { type: i1.TranslateService }, { type: SpModule, decorators: [{
                        type: Inject,
                        args: ['SPModule']
                    }] }];
    } });

/**
 * Atomic zone change service to break cyclic dependencies issue
 */
class ZoneChangeService {
    constructor() {
        this.zoneChange = new Subject();
        this.zonesForUserChange = new Subject();
        this.floorHasChanged = new EventEmitter();
        this.zoneChange.subscribe((zone) => {
            // console.log(`new zone ${JSON.stringify(zone)}`);
            this.currentZone = zone;
        });
        this.zonesForUserChange.subscribe((zones) => {
            // console.log(`new zones ${JSON.stringify(zones)}`);
            this.currentZones = zones;
        });
    }
}
ZoneChangeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ZoneChangeService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ZoneChangeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ZoneChangeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ZoneChangeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class PoiService {
    constructor(apiInjected, awsKinesisAnalyticsInjected, userService, zoneChangeService // inject ZoneChangeService instead of NavigatorService to fix circular dependancy
    ) {
        this.userService = userService;
        this.zoneChangeService = zoneChangeService;
        this.selectedFloor = null;
        this.destroy$ = new Subject();
        this.API = apiInjected;
        this.awsKinesisAnalytics = awsKinesisAnalyticsInjected;
        this.zoneChangeService.zoneChange.subscribe((zone) => {
            if (!zone) {
                return;
            }
            if (zone.spaceID) {
                this.currentSpaceID = zone.spaceID;
            }
            if (!this.currentSpaceID) {
                this.zoneIDFilter = null;
            }
            else if (zone.id !== this.zoneIDFilter) {
                this.zoneIDFilter = zone.id;
            }
        });
        this.zoneChangeService.floorHasChanged.subscribe((floor) => {
            if (floor) {
                this.selectedFloor = floor;
            }
        });
    }
    getPoiByElementId(elementId) {
        return __awaiter(this, void 0, void 0, function* () {
            const pois = yield this.API.__proto__.PoisByElement(elementId);
            if (pois && pois.items.length > 0) {
                return pois.items[0];
            }
            return null;
        });
    }
    getPoisByType(type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.PoisByType(type).then((pois) => pois.items);
        });
    }
    createPOIForSpaceID(poi) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            removeNullKeysFromObject(poi);
            if (!!this.awsKinesisAnalytics && !!this.awsKinesisAnalytics.record && this.awsKinesisAnalytics.record()) {
                this.awsKinesisAnalytics.getInstance().record(
                // @ts-ignore
                {
                    data: {
                        eventType: 'Object Creation',
                        objectType: 'poi',
                        poi: poi,
                        user: this.userService.cu,
                        timestamp: new Date(),
                        floorId: (_a = this.selectedFloor) === null || _a === void 0 ? void 0 : _a.id,
                        locationId: this.currentSpaceID,
                        zoneId: this.zoneIDFilter,
                    },
                    streamName: 'smarterplanKinesis-analytics',
                    // partitionKey: "",
                }, 'AWSKinesis');
            }
            return this.API.__proto__.CreatePOI(poi);
        });
    }
    poiIsVirtual(poi) {
        const { coordinate } = poi;
        return !coordinate;
    }
    updatePoi(poi) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdatePOI(poi);
        });
    }
    deletePoi(poiID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeletePOI({ id: poiID });
        });
    }
    getPoisByMatterportSweepByType(sweep, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .ListPOIs({ matterportSweepID: { eq: sweep } }, 300)
                .then((response) => response.items.filter((poi) => poi.type === type));
        });
    }
    unsubscribe() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
PoiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PoiService, deps: [{ token: 'currentAPIService' }, { token: 'currentAwsKinesisAnalyticsService' }, { token: BaseUserService }, { token: ZoneChangeService }], target: i0.ɵɵFactoryTarget.Injectable });
PoiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PoiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PoiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAwsKinesisAnalyticsService']
                    }] }, { type: BaseUserService }, { type: ZoneChangeService }];
    } });

/* eslint-disable unicorn/filename-case */
class MattertagData {
    constructor(type) {
        this.type = PoiType.TICKET;
        this.position = { x: 0, y: 0, z: 0 };
        this.normal = { x: 0, y: 1, z: 0 };
        this.customIconIndex = 0;
        this.setType(type);
    }
    /*-----------------------------------------------------------------------------
        Setters
    ------------------------------------------------------------------------------*/
    setType(type) {
        this.type = type;
    }
    setObject(object, tagType) {
        this.object = object;
        this.setElementID(object.id);
        this.setType(tagType);
    }
    setElementID(ticketID) {
        this.elementID = ticketID;
    }
    setPosition(position) {
        this.position = position;
    }
    setNormal(normal) {
        this.normal = normal;
    }
    setMediaSource(source) {
        this.mediaSrc = source;
    }
    setSweepID(sweepID) {
        this.sweepID = sweepID;
    }
    setRotation(rotation) {
        this.rotation = rotation;
    }
    setPoi(poi) {
        this.poi = poi;
    }
    /*-----------------------------------------------------------------------------
        Getters
    ------------------------------------------------------------------------------*/
    // MattertagData
    getData() {
        let label = "New Tag";
        switch (this.type) {
            case PoiType.TICKET:
                label = this.object ? "" : "New Tag"; // if the object exists we inject title in html
                break;
            case PoiType.EQUIPMENT:
                label = this.object ? "" : "New Tag";
                break;
            case PoiType.MEASURE:
                label = this.object ? "" : "New Tag";
                break;
            case PoiType.DATA:
                label = this.object ? "" : "New Tag";
                break;
            case PoiType.DESK:
                label = this.object ? "" : "New Tag";
                break;
            case PoiType.OBJECT3D:
                label = this.object ? "" : "Click on blinking icon to load a 3D object here";
                break;
            case PoiType.ROOM:
                label = "";
                break;
            default:
                label = "New Tag";
                break;
        }
        const data = {
            label,
            description: "",
            anchorPosition: {
                x: this.position.x * 1,
                y: this.position.y * 1,
                z: this.position.z * 1,
            },
            stemVector: {
                x: this.normal.x * 0.3,
                y: this.normal.y * 0.3,
                z: this.normal.z * 0.3,
            },
            color: {
                // blue disc
                r: 0,
                g: 0,
                b: 1,
            },
            media: {
                type: "mattertag.media.none",
                src: ""
            },
        };
        return data;
    }
    getType() {
        return this.type;
    }
    getNormal() {
        return this.normal;
    }
    getCallbackActionMode() {
        switch (this.type) {
            case PoiType.TICKET:
                return this.object ? MattertagActionMode.POSITION_TICKET : MattertagActionMode.ADD_TICKET;
            case PoiType.OBJECT3D:
                return MattertagActionMode.POSITION_OBJECT3D;
            // return this.object ? MattertagActionMode.POSITION_OBJECT3D : MattertagActionMode.ADD_OBJECT3D;
            case PoiType.EQUIPMENT:
                return this.object ? MattertagActionMode.POSITION_EQUIPMENT : MattertagActionMode.ADD_EQUIPMENT;
            case PoiType.DATA:
                return this.object ? MattertagActionMode.POSITION_DATA : MattertagActionMode.ADD_DATA;
            case PoiType.DESK:
                return this.object ? MattertagActionMode.POSITION_DATA : MattertagActionMode.ADD_DESK;
            case PoiType.ROOM:
                return this.object ? MattertagActionMode.POSITION_ROOM : MattertagActionMode.ADD_ROOM;
            default:
                return MattertagActionMode.ADD_TICKET;
        }
    }
    getIcon() {
        switch (this.type) {
            case PoiType.TICKET:
                return "icon_ticket.png";
            case PoiType.EQUIPMENT:
                return "icon_equipment.png";
            case PoiType.OBJECT3D:
                return "icon_object3d.png";
        }
        return "";
    }
    getCoordinateString() {
        return JSON.stringify({
            x: this.position.x,
            y: this.position.y,
            z: this.position.z,
            xRotation: this.rotation ? this.rotation.x : null,
            yRotation: this.rotation ? this.rotation.y : null,
        });
    }
    getMetadataString() {
        return JSON.stringify({
            icon: this.getIcon(),
            normal: this.getNormal(),
        });
    }
    getSweepID() {
        return this.sweepID;
    }
    getObject() {
        return this.object;
    }
    getRotation() {
        return this.rotation;
    }
    getPoi() {
        return this.poi;
    }
}

const HoverEvent$1 = 'hover';
const UnhoverEvent$1 = 'unhover';
const RepaintEvent = 'repaint';
class NestThermostat extends SceneComponent {
    constructor() {
        super(...arguments);
        this.cv = null;
        this.planeRenderer = null;
        this.rootScene = null;
        this.mixer = null;
        this.onEnterClip = null;
        this.mesh = null;
        this.currentTime = 0;
        this.nextUpdate = 0;
        this.temperature = 0;
        this.tempChangeRange = 5;
        this.inputs = {
            loadingState: 'Idle',
            texture: null,
            updateInterval: 1000,
        };
        this.outputs = {
            painter: null,
            visible: false,
        };
        this.events = {
            [HoverEvent$1]: true,
            [UnhoverEvent$1]: true,
        };
    }
    onInit(modelNode, plane, inputTexture) {
        if (!this.context) {
            this.context = {
                root: modelNode
            };
        }
        this.inputs.texture = inputTexture;
        const root = this.context.root;
        const THREE = this.context.three;
        this.planeRenderer = plane;
        this.planeRenderer.outputs.objectRoot.translateZ(0.05);
        this.planeRenderer.outputs.objectRoot.translateY(0.4);
        this.planeRenderer.outputs.objectRoot.scale.set(0.5, 0.5, 0.5);
        // planeRenderer.inputs.localPosition.z = 0.05;
        // planeRenderer.inputs.localPosition.y = 0.4;
        // planeRenderer.inputs.localScale = {x: 0.5, y: 0.5, z: 0.5};
        this.outputs.painter = this;
        this.mixer = new AnimationMixer(this.planeRenderer.outputs.objectRoot);
        const tm = 0.2;
        const positionTrack = new VectorKeyframeTrack('.scale', [0, tm], [
            0, 0, 0,
            0.5, 0.5, 0.5
        ], InterpolateSmooth);
        this.onEnterClip = new AnimationClip(null, tm, [positionTrack]);
    }
    onInputsUpdated() {
        if (this.inputs.loadingState === 'Loaded') {
            const lines = [];
            //@ts-ignore
            this.context.root.obj3D.traverse((obj) => {
                // we dont want line segments, track them and remove them.
                if (obj.type === 'LineSegments') {
                    lines.push(obj);
                }
                else if (obj.type === 'Mesh') {
                    this.mesh = obj;
                    const materials = this.mesh.material;
                    materials.forEach((m, idx) => {
                        if (m && m.map.source.data.outerHTML.indexOf('_5b76dbe388862300126c1e14') !== -1) {
                            const newMaterial = new MeshBasicMaterial({ map: this.inputs.texture });
                            this.mesh.material[idx] = newMaterial;
                        }
                    });
                }
            });
            // remove the line segments.
            lines.forEach((line) => {
                line.parent.remove(line);
            });
        }
    }
    onEvent(eventType, eventData) {
        if (eventType === HoverEvent$1) {
            const data = eventData;
            if (data.hover) {
                this.outputs.visible = true;
                const onEnterAction = this.mixer.clipAction(this.onEnterClip);
                onEnterAction.stop();
                onEnterAction.loop = LoopOnce;
                onEnterAction.clampWhenFinished = true;
                onEnterAction.play();
            }
            else {
                this.outputs.visible = false;
            }
        }
    }
    paint(context2d, size) {
        const x = 490;
        const y = 490;
        context2d.fillStyle = 'black';
        context2d.beginPath();
        context2d.arc(x, y, 400, 0, Math.PI * 2);
        context2d.fill();
        context2d.fillStyle = '#CF5300';
        context2d.beginPath();
        context2d.arc(x, y, 300, 0, Math.PI * 2);
        context2d.fill();
        context2d.beginPath();
        context2d.strokeStyle = 'orange';
        context2d.arc(x, y, 240, 0.75 * Math.PI, 0.25 * Math.PI);
        context2d.lineCap = 'butt';
        context2d.lineWidth = 80;
        context2d.stroke();
        context2d.fillStyle = 'white';
        context2d.font = '220px Arial';
        context2d.fillText(`${this.temperature}`, x - 115, y + 75);
        this.outputs.visible = true;
    }
    onTick(delta) {
        this.currentTime += delta;
        if (this.mixer) {
            this.mixer.update(delta / 1000);
        }
        if (this.currentTime > this.nextUpdate) {
            this.nextUpdate += this.inputs.updateInterval;
            this.temperature += (Math.random() * this.tempChangeRange);
            this.temperature = Math.trunc(this.temperature);
            if (this.temperature > 99) {
                this.temperature = 99;
                this.tempChangeRange = -this.tempChangeRange;
            }
            if (this.temperature < 10) {
                this.temperature = 10;
                this.tempChangeRange = -this.tempChangeRange;
            }
            this.component.notify(RepaintEvent);
            this.cv.repaint();
        }
    }
    setComponent(component, plane, cv) {
        component.onTick = this.onTick.bind(this);
        // plane.onTick = this.onTick.bind(this);
        this.cv = cv;
        this.component = component;
        this.context = component.context;
    }
    setRootScene(rootScene) {
        this.rootScene = rootScene;
    }
}
const nestThermostatType = 'mp.nestThermostat';
const makeNestThermostat = function () {
    return new NestThermostat();
};

class PlaneRenderer extends SceneComponent {
    constructor() {
        super(...arguments);
        this.rootScene = null;
        this.inputs = {
            texture: null,
            aspect: 1,
            transparent: true,
            visible: true,
            opacity: 1,
            polygonOffset: false,
            polygonOffsetFactor: 0,
            polygonOffsetUnits: 0,
            localScale: { x: 1, y: 1, z: 1 },
            localPosition: { x: 0, y: 0, z: 0 },
        };
        this.events = {
            [ComponentInteractionType.CLICK]: true,
        };
    }
    onInit(modelNode, inputTexture) {
        this.inputs.texture = inputTexture;
        if (!this.context) {
            this.context = {
                root: modelNode
            };
        }
        this.pivotNode = new Group();
        this.mesh = new Mesh(new PlaneBufferGeometry(1.0, 1.0), new MeshBasicMaterial({
            transparent: this.inputs.transparent,
            map: this.inputs.texture,
            opacity: this.inputs.opacity,
            polygonOffset: this.inputs.polygonOffset,
            polygonOffsetFactor: this.inputs.polygonOffsetFactor,
            polygonOffsetUnits: this.inputs.polygonOffsetUnits,
        }));
        this.mesh.scale.set(this.inputs.localScale.x, this.inputs.localScale.y / this.inputs.aspect, this.inputs.localScale.z);
        this.mesh.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
        this.mesh.updateMatrixWorld();
        this.pivotNode.add(this.mesh);
        this.outputs.objectRoot = this.pivotNode;
        this.outputs.collider = this.pivotNode;
        this.mesh.visible = this.inputs.visible;
    }
    onEvent(eventType, eventData) {
        this.notify(eventType, eventData);
    }
    onInputsUpdated(oldInputs) {
        if (oldInputs.transparent !== this.inputs.transparent) {
            this.mesh.material.transparent = this.inputs.transparent;
        }
        if (oldInputs.texture !== this.inputs.texture) {
            const material = this.mesh.material;
            material.map = this.inputs.texture;
            material.needsUpdate = true;
        }
        if (oldInputs.visible !== this.inputs.visible) {
            this.mesh.visible = this.inputs.visible;
        }
        if (oldInputs.polygonOffset !== this.inputs.polygonOffset) {
            const material = this.mesh.material;
            material.polygonOffset = this.inputs.polygonOffset;
            material.polygonOffsetFactor = this.inputs.polygonOffsetFactor;
            material.polygonOffsetUnits = this.inputs.polygonOffsetUnits;
        }
        this.mesh.scale.set(this.inputs.localScale.x, this.inputs.localScale.y / this.inputs.aspect, this.inputs.localScale.z);
        this.mesh.position.set(this.inputs.localPosition.x, this.inputs.localPosition.y, this.inputs.localPosition.z);
    }
    onDestroy() {
        this.outputs.collider = null;
        this.outputs.objectRoot = null;
        this.mesh.material.dispose();
        this.mesh.geometry.dispose();
    }
    setRootScene(rootScene) {
        this.rootScene = rootScene;
    }
}
const planeRendererType = 'mp.planeRenderer';
function makePlaneRenderer() {
    return new PlaneRenderer();
}

class CanvasRenderer extends SceneComponent {
    constructor() {
        super(...arguments);
        this.inputs = {
            painter: null,
            textureRes: { w: 1024, h: 1024 }, // dim for thermostat
        };
        this.outputs = {
            texture: null,
        };
        this.events = {
            repaint: true,
        };
    }
    onInit() {
        // set up canvas 2d context
        this.canvas = document.createElement('canvas');
        this.renderContext2D = this.canvas.getContext('2d');
        this.outputs.texture = new CanvasTexture(this.canvas);
        this.resize(this.inputs.textureRes);
        this.repaint();
    }
    setCanvasNestThermostatPainter(sc) {
        this.inputs.painter = sc;
    }
    onInputsUpdated(oldInputs) {
        if (oldInputs.textureRes.w !== this.inputs.textureRes.w ||
            oldInputs.textureRes.h !== this.inputs.textureRes.h) {
            this.resize(this.inputs.textureRes);
        }
        if (oldInputs.painter !== this.inputs.painter) {
            this.repaint();
        }
    }
    onEvent(eventType, _eventData) {
        if (eventType === 'repaint') {
            this.repaint();
        }
    }
    onDestroy() {
        this.outputs.texture.dispose();
        this.outputs.texture = null;
    }
    resize(size) {
        this.canvas.width = size.w;
        this.canvas.height = size.h;
    }
    repaint() {
        if (this.inputs.painter) {
            this.inputs.painter.paint(this.renderContext2D, this.inputs.textureRes);
            this.outputs.texture.needsUpdate = true;
        }
    }
}
const canvasRendererType = 'mp.canvasRenderer';
function makeCanvasRenderer() {
    return new CanvasRenderer();
}

const HoverEvent = 'hover';
const UnhoverEvent = 'unhover';
class TvPlayer extends SceneComponent {
    constructor() {
        super(...arguments);
        this.rootScene = null;
        this.mesh = null;
        this.inputs = {
            loadingState: 'Idle',
            texture: null,
            updateInterval: 1000,
        };
        this.events = {
            [HoverEvent]: true,
            [UnhoverEvent]: true,
        };
    }
    onInit(modelNode) {
        if (!this.context) {
            this.context = {
                root: modelNode
            };
        }
        const root = this.context.root;
        const THREE = this.context.three;
    }
    onDestroy() {
        super.onDestroy();
        clearInterval(this.intervalVideoTexture);
    }
    onInputsUpdated() {
        if (this.inputs.loadingState === 'Loaded') {
            const lines = [];
            //@ts-ignore
            this.context.root.obj3D.traverse((obj) => {
                // we dont want line segments, track them and remove them.
                if (obj.type === 'LineSegments') {
                    lines.push(obj);
                }
                else if (obj.type === 'Mesh') {
                    this.mesh = obj;
                    let video, videoImage, videoImageContext, videoTexture;
                    // create the video element
                    video = document.createElement('video');
                    // video.src = "./../assets/video/video_samsic.mp4";
                    video.src = "./../assets/video/121222-04.mp4";
                    video.load(); // must call after setting/changing source
                    video.loop = true;
                    video.play();
                    videoImage = document.createElement('canvas');
                    // videoImage.width = 640;
                    videoImage.width = 1280;
                    // videoImage.height = 360;
                    videoImage.height = 720;
                    videoImageContext = videoImage.getContext('2d');
                    // background color if no video present
                    videoImageContext.fillStyle = '#000000';
                    videoImageContext.fillRect(0, 0, videoImage.width, videoImage.height);
                    videoTexture = new Texture(videoImage);
                    videoTexture.minFilter = LinearFilter;
                    videoTexture.magFilter = LinearFilter;
                    const movieMaterial = new MeshBasicMaterial({ map: videoTexture });
                    this.mesh.material = movieMaterial;
                    const render = () => {
                        if (video.readyState === video.HAVE_ENOUGH_DATA) {
                            videoImageContext.drawImage(video, 0, 0);
                            if (videoTexture)
                                videoTexture.needsUpdate = true;
                        }
                        const camera = (this.context.scene.children.find(u => u.constructor.name === 'CameraRig')).camera;
                        this.context.renderer.render(this.context.scene, camera);
                    };
                    this.intervalVideoTexture = setInterval(() => {
                        render();
                    }, 180);
                }
            });
            // remove the line segments.
            lines.forEach((line) => {
                line.parent.remove(line);
            });
        }
    }
    setComponent(component) {
        this.component = component;
        this.context = component.context;
    }
    setRootScene(rootScene) {
        this.rootScene = rootScene;
    }
}
const TvPlayerType = 'mp.TvPlayer';
const makeTvPlayer = function () {
    return new TvPlayer();
};

class BaseVisibilityService {
    constructor() {
        this.detailShowing = new Subject();
        this.isChangePositionVisible = new Subject();
    }
}
BaseVisibilityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseVisibilityService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaseVisibilityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseVisibilityService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseVisibilityService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class Config {
    constructor() { }
}

class MatterportService {
    constructor(config, router, visibilityService, ngZone) {
        this.router = router;
        this.visibilityService = visibilityService;
        this.ngZone = ngZone;
        this.slots = []; //SlotNode[] = [];
        this.nodes = [];
        this.cursorPositionButtonDisplayed = false;
        // Measure mode
        this.isMeasureModeOn = false;
        this.interactionMode = ViewerInteractions.DEFAULT;
        // List of created Mattertag IDs in the current viewer session
        this.mattertagIDs = [];
        // Dictionnary of MattertagID and its data (mattertagData)
        this.dictionnaryTags = new Map();
        this.dictionnaryObjects3D = new Map();
        this.dictionnarySceneObjects3D = new Map();
        this.lastMeasure = [];
        this.distancesLastMeasure = [];
        this.resolution = {
            width: 500,
            height: 600,
        };
        this.visibility = {
            mattertags: false,
            sweeps: true,
        };
        this.tagsAttachments = {};
        this.currentSweep = new Subject();
        //camera position with rotation
        this.currentCameraPose = new Subject();
        this.forbiddenSweeps = [];
        this.tagAction = new Subject();
        this.inTransitionMode = false;
        this.inTransitionSweep = false;
        this.noLightForObjects = true;
        this.currentCameraMode = CameraMode.OUTSIDE;
        this.onCameraModeChanged = new Subject();
        this.onGoToTag = new Subject();
        this.tagMessengerOn = false;
        /**
         * Actions on left click when positioning mattertag in visit
         */
        this.pointerLeftClickHandler = () => {
            if (this.mattertagToFollow) {
                const mattertagData = this.dictionnaryTags.get(this.mattertagToFollow);
                mattertagData.setPosition(Object.assign({}, this.poseMatterport.position)); // copy!! not the reference
                mattertagData.setNormal(Object.assign({}, this.poseMatterport.normal)); // copy!! not the reference
                this.dictionnaryTags.set(this.mattertagToFollow, mattertagData);
                this.updateMatterTagContentForTagID(this.mattertagToFollow);
            }
            this.onValidatedMattertag();
        };
        this.pointerRightClickHandler = (e) => {
            e.preventDefault();
            this.cancelFollowingCursor();
            alert('action cancelled');
        };
        this.pointerMiddleClickHandler = (e) => {
            this.textDisplayCursorPositionPanel.innerHTML = `position:
       ${this.pointToString(this.poseMatterport.position)}\n
       normal:
       ${this.pointToString(this.poseMatterport.normal)}\n
       floorId:
       ${this.poseMatterport.floorId}`;
            // this.textDisplayCursorPositionPanel.style.display = 'visible';
            this.getCursorPositionButton.style.display = 'none';
        };
        this.config = config;
        // TODO: only for dev!
        if (!!this.getCursorPositionButton &&
            (document.location.href.indexOf('dev') !== -1 || document.location.href.indexOf('localhost') !== -1)) {
            this.intervalCursorPointerPosition = setInterval(() => {
                if (!this.poseMatterport) {
                    return;
                }
                const nextShow = this.poseMatterport.time + 1000;
                if (new Date().getTime() > nextShow) {
                    if (this.cursorPositionButtonDisplayed) {
                        return;
                    }
                    const size = {
                        w: this.container.clientWidth,
                        h: this.container.clientHeight,
                    };
                    const coord = this.sdk.Conversion.worldToScreen(this.poseMatterport.position, this.poseCamera, size);
                    this.getCursorPositionButton.style.left = `${coord.x - 25}px`;
                    this.getCursorPositionButton.style.top = `${coord.y - 22}px`;
                    this.getCursorPositionButton.style.display = 'block';
                    // this.textDisplayCursorPositionPanel.style.display = 'none';
                    this.cursorPositionButtonDisplayed = true;
                }
            }, 500);
        }
    }
    get currentSpaceID() {
        return this._currentSpaceID;
    }
    set currentSpaceID(value) {
        this._currentSpaceID = value;
    }
    /**
     * Initializes Matterport and all listeners/data
     * @param tagService BaseTagService (to inject html)
     * @param module SpModule (Museum, Immo) to subscribe only to needed functionnnalities
     * @returns boolean
     */
    initSdk(tagService, module = SpModule.IMMO) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sdk) {
                // clean if sdk is running already
                yield this.action_delete_all_mattertags();
            }
            this.tagService = tagService;
            this.SPModule = module;
            return new Promise((resolve, reject) => {
                // Retrieve DOM elements
                this.pointerButton = document.querySelector('#viewer-pointer-trick');
                this.container = document.querySelector('#viewer-module');
                const iframe = document.querySelector('#viewer-module');
                if (!iframe) {
                    return;
                }
                // Add listeners
                if (this.pointerButton) {
                    this.pointerButton.addEventListener('click', this.pointerLeftClickHandler);
                    // cancel on right click
                    this.pointerButton.addEventListener('contextmenu', this.pointerRightClickHandler);
                }
                // Retrieve DOM elements
                this.getCursorPositionButton = document.querySelector('#button');
                this.textDisplayCursorPositionPanel = document.querySelector('#text');
                if (this.getCursorPositionButton) {
                    // get position on Matterport "model" on middle click
                    this.getCursorPositionButton.addEventListener('click', this.pointerMiddleClickHandler);
                }
                // Load SDK
                console.log('Loading Matterport SDK');
                const showcaseWindow = iframe.contentWindow;
                iframe.addEventListener('load', function () {
                    return __awaiter(this, void 0, void 0, function* () {
                        try {
                            this.sdk = yield showcaseWindow.MP_SDK.connect(showcaseWindow, 'qn9wsasuy5h2fzrbrn1nzr0id', '3.5');
                        }
                        catch (e) {
                            console.error(e);
                            return;
                        }
                        // Load Mattertag icons and custom subscriptions
                        switch (module) {
                            case SpModule.IMMO:
                                this.sdk.Asset.registerTexture('icon-ticket', this.config.my_config.icon_ticket);
                                this.sdk.Asset.registerTexture('icon-equipment', this.config.my_config.icon_equipment);
                                this.sdk.Asset.registerTexture('icon-measure', this.config.my_config.icon_measure);
                                this.sdk.Asset.registerTexture('icon-data', this.config.my_config.icon_data);
                                this.sdk.Asset.registerTexture('icon-object3d', this.config.my_config.icon_object3d);
                                this.sdk.Measurements.data.subscribe({
                                    onAdded: function (index, item, collection) {
                                        // console.log(
                                        //     "item added to the collection",
                                        //     index,
                                        //     item,
                                        // );
                                        // this.measurements[index] = item;
                                        this.lastMeasure = item.points;
                                    }.bind(this),
                                    onCollectionUpdated: function (collection) {
                                        // console.log('the entire up-to-date collection', collection);
                                        this.getDistanceForLastMeasurement();
                                    }.bind(this),
                                });
                                this.sdk.Measurements.mode.subscribe(function (measurementModeState) {
                                    // measurement mode state has changed
                                    this.isMeasureModeOn = measurementModeState.active;
                                    // console.log('Is measurement mode currently active? ', measurementModeState.active);
                                }.bind(this));
                                break;
                            case SpModule.MUSEUM:
                                this.sdk.Asset.registerTexture('icon-data', this.config.my_config.icon_data);
                                break;
                            case SpModule.HOTEL:
                                this.sdk.Asset.registerTexture('icon_room_available', this.config.my_config.icon_room_available);
                                this.sdk.Asset.registerTexture('icon_room_unavailable', this.config.my_config.icon_room_unavailable);
                                this.sdk.Asset.registerTexture('icon_room_chosen', this.config.my_config.icon_room_chosen);
                                this.sdk.Asset.registerTexture('icon_room_viewed', this.config.my_config.icon_room_viewed);
                                break;
                            default:
                                break;
                        }
                        this.sdk.Asset.registerTexture('icon-position', this.config.my_config.icon_position);
                        // Current Room (used for getting bounding box and eventually lazy load mattertag or object3D inside current Room)
                        this.sdk.Room.current.subscribe((currentRoom) => {
                            console.log(`hello current Room ${JSON.stringify(currentRoom)}`);
                        });
                        // 3D position's pointer
                        this.sdk.Pointer.intersection.subscribe(function (intersection) {
                            this.poseMatterport = intersection;
                            this.poseMatterport.time = new Date().getTime();
                            if (!this.oldPoseMatterportPosition) {
                                this.oldPoseMatterportPosition = {
                                    x: 0,
                                    y: 0,
                                    z: 0,
                                };
                            }
                            if (this.interactionMode !== ViewerInteractions.DEFAULT &&
                                this.mattertagToFollow) {
                                // follow the pointer and changes the position of the last tag
                                // (we are about to validate, but it exists in sdk already)
                                this.enable_following_tag(this.mattertagToFollow);
                            }
                            if (!!this.getCursorPositionButton && !!this.getCursorPositionButton.style &&
                                (document.URL.indexOf('https://dev.smarterplan.io') !== -1 || document.location.href.indexOf('localhost') !== -1)) {
                                this.getCursorPositionButton.style.display = 'none';
                                this.cursorPositionButtonDisplayed = false;
                            }
                        }.bind(this));
                        //Camera mode
                        this.sdk.Mode.current.subscribe((mode) => {
                            this.inTransitionSweep = false;
                            switch (mode) {
                                case 'mode.dollhouse':
                                    this.currentCameraMode = CameraMode.DOLLHOUSE;
                                    break;
                                case 'mode.floorplan':
                                    this.currentCameraMode = CameraMode.FLOORPLAN;
                                    break;
                                case 'mode.inside':
                                    this.currentCameraMode = CameraMode.INSIDE;
                                    break;
                                case 'mode.transitioning':
                                    this.currentCameraMode = CameraMode.TRANSITIONING;
                                    break;
                                default:
                                    this.currentCameraMode = CameraMode.OUTSIDE;
                            }
                            this.onCameraModeChanged.next(this.currentCameraMode);
                        });
                        // Camera's viewpoint
                        this.sdk.Camera.pose.subscribe(function subscr(pose) {
                            this.poseCamera = pose;
                            this.currentCameraPose.next(pose);
                            // console.log('Current position is ', pose.position);
                            // console.log('Rotation angle is ', pose.rotation);
                            // console.log("Sweep UUID is", pose.sweep);
                        }.bind(this));
                        // subscribe to sweeps
                        this.sdk.Sweep.data.subscribe({
                            onCollectionUpdated: function subscr(collection) {
                                // console.log("Sweep collection updated");
                                this.sweeps = Object.keys(collection);
                            }.bind(this),
                        });
                        // subscribe to current sweep
                        this.sdk.Sweep.current.subscribe(function subscr(currentSweep) {
                            // Change to the current sweep has occurred.
                            if (currentSweep.sid === '') {
                                // console.log('Not currently stationed at a sweep position');
                            }
                            else {
                                // console.log("emmiting sweep", currentSweep.sid);
                                this.currentSweep.next(currentSweep.sid);
                            }
                        }.bind(this));
                        // Subscribe to Floor data
                        this.sdk.Floor.data.subscribe({
                            onCollectionUpdated: function upd(collection) {
                                this.floors = Object.values(collection);
                            }.bind(this),
                        });
                        // on tag click open details page
                        this.sdk.on('tag.click', (sid) => {
                            // get object of this tag
                            try {
                                const mattertagData = this.dictionnaryTags.get(sid);
                                const url = tagService.getUrlForSeeDetails(mattertagData.getObject(), mattertagData.getType());
                                if (url !== '') {
                                    this.visibilityService.detailShowing.next(true);
                                    this.ngZone.run(() => {
                                        this.router.navigate([url]);
                                    });
                                }
                            }
                            catch (_a) {
                                console.log('Cannot show details for tag');
                            }
                        });
                        // Pointer trick
                        // Create a div that will appear when the cursor is still
                        // It will intercept the click of the mouse before it trigerring the Matterport's tour navigation
                        this.timerPointer = setInterval(this.updatePointerTrick.bind(this), 50);
                        /**
                         * Transitions
                         */
                        this.sdk.on('viewmode.changestart', function (to, from) {
                            // console.log('Starting to move to ' + to + ' from ' + from);
                            this.inTransitionMode = true;
                        }.bind(this));
                        this.sdk.on('viewmode.changeend', function (oldMode, newMode) {
                            // console.log('Ended to move to ' + newMode + ' from ' + oldMode);
                            if (newMode !== 'mode.transitioning') {
                                this.inTransitionMode = false;
                            }
                        }.bind(this));
                        this.sdk.on(this.sdk.Sweep.Event.ENTER, function (oldSweep, newSweep) {
                            // console.log('Leaving sweep ' + oldSweep);
                            // console.log('Entering sweep ' + newSweep);
                            this.inTransitionSweep = false;
                        }.bind(this));
                        this.sdk.on(this.sdk.Sweep.Event.EXIT, function (fromSweep, toSweep) {
                            //   console.log('Leaving sweep ' + fromSweep);
                            //   console.log('Transitioning to sweep ' + toSweep);
                            this.inTransitionSweep = true;
                        }.bind(this));
                        // TODO: get scene with getter instead!
                        const [sceneObject] = yield this.sdk.Scene.createObjects(1);
                        const node = sceneObject.addNode();
                        node.start();
                        this.threeJSScene = node.obj3D.parent;
                        // await this.sdk.Scene.configure((renderer: any, three: any) => {
                        //   renderer.physicallyCorrectLights = true;
                        //   renderer.outputEncoding = three.sRGBEncoding;
                        //   renderer.shadowMap.enabled = true;
                        //   renderer.shadowMap.bias = 0.0001;
                        //   renderer.shadowMap.type = three.PCFSoftShadowMap;
                        // });
                        // TODO: wait for MP ticket resolution before decomment these!
                        // Wait until Showcase is actually playing....
                        // this.sdk.Tag.data.subscribe({
                        //   onAdded: async function (index, item, collection) {
                        //
                        //     let thisOpacity = 0.2;
                        //     this.sdk.Tag.editOpacity(index, thisOpacity);
                        //
                        //     let source = null;
                        //     try {
                        //       source = await Promise.all([
                        //         this.sdk.Sensor.createSource(this.sdk.Sensor.SourceType.SPHERE, {
                        //           origin: item.anchorPosition,
                        //           radius: Number(3),
                        //           userData: {
                        //             id: index + '-sphere-source',
                        //           },
                        //         })
                        //       ]);
                        //     } catch (e) {
                        //       console.log('could not create Sphere sensor')
                        //       console.error(e);
                        //     }
                        //     if (!source) {
                        //       return;
                        //     }
                        //
                        //     let sensor = null;
                        //     try {
                        //       sensor = await this.sdk.Sensor.createSensor(this.sdk.Sensor.SensorType.CAMERA);
                        //     } catch (e) {
                        //       console.log('could not create Camera sensor')
                        //       console.error(e);
                        //     }
                        //     if (!sensor) {
                        //       return;
                        //     }
                        //
                        //     sensor.addSource(...source);
                        //     sensor.readings.subscribe({
                        //       onUpdated(source, reading) {
                        //         console.log(thisOpacity);
                        //         let oldOpacity = thisOpacity;
                        //         if (reading.inRange) {
                        //           thisOpacity = 1;
                        //           console.log(index + ' is inRange');
                        //         } else if (reading.inView) {
                        //           console.log(index + ' is inView but not inRange');
                        //           thisOpacity = 0.5;
                        //         } else {
                        //           thisOpacity = 0.2;
                        //           console.log(index + ' is not inView or inRange');
                        //         }
                        //
                        //         this.sdk.Tag.editOpacity(index, thisOpacity);
                        //         /*
                        //                   let inc = 0.01;
                        //                   if (oldOpacity > thisOpacity) {
                        //                     inc = -0.01;
                        //                   }
                        //
                        //                   for(var i = oldOpacity; i != thisOpacity; i=i+inc) {
                        //                       setTimeout(function() {
                        //                          mpSdk.Tag.editOpacity(index, i);
                        //                       console.log('Delay', i);
                        //                       },10);
                        //                   }
                        //         */
                        //       }
                        //     });
                        //     //sensor.showDebug(true);
                        //   }.bind(this),
                        //   onCollectionUpdated: function (collection) {
                        //     console.log('Collection received. There are ', Object.keys(collection).length, ' Tags in the collection', collection);
                        //   }
                        // });
                        resolve(true);
                    });
                }.bind(this));
            });
        });
    }
    setLightingOff() {
        this.noLightForObjects = true;
    }
    pointToString(point) {
        var x = point.x.toFixed(3);
        var y = point.y.toFixed(3);
        var z = point.z.toFixed(3);
        return `{ x: ${x}, y: ${y}, z: ${z} }`;
    }
    //
    // ---------- Measurements related ----------
    //
    /**
     * Callback after measurement is performed
     */
    getDistanceForLastMeasurement() {
        if (this.lastMeasure.length > 0) {
            const numberPoints = this.lastMeasure.length;
            this.distancesLastMeasure = [];
            for (let index = 1; index < numberPoints; index += 1) {
                const distance = getDistanceBetweenTwoPoints(this.lastMeasure[index - 1], this.lastMeasure[index]);
                this.distancesLastMeasure.push(distance);
            }
            this.takeScreenShot().then((res) => {
                this.router.navigate([`visit/${this.currentSpaceID}/add_measurement`]);
            });
        }
    }
    getLastDistances() {
        return this.distancesLastMeasure;
    }
    /**
     * Takes screenshot and saves base64 in lastScreenshotUri
     * @returns Promise
     */
    takeScreenShot() {
        return this.sdk.Renderer.takeScreenShot(this.resolution, this.visibility).then(function (screenShotUri) {
            // base64 string
            this.lastScreenshotUri = screenShotUri;
            return Promise.resolve();
        }.bind(this));
    }
    getScreenShotUri() {
        return this.lastScreenshotUri;
    }
    getLastMeasurement() {
        const data = {
            measure: this.lastMeasure,
            sweep: this.poseCamera.sweep,
        };
        return data;
    }
    //
    // ---------- Utils ----------
    //
    /**
     * Styling of pointer
     */
    updatePointerTrick() {
        if (this.interactionMode !== ViewerInteractions.DEFAULT &&
            this.mattertagToFollow &&
            this.poseMatterport &&
            this.getDistPosition(this.poseMatterport.position, this.oldPoseMatterportPosition) > 25) {
            this.pointerButton.style.display = 'none';
            const size = {
                w: this.container.clientWidth,
                h: this.container.clientHeight,
            };
            const coords = this.sdk.Conversion.worldToScreen(this.poseMatterport.position, this.poseCamera, size);
            this.pointerButton.style.left = `${coords.x * Math.sign(coords.x) - 25}px`;
            this.pointerButton.style.top = `${coords.y * Math.sign(coords.x) - 25}px`;
            this.oldPoseMatterportPosition = Object.assign({}, this.poseMatterport.position);
        }
        else {
            this.pointerButton.style.display = 'block';
        }
    }
    /**
     * Realtime mattertag following the cursor
     * @param mattertag string
     */
    enable_following_tag(mattertag) {
        this.sdk.Tag.editPosition(mattertag, {
            anchorPosition: {
                x: this.poseMatterport.position.x * 1,
                y: this.poseMatterport.position.y * 1,
                z: this.poseMatterport.position.z * 1,
            },
            stemVector: {
                x: this.poseMatterport.normal.x * 0.3,
                y: this.poseMatterport.normal.y * 0.3,
                z: this.poseMatterport.normal.z * 0.3,
            },
        });
    }
    /**
     * Get the distance betwween two 3D positions
     * Used in order to see how much the cursor has moved from the previous position
     * @param pos1
     * @param pos2
     */
    getDistPosition(pos1, pos2) {
        const size = {
            w: this.container.clientWidth,
            h: this.container.clientHeight,
        };
        const coords1 = this.sdk.Conversion.worldToScreen(pos1, this.poseCamera, size);
        const coords2 = this.sdk.Conversion.worldToScreen(pos2, this.poseCamera, size);
        return Math.sqrt(Math.pow((coords1.x - coords2.x), 2) + Math.pow((coords1.y - coords2.y), 2));
    }
    //
    // ---------- Mattertag related ----------
    //
    /**
     * Creates the Mattertag that will follow the cursor
     * @param mattertagData MattertagData
     */
    addCursorMattertag(mattertagData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.poseMatterport)
                return;
            this.mattertagToFollow = yield this.addMattertagToViewer(mattertagData);
            console.log('following the tag', this.mattertagToFollow);
            this.sdk.Tag.editIcon(this.mattertagToFollow, 'icon-position');
            this.sdk.Tag.editOpacity(this.mattertagToFollow, 1);
        });
    }
    /**
     * Adds Mattertag to viewer for an existing object with coordinates (in mattertagData.poi)
     * (position, injected html, set icon)
     * @param mattertagData
     * returns mattertagID
     */
    addMattertagToViewer(mattertagData) {
        return __awaiter(this, void 0, void 0, function* () {
            let sidList;
            if (!this.sdk) {
                return null;
            }
            try {
                sidList = yield this.sdk.Tag.add(mattertagData.getData());
            }
            catch (error) {
                console.log('Tag does not belong to the visit', error, mattertagData.getData());
            }
            if (sidList) {
                const mattertagID = sidList[0];
                // console.log("added tag", mattertagData.getType(), mattertagID);
                this.mattertagIDs.push(mattertagID);
                this.dictionnaryTags.set(mattertagID, mattertagData);
                return mattertagID;
            }
            return null;
        });
    }
    /**
     * Actions when position of mattertag is validated by left click
     */
    onValidatedMattertag() {
        this.setInteractionMode(ViewerInteractions.DEFAULT);
        const lastTag = this.getLastTag();
        if (lastTag) {
            const callbackMode = this.dictionnaryTags
                .get(lastTag)
                .getCallbackActionMode();
            this.callbackAfterMattertagValidation(callbackMode);
        }
    }
    /**
     * Registers new icon (path to image) and set its for Mattertag
     * @param mattertagID string
     * @param iconPath string
     */
    addNewIconAndSetForTag(mattertagID, iconPath) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sdk.Asset.registerTexture(`icon_${mattertagID}`, iconPath);
            this.sdk.Tag.editIcon(mattertagID, `icon_${mattertagID}`);
        });
    }
    /**
     * Changes icon of Mattertag (the iconName should be registered = one of default ones)
     * @param mattertagID string
     * @param iconName string
     */
    setRegistredIconForTag(mattertagID, iconName) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.sdk.Tag.editIcon(mattertagID, iconName);
            }
            catch (e) {
                console.log('could not edit Icon with name ', iconName, '. Is it registered?');
            }
        });
    }
    /**
     * Sets default icon for a tag (registered in initSdk) OR uses tagIcon from POI (available from MattertagData)
     * @param mattertagID string
     * @param mattertagData MattertagData
     * @returns
     */
    setTagIconAndOpacity(mattertagID, mattertagData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.SPModule === SpModule.HOTEL) {
                const room = mattertagData.getObject();
                let iconName = `icon_room`;
                if (room.available) {
                    iconName = `${iconName}_available`;
                }
                else {
                    iconName = `${iconName}_unavailable`;
                }
                this.sdk.Tag.editIcon(mattertagID, iconName);
                return;
            }
            const stringTagType = poiTypeToString(mattertagData.getType());
            let opacity = this.config.my_config.DEFAULT_OPACITY_TAG;
            let iconName = `icon-${stringTagType}`;
            const poi = mattertagData.getPoi();
            if (poi && poi.tagIcon) {
                const tagIcon = JSON.parse(poi.tagIcon);
                if (mattertagData.getType() === PoiType.DATA) {
                    const feature = mattertagData.getObject();
                    if (feature.type === FeatureType.INDICATOR_TEMP) {
                        tagIcon.src = this.tagService.getIconTagImageForFeature(feature, poi);
                    }
                }
                if (tagIcon.src) {
                    const pathSigned = yield this.tagService.getSignedTagIconSource(tagIcon.src);
                    if (pathSigned) {
                        try {
                            iconName = `icon-${stringTagType}-${mattertagID}-${mattertagData.customIconIndex}`;
                            yield this.sdk.Asset.registerTexture(iconName, pathSigned);
                            mattertagData.customIconIndex += 1;
                        }
                        catch (_a) {
                            console.log('error registerIcon');
                        }
                    }
                }
                if (tagIcon.opacity) {
                    opacity = tagIcon.opacity;
                }
            }
            try {
                this.sdk.Tag.editIcon(mattertagID, iconName);
                this.sdk.Tag.editOpacity(mattertagID, opacity);
            }
            catch (error) {
                console.log('Error editIcon or opacity', error);
            }
        });
    }
    /**
     * Moves viewer to last tag created
     */
    goToLastTag() {
        setTimeout(() => {
            const lastTag = this.getLastTag();
            this.goToTag(lastTag);
        }, 2000);
    }
    /**
     * Moves viewer to Mattertag with ID provided
     * @param mattertagID string
     * @returns
     */
    goToTag(mattertagID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (mattertagID === '')
                return;
            try {
                this.onGoToTag.next(mattertagID);
                yield this.sdk.Sweep.current.waitUntil((currentSweep) => currentSweep !== '');
                yield this.sdk.Mattertag.navigateToTag(mattertagID, this.sdk.Mattertag.Transition.FLY);
            }
            catch (error) {
                console.log('cannot navigate to tag', error);
            }
        });
    }
    /**
     * Updates content of Mattertag with mattertagID (billboard, injected html, tag icon)
     * @param mattertagID string
     * @param object Ticket, Equipment, Feature, etc
     * @param tagType PoiType
     */
    updateMatterTagContentForTagID(mattertagID, object = null, tagType = null) {
        return __awaiter(this, void 0, void 0, function* () {
            this.sdk.Tag.editBillboard(mattertagID, this.dictionnaryTags.get(mattertagID).getData());
            if (object && tagType) {
                yield this.injectHtmlInTag(tagType, object, mattertagID);
            }
            yield this.setTagIconAndOpacity(mattertagID, this.dictionnaryTags.get(mattertagID));
        });
    }
    /**
     * Updates injected html for Mattertag
     * @param mattertagID string
     * @param object Ticket, Equipment, Feature, etc
     * @param tagType PoiType
     */
    updateInjectedHtmlForTagID(mattertagID, object, tagType) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.injectHtmlInTag(tagType, object, mattertagID);
        });
    }
    /**
     * Deletes Mattertag from Viewer by its ID
     * @param mattertagID string
     */
    deleteMattertagFromId(mattertagID) {
        this.sdk.Tag.remove(mattertagID);
        this.dictionnaryTags.delete(mattertagID);
    }
    /**
     * Deletes latest created mattertag
     */
    deleteLastMattertag() {
        const mattertagID = this.mattertagIDs.pop();
        if (mattertagID) {
            this.deleteMattertagFromId(mattertagID);
        }
    }
    /**
     * Legacy: used to be called action_add_mattertag_from_POI
     * Adds and configures Mattertag for an object (Ticket, Equipment, Feature, etc) that corresponds to POI (coordinates, tagIcon)
     * @param tagType PoiType
     * @param object Ticket, Equipment, Feature...
     * @param poi POI
     * @returns
     */
    createMattertagFromPOI(tagType, object, poi) {
        return __awaiter(this, void 0, void 0, function* () {
            // check if tag exists already
            const { tag, sweep } = this.getTagFromElementId(object.id);
            if (tag) {
                // console.log("tag exists", object)
                return;
            }
            const mattertagData = new MattertagData(tagType);
            mattertagData.setObject(object, tagType);
            if (poi.coordinate) {
                mattertagData.setPosition(JSON.parse(poi.coordinate));
            }
            if (poi.metadata) {
                const tagMetadata = JSON.parse(poi.metadata);
                if (tagMetadata.normal) {
                    mattertagData.setNormal(tagMetadata.normal);
                }
                else {
                    mattertagData.setNormal({ x: 0, y: -0.15, z: 0 });
                }
            }
            if (poi.matterportSweepID) {
                mattertagData.setSweepID(poi.matterportSweepID);
            }
            mattertagData.setPoi(poi);
            const createdTagID = yield this.addMattertagToViewer(mattertagData);
            if (createdTagID && this.sdk) {
                yield this.setTagIconAndOpacity(createdTagID, mattertagData);
                yield this.injectHtmlInTag(tagType, object, createdTagID);
            }
        });
    }
    /**
     * Inject custom HTML as Mattertag content
     * @param tagType PoiType
     * @param object Ticket, Equipment, Feature etc
     * @param tagID string
     */
    injectHtmlInTag(tagType, object, tagID) {
        return __awaiter(this, void 0, void 0, function* () {
            let html = yield this.tagService.getHtmlToInject(tagType, object);
            if (html !== '' && this.sdk) {
                const scriptTag = this.tagService.getScriptForTag(object, tagType);
                html += `${scriptTag}`;
                // create and register the sandbox
                const [sandboxId, messenger] = yield this.sdk.Tag.registerSandbox(html);
                // detach previous sandbox from a tag
                let attachmentID = this.tagsAttachments[tagID];
                if (attachmentID) {
                    this.sdk.Tag.detach(tagID, attachmentID);
                }
                this.tagsAttachments[tagID] = sandboxId;
                // attach the sandbox to a tag
                this.sdk.Tag.attach(tagID, sandboxId);
                // receive data from the sandbox
                // tagMessengerOn allows to go here only once
                if (!this.tagMessengerOn) {
                    this.tagMessengerOn = true;
                    const imageClick = (featureID) => {
                        // console.log("image click handler", featureID);
                        this.tagService.onActionImageClick(featureID);
                    };
                    const audioClick = (audioCommentID) => {
                        // console.log("audio click handler", audioCommentID);
                        this.tagService.onActionAudioClick(audioCommentID);
                    };
                    const videoClick = (url) => {
                        this.tagService.onActionVideoClick(url);
                    };
                    messenger.on(TagAction.DETAIL_CLICK, this.tagService.onActionDetailClick.bind(this.tagService));
                    messenger.on(TagAction.TICKET_CLICK, this.tagService.onActionDetailClick.bind(this.tagService));
                    messenger.on(TagAction.AUDIO_CLICK, audioClick);
                    messenger.on(TagAction.IMAGE_CLICK, imageClick);
                    messenger.on(TagAction.VIDEO_CLICK, videoClick);
                    messenger.on(TagAction.DOC_CLICK, this.tagService.onActionDocClick.bind(this.tagService));
                    messenger.on(TagAction.YOUTUBE_CLICK, this.tagService.onActionYoutubeClick.bind(this.tagService));
                }
            }
            else {
                // if html is empty (case of EMBED content), we edit billboard for Feature and attach new content
                const { comment, tagDescription } = this.tagService.getBillboardMediaToEmbed(object);
                if (comment) {
                    // register the media
                    const [attachmentID] = yield this.sdk.Tag.registerAttachment(comment.externalLink);
                    // attach
                    this.sdk.Tag.attach(tagID, attachmentID);
                    this.sdk.Tag.editBillboard(tagID, {
                        label: object.title,
                        description: tagDescription,
                    });
                }
            }
        });
    }
    action_delete_all_mattertags() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sdk.Tag.remove(...this.mattertagIDs);
            this.mattertagIDs = [];
            this.dictionnaryTags.clear();
        });
    }
    /**
     * Deletes Mattertag from visit associated with object ID (ticketID, etc)
     * @param elementID string
     */
    deleteMattertagForObject(elementID) {
        return __awaiter(this, void 0, void 0, function* () {
            const matterTagID = this.getTagFromElementId(elementID).tag;
            if (matterTagID) {
                try {
                    yield this.sdk.Tag.remove(matterTagID);
                    this.dictionnaryTags.delete(matterTagID);
                    const index = this.mattertagIDs.indexOf(matterTagID);
                    this.mattertagIDs.splice(index, 1);
                }
                catch (error) {
                    console.log('Cannot delete tag', matterTagID, error);
                }
            }
        });
    }
    /**
     * uuid from threejs
     * @param uuid
     */
    deleteObject3D(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            this.dictionnaryObjects3D.get(uuid).obj3D.visible = false;
        });
    }
    getObject3DModelNodeFromDictionnary(uuid) {
        return this.dictionnaryObjects3D.get(uuid);
    }
    /**
     * Creates  MattertagData and start repositioning (creates temporary mattertag that follows the cursor)
     * @param poiType PoiType
     * @param element Ticket, Equipment, Feature, etc
     */
    addMattertagWhenRepositioning(poiType, element) {
        return __awaiter(this, void 0, void 0, function* () {
            const mattertagData = new MattertagData(poiType);
            // set the coordinates of the existing tag
            const [poi] = element.pois.items;
            if (poi && poi.coordinate) {
                mattertagData.setPosition(JSON.parse(poi.coordinate));
                mattertagData.setPoi(poi); // to keep custom tagIcon and opacity
            }
            mattertagData.setSweepID(this.poseCamera.sweep);
            mattertagData.setRotation(this.poseCamera.rotation);
            mattertagData.setObject(element, poiType);
            this.mattertagToFollow = yield this.addMattertagToViewer(mattertagData);
            this.setInteractionMode(ViewerInteractions.POSITIONING);
            yield this.addCursorMattertag(mattertagData);
        });
    }
    /**
     * Creates MattertagData and mattertag that follows the cursor when choosing position for a new object
     * @param poiType
     */
    addMattertagWhenAdding(poiType) {
        return __awaiter(this, void 0, void 0, function* () {
            const mattertagData = new MattertagData(poiType);
            mattertagData.setSweepID(this.poseCamera.sweep);
            mattertagData.setRotation(this.poseCamera.rotation);
            this.setInteractionMode(ViewerInteractions.ADDING);
            yield this.addCursorMattertag(mattertagData);
        });
    }
    /**
     * Cancels following of cursor (meaning deleting last Mattertag)
     */
    cancelFollowingCursor() {
        this.deleteLastMattertag();
        this.setInteractionMode(ViewerInteractions.DEFAULT);
    }
    setLastObject3D(lastObject3D) {
        this.lastObject3D = lastObject3D;
    }
    getLastObject3D() {
        return this.lastObject3D;
    }
    /**
     * Performs callback after mattertag position was validated (creation of object or repositioning)
     * @param mode MattertagActionMode
     */
    callbackAfterMattertagValidation(mode) {
        this.visibilityService.detailShowing.next(true);
        const lastTag = this.getLastTag();
        switch (mode) {
            case MattertagActionMode.ADD_EQUIPMENT:
                this.goToLastTag();
                this.router.navigate([`visit/${this.currentSpaceID}/add_equip`]);
                break;
            case MattertagActionMode.ADD_TICKET:
                this.goToLastTag();
                this.router.navigate([`visit/${this.currentSpaceID}/add_ticket`]);
                break;
            case MattertagActionMode.ADD_OBJECT3D:
                this.goToLastTag();
                this.router.navigate([`visit/${this.currentSpaceID}/add_object3d`]);
                break;
            case MattertagActionMode.ADD_DATA:
                this.goToLastTag();
                let url;
                if (this.router.url.includes('?')) {
                    url = this.router.url.substring(0, this.router.url.indexOf('?'));
                }
                else {
                    url = this.router.url;
                }
                this.router.navigate([`${url}/add_feature`]);
                break;
            case MattertagActionMode.ADD_DESK:
                this.goToLastTag();
                this.router.navigate([`visit/${this.currentSpaceID}/add_feature`], {
                    queryParams: { isDesk: true },
                });
                break;
            case MattertagActionMode.ADD_ROOM:
                this.goToLastTag();
                this.router.navigate([`visit/${this.currentSpaceID}/add_room`]);
                break;
            case MattertagActionMode.POSITION_OBJECT3D:
                if (lastTag) {
                    // DO Nothing (routing), just
                    this.router.navigate([`visit/${this.currentSpaceID}/object3d/${this.lastObject3D.id}`], { queryParams: { positioning: true } });
                }
                break;
            case MattertagActionMode.POSITION_TICKET:
                if (lastTag) {
                    this.router.navigate([
                        `visit/${this.currentSpaceID}/detail/${this.dictionnaryTags.get(lastTag).elementID}`,
                    ], { queryParams: { positioning: true } });
                }
                break;
            case MattertagActionMode.POSITION_EQUIPMENT:
                if (lastTag) {
                    this.router.navigate([
                        `visit/${this.currentSpaceID}/equip/${this.dictionnaryTags.get(lastTag).elementID}`,
                    ], { queryParams: { positioning: true } });
                }
                break;
            case MattertagActionMode.POSITION_DATA:
                if (lastTag) {
                    this.router.navigate([`${this.router.url}`], {
                        queryParams: { positioning: true },
                    });
                }
                break;
            case MattertagActionMode.POSITION_ROOM:
                if (lastTag) {
                    this.router.navigate([`${this.router.url}`], {
                        queryParams: { positioning: true },
                    });
                }
                break;
            default:
                this.router.navigate([`${this.router.url}`]);
                break;
        }
    }
    /**
     * Fully updates existing Mattertag content with data of object (Ticket, Equipment, Desk)
     * @param mattertagID string
     * @param object Ticket, Equipment, Feature, Desk
     * @param poiType PoiType
     * @param poi POI
     */
    setObjectAndPoiInTag(mattertagID, object, poiType, poi = null) {
        return __awaiter(this, void 0, void 0, function* () {
            this.dictionnaryTags.get(mattertagID).setObject(object, poiType);
            if (poi) {
                this.dictionnaryTags.get(mattertagID).setPoi(poi);
            }
            this.dictionnaryTags.get(mattertagID).elementID = object.id;
            try {
                yield this.updateMatterTagContentForTagID(mattertagID, object, poiType);
                // TODO: fix this
                yield this.updateMatterTagPosInSdkViewer(mattertagID, object, poiType, poi);
            }
            catch (e) {
                console.log(`error in setObjectAndPoiInTag: ${e}`);
            }
        });
    }
    updateMatterTagPosInSdkViewer(mattertagID, object, poiType, poi = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const IndexToUpdate = object.pois.items.findIndex((u) => u.id === poi.id);
            object.pois.items[IndexToUpdate] = poi;
            const { x, y, z } = JSON.parse(poi.coordinate);
            const newPosition = {
                anchorPosition: {
                    x: x,
                    y: y,
                    z: z,
                },
                stemVector: {
                    // make the Tag stick straight up and make it 0.30 meters (~1 foot) tall
                    x: 0,
                    y: 0.3,
                    z: 0,
                },
            };
            this.sdk.Mattertag.editPosition(mattertagID, newPosition);
            this.sdk.Tag.editPosition(mattertagID, newPosition);
            this.dictionnaryTags
                .get(mattertagID)
                .setPosition(newPosition.anchorPosition);
            for (let tagId of this.mattertagIDs) {
                const currentTag = this.dictionnaryTags.get(tagId);
                if (!currentTag) {
                    continue;
                }
                if (currentTag.elementID === object.id && tagId !== mattertagID) {
                    this.dictionnaryTags.delete(tagId);
                    this.sdk.Tag.remove(tagId);
                    this.sdk.Mattertag.remove(tagId);
                    break;
                }
            }
        });
    }
    /**
     * Gets matterTagID and its sweep for an object ID (ticket ID, etc)
     * @param elementID string
     * @returns {tag: string | null, sweep: string | null}
     */
    getTagFromElementId(elementID) {
        let tagID = null;
        let sweepID = null;
        for (let [mattertagID, mattertagData] of this.dictionnaryTags) {
            if (mattertagData.elementID === elementID) {
                tagID = mattertagID;
                const sweep = mattertagData.getSweepID();
                if (sweep && this.sweeps && this.sweeps.includes(sweep)) {
                    sweepID = sweep;
                }
            }
        }
        return { tag: tagID, sweep: sweepID };
    }
    /**
     * Gets latest tag created in the visit (when following the cursor to position)
     * @returns string mattertagID
     */
    getLastTag() {
        if (this.mattertagToFollow) {
            return this.mattertagToFollow;
        }
        else {
            return this.mattertagIDs.length === 0
                ? null
                : this.mattertagIDs[this.mattertagIDs.length - 1];
        }
    }
    /**
     * Gets MattertagData for Mattertag (replaces getTagDataFromId)
     * @param mattertagID
     * @returns MattertagData
     */
    getMatterTagDataForMattertag(mattertagID) {
        try {
            return this.dictionnaryTags.get(mattertagID);
        }
        catch (_a) {
            console.log('cannot retrieve mattertagData for tag', mattertagID);
        }
        return null;
    }
    //
    // ---------- Viewer related (switch views, go to) ----------
    //
    action_toolbox_floorplan() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.inTransitionMode || this.inTransitionSweep) {
                console.log('viewer is in transition, cannot go floorplan');
                return;
            }
            try {
                yield this.sdk.Mode.moveTo('mode.floorplan');
            }
            catch (e) {
                console.log('cannot go to floorplan', e);
            }
        });
    }
    action_toolbox_inside_view() {
        this.sdk.Mode.moveTo('mode.inside');
    }
    actionShowAllFloors() {
        try {
            this.sdk.Floor.showAll();
        }
        catch (e) {
            console.log('cannot show all floors', e);
        }
    }
    action_toolbox_dollhouse() {
        return __awaiter(this, void 0, void 0, function* () {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                // console.log("mode: ", this.inTransitionMode, " sweep: ", this.inTransitionSweep);
                if (this.inTransitionMode || this.inTransitionSweep) {
                    console.log('viewer is in transition, cannot go dollhouse');
                    return;
                }
                try {
                    yield this.sdk.Mode.moveTo('mode.dollhouse');
                }
                catch (e) {
                    console.log('cannot go to dollhouse', e);
                }
            }), 1200);
        });
    }
    action_toolbox_mesure() {
        const newState = !this.isMeasureModeOn;
        this.sdk.Measurements.toggleMode(newState).then(() => {
            console.log(`Measurement mode is now ${newState ? 'enabled' : 'disabled'}`);
        });
    }
    action_toolbox_cancel_mesure() {
        if (this.isMeasureModeOn) {
            this.action_toolbox_mesure();
        }
    }
    action_go_to_floor(floorName, matterportFloorSequence = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.floors) {
                console.log('Floor are not loaded yet');
                return;
            }
            // console.log(this.floors);
            // look up for sequence number (the safest method)
            let floorMatterport = this.floors.find((floor) => floor.sequence === matterportFloorSequence);
            if (!floorMatterport) {
                floorMatterport = this.floors.find((floor) => floorName.includes(floor.name) && floor.name != '');
            }
            if (!floorMatterport) {
                floorMatterport = this.floors.find((floor) => floorName.includes(floor.id));
            }
            // console.log(floorMatterport)
            if (floorMatterport) {
                let retry = true;
                while (retry) {
                    try {
                        const floorIndex = yield this.sdk.Floor.moveTo(floorMatterport.sequence);
                        // console.log("moved to floorIndex", floorIndex);
                        retry = false;
                    }
                    catch (error) {
                        console.log('Cannot move to Floor', error);
                        yield wait(100);
                    }
                }
            }
            else {
                console.warn('No matterport floor found to move to');
            }
        });
    }
    action_go_to_sweep(sweep, rotation = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.forbiddenSweeps.includes(sweep)) {
                console.log('user is not allowed to go to this sweep');
                return;
            }
            // console.log("going to sweep", sweep, "with rotation:", rotation);
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                if (this.inTransitionMode || this.inTransitionSweep) {
                    console.log('Cannot go to sweep, in transition');
                    return;
                }
                try {
                    this.inTransitionSweep = true;
                    yield this.sdk.Sweep.moveTo(sweep, {
                        transition: 'transition.instant',
                        transitionTime: 1500,
                    });
                }
                catch (error) {
                    this.inTransitionSweep = false;
                    console.log('Cannot move to sweep', error);
                }
                if (rotation) {
                    yield this.sdk.Camera.setRotation(rotation, { speed: 100 }); // speed is degrees per second
                }
            }), 1000);
        });
    }
    getCurrentSweep() {
        if (this.poseCamera) {
            return this.poseCamera.sweep;
        }
        return null;
    }
    getCurrentCameraPosition() {
        if (this.poseCamera) {
            return this.poseCamera;
        }
        return null;
    }
    setInteractionMode(interactionMode) {
        this.interactionMode = interactionMode;
    }
    getInteractionMode() {
        return this.interactionMode;
    }
    /**
     * Clear all variables, deletes all tags (when viewer is remover or model changed=reload needed)
     */
    clearAll() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('removing viewer');
            this.action_delete_all_mattertags();
            this.floors = null;
            this.sweeps = null;
            this.sdk = null;
            clearInterval(this.timerPointer);
            this.forbiddenSweeps = [];
            this.tagMessengerOn = false;
            // cancel subscriptions
            this.pointerButton.removeEventListener('click', this.pointerLeftClickHandler);
            this.pointerButton.removeEventListener('contextmenu', this.pointerRightClickHandler);
            // TODO: only For Admins
            if (this.getCursorPositionButton) {
                this.getCursorPositionButton.removeEventListener('auxclick', this.pointerMiddleClickHandler);
            }
            // TODO: only for dev!
            if (!!this.getCursorPositionButton &&
                (document.location.href.indexOf('dev') !== -1 || document.location.href.indexOf('localhost') !== -1)) {
                clearInterval(this.intervalCursorPointerPosition);
            }
        });
    }
    removeForbiddenSweeps(forbiddenSweeps) {
        return __awaiter(this, void 0, void 0, function* () {
            this.forbiddenSweeps = [...forbiddenSweeps];
            let removed = 0;
            yield Promise.all(forbiddenSweeps.map((sweep) => __awaiter(this, void 0, void 0, function* () {
                try {
                    yield this.sdk.Sweep.disable(sweep);
                    removed += 1;
                }
                catch (error) {
                    console.log(error);
                }
            })));
            console.log('removed sweeps:', removed);
        });
    }
    //
    // ---------- 3D objects (SDK Bundle only) ----------
    //
    init3DObjectViewer() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                var [sceneObject] = yield this.sdk.Scene.createObjects(1);
                var node = sceneObject.addNode();
                // TODO change this 🤮
                node.addComponent('mp.lights');
                node.addComponent('mp.lights');
                node.addComponent('mp.lights');
                node.addComponent('mp.lights');
                node.start();
                const nodeControl = sceneObject.addNode();
                this.objectControl = nodeControl.addComponent('mp.transformControls');
                nodeControl.start();
                resolve();
            }));
        });
    }
    add3DObject(obj, mode) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const [sceneObject] = yield this.sdk.Scene.createObjects(1);
                // TODO: improvment, regroup all of these in Dynamical Objects Lib
                // SecurityCamera
                // NestThermostat
                // Video
                let isAnimatedSecurityCamera = false;
                let isNestThermostat = false;
                let isSmarterplanPromotionalVideo = false;
                /**
                 * TODO: refacto with an enum or switch/case
                 */
                if (obj.object === "security_camera") {
                    isAnimatedSecurityCamera = true;
                }
                if (obj.object === "nest_thermostat") {
                    isNestThermostat = true;
                }
                if (obj.object === 'video') {
                    isSmarterplanPromotionalVideo = true;
                }
                const modelNode = sceneObject.addNode();
                let component = null;
                const initial = {
                    url: `/assets/3Dobjects/objects/${obj.object}${obj.format.indexOf('.') === -1 ? '.' + obj.format : obj.format}`,
                    // TODO/ store localPosition && localRotation in BDD too (in order to have pertfect initial placement)
                    localRotation: { "x": 0, "y": 0, "z": 0 },
                    // TODO/ store localPosition && localRotation in BDD too (in order to have pertfect initial placement)
                    localPosition: { "x": 0, "y": 0, "z": 0 },
                    visible: true,
                    colliderEnabled: true
                };
                switch (obj.format) {
                    case '.obj':
                    case 'obj':
                        component = modelNode.addComponent('mp.objLoader', initial);
                        break;
                    case '.fbx':
                    case 'fbx':
                        component = modelNode.addComponent('mp.fbxLoader', initial);
                        break;
                    case '.gltf':
                    case 'gltf':
                        component = modelNode.addComponent('mp.gltfLoader', initial);
                        break;
                    case '.glb':
                    case 'glb':
                        component = modelNode.addComponent('mp.gltfLoader', initial);
                        break;
                    case '.dae':
                    case 'dae':
                        component = modelNode.addComponent('mp.daeLoader', initial);
                        break;
                    default:
                        console.log('Format not supported');
                        break;
                }
                // Use 3 ?! Ambient lightings
                if (this.noLightForObjects) {
                    const lightsNode = sceneObject.addNode();
                    lightsNode.addComponent('mp.ambientLight', {
                        intensity: 1,
                        color: { r: 1.0, g: 1.0, b: 1.0 },
                    });
                    this.noLightForObjects = false;
                }
                // if (obj.mode) {
                //   this.set3DObjectMode(node, obj.mode);
                // }
                modelNode.obj3D.position.set(obj.position.x, obj.position.y, obj.position.z);
                modelNode.obj3D.rotation.set(obj.rotation.x, obj.rotation.y, obj.rotation.z);
                modelNode.obj3D.scale.set(obj.scale.x, obj.scale.y, obj.scale.z);
                // By defaut, during creation, object has translation gizmo
                // => User has to click on lateral panel, and save its position after playing with it!
                if (mode && !isNestThermostat) {
                    this.attachGizmoControlTo3DObject(modelNode, sceneObject, mode, true).catch((e) => console.log(e));
                }
                if (this.lastObject3D && typeof this.lastObject3D.id === 'string') {
                    // prompt ThreeJS UUID to match our last generated object if new (not from Db)
                    modelNode.obj3D.uuid = this.lastObject3D.id;
                }
                else if (obj.id) {
                    modelNode.obj3D.uuid = obj.id;
                }
                this.lastObject3D = modelNode.obj3D;
                // Store this in memory Map dictionnary
                this.dictionnaryObjects3D.set(modelNode.obj3D.uuid, modelNode);
                this.dictionnarySceneObjects3D.set(modelNode.obj3D.uuid, sceneObject);
                if (isAnimatedSecurityCamera) {
                    const animator = modelNode.addComponent('mp.securityCamera', {
                        "nearPlane": 0.1,
                        "farPlane": 10,
                        "horizontalFOV": 52,
                        "aspect": 1.7777777777777777,
                        "localPosition": {
                            "x": 0.3,
                            "y": 0.18,
                            "z": 0
                        },
                        "localRotation": {
                            "x": -15,
                            "y": -90,
                            "z": 0
                        },
                        "color": 65280,
                        "panPeriod": 5,
                        "panAngle": -45
                    });
                    const modelOutput = sceneObject.addPath({
                        id: 'animated-model',
                        type: this.sdk.Scene.PathType.OUTPUT,
                        node: modelNode,
                        component: animator,
                        property: 'objectRoot'
                    });
                    this.securityCameraAnimator = animator;
                    if (!obj.viewFrustum) {
                        setTimeout(() => {
                            animator.toggleViewFrustum();
                        }, 1000);
                    }
                }
                if (isNestThermostat) {
                    // TODO: use bindPath instead using MP sdk classes (see Security Camera example)
                    // for TV uses CanvasImage below!
                    // const ci = new CanvasImage();
                    // ci.onInit();
                    const cv = new CanvasRenderer();
                    cv.onInit();
                    const plane = new PlaneRenderer();
                    plane.outputs = {
                        objectRoot: new Object3D(),
                        collider: new Object3D()
                    };
                    const inputTexture = cv.outputs.texture;
                    plane.setRootScene(this.threeJSScene);
                    plane.onInit(modelNode, inputTexture);
                    const sc = new NestThermostat();
                    sc.setComponent(component, plane, cv);
                    sc.setRootScene(this.threeJSScene);
                    sc.onInit(modelNode, plane, inputTexture);
                    cv.setCanvasNestThermostatPainter(sc);
                    setTimeout(() => {
                        sc.inputs.loadingState = "Loaded";
                        sc.onInputsUpdated();
                    }, 5000);
                }
                if (isSmarterplanPromotionalVideo) {
                    // TODO: use bindPath instead using MP sdk classes (see Security Camera example)
                    const sc = new TvPlayer();
                    sc.setComponent(component);
                    sc.onInit(modelNode);
                    setTimeout(() => {
                        sc.inputs.loadingState = "Loaded";
                        sc.onInputsUpdated();
                    }, 5000);
                }
                sceneObject.start();
                resolve(this.lastObject3D);
            }));
        });
    }
    getSceneNodeFromObject3DId(uuid) {
        return this.dictionnarySceneObjects3D.get(uuid);
    }
    attachGizmoControlTo3DObject(modelNode, sceneObject, mode, visible) {
        return __awaiter(this, void 0, void 0, function* () {
            // Create a scene node with a transform control component.
            let node = null;
            node = sceneObject.addNode();
            if (!node) {
                const [sceneObject] = yield this.sdk.Scene.createObjects(1);
                node = sceneObject.addNode();
            }
            const myControl = node.addComponent('mp.transformControls');
            node.start();
            //
            // // Make the transform control visible so that the user can manipulate the control selection.
            myControl.inputs.visible = visible;
            //
            // // Attach the model to the transform control
            myControl.inputs.selection = modelNode;
            //
            // // set 'translate' mode to position the selection.
            myControl.inputs.mode = mode;
            modelNode.obj3D.controls = myControl; // store gizmoCtrl inside object
            if (!this.lastObject3D || !this.lastObject3D.controls) {
                try {
                    modelNode.obj3D.uuid = this.lastObject3D.uuid || this.lastObject3D.id;
                }
                catch (e) {
                    console.log(`id obj in Scene was not assigned to id from DB since`);
                }
                this.lastObject3D = modelNode.obj3D;
            }
            return modelNode;
        });
    }
    removeGizmoFromLastObject() {
        this.lastObject3D.controls.transformControls.visible = false;
        this.lastObject3D.controls.transformControls.dispose();
        this.lastObject3D.controls = null;
    }
    toggleViewFrustum() {
        this.securityCameraAnimator.toggleViewFrustum();
    }
}
MatterportService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MatterportService, deps: [{ token: 'config' }, { token: i1$1.Router }, { token: BaseVisibilityService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
MatterportService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MatterportService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MatterportService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: Config, decorators: [{
                        type: Inject,
                        args: ['config']
                    }] }, { type: i1$1.Router }, { type: BaseVisibilityService }, { type: i0.NgZone }];
    } });

class ViewerService {
    constructor(poiService, matterportService) {
        this.poiService = poiService;
        this.matterportService = matterportService;
        this.viewerMode = 'Matterport';
        this.viewerIsOn = new Subject();
        this.dataIsLoaded = new Subject();
        this.isLoaded = false;
        this.showingViewer = false;
        this.toolboxStates = {
            dollhouse: {
                stat: false,
                iconId: 'ui-dollhouse',
                show() {
                },
                hide() {
                },
            },
            floorplan: {
                stat: false,
            },
            mesure: {
                stat: false,
                iconId: 'ui-mesure',
                show() {
                },
                hide() {
                },
            },
            filter: {
                stat: false,
            },
        };
        this.isObjectLoaded = false;
        this.setMode('Matterport');
    }
    /*-----------------------------------------------------------------------------------------------------------------
         Utils
      -----------------------------------------------------------------------------------------------------------------*/
    checkMode(indexMode) {
        return this.viewerMode === indexMode;
    }
    /*-----------------------------------------------------------------------------------------------------------------
         Setters
      -----------------------------------------------------------------------------------------------------------------*/
    setMode(indexMode) {
        this.viewerMode = indexMode;
    }
    setTourUrl(model3d, showIconPlan = true, showIconDollhouse = true, showIconFloors = true, enableQuickStart = true) {
        // this.tourUrl = `https://my.matterport.com/show/?m=${model3d}&play=1&hr=0&gt=0&title=0&log=0&brand=0&search=0&applicationKey=qn9wsasuy5h2fzrbrn1nzr0id&mds=0&newtags=1`;
        this.tourUrl = `/assets/bundle/showcase.html?m=${model3d}&play=1&hr=0&gt=0&title=0&log=0&brand=0&search=0&applicationKey=qn9wsasuy5h2fzrbrn1nzr0id&mds=0&newtags=1`;
        if (!showIconPlan) {
            this.tourUrl += '&fp=0';
        }
        if (!showIconDollhouse) {
            this.tourUrl += '&dh=0';
        }
        if (!showIconFloors) {
            this.tourUrl += '&f=0';
        }
        if (enableQuickStart) {
            this.tourUrl += '&qs=1';
        }
    }
    clearAll() {
        return __awaiter(this, void 0, void 0, function* () {
            // this.sweepToMove = null;
            // this.rotationToMove = null;
            if (this.checkMode('Matterport')) {
                this.showingViewer = false;
                this.isLoaded = false;
                yield this.matterportService.clearAll();
                this.viewerIsOn.next({
                    spaceID: null,
                    model3D: null,
                    sweep: null,
                    rotation: null,
                });
            }
        });
    }
    /*-----------------------------------------------------------------------------------------------------------------
         Getters
      -----------------------------------------------------------------------------------------------------------------*/
    getMode() {
        return this.viewerMode;
    }
    getViewerSelectedService() {
        // Matterport
        // if (this.checkMode("Matterport")) {
        //     return this.getMatterportService();
        // }
        return this.getMatterportService();
    }
    getTourUrl() {
        return this.tourUrl;
    }
    getMatterportService() {
        return this.matterportService;
    }
    /*-----------------------------------------------------------------------------------------------------------------
         Generic Main action functions
      -----------------------------------------------------------------------------------------------------------------*/
    setSweepToMove(sweep) {
        this.sweepToMove = sweep;
    }
    setRotationToMove(rotation) {
        this.rotationToMove = rotation;
    }
    action_move_to_tag(elementId) {
        return __awaiter(this, void 0, void 0, function* () {
            // Matterport
            if (this.checkMode('Matterport')) {
                const result = this.matterportService.getTagFromElementId(elementId);
                if (result.tag) {
                    yield this.matterportService.goToTag(result.tag);
                    return true;
                }
                if (result.sweep) {
                    this.sweepToMove = result.sweep;
                }
                return false;
            }
            return false;
        });
    }
    /**
     * Adds Mattertags to Viewer
     * @param objects List of objects (tickets, equipments) etc to be added as Mattertags
     */
    addObjectTagsToViewer(objects) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all(objects.map((object) => __awaiter(this, void 0, void 0, function* () {
                const poi = yield this.poiService.getPoiByElementId(object.id);
                if (poi && poi.coordinate) {
                    yield this.actionAddObjectFromPOI(object, poi);
                }
            })));
        });
    }
    actionAddObjectFromPOI(object, poi) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkMode('Matterport')) {
                return this.matterportService.createMattertagFromPOI(poi.type, object, poi);
            }
            // Cupix
            // TODO
            return Promise.resolve();
        });
    }
    action_delete_element(element) {
        return __awaiter(this, void 0, void 0, function* () {
            // Matterport
            if (this.checkMode('Matterport')) {
                yield this.matterportService.deleteMattertagForObject(element.id);
            }
        });
    }
    /**
     * Enable tag placement menu to add a new element depending on its type (TICKET, DATA, EQUIPMENT etc)
     */
    actionAddNewElementToViewer(poiType) {
        return __awaiter(this, void 0, void 0, function* () {
            this.action_toolbox_inside_view();
            // Matterport
            if (this.checkMode('Matterport') &&
                this.matterportService.getInteractionMode() === ViewerInteractions.DEFAULT) {
                yield this.matterportService.addMattertagWhenAdding(poiType);
            }
        });
    }
    /**
     * Launches the repositioning of an existing Mattertag related to parameter object
     * @param element object (TICKET, EQUIPMENT, FEATURE, etc)
     * @param poiType type of object
     */
    actionRepositionElementInViewer(element, poiType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkMode('Matterport') &&
                this.matterportService.getInteractionMode() === ViewerInteractions.DEFAULT) {
                yield this.matterportService.addMattertagWhenRepositioning(poiType, element);
            }
        });
    }
    /**
     * Enable ticket placement menu to add a new ticket
     */
    action_canceled() {
        // Matterport
        if (this.checkMode('Matterport')) {
            this.matterportService.cancelFollowingCursor();
        }
    }
    action_toolbox_inside_view() {
        // Matterport
        if (this.checkMode('Matterport')) {
            this.matterportService.action_toolbox_inside_view();
        }
    }
    actionShowAllFloors() {
        // Matterport
        if (this.checkMode('Matterport')) {
            this.matterportService.actionShowAllFloors();
        }
    }
    action_toolbox_dollhouse() {
        if (this.matterportService.getInteractionMode() !== ViewerInteractions.DEFAULT) {
            this.action_canceled();
        }
        this.action_toolbox_cancel_mesure();
        // Matterport
        if (this.checkMode('Matterport')) {
            this.matterportService.action_toolbox_dollhouse();
        }
    }
    action_floorplan() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.matterportService.getInteractionMode() !== ViewerInteractions.DEFAULT) {
                this.action_canceled();
            }
            // Matterport
            if (this.checkMode('Matterport')) {
                yield this.matterportService.action_toolbox_floorplan();
            }
        });
    }
    action_toolbox_mesure() {
        if (this.matterportService.getInteractionMode() !== ViewerInteractions.DEFAULT) {
            this.action_canceled();
        }
        this.action_toolbox_inside_view();
        // Matterport
        if (this.checkMode('Matterport')) {
            this.matterportService.action_toolbox_mesure();
        }
    }
    action_toolbox_cancel_mesure() {
        // Matterport
        if (this.checkMode('Matterport')) {
            this.matterportService.action_toolbox_cancel_mesure();
        }
    }
    action_update_poi(poi, isValid, element) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkMode('Matterport')) {
                if (isValid) {
                    const lastTag = this.matterportService.mattertagToFollow
                        ? this.matterportService.mattertagToFollow
                        : this.matterportService.getLastTag();
                    if (!lastTag) {
                        return Promise.resolve(poi);
                    }
                    const tagData = this.matterportService.getMatterTagDataForMattertag(lastTag);
                    if (!tagData) {
                        return Promise.resolve(poi);
                    }
                    const poiMetadata = (!!poi && poi.metadata) ? JSON.parse(poi.metadata) : {};
                    poiMetadata.normal = tagData.getNormal();
                    if (!poi) {
                        return Promise.resolve({});
                    }
                    const poiInput = {
                        id: poi.id,
                        coordinate: tagData.getCoordinateString(),
                        matterportSweepID: tagData.getSweepID(),
                        metadata: JSON.stringify(poiMetadata),
                    };
                    const updatedPoi = yield this.poiService.updatePoi(poiInput);
                    tagData.setPoi(updatedPoi);
                    yield this.matterportService.setObjectAndPoiInTag(lastTag, element, PoiType.DESK, updatedPoi);
                    yield this.matterportService.injectHtmlInTag(poi.type, element, lastTag);
                    yield this.matterportService.setTagIconAndOpacity(lastTag, tagData);
                    this.matterportService.goToTag(lastTag);
                    return Promise.resolve(updatedPoi);
                }
                this.matterportService.deleteLastMattertag();
                return Promise.resolve(poi);
            }
            return Promise.resolve(poi);
        });
    }
    editOnlyTagStyleForPoi(poi, object) {
        if (this.checkMode('Matterport')) {
            const tagData = this.matterportService.getTagFromElementId(poi.elementID);
            if (tagData.tag) {
                const mattertagData = this.matterportService.getMatterTagDataForMattertag(tagData.tag);
                mattertagData.setObject(object, PoiType.ROOM);
                this.matterportService.setTagIconAndOpacity(tagData.tag, mattertagData);
            }
        }
    }
    addIconAndSetForPoi(poi, iconPath) {
        if (this.checkMode('Matterport')) {
            const tagData = this.matterportService.getTagFromElementId(poi.elementID);
            if (tagData.tag) {
                this.matterportService.addNewIconAndSetForTag(tagData.tag, iconPath);
            }
        }
    }
    changeToRegistredIconForPoi(poi, iconName) {
        if (this.checkMode('Matterport')) {
            const tagData = this.matterportService.getTagFromElementId(poi.elementID);
            if (tagData.tag) {
                this.matterportService.setRegistredIconForTag(tagData.tag, iconName);
            }
        }
    }
    updateHtmlTagForPoiWithObject(poi, object) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkMode('Matterport')) {
                const tagData = this.matterportService.getTagFromElementId(poi.elementID);
                if (tagData.tag) {
                    yield this.matterportService.updateInjectedHtmlForTagID(tagData.tag, object, poi.type);
                }
            }
        });
    }
    /**
     * Move an existing poi in Matterport
     * @param poi
     * @param element
     */
    action_move_poi_visually(poi, element) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.action_delete_element(element);
            yield this.actionAddObjectFromPOI(element, poi);
        });
    }
    /*-----------------------------------------------------------------------------------------------------------------
      Cupix
   -----------------------------------------------------------------------------------------------------------------*/
    /*-----------------------------------------------------------------------------------------------------------------
      Matterport
      https://matterport.github.io/showcase-sdk/docs/sdk/reference/current/modules/mattertag.html#add
      https://matterport.github.io/showcase-sdk/docs/sdk/reference/current/modules/mattertag.html#remove
  -----------------------------------------------------------------------------------------------------------------*/
    initMatterportSdk(spaceID, model3D, tagService, module = SpModule.IMMO) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isLoaded = false;
            this.matterportService.currentSpaceID = spaceID;
            if (this.matterportService.sdk) {
                yield this.clearAll();
            }
            return this.matterportService
                .initSdk(tagService, module)
                .then((result) => __awaiter(this, void 0, void 0, function* () {
                if (result) {
                    const { sdk } = this.matterportService;
                    // TODO: add condition whether we want to enable it or not
                    // Additionnal extensions for Matterport
                    // 1. Security Camera with Frustum (FOV)
                    // 2. TODO register all new Matterport extensions here (nestSensor, lods, slots, ...)
                    yield Promise.all([
                        sdk.Scene.register(securityCameraType, makeSecurityCamera.bind(sdk.Scene)),
                        sdk.Scene.register(ViewFrustumMeshType, makeViewFrustumMesh.bind(sdk.Scene))
                    ]);
                    sdk.App.state.subscribe(function (appState) {
                        // app state has changed
                        // console.log('The current phase: ', appState.phase);
                        if (appState.phase === sdk.App.Phase.PLAYING) {
                            // console.log('The app is playing');
                            this.showingViewer = true;
                            this.viewerIsOn.next({
                                spaceID,
                                model3D,
                                sweep: this.sweepToMove,
                                rotation: this.rotationToMove,
                            });
                            this.dataIsLoaded.next(true);
                            this.isLoaded = true;
                            this.sweepToMove = null;
                            this.rotationToMove = null;
                        }
                    }.bind(this));
                    return Promise.resolve();
                }
                return Promise.reject();
            }));
        });
    }
    removeForbiddenSweeps(forbiddenSweeps) {
        if (this.checkMode('Matterport')) {
            this.matterportService.removeForbiddenSweeps(forbiddenSweeps);
        }
    }
    setObject3DLoadedInPosition(objectLoaded) {
        this.isObjectLoaded = objectLoaded;
    }
    isObject3DLoadedInPosition() {
        return this.isObjectLoaded;
    }
}
ViewerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ViewerService, deps: [{ token: PoiService }, { token: MatterportService }], target: i0.ɵɵFactoryTarget.Injectable });
ViewerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ViewerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ViewerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PoiService }, { type: MatterportService }]; } });

class ModalSwitchVisitComponent {
    constructor(activeModal, router, viewerService) {
        this.activeModal = activeModal;
        this.router = router;
        this.viewerService = viewerService;
    }
    ngOnInit() { }
    switchVisit() {
        this.activeModal.close();
        if (this.dataToMove) {
            this.viewerService.setSweepToMove(this.dataToMove.sweepToMove);
            this.viewerService.setRotationToMove(this.dataToMove.rotation);
        }
        // this.objectSubService.forceRemove = true; // we reset the tags when changing visit
        this.router.navigate(["visit", this.spaceID], {
            queryParams: { model3D: this.model3D },
        });
    }
}
ModalSwitchVisitComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ModalSwitchVisitComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: i1$1.Router }, { token: ViewerService }], target: i0.ɵɵFactoryTarget.Component });
ModalSwitchVisitComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: ModalSwitchVisitComponent, selector: "lib-modal-switch-visit", inputs: { content: "content", model3D: "model3D", spaceID: "spaceID", dataToMove: "dataToMove" }, ngImport: i0, template: "<div class=\"modal-container\">\n    <p>{{content}}</p>\n    <button class=\"btn btn-outline-primary rounded-pill\" (click)=\"switchVisit()\">{{'Yes, switch visit' | translate }}</button>\n    <button class=\"btn btn-outline-primary rounded-pill\"(click)=\"activeModal.close()\">{{'No, stay here' | translate }}</button>\n</div>\n", styles: [".modal-container{margin:10px}button{margin-right:8px}\n"], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ModalSwitchVisitComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-modal-switch-visit', template: "<div class=\"modal-container\">\n    <p>{{content}}</p>\n    <button class=\"btn btn-outline-primary rounded-pill\" (click)=\"switchVisit()\">{{'Yes, switch visit' | translate }}</button>\n    <button class=\"btn btn-outline-primary rounded-pill\"(click)=\"activeModal.close()\">{{'No, stay here' | translate }}</button>\n</div>\n", styles: [".modal-container{margin:10px}button{margin-right:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: i1$1.Router }, { type: ViewerService }]; }, propDecorators: { content: [{
                type: Input
            }], model3D: [{
                type: Input
            }], spaceID: [{
                type: Input
            }], dataToMove: [{
                type: Input
            }] } });

const deleteFromS3 = (path) => __awaiter(void 0, void 0, void 0, function* () {
    yield Storage.remove(path, { level: "public" })
        .then((result) => console.log("Successfully deleted =>", result))
        .catch((error) => console.log("Deleting from S3 error:", error));
});
const uploadFileToS3 = (path, file, objectId) => __awaiter(void 0, void 0, void 0, function* () {
    const prefix = objectId ? `${objectId.slice(0, 8)}_` : "";
    return Storage.put(path + prefix + file.name, file, {
        progressCallback(progress) {
            // console.log('Uploaded : ', progress);
        },
        contentType: file.type,
    })
        .then((result) => {
        console.log("Success =>", result);
        return result.key;
    })
        .catch((error) => {
        console.log("error =>", error);
        return null;
    });
});
const getSignedImageUrlForEquipment = (equip) => __awaiter(void 0, void 0, void 0, function* () {
    if (!equip.photo) {
        return Promise.resolve(null);
    }
    return Storage.get(equip.photo, { level: "public" })
        .then((result) => {
        return result;
    })
        .catch((error) => {
        console.log("error fetching file from s3 =>", error);
        return null;
    });
});
const getSignedImageUrlForProfile = (profile) => __awaiter(void 0, void 0, void 0, function* () {
    return Storage.get(profile.avatar, { level: "public" })
        .then((result) => {
        return result;
    })
        .catch((error) => {
        console.log("error fetching file from s3 =>", error);
    });
});
const getSignedImageUrlForSpace = (space) => __awaiter(void 0, void 0, void 0, function* () {
    return Storage.get(space.annexes, { level: "public" })
        .then((result) => {
        return result;
    })
        .catch((error) => {
        console.log("error fetching file from s3 =>", error);
    });
});
const uploadBase64Image = (uri, objectId, path, friendlyFileName) => __awaiter(void 0, void 0, void 0, function* () {
    return fetch(uri)
        .then((res) => res.blob())
        .then((blob) => {
        const file = new File([blob], `${friendlyFileName}.jpeg`, {
            type: "image/jpeg",
        });
        return uploadFileToS3(path, file, objectId);
    });
});
const removeAllFilesFromFolderS3 = (folderPath) => __awaiter(void 0, void 0, void 0, function* () {
    const arrayOfPromises = [];
    Storage.list(folderPath, { level: "public" })
        .then((res) => {
        Object.keys(res).map((key) => __awaiter(void 0, void 0, void 0, function* () {
            const file = res[key];
            arrayOfPromises.push(deleteFromS3(file.key));
        }));
    })
        .catch((error) => console.error("List failure", error));
    return Promise.all(arrayOfPromises);
});
const listFilesInFolder = (folderPath) => __awaiter(void 0, void 0, void 0, function* () {
    return Storage.list(folderPath, { level: "public", pageSize: 'ALL' })
        .then((res) => {
        return res.results;
    })
        .catch((error) => console.error("List failure", error));
});
const getSignedFile = (path) => __awaiter(void 0, void 0, void 0, function* () {
    return Storage.get(path, { level: "public" })
        .then((result) => {
        return result;
    })
        .catch((error) => {
        console.log("error fetching file from s3 =>", error);
        return null;
    });
});
const downloadFileAsObject = (path) => __awaiter(void 0, void 0, void 0, function* () {
    return Storage.get(path, { download: true, level: "public" })
        .then((result) => {
        return result;
    })
        .catch((error) => {
        console.log("error fetching file from s3 =>", error);
    });
});
const getBufferForFileFromS3 = (path) => __awaiter(void 0, void 0, void 0, function* () {
    const object = yield downloadFileAsObject(path);
    if (object) {
        // @ts-ignore
        return new ArrayBuffer(object.Body, "binary");
    }
    return null;
});
const uploadJsonToS3 = (path, json, filename) => __awaiter(void 0, void 0, void 0, function* () {
    return Storage.put(path + filename, json, {
        contentType: "application/json",
    })
        .then((result) => {
        console.log("Success =>", result);
        return result.key;
    })
        .catch((error) => {
        console.log("error =>", error);
        return null;
    });
});

function getDistanceBetweenTwoPoints(startPoint, endPoint) {
    const dx = endPoint.x - startPoint.x;
    const dy = endPoint.y - startPoint.y;
    const dz = endPoint.z - startPoint.z;
    const distance = Math.sqrt(dx * dx + dy * dy + dz * dz);
    return Math.round(distance * 100) / 100;
}
function poiTypeToString(type) {
    switch (type) {
        case PoiType.EQUIPMENT:
            return "equipment";
        case PoiType.TICKET:
            return "ticket";
        case PoiType.DATA:
            return "data";
        case PoiType.DESK:
            return "data";
        case PoiType.INFORMATION:
            return "information";
        case PoiType.MEASURE:
            return "measure";
        case PoiType.PEOPLE:
            return "people";
        default:
            return "ticket";
    }
}
function wait(timeout) {
    return new Promise((resolve) => {
        timeout = timeout || 2000;
        setTimeout(() => {
            resolve();
        }, timeout);
    });
}
const waitUntil = (condition) => {
    return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            if (condition()) {
                clearInterval(intervalId);
                resolve();
            }
        }, 30);
    });
};
function enumToArray(enumerable) {
    return Object.keys(enumerable)
        .filter((value) => isNaN(Number(value)) === true)
        .map((key) => enumerable[key]);
}
function getLevelsBelow(level) {
    const all = [
        LevelStatus.MINIMUM,
        LevelStatus.LOW,
        LevelStatus.MEDIUM,
        LevelStatus.HIGH,
        LevelStatus.MAXIMUM,
    ];
    switch (level) {
        case LevelStatus.MAXIMUM:
            return all;
        case LevelStatus.HIGH:
            all.splice(4, 1);
            return all;
        case LevelStatus.MEDIUM:
            all.splice(3, 2);
            return all;
        case LevelStatus.LOW:
            return [LevelStatus.MINIMUM, LevelStatus.LOW];
        case LevelStatus.MINIMUM:
            return [LevelStatus.MINIMUM];
        default:
            return [LevelStatus.MINIMUM];
    }
}
function getHighestLevelForMissions(missions) {
    let latestVisibleLevels = [LevelStatus.MINIMUM];
    for (const m of missions) {
        const visibleLevels = getLevelsBelow(m.level);
        if (visibleLevels.length > latestVisibleLevels.length) {
            latestVisibleLevels = visibleLevels;
        }
    }
    switch (latestVisibleLevels.length) {
        case 1:
            return LevelStatus.MINIMUM;
        case 2:
            return LevelStatus.LOW;
        case 3:
            return LevelStatus.MEDIUM;
        case 4:
            return LevelStatus.HIGH;
        case 5:
            return LevelStatus.MAXIMUM;
        default:
            return LevelStatus.MINIMUM;
    }
}
function getHighestRoleForMissions(missions) {
    let highestRole = RoleStatus.VISITOR;
    for (const m of missions) {
        if (m.role === RoleStatus.ADMIN) {
            return RoleStatus.ADMIN;
        }
        if (highestRole === RoleStatus.OWNER) {
            continue;
        }
        if (m.role === RoleStatus.OWNER) {
            highestRole = RoleStatus.OWNER;
        }
        if (m.role === RoleStatus.MANAGER) {
            highestRole = RoleStatus.MANAGER;
        }
        if (m.role === RoleStatus.SERVICE &&
            highestRole !== RoleStatus.MANAGER) {
            highestRole = RoleStatus.SERVICE;
        }
        if (m.role === RoleStatus.OCCUPANT &&
            highestRole === RoleStatus.VISITOR) {
            highestRole = RoleStatus.OCCUPANT;
        }
        if (m.role === RoleStatus.GUIDE_MUSEUM) {
            highestRole = RoleStatus.GUIDE_MUSEUM;
        }
        if (m.role === RoleStatus.VISITOR_MUSEUM) {
            highestRole = RoleStatus.VISITOR_MUSEUM;
        }
    }
    return highestRole;
}
function getRolesBelowForManager(role) {
    const all = [
        RoleStatus.VISITOR,
        RoleStatus.OCCUPANT,
        RoleStatus.SERVICE,
        RoleStatus.MANAGER,
        RoleStatus.OWNER,
        RoleStatus.ADMIN,
    ];
    const museum = [RoleStatus.VISITOR_MUSEUM, RoleStatus.GUIDE_MUSEUM];
    switch (role) {
        case RoleStatus.ADMIN:
            return [...all, ...museum];
        case RoleStatus.OWNER:
            all.splice(5, 1);
            return all;
        case RoleStatus.MANAGER:
            all.splice(4, 2);
            return all;
        case RoleStatus.GUIDE_MUSEUM:
            return museum;
        default:
            return all.splice(4, 2);
    }
}
function filterUniqueArrayByID(arrayOfObjects) {
    return arrayOfObjects.filter((v, index, a) => a.findIndex((t) => t.id === v.id) === index);
}
function removeNullKeysFromObject(object) {
    for (const key of Object.keys(object)) {
        if (object[key] === null) {
            delete object[key];
        }
    }
}
/**
 * Test if a date has expired
 * @param date
 * @returns true if the date has expired, false otherwise
 */
function dateHasExpired(date) {
    if (date) {
        return new Date(date) <= new Date();
    }
    return false;
}
function stringLocaleToEnum(locale) {
    switch (locale) {
        case "en":
            return Locale.EN;
        case "fr":
            return Locale.FR;
        default:
            return Locale.EN;
    }
}
function getMetaForImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.addEventListener("load", () => {
            resolve(img);
        });
        img.addEventListener("error", () => reject());
        img.src = url;
    });
}
function sortAlphabeticallyOnName(array) {
    return array.sort((a, b) => a.name.localeCompare(b.name));
}
function validEmail(email) {
    const re = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/;
    return re.test(email);
}
function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
        setTimeout(() => {
            URL.revokeObjectURL(url);
            a.removeEventListener("click", clickHandler);
        }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    return a;
}
/*
    Open modal if one has to switch virtual visit
*/
function openModalForVisitSwitch(modalService, model3D, spaceID, dataToMove = null) {
    const modalReference = modalService.open(ModalSwitchVisitComponent);
    modalReference.componentInstance.content =
        "This object belongs to another 3D visit. Are you sure you want to switch the visit?";
    modalReference.componentInstance.model3D = model3D;
    modalReference.componentInstance.spaceID = spaceID;
    if (dataToMove) {
        modalReference.componentInstance.dataToMove = dataToMove;
    }
}
/**
 * Return a string of a given date time in local format.
 * The format is determined by the current language.
 */
function dateTimeToLocalString(date, translate, mode) {
    let lang = "en-EN";
    if (translate) {
        /** Get current language */
        lang = translate.currentLang
            ? translate.currentLang
            : translate.defaultLang;
        /** Transforme '_fr' to 'fr' */
        if (lang) {
            lang = lang.slice(1);
        }
    }
    let options;
    switch (mode) {
        case "day_numeric":
            options = { day: "numeric" };
            break;
        case "day":
            options = { weekday: "long" };
            break;
        case "date":
            options = { dateStyle: "long" };
            break;
        case "short_date_time":
            options = {
                year: "2-digit",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            };
            break;
        case "time":
            options = { hour: "numeric", minute: "numeric" };
            break;
        case "day_time_zone":
            options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                timeZoneName: "shortOffset",
            };
            break;
        default:
            options = {
                dateStyle: "long",
                timeStyle: "short",
            };
    }
    return new Date(date).toLocaleString(lang, options);
}
/**
 * Compares two string arrays
 * @param array1
 * @param array2
 * @returns
 */
function arraysContainSameElements(array1, array2) {
    array1.sort();
    array2.sort();
    return JSON.stringify(array1) === JSON.stringify(array2);
}
function getVisitUrl(currentUrl) {
    const path = currentUrl.split("/");
    path.splice(3, path.length - 2);
    return path.join("/");
}
/**
 * Extract spaceID from url when in visit 3D
 */
function getSpaceIDFromUrl(url) {
    const visitUrl = getVisitUrl(url);
    return visitUrl.split("/")[2];
}
function downloadFile(fileUrl, fileName) {
    FileSaver.saveAs(fileUrl + fileName, fileName);
}
function openDocument(fileUrl, fileName, id) {
    window.open(`${fileUrl + fileName}#doc=${id}`, "_blank", "");
}
const downloadEquipmentDocument = (document_) => __awaiter(void 0, void 0, void 0, function* () {
    const signedFile = yield downloadFileAsObject(document_.url);
    if (signedFile) {
        // @ts-ignore
        downloadBlob(signedFile.Body, document_.filename);
    }
});
function checkElementById(selector) {
    return __awaiter(this, void 0, void 0, function* () {
        let querySelector = null;
        while (querySelector === null) {
            yield rafAsync();
            querySelector = document.getElementById(selector);
        }
        return querySelector;
    });
}
function rafAsync() {
    return new Promise((resolve) => {
        requestAnimationFrame(resolve); // faster than set time out
    });
}
/* @param {Array} numbers An array of numbers.
 * @return {Number} The calculated average (or mean) value from the specified
 *     numbers.
 */
function mean(numbers) {
    let total = 0;
    for (const number of numbers) {
        total += number;
    }
    return total / numbers.length;
}
function convertTimestampToLocalZone(timestamp) {
    const selectedDate = new Date(timestamp);
    const localOffset = -1 * selectedDate.getTimezoneOffset() * 60000;
    const stamp = timestamp + localOffset;
    return stamp;
}
/**
 * Return string for period of time. Parameters are DateTime objects of luxon library.
 */
function translateDatePeriod(translateService, dateStartPeriod, dateEndPeriod) {
    const locale = getLocaleLong(translateService);
    return `${dateStartPeriod.toLocaleString({
        locale,
        month: "long",
        day: "2-digit",
    })} - ${dateEndPeriod.toLocaleString({
        locale,
        month: "long",
        day: "2-digit",
    })} `;
}
/**
* Return local in the canonical form: "en-GB", "fr-FR"
*/
function getLocaleLong(translate) {
    let lang = translate.currentLang
        ? translate.currentLang
        : translate.defaultLang;
    /** Transform '_fr' to 'fr' */
    lang = lang.slice(1);
    if (lang === "en") {
        return "en-GB";
    }
    return `${lang}-${lang.toUpperCase()}`;
}
/**
 * Return local in the short form: "en", "fr"
 */
function getLocaleShort(translate) {
    let lang = translate.currentLang
        ? translate.currentLang
        : translate.defaultLang;
    /** Transform '_fr' to 'fr' */
    lang = lang.slice(1);
    return lang;
}
/**
 * Format string to lowercase, no spaces
 */
function stringToLowercaseNoSpaces(input) {
    const words = input.toLowerCase().split(/\s+/);
    return words.join("");
}
/**
 * Test if the object === {}
 * @param obj object {key:value}
 * @returns boolean
 */
function isEmptyObject(object) {
    for (const x in object) {
        return false;
    }
    return true;
}
function shuffleArray(array) {
    const newArray = [...array];
    for (let index = array.length - 1; index > 0; index--) {
        const indexNew = Math.floor(Math.random() * (index + 1));
        // eslint-disable-next-line no-param-reassign
        [newArray[index], newArray[indexNew]] = [
            newArray[indexNew],
            newArray[index],
        ];
    }
    return newArray;
}
function numberToDateString(timestamp) {
    const jsDate = new Date(timestamp);
    return jsDate.toLocaleString("fr-FR");
}
function durationToString(duration, translate) {
    const days = Math.floor(duration / 3600 / 24);
    const hours = Math.floor((duration - days * 24 * 3600) / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = Math.floor(duration % 60);
    const daysString = translate.instant("day(s)");
    const hoursString = translate.instant("hour(s)");
    const oneHourString = translate.instant("hour");
    const minutesString = translate.instant("minute(s)");
    const secondsString = translate.instant("second(s)");
    if (duration > 3600 * 24 * 7) {
        return `${days} ${daysString}`;
    }
    if (duration > 3600 * 24) {
        return `${days} ${daysString} ${hours} ${hoursString}`;
    }
    if (duration === 3600) {
        return `${hours} ${oneHourString}`;
    }
    if (duration > 3600) {
        if (minutes === 0) {
            return `${hours} ${hoursString}`;
        }
        return `${hours} ${hoursString} ${minutes} ${minutesString}`;
    }
    if (duration >= 60) {
        if (seconds === 0) {
            return `${minutes} ${minutesString}`;
        }
        return `${minutes} ${minutesString} ${seconds} ${secondsString}`;
    }
    return `${seconds} ${secondsString}`;
}

class ZoneService {
    constructor(apiInjected, userService) {
        this.userService = userService;
        this.API = apiInjected;
    }
    getZonesBySpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const list = [];
            if (this.API.__proto__.hasOwnProperty('ZonesBySpace')) {
                const zones = yield this.API.__proto__.ZonesBySpace(spaceID);
                if (zones) {
                    for (const zone of zones.items) {
                        const zoneObject = Object.assign({}, zone);
                        zoneObject.virtual = this.zoneIsVirtual(zone);
                        list.push(zoneObject);
                    }
                }
                return list;
            }
            else {
                throw new Error('ZonesBySpace not implemented');
            }
        });
    }
    getZonesBySpaceForUser(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const missionForLocation = this.userService.currentMission(spaceID);
            const list = [];
            if (missionForLocation && missionForLocation.zoneID) {
                const allowedZone = yield this.getZone(missionForLocation.zoneID);
                allowedZone.virtual = this.zoneIsVirtual(allowedZone);
                if (!allowedZone.parent) {
                    // the whole building is authorized
                    return this.getZonesBySpace(spaceID);
                }
                list.push(allowedZone);
                // allow all children zones of an allowed parent
                const children = (yield this.API.__proto__.ZonesByZone(allowedZone.id))
                    .items;
                if (children.length > 0) {
                    for (const child of children) {
                        const childZone = Object.assign({}, child);
                        childZone.virtual = this.zoneIsVirtual(child);
                        list.push(childZone);
                    }
                }
                // allow the parent Floor of the allowed zone
                if (allowedZone.parent.layer &&
                    allowedZone.parent.layer.name === 'FLOOR') {
                    list.push(allowedZone.parent);
                }
            }
            else {
                return this.getZonesBySpace(spaceID);
            }
            return list;
        });
    }
    filterZonesIDsForUser(zones) {
        return __awaiter(this, void 0, void 0, function* () {
            const { spaceID } = zones[0];
            const zoneIDs = new Set(zones.map((zone) => zone.id));
            const allowedZones = yield this.getZonesBySpaceForUser(spaceID);
            const filteredZones = allowedZones.filter((zone) => zoneIDs.has(zone.id));
            return filteredZones;
        });
    }
    deleteZone(zoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteZone({ id: zoneID });
        });
    }
    getZonesForSweepForSpace(sweepID, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const zonesSpace = (yield this.API.__proto__.ZonesBySpace(spaceID)).items;
            return zonesSpace.filter((zone) => zone.sweepIDs && zone.sweepIDs.includes(sweepID));
        });
    }
    // // eslint-disable-next-line class-methods-use-this
    sortZonesFromChildToParent(zonesToSort) {
        // get default
        const defaultZone = zonesToSort.find((z) => !z.parentID);
        if (defaultZone) {
            const indexOf = zonesToSort.indexOf(defaultZone);
            zonesToSort.splice(indexOf, 1);
        }
        const zones = zonesToSort.sort((a, b) => {
            if (a.parentID === b.id) {
                return -1;
            }
            return 0;
        });
        // so far by number of navigation points in them
        // const zones = zonesToSort.sort(
        //     (a, b) => a.navigations.items.length - b.navigations.items.length,
        // );
        if (defaultZone) {
            zones.push(defaultZone);
        }
        return zones;
    }
    getZonesForObject(object) {
        return __awaiter(this, void 0, void 0, function* () {
            if (object.pois.items && object.pois.items.length > 0) {
                const [poi] = object.pois.items;
                if (poi.matterportSweepID) {
                    const zones = yield this.getZonesForSweepForSpace(poi.matterportSweepID, object.spaceID);
                    return zones;
                }
            }
            return null;
        });
    }
    createVirtualZone(zoneInput) {
        return __awaiter(this, void 0, void 0, function* () {
            zoneInput.sweepIDs = [];
            const zone = yield this.API.__proto__.CreateZone(zoneInput);
            console.log('virtual zone created', zone);
            return zone;
        });
    }
    zoneIsVirtual(zone) {
        if (!zone.sweepIDs) {
            return true;
        }
        if ((zone.tags && zone.tags.includes('virtual')) ||
            zone.sweepIDs.length === 0) {
            return true;
        }
        return false;
    }
    getModel3DForZone(zoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            const zone = yield this.API.__proto__.GetZone(zoneID);
            if (zone.nodeIDs) {
                const node = yield this.API.__proto__.GetNode(zone.nodeIDs[0]);
                return node.model3D;
            }
            return null;
        });
    }
    getZone(zoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetZone(zoneID);
        });
    }
    getDefaultZoneForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getZonesBySpace(spaceID).then((zones) => __awaiter(this, void 0, void 0, function* () {
                const zonesBuilding = zones.filter((zone) => zone.layer && zone.layer.name === 'BUILDING');
                if (zonesBuilding.length === 1) {
                    return zonesBuilding[0];
                }
                const parentZone = zones.find((zone) => !zone.parentID);
                return parentZone;
            }));
        });
    }
    create(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateZone(input);
        });
    }
    // async getSortedZonesForSweepForUser(
    //     sweep: string,
    //     spaceID: string,
    // ): Promise<Zone[]> {
    //     if (!spaceID) {
    //         return [];
    //     }
    //     const zones = await this.getZonesForSweepForSpace(sweep, spaceID);
    //     if (zones.length === 0) {
    //         return [];
    //     }
    //     const filteredZones = await this.filterZonesIDsForUser(zones);
    //     if (filteredZones.length > 0) {
    //         let zonesSorted = this.sortZonesFromChildToParent(filteredZones);
    //         zonesSorted = zonesSorted.filter((zone) => zone !== undefined);
    //         return zonesSorted;
    //     }
    //     return [];
    // }
    updateZone(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateZone(input);
        });
    }
    getZonesForNodeForSpace(nodeID, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ZonesBySpace(spaceID).then((zones) => __awaiter(this, void 0, void 0, function* () {
                const filteredZones = zones.items.filter((zone) => zone.nodeIDs && zone.nodeIDs.includes(nodeID));
                return filteredZones;
            }));
        });
    }
    /**
     * Gets the Zone (layer FLOOR) for a matterport sweep ID in a given Space
     * @param sweepID
     * @param spaceID
     * @returns Zone
     */
    getFloorZoneForSweepInSpace(sweepID, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const zones = yield this.getZonesForSweepForSpace(sweepID, spaceID);
            const floors = zones.filter((zone) => zone.layer && zone.layer.name.includes('FLOOR'));
            return floors.length > 0 ? floors[0] : null;
        });
    }
    /**
     * Get zones with audio track for entire space
     * @param spaceID
     * @returns  Promise<Zone[]>
     */
    getAudioZonesForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const allZones = yield this.getZonesBySpace(spaceID);
            return allZones.filter((zone) => zone.audioID);
        });
    }
    /**
     * Get audio zones for user (within allowed zones)
     * @param spaceID
     * @returns  Promise<Zone[]>
     */
    getAudioZonesForUserForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const userZones = yield this.getZonesBySpaceForUser(spaceID);
            return userZones.filter((zone) => zone.audioID);
        });
    }
    /**
     * Get Zones by Parent Zone ID
     * @param parentZoneID string
     * @returns Promise<Zone[]>
     */
    getZonesByParentZone(parentZoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .ZonesByZone(parentZoneID)
                .then((res) => res.items);
        });
    }
}
ZoneService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ZoneService, deps: [{ token: 'currentAPIService' }, { token: BaseUserService }], target: i0.ɵɵFactoryTarget.Injectable });
ZoneService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ZoneService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ZoneService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: BaseUserService }];
    } });

var FilterType;
(function (FilterType) {
    FilterType["DOMAIN"] = "DOMAIN";
    FilterType["LEVEL"] = "LEVEL";
    FilterType["ROLE"] = "ROLE";
    FilterType["ZONE"] = "ZONE";
    FilterType["SPACE"] = "SPACE";
    FilterType["HASHTAG"] = "HASHTAG";
})(FilterType || (FilterType = {}));
class FilterService {
    constructor(userService, zoneService, poiService) {
        this.userService = userService;
        this.zoneService = zoneService;
        this.poiService = poiService;
        this.updateDateFilter = new Subject();
    }
    filterTicketsByDomain(ticketsToFilter, domain) {
        return ticketsToFilter.filter((tic) => tic.domainID === domain);
    }
    filterObjectsByLevel(objectsToFilter, level) {
        const visibleLevels = getLevelsBelow(level);
        const filtered = objectsToFilter.filter((tic) => visibleLevels.includes(tic.level));
        return filtered;
    }
    filterTicketsForMission(ticketsToFilter, mission) {
        const managerRoles = [
            RoleStatus.MANAGER,
            RoleStatus.ADMIN,
            RoleStatus.OWNER,
        ];
        if (!managerRoles.includes(mission.role)) {
            if (mission.role === RoleStatus.SERVICE) {
                // SERVICE can see tickets to which he is assigned
                const ticketsAssigned = [];
                for (const t of ticketsToFilter) {
                    if (t.assignees.items.length > 0) {
                        for (const assignment of t.assignees.items) {
                            if (assignment.missionID === mission.id) {
                                ticketsAssigned.push(t);
                            }
                        }
                    }
                }
                return ticketsAssigned;
            }
            // OCCUPANT and VISITOR can see only tickets that they created
            return ticketsToFilter.filter((ticket) => {
                return ticket.ownerMissionID === mission.id;
            });
        }
        return ticketsToFilter;
    }
    getFiltersForRole(role) {
        switch (role) {
            case RoleStatus.ADMIN:
                return [FilterType.LEVEL];
            case RoleStatus.MANAGER:
                return [FilterType.ZONE, FilterType.LEVEL];
            case RoleStatus.OWNER:
                return [FilterType.ZONE, FilterType.LEVEL];
            case RoleStatus.SERVICE:
                return [
                    FilterType.ZONE,
                    FilterType.LEVEL,
                    FilterType.DOMAIN,
                    FilterType.ROLE, // that is the most severe filter
                ];
            case RoleStatus.OCCUPANT:
                return [
                    FilterType.ZONE,
                    FilterType.DOMAIN,
                    FilterType.ROLE,
                    FilterType.LEVEL,
                    FilterType.HASHTAG,
                ];
            case RoleStatus.VISITOR:
                return [
                    FilterType.ZONE,
                    FilterType.LEVEL,
                    FilterType.DOMAIN,
                    FilterType.ROLE,
                    FilterType.HASHTAG,
                ];
            case RoleStatus.VISITOR_MUSEUM:
                return [FilterType.ZONE, FilterType.LEVEL, FilterType.HASHTAG];
            case RoleStatus.GUIDE_MUSEUM:
                return [FilterType.LEVEL];
            default:
                return [FilterType.LEVEL];
        }
    }
    filterObjectsForCurrentUserInSpace(objects, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalObject3Ds = [];
            let domFiltered = objects;
            let levelFiltered = objects;
            let zoneFiltered = objects;
            const missions = this.userService.currentMissions;
            if (missions) {
                const currentSpaceMissions = missions.filter((m) => m.spaceID === spaceID);
                if (currentSpaceMissions.length > 0) {
                    for (const obj of levelFiltered) {
                        if (domFiltered.includes(obj) &&
                            zoneFiltered.includes(obj)) {
                            finalObject3Ds.push(obj);
                        }
                    }
                }
            }
            return finalObject3Ds;
        });
    }
    filterTicketsForCurrentUserInSpace(tickets, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalTickets = [];
            let domFiltered = tickets;
            let roleFiltered = tickets;
            let levelFiltered = tickets;
            let zoneFiltered = tickets;
            const missions = this.userService.currentMissions;
            if (missions) {
                const currentSpaceMissions = missions.filter((m) => m.spaceID === spaceID);
                if (currentSpaceMissions.length > 0) {
                    const highestLelel = getHighestLevelForMissions(currentSpaceMissions);
                    const highestRole = getHighestRoleForMissions(currentSpaceMissions);
                    // console.log("Highest level: ", highestLelel, ", Highest Role: ", highestRole)
                    const filters = this.getFiltersForRole(highestRole);
                    for (const filter of filters) {
                        if (filter === FilterType.DOMAIN) {
                            let domains = [];
                            for (const m of currentSpaceMissions) {
                                if (m.domains) {
                                    domains = [...domains, ...m.domains];
                                }
                            }
                            let allDomainsFiltered = [];
                            for (const d of domains) {
                                const currentDomFiltered = this.filterTicketsByDomain(tickets, d);
                                allDomainsFiltered = [
                                    ...allDomainsFiltered,
                                    ...currentDomFiltered,
                                ];
                            }
                            domFiltered = allDomainsFiltered;
                        }
                        if (filter === FilterType.ROLE) {
                            const highestRoleMission = currentSpaceMissions.find((m) => m.role === highestRole);
                            roleFiltered = this.filterTicketsForMission(tickets, highestRoleMission);
                        }
                        if (filter === FilterType.LEVEL) {
                            levelFiltered = this.filterObjectsByLevel(tickets, highestLelel);
                        }
                        if (filter === FilterType.ZONE) {
                            zoneFiltered = yield this.applyZoneFilterForMissions(currentSpaceMissions, tickets);
                        }
                    }
                    // keep only tickets present in all filtered arrays
                    // console.log(domFiltered);
                    // console.log(roleFiltered);
                    // console.log(levelFiltered);
                    // console.log(zoneFiltered);
                    for (const tic of levelFiltered) {
                        if (domFiltered.includes(tic) &&
                            roleFiltered.includes(tic) &&
                            zoneFiltered.includes(tic)) {
                            finalTickets.push(tic);
                        }
                    }
                }
            }
            // console.log(finalTickets);
            return finalTickets;
        });
    }
    subscribeToDataFilterUpdate(next, error, complete) {
        const s = this.updateDateFilter.subscribe(next, error, complete);
        return s;
    }
    dateFilterUpdated(dateRange) {
        this.currentDateFilter = dateRange;
        this.updateDateFilter.next(dateRange);
    }
    filterObjectsForDateRange(objects, dateRange) {
        return objects.filter((object) => {
            const createdAtDate = new Date(object.createdAt);
            return (createdAtDate >= dateRange[0] && createdAtDate <= dateRange[1]);
        });
    }
    filterMeasurementsForDateRange(measurements, dateRange) {
        return measurements.filter((measure) => {
            const createdAtDate = new Date(measure.comment.createdAt);
            return (createdAtDate >= dateRange[0] && createdAtDate <= dateRange[1]);
        });
    }
    filterObjectsForZone(objects, // TODO: remove any here..
    zoneID = null, zone = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const filteredObjects = [];
            yield Promise.all(objects.map((object) => __awaiter(this, void 0, void 0, function* () {
                const [poi] = object.pois.items;
                if (poi && zone) {
                    if (zone.sweepIDs && zone.sweepIDs.includes(poi.matterportSweepID)) {
                        if (this.poiService.poiIsVirtual(poi) && zone.layer && zone.layer.name === "FLOOR") {
                            // we include in Floor zone only
                            filteredObjects.push(object);
                        }
                        if (!this.poiService.poiIsVirtual(poi)) {
                            filteredObjects.push(object);
                        }
                    }
                }
                if (poi && !zone && zoneID) {
                    const zones = yield this.zoneService.getZonesForObject(object);
                    if (zones &&
                        zones.some((zone_) => zone_.id === zoneID ||
                            zone_.parentID === zoneID)) {
                        filteredObjects.push(object);
                    }
                }
            })));
            return filteredObjects;
        });
    }
    filterEquipmentsByDomainList(equipments, domainIDList) {
        let filtered = [];
        const filteredByDomain = equipments.filter((equip) => domainIDList.includes(equip.domainID));
        filtered = [...filtered, ...filteredByDomain];
        const filteredByParentDomain = equipments.filter((equip) => equip.domain &&
            equip.domain.parentID &&
            domainIDList.includes(equip.domain.parentID));
        filtered = [...filtered, ...filteredByParentDomain];
        return filterUniqueArrayByID(filtered);
    }
    // Not implemented yet!
    // filterObjects3DByDomainList(
    //   objects3D: Object3D[],
    //   domainIDList: string[],
    // ): Object3D[] {
    //   let filtered = [];
    //   const filteredByDomain = objects3D.filter((equip) =>
    //     domainIDList.includes(equip.domainID),
    //   );
    //   filtered = [...filtered, ...filteredByDomain];
    //   const filteredByParentDomain = objects3D.filter(
    //     (obj) =>
    //       obj.domain &&
    //       obj.domain.parentID &&
    //       domainIDList.includes(obj.domain.parentID),
    //   );
    //   filtered = [...filtered, ...filteredByParentDomain];
    //   return filterUniqueArrayByID(filtered);
    // }
    filterEquipmentsForTerm(equips, term) {
        // filter domains
        let byDomain = equips.filter((eq) => {
            if (eq.domain && eq.domain.name) {
                const normalizedDomain = eq.domain.name.toLowerCase();
                const lev = levenshtein(normalizedDomain, term);
                return lev <= 2 || normalizedDomain.includes(term);
            }
            return false;
        });
        const byParentDomain = equips.filter((eq) => {
            if (eq.domain && eq.domain.parentID) {
                const normalizedParent = eq.domain.parent.name.toLowerCase();
                const lev = levenshtein(normalizedParent, term);
                return lev <= 2 || normalizedParent.includes(term);
            }
            return false;
        });
        byDomain = [...byDomain, ...byParentDomain];
        // filter name
        let byName = [];
        const terms = term.split(" ").filter((token) => token.length > 2);
        for (const eq of equips) {
            const words = eq.name
                .toLowerCase()
                .split(" ")
                .filter((token) => token.length > 2);
            const matched = [];
            for (const token of terms) {
                for (const word of words) {
                    if (levenshtein(token, word) <= 1) {
                        matched.push(true);
                        break;
                    }
                }
            }
            if (matched.length === terms.length) {
                byName.push(eq);
            }
        }
        const byNameSimple = equips.filter((eq) => eq.name.toLowerCase().includes(term));
        byName = [...byName, ...byNameSimple];
        // by serial number
        const bySerialNumber = equips.filter((eq) => eq.serialNumber && eq.serialNumber.toLowerCase() === term);
        const result = [...byDomain, ...byName, ...bySerialNumber];
        return filterUniqueArrayByID(result);
    }
    filterTicketsForTerm(tickets, term) {
        // filter term in title and description
        const byTitle = this.filterObjectsForTerm(tickets, term);
        // by equipment
        const byEquipment = tickets.filter((ticket) => ticket.equipments &&
            this.filterEquipmentsForTerm(ticket.equipments, term).length >
                0);
        return filterUniqueArrayByID([...byTitle, ...byEquipment]);
    }
    filterLocationsForTerm(locations, term) {
        // by name
        const byName = locations.filter((loc) => loc.name.toLowerCase().includes(term));
        // by address
        const byAddress = locations.filter((loc) => loc.addresses.toLowerCase().includes(term));
        return filterUniqueArrayByID([...byName, ...byAddress]);
    }
    filterOrganisationsForTerm(orgs, term) {
        const byName = orgs.filter((org) => {
            const words = org.name.toLowerCase().split(" ");
            return (words.some((word) => word.length > 2 && levenshtein(word, term) <= 1) || org.name.toLowerCase().includes(term));
        });
        return byName;
    }
    filterUsersForTerm(users, term) {
        const byName = users.filter((user) => {
            const words = user.displayName.toLowerCase().split(" ");
            return (words.some((word) => word.length > 2 && levenshtein(word, term) <= 1) || user.displayName.toLowerCase().includes(term));
        });
        return byName;
    }
    filterFeaturesForCurrentUserInSpace(features, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalFeatures = [];
            let levelFiltered = features;
            let zoneFiltered = features;
            let hashtagFiltered = features;
            const missions = this.userService.currentMissions;
            if (missions) {
                const currentSpaceMissions = missions.filter((m) => m.spaceID === spaceID);
                if (currentSpaceMissions.length > 0) {
                    const highestLelel = getHighestLevelForMissions(currentSpaceMissions);
                    const highestRole = getHighestRoleForMissions(currentSpaceMissions);
                    const filters = this.getFiltersForRole(highestRole);
                    for (const filter of filters) {
                        if (filter === FilterType.LEVEL) {
                            levelFiltered = this.filterObjectsByLevel(features, highestLelel);
                        }
                        if (filter === FilterType.ZONE) {
                            zoneFiltered = yield this.applyZoneFilterForMissions(currentSpaceMissions, features);
                        }
                        if (filter === FilterType.HASHTAG) {
                            hashtagFiltered =
                                this.filterFeaturesByHashtagsAndLocale(currentSpaceMissions, features);
                        }
                    }
                    for (const feature of levelFiltered) {
                        if (hashtagFiltered.includes(feature) &&
                            zoneFiltered.includes(feature)) {
                            finalFeatures.push(feature);
                        }
                    }
                }
            }
            return finalFeatures;
        });
    }
    filterFeaturesForTerm(features, term) {
        // filter term in title
        const byTitle = this.filterObjectsForTerm(features, term);
        // by comments
        const byComment = features.filter((feature) => this.filterObjectsForTerm(feature.comments.items, term).length >
            0);
        return filterUniqueArrayByID([...byTitle, ...byComment]);
    }
    /**
     *
     * @param objects Array of Comments, Tickets, Features. Obligatory proporties: title, description
     * @param term string
     */
    filterObjectsForTerm(objects, term) {
        // filter term in title
        const byTitle = objects.filter((feature) => {
            const words = feature.title.toLowerCase().split(" ");
            return (words.some((word) => word.length > 2 && levenshtein(word, term) <= 1) || feature.title.toLowerCase().includes(term));
        });
        // term present in description
        const byDescription = objects.filter((feature) => feature.description &&
            feature.description.toLowerCase().includes(term));
        return filterUniqueArrayByID([...byTitle, ...byDescription]);
    }
    filterMissionByStartTimeDateForDateRange(missions, dateRange) {
        return missions.filter((mission) => {
            const startDateTime = new Date(mission.startDateTime);
            return (startDateTime >= dateRange[0] && startDateTime <= dateRange[1]);
        });
    }
    applyZoneFilterForMissions(currentSpaceMissions, objects) {
        return __awaiter(this, void 0, void 0, function* () {
            const allowedZones = [];
            for (const mission of currentSpaceMissions) {
                if (mission.zoneID) {
                    allowedZones.push(mission.zoneID);
                }
            }
            if (allowedZones.length === currentSpaceMissions.length) {
                let allZoneFiltered = [];
                yield Promise.all(allowedZones.map((zoneID) => __awaiter(this, void 0, void 0, function* () {
                    const currentZoneFiltered = yield this.filterObjectsForZone(objects, zoneID);
                    allZoneFiltered = [
                        ...allZoneFiltered,
                        ...currentZoneFiltered,
                    ];
                })));
                return filterUniqueArrayByID(allZoneFiltered);
            }
            return objects;
        });
    }
    filterEquipmentsForCurrentUserInSpace(spaceID, equips) {
        return __awaiter(this, void 0, void 0, function* () {
            const finalEquips = [];
            let domFiltered = equips;
            const roleFiltered = equips;
            const levelFiltered = equips;
            let zoneFiltered = equips;
            const missions = this.userService.currentMissions;
            if (missions) {
                const currentSpaceMissions = missions.filter((m) => m.spaceID === spaceID);
                if (currentSpaceMissions.length > 0) {
                    const highestLelel = getHighestLevelForMissions(currentSpaceMissions);
                    const highestRole = getHighestRoleForMissions(currentSpaceMissions);
                    // console.log("Highest level: ", highestLelel, ", Highest Role: ", highestRole)
                    const filters = this.getFiltersForRole(highestRole);
                    for (const filter of filters) {
                        if (filter === FilterType.DOMAIN) {
                            let domains = [];
                            for (const m of currentSpaceMissions) {
                                if (m.domains) {
                                    domains = [...domains, ...m.domains];
                                }
                            }
                            let allDomainsFiltered = [];
                            const currentDomFiltered = this.filterEquipmentsByDomainList(equips, domains);
                            allDomainsFiltered = [
                                ...allDomainsFiltered,
                                ...currentDomFiltered,
                            ];
                            domFiltered = allDomainsFiltered;
                        }
                        if (filter === FilterType.ROLE) {
                            // const highestRoleMission = currentSpaceMissions.find(
                            //     (m) => m.role === highestRole,
                            // );
                            // TODO
                        }
                        if (filter === FilterType.LEVEL) {
                            // TODO, equipment does not have level
                        }
                        if (filter === FilterType.ZONE) {
                            zoneFiltered = yield this.applyZoneFilterForMissions(currentSpaceMissions, equips);
                        }
                    }
                    for (const tic of levelFiltered) {
                        if (domFiltered.includes(tic) &&
                            roleFiltered.includes(tic) &&
                            zoneFiltered.includes(tic)) {
                            finalEquips.push(tic);
                        }
                    }
                }
            }
            return finalEquips;
        });
    }
    filterMeasurementsForCurrentUserInSpace(spaceID, comments) {
        return __awaiter(this, void 0, void 0, function* () {
            let finalMeasurements = [];
            let zoneFiltered = comments;
            const missions = this.userService.currentMissions;
            if (missions) {
                const currentSpaceMissions = missions.filter((m) => m.spaceID === spaceID);
                if (currentSpaceMissions.length > 0) {
                    const highestRole = getHighestRoleForMissions(currentSpaceMissions);
                    const filters = this.getFiltersForRole(highestRole);
                    for (const filter of filters) {
                        if (filter === FilterType.ZONE) {
                            zoneFiltered = yield this.applyZoneFilterForMissions(currentSpaceMissions, comments);
                        }
                    }
                    finalMeasurements = zoneFiltered;
                }
            }
            return finalMeasurements;
        });
    }
    isObjectAllowedForUserInSpace(object, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const mission = this.userService.currentMission(spaceID);
            const filters = this.getFiltersForRole(mission.role);
            for (const filter of filters) {
                if (filter === FilterType.LEVEL &&
                    Object.prototype.hasOwnProperty.call(object, "level")) {
                    const levelFiltered = this.filterObjectsByLevel([object], mission.level);
                    if (levelFiltered.length === 0) {
                        return false;
                    }
                }
                if (filter === FilterType.ZONE) {
                    const zoneFiltered = yield this.applyZoneFilterForMissions([mission], [object]);
                    if (zoneFiltered.length === 0) {
                        return false;
                    }
                }
            }
            return true;
        });
    }
    filterTemplatesForTerm(missions, term) {
        // term present in description
        const byDescription = missions.filter((mis) => mis.description && mis.description.toLowerCase().includes(term));
        // by user lastName which is the name of the visit:
        // metadata: "{\"firstName\":\"\",\"lastName\":\"Visite du 5 Juillet\"}"
        const userProfiles = missions.map((mis) => new ProfileEntity(mis.user));
        const byUserLastname = this.filterUsersForTerm(userProfiles, term);
        const userIds = new Set(byUserLastname.map((user) => user.id));
        const missionsByUser = missions.filter((mis) => userIds.has(mis.userID));
        return filterUniqueArrayByID([...byDescription, ...missionsByUser]);
    }
    filterObjectsForSweep(objects, objectType, sweep) {
        return __awaiter(this, void 0, void 0, function* () {
            let filtered = [];
            switch (objectType) {
                case PoiType.EQUIPMENT:
                    const pois = yield this.poiService.getPoisByMatterportSweepByType(sweep, objectType);
                    const equipIDs = new Set(pois.map((poi) => poi.elementID));
                    filtered = objects.filter((object) => equipIDs.has(object.id));
                    break;
                default:
                    break;
            }
            return filtered;
        });
    }
    filterFeaturesByHashtagsAndLocale(currentSpaceMissions, features) {
        const [currentMission] = currentSpaceMissions;
        // filter by locale
        let filteredLocale = [...features];
        if (currentMission.locale) {
            filteredLocale = features.filter((feature) => feature.locale && feature.locale === currentMission.locale);
        }
        // filter by hashtags
        if (currentMission.hashtags && currentMission.hashtags.length > 0) {
            const filteredByHashtags = [];
            for (const feature of filteredLocale) {
                if (!feature.hashtags || feature.hashtags.length === 0) {
                    // Feature without hashtag is available for everybody
                    filteredByHashtags.push(feature);
                }
                else if (currentMission.hashtags.every((hashtag) => feature.hashtags.includes(hashtag))) {
                    filteredByHashtags.push(feature);
                }
            }
            return filteredByHashtags;
        }
        return filteredLocale;
    }
    filterFeaturesForMissionWithoutZone(features, mission) {
        const finalFeatures = [];
        let levelFiltered = features;
        let zoneFiltered = features;
        let hashtagFiltered = features;
        const filters = this.getFiltersForRole(mission.role);
        for (const filter of filters) {
            if (filter === FilterType.LEVEL) {
                levelFiltered = this.filterObjectsByLevel(features, mission.level);
            }
            // if (filter === FilterType.ZONE) {
            //     zoneFiltered = await this.applyZoneFilterForMissions(
            //         currentSpaceMissions,
            //         features,
            //     );
            // }
            if (filter === FilterType.HASHTAG) {
                hashtagFiltered =
                    this.filterFeaturesByHashtagsAndLocale([mission], features);
            }
        }
        for (const feature of levelFiltered) {
            if (hashtagFiltered.includes(feature) &&
                zoneFiltered.includes(feature)) {
                finalFeatures.push(feature);
            }
        }
        return finalFeatures;
    }
}
FilterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FilterService, deps: [{ token: BaseUserService }, { token: ZoneService }, { token: PoiService }], target: i0.ɵɵFactoryTarget.Injectable });
FilterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FilterService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FilterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: BaseUserService }, { type: ZoneService }, { type: PoiService }]; } });

class NavigationService {
    constructor(apiInjected, userService, zoneService) {
        this.userService = userService;
        this.zoneService = zoneService;
        this.API = apiInjected;
    }
    createNavigation(navInput) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateNavigation(navInput);
        });
    }
    deleteNavigation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteNavigation({ id });
        });
    }
    getNavigationsForNode(nodeID) {
        return __awaiter(this, void 0, void 0, function* () {
            const limit = 200;
            let navigationsTokenDict = { navigations: [], nextToken: null };
            do {
                navigationsTokenDict =
                    yield this.mergeAPIResponseWithNextTokenWithLimit(nodeID, limit, navigationsTokenDict);
            } while (navigationsTokenDict.nextToken);
            return navigationsTokenDict.navigations;
        });
    }
    mergeAPIResponseWithNextTokenWithLimit(nodeID, limit, navigationsTokenDict) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.NavigationsByNode(nodeID, null, null, limit, navigationsTokenDict.nextToken).then((response) => {
                const navigations = response.items;
                const navObject = {
                    navigations: [...navigationsTokenDict.navigations, ...navigations],
                    nextToken: response.nextToken,
                };
                return navObject;
            });
        });
    }
    getNavigation(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetNavigation(id);
        });
    }
    getSweepsIDsForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const zones = yield this.zoneService.getZonesBySpace(spaceID);
            const zonesWithSweeps = zones.filter((zone) => zone.sweepIDs && zone.sweepIDs.length > 0);
            const allSweeps = zonesWithSweeps.flatMap((zone) => zone.sweepIDs);
            return [...new Set(allSweeps)];
        });
    }
    getAllowedSweepsIDsForUserInSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const missionsForSpace = this.userService.currentMissions.filter((mis) => mis.spaceID === spaceID);
            let navIDs = [];
            if (this.userService.userHasAccessToAllZonesInSpace(spaceID)) {
                return this.getSweepsIDsForSpace(spaceID);
            }
            yield Promise.all(missionsForSpace.map((mission) => __awaiter(this, void 0, void 0, function* () {
                navIDs = [...navIDs, ...mission.zone.sweepIDs];
            })));
            return navIDs;
        });
    }
    getForbiddenNavigationIDsForUserInSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const allowed = yield this.getAllowedSweepsIDsForUserInSpace(spaceID);
            const allNavs = yield this.getSweepsIDsForSpace(spaceID);
            const difference = allNavs.filter((x) => !allowed.includes(x));
            return difference.length > 0 ? difference : null;
        });
    }
    getNavigationsForMatterportIDForSpace(matterportID, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.NavigationsByMatterportIDBySpace(matterportID, {
                eq: spaceID,
            }).then((navs) => navs.items);
        });
    }
    getNavigationsForZone(zone) {
        return __awaiter(this, void 0, void 0, function* () {
            const responseNavs = [];
            yield Promise.all(zone.sweepIDs.map((sweepID) => __awaiter(this, void 0, void 0, function* () {
                const navs = yield this.getNavigationsForMatterportIDForSpace(sweepID, zone.spaceID);
                if (navs.length > 0) {
                    responseNavs.push(navs[0]);
                }
            })));
            return responseNavs;
        });
    }
    updateNavigation(navInput) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateNavigation(navInput);
        });
    }
}
NavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigationService, deps: [{ token: 'currentAPIService' }, { token: BaseUserService }, { token: ZoneService }], target: i0.ɵɵFactoryTarget.Injectable });
NavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigationService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: BaseUserService }, { type: ZoneService }];
    } });

class BaseObjectService {
    constructor(poiService, navigationService) {
        this.poiService = poiService;
        this.navigationService = navigationService;
    }
    getModel3dAndSweep(object) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.poiService
                .getPoiByElementId(object.id)
                .then((poi) => __awaiter(this, void 0, void 0, function* () {
                if (poi && poi.matterportSweepID) {
                    const navigations = yield this.navigationService.getNavigationsForMatterportIDForSpace(poi.matterportSweepID, object.spaceID);
                    const [poiNavigation] = navigations;
                    if (this.poiService.poiIsVirtual(poi)) {
                        return {
                            model3D: poiNavigation.node.model3D,
                            sweep: null,
                            rotation: null,
                        };
                    }
                    const coordinate = JSON.parse(poi.coordinate);
                    let rotation = null;
                    if (coordinate.xRotation) {
                        rotation = {
                            x: Number(coordinate.xRotation),
                            y: Number(coordinate.yRotation),
                        };
                    }
                    return {
                        model3D: poiNavigation.node.model3D,
                        sweep: poi.matterportSweepID,
                        rotation,
                    };
                }
                return null;
            }))
                .catch((error) => {
                return null;
            });
        });
    }
    updateIconForAllObjects(objects, tagIcon) {
        return __awaiter(this, void 0, void 0, function* () {
            const IDs = [];
            for (const object of objects) {
                IDs.push(object.id);
            }
            const pois = [];
            yield Promise.all(IDs.map((id) => __awaiter(this, void 0, void 0, function* () {
                const poi = yield this.poiService.getPoiByElementId(id);
                const updated = yield this.poiService.updatePoi({
                    id: poi.id,
                    tagIcon,
                });
                pois.push(updated);
            })));
            console.log("updated", pois.length, "pois with new icons");
            return pois;
        });
    }
}
BaseObjectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseObjectService, deps: [{ token: PoiService }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Injectable });
BaseObjectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseObjectService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseObjectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: PoiService }, { type: NavigationService }]; } });

class OperationService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    getOperationsByTicketID(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.OperationsByTicket(id).then((res) => res.items);
        });
    }
    getOperationsByEquipmentID(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.OperationsByEquipment(id).then((res) => res.items);
        });
    }
    getTicketsByEquipmentID(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const operations = yield this.getOperationsByEquipmentID(id);
            const tickets = operations.map((operation) => operation.ticket);
            return tickets;
        });
    }
    deleteOperationsForEquipment(equipID) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleted = [];
            yield this.getOperationsByEquipmentID(equipID)
                .then((operations) => __awaiter(this, void 0, void 0, function* () {
                if (operations.length > 0) {
                    yield Promise.all(operations.map((op) => __awaiter(this, void 0, void 0, function* () {
                        const deletedOp = yield this.API.__proto__.DeleteOperation({ id: op.id });
                        deleted.push(deletedOp);
                    })));
                }
            }));
            return deleted;
        });
    }
    deleteOperationsForTicket(ticketID) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getOperationsByTicketID(ticketID)
                .then((operations) => __awaiter(this, void 0, void 0, function* () {
                if (operations.length > 0) {
                    yield Promise.all(operations.map((op) => __awaiter(this, void 0, void 0, function* () {
                        yield this.API.__proto__.DeleteOperation({ id: op.id });
                    })));
                }
            }));
        });
    }
    deleteOperation(operationID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteOperation({ id: operationID });
        });
    }
    createOperation(operation) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateOperation(operation);
        });
    }
}
OperationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: OperationService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
OperationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: OperationService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: OperationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class EventService {
    constructor(apiInjected, userService, translate) {
        this.userService = userService;
        this.translate = translate;
        this.translationEventSubcriptions = {};
        this.API = apiInjected;
    }
    /**
     * CRUD
     * */
    createEvent(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateEvent(input);
        });
    }
    updateEvent(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateEvent(input);
        });
    }
    deleteEvent(eventID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteEvent({ id: eventID });
        });
    }
    getEvent(eventID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetEvent(eventID);
        });
    }
    /**
     * Custom get by GSI
     * */
    getEventsByTicketID(ticketID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.EventsByTicket(ticketID).then((events) => events.items);
        });
    }
    getEventsByTicketIDSortedByDateDesc(ticketID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.EventsByTicketByDate(ticketID, null, "DESC").then((events) => events.items);
        });
    }
    getEventsByGroup(group) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.API.__proto__.EventsByGroup(group)).items;
        });
    }
    /**
     *
     * SORTING
     */
    sortEventsByCreatedAtDateDesc(events) {
        events.sort((event1, event2) => {
            // @ts-ignore
            return new Date(event2.createdAt) - new Date(event1.createdAt);
        });
        return events;
    }
    sortEventsByCreatedAtDateAsc(events) {
        events.sort((event1, event2) => {
            // @ts-ignore
            return new Date(event1.createdAt) - new Date(event2.createdAt);
        });
        return events;
    }
    /**
     *  TRANSLATIONS
     * */
    /** Apply a translation to a ticket event, with the current language */
    applyTicketEventTranslate(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const meta = yield this.getTranslatedMetaEvent(event);
            const path = event.translationPath;
            if (path) {
                const titlePath = `${path}.title`;
                const descriptionPath = `${path}.description`;
                const value = this.translate.instant([titlePath, descriptionPath], meta);
                event.title = value[titlePath];
                event.description = value[descriptionPath];
            }
        });
    }
    /** Unsubscribe a ticket event for his translation */
    ticketEventSubscribeTranslation(event) {
        if (event.id in this.translationEventSubcriptions) {
            this.ticketEventUnsubscribeTranslation(event.id);
        }
        this.translationEventSubcriptions[event.id] =
            this.translate.onLangChange.subscribe((change) => {
                this.applyTicketEventTranslate(event);
            });
        this.applyTicketEventTranslate(event);
    }
    /** Unsubscribe a ticket event for his translation */
    ticketEventUnsubscribeTranslation(id) {
        if (id in this.translationEventSubcriptions) {
            this.translationEventSubcriptions[id].unsubscribe();
            delete this.translationEventSubcriptions[id];
        }
    }
    /** Generate the translated metadata of an event, according to the current language */
    getTranslatedMetaEvent(event) {
        return __awaiter(this, void 0, void 0, function* () {
            let meta = {};
            const owner = yield this.userService.userFromUserID(event.owner.userID);
            try {
                if (event.metadata)
                    meta = JSON.parse(event.metadata);
            }
            catch (_a) { }
            meta.firstName = owner.firstName;
            meta.lastName = owner.lastName;
            if (event.estimateStartDate) {
                meta.fromDate = dateTimeToLocalString(event.estimateStartDate, this.translate);
            }
            if (event.estimateEndDate)
                meta.toDate = dateTimeToLocalString(event.estimateEndDate, this.translate);
            if (meta.oldStatus)
                meta.oldStatus = this.translate.instant(meta.oldStatus);
            if (meta.newStatus)
                meta.newStatus = this.translate.instant(meta.newStatus);
            if (meta.type)
                meta.type = this.translate.instant(meta.type);
            return meta;
        });
    }
}
EventService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: EventService, deps: [{ token: 'currentAPIService' }, { token: BaseUserService }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
EventService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: EventService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: EventService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: BaseUserService }, { type: i1.TranslateService }];
    } });

class AffectationService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    getAffectationsFromTicketID(ticketID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ListAffectations({
                ticketID: {
                    eq: ticketID,
                },
            })
                .then((results) => {
                return results.items;
            })
                .catch((error) => {
                console.log(` Error while retrieving affectations for ${ticketID} : ${JSON.stringify(error)}`);
            });
        });
    }
    getAffectationsFromMissionID(missionID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.AffectationsByMission(missionID).then((resposne) => resposne.items);
        });
    }
    softDeleteAffectationByMissionByTicket(ticketID, missionID) {
        return __awaiter(this, void 0, void 0, function* () {
            const affectations = yield this.getAffecationsForTicketForMission(missionID, ticketID);
            yield Promise.all(affectations.map((affectation) => __awaiter(this, void 0, void 0, function* () {
                const deleted = yield this.API.__proto__.UpdateAffectation({
                    id: affectation.id,
                    deletedAt: Date.now(),
                });
                console.log("soft deleted affectation", deleted);
            })));
            return affectations;
        });
    }
    getAffecationsForTicketForMission(ticketID, missionID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.AffectationsByMissionByTicket(missionID, {
                eq: ticketID,
            }).then((resposne) => resposne.items);
        });
    }
    softDeleteAffectationByID(affectationID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateAffectation({
                id: affectationID,
                deletedAt: Date.now(),
            });
        });
    }
    createAffectation(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateAffectation(input);
        });
    }
}
AffectationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AffectationService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
AffectationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AffectationService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AffectationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class NavigatorService {
    constructor(matterportService, viewerService, zoneService, userService, zoneChangeService) {
        this.matterportService = matterportService;
        this.viewerService = viewerService;
        this.zoneService = zoneService;
        this.userService = userService;
        this.zoneChangeService = zoneChangeService;
        this.visitLastPosition = new Map();
        this.locationIDChange = new Subject();
        this.navBarZoneIDChange = new Subject();
        this.isVisibleChanged = new Subject();
        this.audioZonesChange = new Subject();
        this.matterportService.currentSweep
            .pipe(first()) //  take first in order not to wait 2 sec an first load
            .subscribe((sweep) => {
            this.currentSweep = sweep;
            if (this.zonesForUserForSpace) {
                this.setZonesForCurrentSweep();
            }
        });
        this.matterportService.currentSweep
            .pipe(debounceTime(1500)) //  delays values emitted and return only the latest
            .subscribe((sweep) => {
            if (sweep === this.currentSweep) {
                return;
            }
            this.currentSweep = sweep;
            if (this.zonesForUserForSpace) {
                this.setZonesForCurrentSweep();
            }
        });
        this.viewerService.viewerIsOn.subscribe((data) => {
            if (this.currentSpaceID !== data.spaceID) {
                this.currentSpaceID = data.spaceID;
            }
            if (!data.spaceID) {
                this.zonesForUserForSpace = null;
                this.zonesSortedForCurrentSweep = null;
                this.audioZonesForUserForSpace = null;
                this.currentZone = null;
                this.zoneChangeService.zoneChange.next(null);
                this.currentSweep = null;
                // save last position
                const lastPose = this.matterportService.poseCamera;
                if (lastPose && this.currentModel3D && this.userService.cu) {
                    this.visitLastPosition.set(this.currentModel3D, {
                        sweep: lastPose.sweep,
                        rotation: lastPose.rotation,
                    });
                }
                this.currentModel3D = data.model3D;
            }
            else {
                this.currentModel3D = data.model3D;
                this.targetSweep = data.sweep;
                this.targetRotation = data.rotation;
                this.onViewerLoaded().catch((e) => console.log(e));
            }
        });
        this.userService.isChanged.subscribe((isConnected) => {
            if (!isConnected) {
                // user disconnected, clean Map
                this.visitLastPosition = new Map();
            }
        });
    }
    getLastPositionForModel(model3D) {
        return this.visitLastPosition.get(model3D);
    }
    goToSweepWithRotation(sweep, rotation = null) {
        this.matterportService.action_go_to_sweep(sweep, rotation);
    }
    goToFloor(floor) {
        return __awaiter(this, void 0, void 0, function* () {
            let matterportFloorSequence = null;
            if (floor.metadata) {
                const metadata = JSON.parse(floor.metadata);
                if (metadata.matterportFloorSequence !== undefined) {
                    matterportFloorSequence = metadata.matterportFloorSequence;
                }
            }
            yield this.matterportService.action_go_to_floor(floor.name, matterportFloorSequence);
        });
    }
    onViewerLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            let sweepToGo = null;
            let rotation = null;
            if (this.targetSweep) {
                sweepToGo = this.targetSweep;
                rotation = this.targetRotation
                    ? this.targetRotation
                    : this.checkRotationForSweep(this.targetSweep);
            }
            else {
                const lastPostion = this.getLastPositionForModel(this.currentModel3D);
                if (lastPostion) {
                    sweepToGo = lastPostion.sweep;
                    rotation = lastPostion.rotation;
                }
            }
            if (this.targetRotation) {
                rotation = this.targetRotation;
            }
            if (sweepToGo && !this.floorToGo) {
                // console.log("go to sweep", sweepToGo);
                this.goToSweepWithRotation(sweepToGo, rotation);
            }
            if (this.floorToGo) {
                this.goToFloor(this.floorToGo);
                this.floorToGo = null;
            }
            // if first load and zones are not set
            this.zonesForUserForSpace = yield this.zoneService.getZonesBySpaceForUser(this.currentSpaceID);
            this.audioZonesForUserForSpace = this.zonesForUserForSpace.filter((zone) => zone.audioID);
            this.setZonesForCurrentSweep();
        });
    }
    checkRotationForSweep(sweep) {
        const lastPosition = this.visitLastPosition.get(this.currentModel3D);
        if (lastPosition && lastPosition.sweep === sweep) {
            return lastPosition.rotation;
        }
        return null;
    }
    setZonesForCurrentSweep() {
        var _a, _b;
        if (!this.currentSweep) {
            return;
        }
        let zonesForSweep = (_a = this.zonesForUserForSpace) === null || _a === void 0 ? void 0 : _a.filter((zone) => zone.sweepIDs && zone.sweepIDs.includes(this.currentSweep));
        const audioZones = (_b = this.audioZonesForUserForSpace) === null || _b === void 0 ? void 0 : _b.filter((zone) => zone.sweepIDs && zone.sweepIDs.includes(this.currentSweep));
        this.audioZonesChange.next(audioZones);
        this.currentAudioZones = audioZones;
        // filter out audio zone (not to show to user it's name)
        zonesForSweep = zonesForSweep.filter((zone) => !zone.audio);
        // LINE BELOW IS COMMENTED SINCE CREATES INFINITE SPINNER FOR ZONES WITHOUT AUDIO...
        // if (zonesForSweep && zonesForSweep.length > 0) {
        this.zonesSortedForCurrentSweep = zonesForSweep.sort((a, b) => {
            var _a, _b;
            if (a.sweepIDs.length === b.sweepIDs.length) {
                // if the same amount of sweeps: floor == the whole space
                if (a.layer && b.layer) {
                    // put type BUILDING at the end
                    return a.layer.name !== 'BUILDING'
                        ? -1
                        : b.layer.name !== 'BUILDING'
                            ? 1
                            : 0;
                }
                return ((_a = a.parent) === null || _a === void 0 ? void 0 : _a.sweepIDs) ? -1 : ((_b = b.parent) === null || _b === void 0 ? void 0 : _b.sweepIDs) ? 1 : 0;
            }
            return a.sweepIDs.length - b.sweepIDs.length;
        });
        this.zoneChangeService.zonesForUserChange.next(this.zonesSortedForCurrentSweep);
        if (this.zonesSortedForCurrentSweep.length > 0 &&
            this.currentZone !== this.zonesSortedForCurrentSweep[0]) {
            [this.currentZone] = this.zonesSortedForCurrentSweep;
            this.zoneChangeService.zoneChange.next(this.currentZone);
        }
        // }
    }
}
NavigatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigatorService, deps: [{ token: MatterportService }, { token: ViewerService }, { token: ZoneService }, { token: BaseUserService }, { token: ZoneChangeService }], target: i0.ɵɵFactoryTarget.Injectable });
NavigatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: MatterportService }, { type: ViewerService }, { type: ZoneService }, { type: BaseUserService }, { type: ZoneChangeService }]; } });

class InterventionService {
    constructor(eventService, missionService) {
        this.eventService = eventService;
        this.missionService = missionService;
        this.interventionEventTypes = [
            EventType.NON_CONTRACTUAL_INTERVENTION,
            EventType.CONTRACTUAL_INTERVENTION,
            EventType.REPORTING,
            EventType.REQUEST_FOR_INTERVENTION,
        ];
    }
    getRequestInterventionFromTicket(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            const events = yield this.eventService.getEventsByTicketIDSortedByDateDesc(ticket.id);
            const relatedEvents = events.filter((event_) => this.interventionEventTypes.includes(event_.type));
            const allRequests = relatedEvents.filter((event_) => event_.type === EventType.REQUEST_FOR_INTERVENTION);
            if (allRequests.length > 0) {
                const mostRecent = allRequests[0];
                const composedRequest = this.eventToRequestIntervention(mostRecent);
                if (composedRequest.status === EventStatus.CANCELLED) {
                    return composedRequest;
                }
                let eventsForMostRecentRequest = relatedEvents.filter((event) => event.group === composedRequest.id);
                let intervention;
                if (eventsForMostRecentRequest.length === 0) {
                    // back compatibility
                    eventsForMostRecentRequest = relatedEvents;
                    // get intervention
                    intervention = this.composeInterventionForRequest(relatedEvents, null);
                    // set duration
                    composedRequest.realDuration =
                        this.getDurationForRequest(relatedEvents, null);
                }
                else {
                    intervention = this.composeInterventionForRequest(eventsForMostRecentRequest, composedRequest.id);
                    composedRequest.realDuration =
                        this.getDurationForRequest(eventsForMostRecentRequest, composedRequest.id);
                }
                if (!composedRequest.estimateStartDate) {
                    composedRequest.estimateStartDate =
                        this.getMostRecentEstimateStartDate(eventsForMostRecentRequest);
                }
                composedRequest.realStartDate =
                    this.getEarliestRealStartDateForRequest(relatedEvents, composedRequest.id);
                if (!composedRequest.estimateEndDate) {
                    composedRequest.estimateEndDate =
                        this.getMostRecentEstimateEndDate(eventsForMostRecentRequest);
                }
                composedRequest.realEndDate =
                    this.getLatestRealEndDateForRequest(relatedEvents, composedRequest.id);
                composedRequest.intervention = intervention;
                return composedRequest;
            }
            return null;
        });
    }
    composeInterventionForRequest(relatedEvents, requestID) {
        const interventions = requestID
            ? relatedEvents.filter((event_) => (event_.type === EventType.NON_CONTRACTUAL_INTERVENTION ||
                event_.type === EventType.CONTRACTUAL_INTERVENTION) &&
                event_.group === requestID)
            : relatedEvents.filter((event_) => event_.type === EventType.NON_CONTRACTUAL_INTERVENTION ||
                event_.type === EventType.CONTRACTUAL_INTERVENTION);
        if (interventions.length > 0) {
            const lastIntervention = interventions[0];
            return lastIntervention;
        }
        return null;
    }
    getPrestataireForTicket(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (ticket.assignees.items.length > 0) {
                const sortedAffectations = ticket.assignees.items.sort((a, b) => 
                // @ts-ignore
                // eslint-disable-next-line prettier/prettier
                new Date(b.createdAt) - new Date(a.createdAt));
                const missionIDpresta = sortedAffectations[0].missionID;
                const prestaMission = yield this.missionService.getMission(missionIDpresta);
                const userPrestataire = new ProfileEntity(prestaMission.user);
                const prestataire = {
                    organisation: prestaMission.organisation,
                    mission: prestaMission,
                    profile: userPrestataire,
                    name: userPrestataire.displayName,
                };
                return prestataire;
            }
            return null;
        });
    }
    getEarliestRealStartDateForRequest(events, requestID) {
        let date = null;
        const interventions = events.filter((event_) => (event_.type === EventType.CONTRACTUAL_INTERVENTION ||
            event_.type === EventType.NON_CONTRACTUAL_INTERVENTION) &&
            event_.group === requestID);
        const sortedInterventions = this.eventService.sortEventsByCreatedAtDateAsc(interventions);
        if (sortedInterventions.length > 0) {
            for (const event of sortedInterventions) {
                if (event.realStartDate) {
                    date = event.realStartDate;
                    break;
                }
            }
        }
        return date;
    }
    getLatestRealEndDateForRequest(events, requestID) {
        let date = null;
        const interventions = events.filter((event_) => (event_.type === EventType.CONTRACTUAL_INTERVENTION ||
            event_.type === EventType.NON_CONTRACTUAL_INTERVENTION) &&
            event_.group === requestID);
        const sortedInterventions = this.eventService.sortEventsByCreatedAtDateDesc(interventions);
        if (sortedInterventions.length > 0) {
            for (const event of sortedInterventions) {
                if (event.realEndDate) {
                    date = event.realEndDate;
                    break;
                }
            }
        }
        return date;
    }
    getDurationForRequest(events, requestID) {
        let duration = 0; // in miliseconds
        const interventions = requestID
            ? events.filter((event_) => (event_.type === EventType.CONTRACTUAL_INTERVENTION ||
                event_.type ===
                    EventType.NON_CONTRACTUAL_INTERVENTION) &&
                event_.group === requestID)
            : events.filter((event_) => event_.type === EventType.CONTRACTUAL_INTERVENTION ||
                event_.type === EventType.NON_CONTRACTUAL_INTERVENTION);
        for (const event of interventions) {
            if (event.timeSpent) {
                duration += event.timeSpent;
            }
        }
        return duration;
    }
    getIntervention(events) {
        const interventions = events.filter((event_) => event_.type === EventType.NON_CONTRACTUAL_INTERVENTION ||
            event_.type === EventType.CONTRACTUAL_INTERVENTION);
        if (interventions.length > 0) {
            const lastIntervention = interventions[0];
            return lastIntervention;
        }
        return null;
    }
    eventToRequestIntervention(event) {
        const request = {
            id: event.group === "default" ? event.id : event.group,
            realEndDate: event.realEndDate,
            realStartDate: event.realStartDate,
            estimateStartDate: event.estimateStartDate,
            estimateEndDate: event.estimateEndDate,
            realDuration: event.timeSpent,
            type: event.type,
            status: event.status,
            createdAt: event.createdAt,
            updatedAt: event.updatedAt,
            ticketID: event.ticketID,
        };
        return request;
    }
    getMostRecentTimeSpent(events) {
        let timeSpent = null;
        const sortedEvents = this.getAllEventsAfterLastCreated(events);
        for (const event_ of sortedEvents) {
            if (event_.timeSpent) {
                timeSpent = event_.timeSpent;
                break;
            }
        }
        return timeSpent;
    }
    getAllEventsAfterLastCreated(events) {
        const eventsAfter = [];
        const currentIntervention = this.getCurrentIntevention(events);
        const sortedEvents = this.eventService.sortEventsByCreatedAtDateDesc(events);
        if (sortedEvents.length > 0 && currentIntervention) {
            for (const event_ of sortedEvents) {
                eventsAfter.push(event_);
                if (event_.id === currentIntervention.id) {
                    break;
                }
            }
        }
        return eventsAfter;
    }
    getCurrentIntevention(events) {
        const sortedEvents = this.eventService.sortEventsByCreatedAtDateDesc(events);
        let currentIntervention;
        for (const event_ of sortedEvents) {
            if (event_.status === EventStatus.CREATED) {
                currentIntervention = event_;
            }
            if (event_.status !== EventStatus.CREATED && currentIntervention) {
                break;
            }
        }
        return currentIntervention;
    }
    getMostRecentEstimateStartDate(events) {
        let estimateStartDate = null;
        // const sortedEvents = this.getAllEventsAfterLastCreated(events);
        const sortedEvents = this.eventService.sortEventsByCreatedAtDateDesc(events);
        for (const event_ of sortedEvents) {
            if (event_.estimateStartDate) {
                estimateStartDate = event_.estimateStartDate;
                break;
            }
        }
        return estimateStartDate;
    }
    getMostRecentEstimateEndDate(events) {
        let date = null;
        const sortedEvents = this.eventService.sortEventsByCreatedAtDateDesc(events);
        for (const event_ of sortedEvents) {
            if (event_.estimateEndDate) {
                date = event_.estimateEndDate;
                break;
            }
        }
        return date;
    }
}
InterventionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InterventionService, deps: [{ token: EventService }, { token: MissionService }], target: i0.ɵɵFactoryTarget.Injectable });
InterventionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InterventionService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: InterventionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: EventService }, { type: MissionService }]; } });

class TicketsService extends BaseObjectService {
    constructor(awsKinesisAnalyticsInjected, apiInjected, operationService, eventService, affectationService, poiService, userService, navigatorService, filterService, interventionService, navigationService, viewerService, zoneChangeService, modalService) {
        super(poiService, navigationService);
        this.operationService = operationService;
        this.eventService = eventService;
        this.affectationService = affectationService;
        this.userService = userService;
        this.navigatorService = navigatorService;
        this.filterService = filterService;
        this.interventionService = interventionService;
        this.viewerService = viewerService;
        this.zoneChangeService = zoneChangeService;
        this.modalService = modalService;
        this.currentTickets = {
            zone: [],
            space: [],
        };
        this.ticketTags = new Subject();
        this.ticketsFiltered = [];
        this.ticketsUpdated = new Subject();
        this.reportingIcon = ReportingIcon;
        this.maintenanceIcon = MaintenanceIcon;
        this.workorderIcon = WordOrderIcon;
        this.informationIcon = InformationIcon;
        this.accidentIcon = AccidentIcon;
        this.updateDone = new Subject();
        this.updating = new Subject();
        this.isMuseumUser = false;
        this.floorsPerSpace = null;
        this.selectedFloor = null;
        this.destroy$ = new Subject();
        this.awsKinesisAnalytics = awsKinesisAnalyticsInjected;
        this.API = apiInjected;
        this.isMuseumUser = this.userService.hasOnlyMuseumRole();
        this.initSubscriptions();
        this.userService.isChanged.subscribe((isConnected) => {
            if (isConnected) {
                this.isMuseumUser = this.userService.hasOnlyMuseumRole();
                this.initSubscriptions();
            }
            else {
                if (this.navSubscription) {
                    this.navSubscription.unsubscribe();
                    this.filetrSubscription.unsubscribe();
                }
            }
        });
        this.zoneChangeService.floorHasChanged.subscribe((floor) => {
            if (floor) {
                this.selectedFloor = floor;
            }
        });
    }
    initTickets() {
        return __awaiter(this, void 0, void 0, function* () {
            let ticketsFiltered = [];
            if (this.currentSpaceID) {
                this.updating.next(true);
                yield this.getTicketsBySpace(this.currentSpaceID).then((tickets) => {
                    if (tickets) {
                        ticketsFiltered = tickets;
                    }
                });
                ticketsFiltered =
                    yield this.filterService.filterTicketsForCurrentUserInSpace(ticketsFiltered, this.currentSpaceID);
                // @ts-ignore
                if (this.dateFilter && this.dateFilter[0] != "Invalid Date" && this.dateFilter[1] != "Invalid Date") {
                    ticketsFiltered = this.filterService.filterObjectsForDateRange(ticketsFiltered, this.dateFilter);
                }
                if (this.ticketTypeFilter) {
                    ticketsFiltered = ticketsFiltered.filter((ticket) => this.ticketTypeFilter.includes(ticket.type));
                }
                this.currentTickets.space = ticketsFiltered;
                this.ticketTags.next(ticketsFiltered); // tags without zone filter
                if (this.zoneIDFilter) {
                    ticketsFiltered = yield this.filterService.filterObjectsForZone(ticketsFiltered, this.zoneIDFilter);
                }
                this.currentTickets.zone = ticketsFiltered;
                this.ticketsUpdated.next(this.currentTickets);
                this.updating.next(false);
            }
            else {
                this.ticketTags.next(null);
            }
        });
    }
    adaptTicket(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (ticket.comments.items.length > 0) {
                ticket.comments.items.sort((a, b) => {
                    // @ts-ignore
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
            }
            if (ticket.events.items.length > 0) {
                // Sort events by date
                ticket.events.items.sort((event1, event2) => {
                    // @ts-ignore
                    return new Date(event2.createdAt) - new Date(event1.createdAt);
                });
            }
            ticket.prestataire = yield this.interventionService.getPrestataireForTicket(ticket);
            return ticket;
        });
    }
    getPriorityColor(ticket) {
        switch (ticket.priority) {
            case TicketPriority.MAXIMUM:
                return 'crimson';
            case TicketPriority.HIGH:
                return 'red';
            case TicketPriority.MEDIUM:
                return 'orange';
            case TicketPriority.LOW:
                return 'green';
            case TicketPriority.MINIMUM:
                return 'blue';
            default:
                return 'blue';
        }
    }
    getStatusColor(ticket) {
        switch (ticket.status) {
            case TicketStatus.TO_BE_PROCESSED:
                return '#B0B0B1';
            case TicketStatus.PLANNED:
                return '#EBDF27';
            case TicketStatus.IN_PROGRESS:
                return '#EBDF27';
            case TicketStatus.WAITING_FOR_VALIDATION:
                return '#EBDF27';
            case TicketStatus.VALIDATED:
                return '#BCE2E5';
            case TicketStatus.REJECTED:
                return '#e84c35';
            case TicketStatus.RESOLVED:
                return '#BCE2E5';
            case TicketStatus.ARCHIVED:
                return '#B0B0B1';
            case TicketStatus.LATE:
                return '#e84c35';
            case TicketStatus.BLOCKED:
                return '#e84c35';
            case TicketStatus.COMPLETED:
                return '#388659';
            case TicketStatus.DELAYED:
                return '#DB7543';
            case TicketStatus.CANCELLED:
                return '#e84c35';
            case TicketStatus.TO_REDO:
                return '#DB7543';
            case TicketStatus.CREATED:
                return '#B0B0B1';
            default:
                return '#BCE2E5';
        }
    }
    getTicketPriorityNumber(t) {
        return t.priority === TicketPriority.MINIMUM
            ? -1
            : t.priority === TicketPriority.LOW
                ? 0
                : t.priority === TicketPriority.MEDIUM
                    ? 1
                    : t.priority === TicketPriority.HIGH
                        ? 2
                        : t.priority === TicketPriority.MAXIMUM
                            ? 3
                            : -1;
    }
    getTicketIcon(type) {
        // const typeIcon : TicketType = ticket.type;
        switch (type) {
            case TicketType.REPORTING:
                return this.reportingIcon;
            case TicketType.REQUEST_FOR_INTERVENTION:
                return this.maintenanceIcon;
            case TicketType.REQUEST_FOR_MAINTENANCE:
                return this.maintenanceIcon;
            case TicketType.WORK_ORDER:
                return this.workorderIcon;
            case TicketType.INCIDENT:
                return this.accidentIcon;
            case TicketType.INFORMATION:
                return this.informationIcon;
            default:
                return this.maintenanceIcon;
        }
    }
    addEventToTicket(ticket, event) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const currentMission = this.userService.currentMission(ticket.spaceID);
            event.group = event.group ? event.group : 'default';
            event.ticketID = event.ticketID ? event.ticketID : ticket.id;
            event.status = event.status ? event.status : EventStatus.CREATED;
            event.type = event.type ? event.type : EventType.TICKET;
            event.ownerID = event.ownerID ? event.ownerID : currentMission.id;
            try {
                const receivedEvent = yield this.eventService.createEvent(event);
                if (!!this.awsKinesisAnalytics && !!this.awsKinesisAnalytics.record && this.awsKinesisAnalytics.record()) {
                    this.awsKinesisAnalytics.getInstance().record(
                    // @ts-ignore
                    {
                        data: {
                            eventType: 'Ticket Change',
                            ticketId: event.ticketID,
                            ticket: ticket,
                            status: event.status,
                            event: event,
                            user: this.userService.cu,
                            locationId: this.currentSpaceID,
                            timestamp: new Date(),
                            zoneId: this.zoneIDFilter,
                            floorId: (_a = this.selectedFloor) === null || _a === void 0 ? void 0 : _a.id,
                        },
                        streamName: 'smarterplanKinesis-analytics',
                        // partitionKey: "",
                    }, 'AWSKinesis');
                }
                // console.log('Event successfully created !');
                return receivedEvent;
            }
            catch (error) {
                return null;
            }
        });
    }
    addTicket(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            ticket.status = TicketStatus.CREATED;
            if (!ticket.ownerMissionID) {
                ticket.ownerMissionID = this.userService.currentMission(ticket.spaceID).id;
            }
            // TODO!!! filter missions by space of ticket
            try {
                const receivedTicket = yield this.createTicket(ticket);
                // console.log('!!! Response from creating ticket :');
                // console.log(receivedTicket);
                this.addEventToTicket(receivedTicket, {
                    title: 'Création du ticket',
                    description: `Ticket créé par -`,
                    translationPath: 'ticketEvent.ticket.created',
                });
                this.updateDone.next(true);
                return receivedTicket; // instead of true
            }
            catch (error) {
                console.log('Ticket creation FAILED');
                console.log(JSON.stringify(error));
            }
        });
    }
    updateTicketWithEvent(ticket, event) {
        return __awaiter(this, void 0, void 0, function* () {
            const receivedTicket = yield this.updateTicket(ticket);
            if (receivedTicket) {
                console.log('Updated ticket :');
                console.log(receivedTicket);
                if (event) {
                    yield this.addEventToTicket(receivedTicket, event);
                }
                this.updateDone.next(true);
            }
            return receivedTicket;
        });
    }
    removeAssigneeFromTicket(ticket, assignee) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const affectation = yield this.affectationService.softDeleteAffectationByID(assignee.id);
                if (!affectation) {
                    console.warn(`removeAssigneeFromTicket(${ticket.id}, ${assignee.id}) failed`);
                }
            }
            catch (error) {
                console.error(error);
            }
            return ticket;
        });
    }
    updateTicketLocation(ticket, tagData) {
        return __awaiter(this, void 0, void 0, function* () {
            const poiInput = {
                coordinate: tagData.getCoordinateString(),
                type: PoiType.TICKET,
                elementID: ticket.id,
                metadata: tagData.getMetadataString(),
                matterportSweepID: tagData.getSweepID(),
            };
            const poi = yield this.poiService.createPOIForSpaceID(poiInput);
            yield this.addEventToTicket(ticket, {
                title: 'Changement position du ticket',
                description: "Le point d'intérêt du ticket a été modifié",
                status: EventStatus.POSITION_SET,
                translationPath: 'ticketEvent.position.set',
            });
            return poi;
        });
    }
    updateStatusOfTicket(ticket, status) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentStatus = ticket.status;
            const oldTicketStatus = ticket.status;
            ticket.status = status;
            if (currentStatus === status) {
                return ticket;
            }
            console.log('Updating status');
            return this.updateTicket({
                id: ticket.id,
                status,
            });
        });
    }
    updateTypeOfTicket(ticket, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const previousType = ticket.type;
            ticket.type = type;
            yield this.updateTicketWithEvent({ id: ticket.id, type: ticket.type }, {
                title: 'Type changé',
                description: `Changement de ${previousType} vers ${ticket.type}`,
                metadata: JSON.stringify({ type: ticket.type }),
                translationPath: 'ticketEvent.ticket.type',
            });
            return ticket;
        });
    }
    getTicketsForUserForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const ticketsSpace = yield this.getTicketsBySpace(spaceID);
            return this.filterService.filterTicketsForCurrentUserInSpace(ticketsSpace, spaceID);
        });
    }
    /** Basic CRUD operations */
    readTicket(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetTicket(id);
        });
    }
    createTicket(input) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!!this.awsKinesisAnalytics && !!this.awsKinesisAnalytics.record && this.awsKinesisAnalytics.record()) {
                this.awsKinesisAnalytics.getInstance().record(
                // @ts-ignore
                {
                    data: {
                        eventType: 'Object Creation',
                        objectType: 'ticket',
                        //zoneId: input.spaceID, // TODO: check if spaceId == zoneId
                        domain: input.domain,
                        user: this.userService.cu,
                        locationId: this.currentSpaceID,
                        timestamp: new Date(),
                        zoneId: this.zoneIDFilter,
                        floorId: (_a = this.selectedFloor) === null || _a === void 0 ? void 0 : _a.id,
                    },
                    streamName: 'smarterplanKinesis-analytics',
                    // partitionKey: "",
                }, 'AWSKinesis');
            }
            return this.API.__proto__.CreateTicket(input);
        });
    }
    updateTicket(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateTicket(input);
        });
    }
    deleteTicket(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleted = yield this.API.__proto__.DeleteTicket({ id: ticket.id });
            // delete POI
            const poi = yield this.poiService.getPoiByElementId(ticket.id);
            if (poi) {
                this.poiService.deletePoi(poi.id);
            }
            // clean parentID
            if (ticket.children.items.length > 0) {
                ticket.children.items.map((childTicket) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield this.API.__proto__.UpdateTicket({
                            id: childTicket.id,
                            parentID: null,
                        });
                    }
                    catch (_a) {
                        console.warn('Could not update ticket', childTicket.id);
                    }
                    yield this.API.__proto__.CreateEvent({
                        title: 'Ticket parent supprimé',
                        ticketID: childTicket.id,
                        description: `Ticket \"$ticket.title}\" a été supprimé`,
                    });
                }));
            }
            // delete events
            yield Promise.all(ticket.events.items.map((event_) => __awaiter(this, void 0, void 0, function* () {
                yield this.API.__proto__.DeleteEvent({ id: event_.id });
            })));
            // delete affectationns
            if (ticket.assignees.items.length > 0) {
                for (const element of ticket.assignees.items) {
                    this.API.__proto__.DeleteAffectation({ id: element.id });
                }
            }
            // delete comments
            yield Promise.all(ticket.comments.items.map((comment) => __awaiter(this, void 0, void 0, function* () {
                yield this.API.__proto__.DeleteComment({ id: comment.id });
            })));
            yield this.operationService.deleteOperationsForTicket(ticket.id);
            return deleted;
        });
    }
    /** Custom requests */
    getTicketsBySpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .TicketsBySpace(spaceID)
                .then((tickets) => tickets.items);
        });
    }
    updateIconForAllTicketsInSpace(tagIcon, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const tickets = yield this.getTicketsBySpace(spaceID);
            const pois = yield this.updateIconForAllObjects(tickets, tagIcon);
            return { tickets, pois };
        });
    }
    /** Archive related */
    /** Return true if the current user has archived this ticket */
    isArchived(ticket) {
        return ticket.archivedForMissionID
            ? ticket.archivedForMissionID.includes(this.userService.currentMission(ticket.spaceID).id)
            : false;
    }
    setArchived(ticket, archived) {
        let archivedList = ticket.archivedForMissionID
            ? ticket.archivedForMissionID
            : [];
        const missionID = this.userService.currentMission(ticket.spaceID).id;
        archivedList = archivedList.filter((m) => m !== missionID);
        if (archived) {
            archivedList.push(missionID);
        }
        return this.updateTicketWithEvent({
            id: ticket.id,
            archivedForMissionID: archivedList,
        });
    }
    navigateToTicketIn3D(ticket, forceSwitchVisit = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `visit/${ticket.spaceID}`;
            if (forceSwitchVisit) {
                url += `/detail/${ticket.id}`;
            }
            const canGoToTag = yield this.viewerService.action_move_to_tag(`${ticket.id}`);
            if (canGoToTag) {
                return;
            }
            const result = yield this.getModel3dAndSweep(ticket);
            if (!result || !result.model3D) {
                alert('Error while getting virtual visit model');
                return;
            }
            if (!forceSwitchVisit) {
                /** Si on ne force pas la visite, on demande si on veut etre switch */
                openModalForVisitSwitch(this.modalService, result.model3D, ticket.spaceID, { sweepToMove: result.sweep, rotation: result.rotation });
            }
            else {
                /** Si on force le switch de la visit */
                window.open(`${url}?model3D=${result.model3D}&sweep=true`, '_blank');
            }
        });
    }
    initSubscriptions() {
        if (!this.isMuseumUser) {
            this.navSubscription = this.zoneChangeService.zoneChange.subscribe((zone) => {
                this.currentSpaceID = this.navigatorService.currentSpaceID;
                if (!this.currentSpaceID) {
                    this.ticketTags.next(null);
                    this.ticketsUpdated.next({ space: [], zone: null });
                    this.ticketTypeFilter = null;
                    this.zoneIDFilter = null;
                }
                else if (zone.id !== this.zoneIDFilter) {
                    this.zoneIDFilter = zone.id;
                    // console.log("going to init tickets from zone");
                    this.initTickets().catch((e) => console.log(e.message));
                }
            });
            this.filetrSubscription = this.filterService.subscribeToDataFilterUpdate((dateRange) => {
                this.dateFilter = dateRange;
                this.initTickets().catch((e) => console.log(e.message));
            });
            this.dateFilter = this.filterService.currentDateFilter;
            this.updateDone.subscribe(() => {
                if (this.currentSpaceID) {
                    this.initTickets().catch((e) => console.log(e.message));
                }
            });
        }
    }
    unsubscribe() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
TicketsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TicketsService, deps: [{ token: 'currentAwsKinesisAnalyticsService' }, { token: 'currentAPIService' }, { token: OperationService }, { token: EventService }, { token: AffectationService }, { token: PoiService }, { token: BaseUserService }, { token: NavigatorService }, { token: FilterService }, { token: InterventionService }, { token: NavigationService }, { token: ViewerService }, { token: ZoneChangeService }, { token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
TicketsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TicketsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TicketsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAwsKinesisAnalyticsService']
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: OperationService }, { type: EventService }, { type: AffectationService }, { type: PoiService }, { type: BaseUserService }, { type: NavigatorService }, { type: FilterService }, { type: InterventionService }, { type: NavigationService }, { type: ViewerService }, { type: ZoneChangeService }, { type: i1$2.NgbModal }];
    } });

class EquipmentService extends BaseObjectService {
    constructor(apiInjected, awsKinesisAnalyticsInjected, poiService, navigationService, operationService, ticketsService, navigatorService, filterService, userService, viewerService, modalService, zoneChangeService) {
        super(poiService, navigationService);
        this.operationService = operationService;
        this.ticketsService = ticketsService;
        this.navigatorService = navigatorService;
        this.filterService = filterService;
        this.userService = userService;
        this.viewerService = viewerService;
        this.modalService = modalService;
        this.zoneChangeService = zoneChangeService;
        this.prefix = {
            technical: 'equipments/note/technical/',
            image: 'equipments/note/image/',
            financial: 'equipments/note/financial/',
            information: 'equipments/note/information/',
            other: 'equipments/note/other/',
            contractual: 'equipments/note/contractual/',
        };
        this.equipmentsUpdated = new Subject();
        this.currentEquipments = {
            space: [],
            zonesMap: new Map(),
        };
        this.equipmentsTags = new Subject();
        this.floorsPerSpace = null;
        /** Null means we do not apply a filter, empty array ([]), means we that we hide all equipment */
        this.equipmentDomainFilter = null;
        this.updating = new Subject();
        this.currentlyUpdating = false;
        this.deleteObservable = new Subject();
        this.createObservable = new Subject();
        this.updateObservable = new Subject();
        this.selectedFloor = null;
        this.isMuseumUser = false;
        this.destroy$ = new Subject();
        this.API = apiInjected;
        this.awsKinesisAnalytics = awsKinesisAnalyticsInjected;
        this.isMuseumUser = this.userService.hasOnlyMuseumRole();
        this.initSubscriptions();
        this.userService.isChanged.subscribe((isConnected) => {
            if (isConnected) {
                this.isMuseumUser = this.userService.hasOnlyMuseumRole();
                this.initSubscriptions();
            }
            else {
                this.unsubscribe();
            }
        });
        this.zoneChangeService.floorHasChanged.subscribe((floor) => {
            if (floor) {
                this.selectedFloor = floor;
            }
        });
    }
    readEquipment(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetEquipment(id).then((receivedEquip) => __awaiter(this, void 0, void 0, function* () {
                let equip;
                if (receivedEquip) {
                    equip = receivedEquip;
                    equip = yield this.getSignedUrlsForEquipment(receivedEquip);
                    if (equip.domain) {
                        if (equip.domain.parentID) {
                            equip.childDomain = equip.domain;
                            equip.parentDomain = equip.domain.parent;
                        }
                        else {
                            equip.parentDomain = equip.domain;
                        }
                    }
                    if (equip.subequipmentsIDs) {
                        const subEquips = [];
                        yield Promise.all(equip.subequipmentsIDs.map((subId) => __awaiter(this, void 0, void 0, function* () {
                            const subEquip = yield this.API.GetEquipment(subId);
                            subEquips.push(subEquip);
                        })));
                        equip.subEquipments = subEquips;
                    }
                }
                return equip;
            }));
        });
    }
    createEquipment(equip, imageFile, documentFile) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            removeNullKeysFromObject(equip);
            if (!!this.awsKinesisAnalytics && !!this.awsKinesisAnalytics.record && this.awsKinesisAnalytics.record()) {
                this.awsKinesisAnalytics.getInstance().record(
                // @ts-ignore
                {
                    data: {
                        eventType: 'Object Creation',
                        objectType: 'equipment',
                        poi: equip,
                        user: this.userService.cu,
                        locationId: this.currentSpaceID,
                        timestamp: new Date(),
                        zoneId: this.currentZone.id,
                        floorId: (_a = this.selectedFloor) === null || _a === void 0 ? void 0 : _a.id,
                    },
                    streamName: 'smarterplanKinesis-analytics',
                    // partitionKey: "",
                }, 'AWSKinesis');
            }
            return this.API.CreateEquipment(equip).then((receivedEquipment) => __awaiter(this, void 0, void 0, function* () {
                let equipment = receivedEquipment;
                if (equipment) {
                    console.log('equipment created:', equipment);
                    if (documentFile) {
                        yield this.uploadDoc(equipment, documentFile, TypeNote.TECHNICAL);
                    }
                    if (imageFile) {
                        yield this.uploadImage(equipment, imageFile);
                    }
                }
                return equipment;
            }));
        });
    }
    getSignedUrlsForEquipment(equip) {
        return __awaiter(this, void 0, void 0, function* () {
            const equipment = Object.assign({}, equip);
            if (equipment.notes.items.length > 0) {
                const docs = [];
                yield Promise.all(equipment.notes.items.map((note) => __awaiter(this, void 0, void 0, function* () {
                    equipment.documentationImageUrlSigned =
                        yield getSignedImageUrlForEquipment(equipment);
                    if (note.attachment) {
                        const { length } = note.attachment.split('/');
                        const filename = note.attachment.split('/')[length - 1];
                        const attachment = yield getSignedFile(note.attachment);
                        if (attachment) {
                            docs.push({
                                filename,
                                url: note.attachment,
                                urlSigned: attachment,
                                noteID: note.id,
                            });
                        }
                    }
                })));
                equipment.documents = docs;
                return equipment;
            }
            return equipment;
        });
    }
    getEquipmentsForTicket(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            const operations = ticket.operations.items;
            if (operations.length > 0) {
                operations.sort((a, b) => 
                // @ts-ignore
                // eslint-disable-next-line prettier/prettier
                new Date(b.createdAt) - new Date(a.createdAt));
                yield Promise.all(operations.map((operation) => __awaiter(this, void 0, void 0, function* () {
                    operation.equipment = yield this.readEquipment(operation.equipmentID);
                })));
            }
            // to keep the sorting by createdAt
            return operations.map((o) => o.equipment);
        });
    }
    getEquipmentsForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            // split by 100
            const limit = 100;
            let equipsToken = { equips: [], nextToken: null };
            do {
                equipsToken = yield this.mergeEquipmentsForSpaceWithNextTokenWithLimit(spaceID, limit, equipsToken);
            } while (equipsToken.nextToken);
            return equipsToken.equips;
        });
    }
    mergeEquipmentsForSpaceWithNextTokenWithLimit(spaceID, limit, equipsToken) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .EquipmentsBySpace(spaceID, null, 'DESC', null, limit, equipsToken.nextToken // nextToken
            )
                .then((response) => {
                const equipsLimit = response.items;
                const equipsObject = {
                    equips: [...equipsToken.equips, ...equipsLimit],
                    nextToken: response.nextToken,
                };
                return equipsObject;
            });
        });
    }
    uploadImageForAllEquipments(equipments, imageFile) {
        return __awaiter(this, void 0, void 0, function* () {
            if (equipments.length === 0) {
                return [];
            }
            return uploadFileToS3(this.prefix.image, imageFile, 'BATCH').then((url) => __awaiter(this, void 0, void 0, function* () {
                if (url) {
                    const equips = [];
                    for (const equip of equipments) {
                        const currentMission = this.userService.currentMission(equip.spaceID);
                        yield this.API.__proto__.CreateNote({
                            attachment: url,
                            type: TypeNote.IMAGE,
                            equipmentID: equip.id,
                            ownerMissionID: currentMission ? currentMission.id : null,
                        });
                        const update = yield this.API.__proto__.UpdateEquipment({
                            id: equip.id,
                            photo: url,
                        });
                        equips.push(update);
                    }
                    return equips;
                }
                return [];
            }));
        });
    }
    uploadImage(equipment, imageFile) {
        return __awaiter(this, void 0, void 0, function* () {
            return uploadFileToS3(this.prefix.image, imageFile, equipment.id).then((url) => __awaiter(this, void 0, void 0, function* () {
                if (url) {
                    const currentMission = this.userService.currentMission(equipment.spaceID);
                    const note = yield this.API.__proto__.CreateNote({
                        attachment: url,
                        type: TypeNote.IMAGE,
                        equipmentID: equipment.id,
                        ownerMissionID: currentMission ? currentMission.id : null,
                    });
                    yield this.API.__proto__.UpdateEquipment({
                        id: equipment.id,
                        photo: url,
                    });
                    return note;
                }
                return null;
            }));
        });
    }
    updateEquipment(equip, file = null, noteType = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .UpdateEquipment(equip)
                .then((receivedEquipment) => __awaiter(this, void 0, void 0, function* () {
                let equipment = receivedEquipment;
                if (equipment) {
                    console.log('equipment updated:', equipment);
                    if (noteType) {
                        switch (noteType) {
                            case TypeNote.IMAGE:
                                yield this.uploadImage(equipment, file);
                                break;
                            default:
                                yield this.uploadDoc(equipment, file, noteType);
                                break;
                        }
                    }
                }
                return equipment;
            }));
        });
    }
    getPrefixDoc(type) {
        let prefix;
        switch (type) {
            case TypeNote.INFORMATION:
                prefix = this.prefix.information;
                break;
            case TypeNote.FINANCIAL:
                prefix = this.prefix.financial;
                break;
            case TypeNote.CONTRACTUAL:
                prefix = this.prefix.contractual;
                break;
            case TypeNote.OTHER:
                prefix = this.prefix.other;
                break;
            case TypeNote.IMAGE:
                prefix = this.prefix.image;
                break;
            default:
                prefix = this.prefix.technical;
                break;
        }
        return prefix;
    }
    uploadDocForAllEquipments(equipments, documentFile, type) {
        return __awaiter(this, void 0, void 0, function* () {
            if (equipments.length === 0) {
                return [];
            }
            const prefix = this.getPrefixDoc(type);
            const url = yield uploadFileToS3(prefix, documentFile, 'BATCH');
            if (url) {
                const updateList = [];
                for (const equip of equipments) {
                    const mission = this.userService.currentMission(equip.spaceID);
                    const newEquip = yield this.API.__proto__.CreateNote({
                        attachment: url,
                        type,
                        equipmentID: equip.id,
                        ownerMissionID: mission ? mission.id : null,
                    });
                    updateList.push(newEquip);
                }
                return updateList;
            }
            return [];
        });
    }
    uploadDoc(equipment, documentFile, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const prefix = this.getPrefixDoc(type);
            const mission = this.userService.currentMission(equipment.spaceID);
            return uploadFileToS3(prefix, documentFile, equipment.id).then((url) => __awaiter(this, void 0, void 0, function* () {
                if (url) {
                    return this.API.__proto__.CreateNote({
                        attachment: url,
                        type,
                        equipmentID: equipment.id,
                        ownerMissionID: mission ? mission.id : null,
                    });
                }
                return null;
            }));
        });
    }
    deleteEquipment(equip) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleted = yield this.API.__proto__.DeleteEquipment({ id: equip.id });
            console.log('Deleted equipment', deleted);
            // delete POI
            const [poi] = equip.pois.items;
            if (poi) {
                yield this.poiService.deletePoi(poi.id);
            }
            // delete notes related
            if (equip.notes.items.length > 0) {
                yield Promise.all(equip.notes.items.map((note) => __awaiter(this, void 0, void 0, function* () {
                    // delete files from S3
                    /** Not shared with other equipment */
                    if (note.attachment &&
                        !note.attachment.split('/').pop().startsWith('BATCH_')) {
                        yield deleteFromS3(note.attachment);
                    }
                    yield this.API.__proto__.DeleteNote({ id: note.id });
                })));
            }
            // delete operations (remove from linked tickets)
            yield this.operationService.deleteOperationsForEquipment(equip.id);
            return deleted;
        });
    }
    updateEquipmentLocation(equip, tagData) {
        return __awaiter(this, void 0, void 0, function* () {
            const poiInput = {
                coordinate: tagData.getCoordinateString(),
                type: PoiType.EQUIPMENT,
                elementID: equip.id,
                metadata: tagData.getMetadataString(),
                matterportSweepID: tagData.getSweepID(),
            };
            const poi = yield this.poiService.createPOIForSpaceID(poiInput);
            return poi;
        });
    }
    removeTicketFromEquipment(ticket, equip) {
        return __awaiter(this, void 0, void 0, function* () {
            const operationEquip = yield this.operationService.getOperationsByEquipmentID(equip.id);
            const operationToDelete = operationEquip.find((op) => op.ticketID === ticket.id);
            return this.operationService
                .deleteOperation(operationToDelete.id)
                .then((res) => {
                this.ticketsService.addEventToTicket(ticket, {
                    title: 'Equipement retiré du ticket',
                    description: `Equipement ${equip.name} a été retiré du ticket`,
                    status: EventStatus.UNLINKED_FROM_EQUIPMENT,
                    type: EventType.TICKET,
                    translationPath: 'ticketEvent.ticket.unlinkedFromEquipment',
                    metadata: JSON.stringify({ equipment: equip.name }),
                });
                return res;
            });
        });
    }
    initEquips() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.currentSpaceID) {
                return;
            }
            this.updating.next(true);
            this.currentlyUpdating = true;
            let eqList = yield this.getEquipmentsForSpace(this.currentSpaceID);
            eqList = yield this.filterService.filterEquipmentsForCurrentUserInSpace(this.currentSpaceID, eqList);
            // console.log(eqList);
            if (eqList.length > 0) {
                let filteredEquips = eqList.filter((equipment) => !this.isArchived(equipment));
                yield Promise.all(filteredEquips.map((equip) => __awaiter(this, void 0, void 0, function* () {
                    equip.documentationImageUrlSigned =
                        yield getSignedImageUrlForEquipment(equip);
                })));
                if (this.equipmentDomainFilter) {
                    filteredEquips = this.filterService.filterEquipmentsByDomainList(filteredEquips, this.equipmentDomainFilter);
                }
                this.currentEquipments.space = filteredEquips;
                if (this.zoneIDFilter) {
                    filteredEquips = (yield this.filterService.filterObjectsForZone(filteredEquips, this.zoneIDFilter, this.currentZone));
                }
                this.currentEquipments.zonesMap.set(this.zoneIDFilter, filteredEquips);
                this.equipmentsTags.next(filteredEquips); // adding tags only for the current zone
                this.equipmentsUpdated.next({
                    space: this.currentEquipments.space,
                    zone: filteredEquips,
                }); // for lateral menu
            }
            else {
                if (this.zoneIDFilter) {
                    this.currentEquipments.zonesMap.set(this.zoneIDFilter, []);
                }
                this.equipmentsUpdated.next({ space: [], zone: [] }); // for lateral menu
            }
            // console.log(this.currentEquipments);
            this.updating.next(false);
            this.currentlyUpdating = false;
        });
    }
    getEquipmentsForCurrentUserForSpace(spaceID, missions) {
        return __awaiter(this, void 0, void 0, function* () {
            let results = [];
            const spaceMissions = missions.filter((m) => m.spaceID === spaceID);
            if (spaceMissions.length === 0) {
                return results;
            }
            const canSeeEquips = spaceMissions.some((m) => this.userService.managers.includes(m.role) ||
                m.role === RoleStatus.SERVICE);
            if (!canSeeEquips) {
                return results;
            }
            let domains = [];
            for (const m of spaceMissions) {
                domains = [...domains, m.domains];
            }
            if (domains.length === 0) {
                return results;
            }
            results = yield this.getEquipmentsForSpace(spaceID);
            // results = this.filterService.filterEquipmentsByDomainList(
            //     results,
            //     domains,
            // );
            return results;
        });
    }
    updateIconForAllEquipmentsInSpace(tagIcon, spaceID, domainID = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let equips = yield this.getEquipmentsForSpace(spaceID);
            if (domainID) {
                equips = equips.filter((equip) => equip.domainID === domainID);
            }
            const pois = yield this.updateIconForAllObjects(equips, tagIcon);
            return { equips, pois };
        });
    }
    /** Return true if the current user has archived this equipment */
    isArchived(equipment) {
        return equipment.archivedForMissionID
            ? equipment.archivedForMissionID.includes(this.userService.currentMission(equipment.spaceID).id)
            : false;
    }
    setArchived(equipment, archived) {
        let archivedList = equipment.archivedForMissionID
            ? equipment.archivedForMissionID
            : [];
        const missionID = this.userService.currentMission(equipment.spaceID).id;
        archivedList = archivedList.filter((m) => m !== missionID);
        if (archived) {
            archivedList.push(missionID);
        }
        return this.updateEquipment({
            id: equipment.id,
            archivedForMissionID: archivedList,
        });
    }
    deleteFile(document_) {
        return __awaiter(this, void 0, void 0, function* () {
            yield deleteFromS3(document_.url);
            yield this.API.DeleteNote({ id: document_.noteID });
        });
    }
    navigateToEquipmentIn3D(equipment, forceSwitchVisit = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `visit/${equipment.spaceID}`;
            if (forceSwitchVisit) {
                url += `/equip/${equipment.id}`;
            }
            const canGoToTag = yield this.viewerService.action_move_to_tag(`${equipment.id}`);
            if (canGoToTag) {
                return;
            }
            const result = yield this.getModel3dAndSweep(equipment);
            if (!result || !result.model3D) {
                alert('Error while getting virtual visit model');
                return;
            }
            if (!forceSwitchVisit) {
                // check if we are moving within the same 3D model
                const currentModel = localStorage.getItem('model3D');
                if (currentModel && currentModel === result.model3D) {
                    // we add tag to the visit
                    const poi = equipment.pois.items[0];
                    if (poi.coordinate) {
                        // we force add because we might be in an another zone
                        yield this.viewerService.actionAddObjectFromPOI(equipment, poi);
                        yield this.viewerService.action_move_to_tag(equipment.id);
                    }
                }
                else {
                    /** Si on ne force pas la visite, on demande si on veut etre switch */
                    openModalForVisitSwitch(this.modalService, result.model3D, equipment.spaceID, { sweepToMove: result.sweep, rotation: result.rotation });
                }
            }
            else {
                /** Si on force le switch de la visit */
                window.open(`${url}?model3D=${result.model3D}&sweep=true`, '_blank');
            }
        });
    }
    updateEquipsForZone() {
        return __awaiter(this, void 0, void 0, function* () {
            this.updating.next(true);
            let filteredEquips = [];
            if (this.currentEquipments.space.length > 0) {
                if (this.zoneIDFilter &&
                    this.currentEquipments.zonesMap.has(this.zoneIDFilter)) {
                    filteredEquips = this.currentEquipments.zonesMap.get(this.zoneIDFilter);
                    // console.log("i have equips for this zone", filteredEquips);
                }
                else {
                    filteredEquips = (yield this.filterService.filterObjectsForZone(this.currentEquipments.space, this.zoneIDFilter, this.currentZone));
                    this.currentEquipments.zonesMap.set(this.zoneIDFilter, [
                        ...filteredEquips,
                    ]);
                }
                if (this.equipmentDomainFilter) {
                    filteredEquips = this.filterService.filterEquipmentsByDomainList(filteredEquips, this.equipmentDomainFilter);
                }
                this.equipmentsTags.next(filteredEquips); // adding tags only for the current zone
                this.equipmentsUpdated.next({
                    space: this.currentEquipments.space,
                    zone: filteredEquips,
                }); // for lateral menu
            }
            else {
                this.equipmentsUpdated.next({ space: [], zone: [] }); // for lateral menu
            }
            this.updating.next(false);
        });
    }
    updateDueToDelete(deletedEquipment) {
        // console.log("update due to delete", deletedEquipment);
        const equip = this.currentEquipments.space.find((_equip) => _equip.id === deletedEquipment.id);
        if (equip) {
            const index = this.currentEquipments.space.indexOf(equip);
            this.currentEquipments.space.splice(index, 1);
        }
        for (const zone of this.currentEquipments.zonesMap.keys()) {
            const equipToDelete = this.currentEquipments.zonesMap
                .get(zone)
                .find((_equip) => _equip.id === deletedEquipment.id);
            if (equipToDelete) {
                const index = this.currentEquipments.zonesMap
                    .get(zone)
                    .indexOf(equipToDelete);
                this.currentEquipments.zonesMap.get(zone).splice(index, 1);
            }
        }
        this.equipmentsUpdated.next({
            space: this.currentEquipments.space,
            zone: this.currentEquipments.zonesMap.get(this.zoneIDFilter),
        }); // for lateral menu
    }
    updateDueToCreate(createdEquip) {
        this.currentEquipments.space.unshift(createdEquip);
        this.currentEquipments.zonesMap
            .get(this.zoneIDFilter)
            .unshift(createdEquip);
        this.equipmentsUpdated.next({
            space: this.currentEquipments.space,
            zone: this.currentEquipments.zonesMap.get(this.zoneIDFilter),
        }); // for lateral menu
    }
    updateDueToEquipUpdated(updatedEquip) {
        const equip = this.currentEquipments.space.find((_equip) => _equip.id === updatedEquip.id);
        if (equip) {
            const index = this.currentEquipments.space.indexOf(equip);
            if (this.isArchived(equip)) {
                // we remove archived equipment
                this.currentEquipments.space.splice(index, 1);
            }
            else {
                this.currentEquipments.space.splice(index, 1, updatedEquip);
            }
        }
        for (const zone of this.currentEquipments.zonesMap.keys()) {
            const equipToUpd = this.currentEquipments.zonesMap
                .get(zone)
                .find((_equip) => _equip.id === updatedEquip.id);
            if (equipToUpd) {
                const index = this.currentEquipments.zonesMap
                    .get(zone)
                    .indexOf(equipToUpd);
                if (this.isArchived(equip)) {
                    this.currentEquipments.zonesMap.get(zone).splice(index, 1);
                }
                else {
                    this.currentEquipments.zonesMap
                        .get(zone)
                        .splice(index, 1, updatedEquip);
                }
            }
        }
        this.equipmentsUpdated.next({
            space: this.currentEquipments.space,
            zone: this.currentEquipments.zonesMap.get(this.zoneIDFilter),
        }); // for lateral menu
    }
    initSubscriptions() {
        if (!this.isMuseumUser) {
            this.zoneChangeService.zoneChange
                .pipe(takeUntil(this.destroy$))
                .subscribe((zone) => {
                if (!zone || !this.navigatorService.currentSpaceID) {
                    this.currentSpaceID = this.navigatorService.currentSpaceID;
                    this.equipmentsTags.next(null);
                    this.equipmentsUpdated.next({ space: [], zone: null });
                    this.zoneIDFilter = null;
                    this.currentEquipments = {
                        space: [],
                        zonesMap: new Map(),
                    };
                    return;
                }
                if (zone.id !== this.zoneIDFilter) {
                    this.zoneIDFilter = zone.id;
                    this.currentZone = zone;
                    if (this.currentSpaceID === this.navigatorService.currentSpaceID) {
                        // same space,  only zone update
                        // console.log(
                        //     "going to update equips for zone (same space)",
                        //     zone,
                        // );
                        this.updateEquipsForZone();
                    }
                    else {
                        this.currentSpaceID = this.navigatorService.currentSpaceID;
                        // console.log(
                        //     "going to init equips for zone for new space",
                        //     this.currentSpaceID,
                        // );
                        this.initEquips();
                    }
                }
            });
            this.deleteObservable
                .pipe(takeUntil(this.destroy$))
                .subscribe((equipment) => {
                if (this.currentSpaceID) {
                    this.updateDueToDelete(equipment);
                }
            });
            this.createObservable
                .pipe(takeUntil(this.destroy$))
                .subscribe((equipment) => {
                if (this.currentSpaceID) {
                    this.updateDueToCreate(equipment);
                }
            });
            this.updateObservable
                .pipe(takeUntil(this.destroy$))
                .subscribe((equipment) => {
                if (this.currentSpaceID) {
                    this.updateDueToEquipUpdated(equipment);
                }
            });
        }
    }
    unsubscribe() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
EquipmentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: EquipmentService, deps: [{ token: 'currentAPIService' }, { token: 'currentAwsKinesisAnalyticsService' }, { token: PoiService }, { token: NavigationService }, { token: OperationService }, { token: TicketsService }, { token: NavigatorService }, { token: FilterService }, { token: BaseUserService }, { token: ViewerService }, { token: i1$2.NgbModal }, { token: ZoneChangeService }], target: i0.ɵɵFactoryTarget.Injectable });
EquipmentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: EquipmentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: EquipmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAwsKinesisAnalyticsService']
                    }] }, { type: PoiService }, { type: NavigationService }, { type: OperationService }, { type: TicketsService }, { type: NavigatorService }, { type: FilterService }, { type: BaseUserService }, { type: ViewerService }, { type: i1$2.NgbModal }, { type: ZoneChangeService }];
    } });

var SearchObjectType;
(function (SearchObjectType) {
    SearchObjectType["USER"] = "USER";
    SearchObjectType["EQUIPMENT"] = "EQUIPMENT";
    SearchObjectType["TICKET"] = "TICKET";
    SearchObjectType["LOCATION"] = "LOCATION";
    SearchObjectType["FEATURE"] = "FEATURE";
    SearchObjectType["TEMPLATE"] = "TEMPLATE";
})(SearchObjectType || (SearchObjectType = {}));
class SearchService {
    constructor(filterService, equipmentService) {
        this.filterService = filterService;
        this.equipmentService = equipmentService;
    }
    searchForTermForTypeInMap(term, objectType, searchable) {
        return __awaiter(this, void 0, void 0, function* () {
            let results;
            switch (objectType) {
                case SearchObjectType.EQUIPMENT:
                    results = new Map();
                    for (const [space, equips] of searchable.entries()) {
                        const filteredEquips = this.filterService.filterEquipmentsForTerm(equips, term);
                        results.set(space, filteredEquips);
                    }
                    break;
                case SearchObjectType.TICKET:
                    results = new Map();
                    for (const [space, tickets] of searchable.entries()) {
                        yield Promise.all(tickets.map((ticket) => __awaiter(this, void 0, void 0, function* () {
                            const equips = yield this.equipmentService.getEquipmentsForTicket(ticket);
                            if (equips.length > 0) {
                                ticket.equipments = equips;
                            }
                        })));
                        const filteredTickets = this.filterService.filterTicketsForTerm(tickets, term);
                        results.set(space, filteredTickets);
                    }
                    break;
                case SearchObjectType.LOCATION:
                    results = this.filterService.filterLocationsForTerm(searchable, term);
                    break;
                case SearchObjectType.USER:
                    results = [];
                    for (const orgObject of searchable) {
                        const orgResults = this.filterService.filterOrganisationsForTerm([orgObject.org], term);
                        if (orgResults.length === 0) {
                            const profiles = orgObject.users.map((object) => object.user);
                            const userResults = this.filterService.filterUsersForTerm(profiles, term);
                            const filteredUserMissions = orgObject.users.filter((object) => userResults.includes(object.user));
                            if (userResults.length > 0) {
                                results.push({
                                    org: orgObject.org,
                                    users: filteredUserMissions,
                                });
                            }
                        }
                        else {
                            results.push(orgObject);
                        }
                    }
                    break;
                case SearchObjectType.FEATURE:
                    results = new Map();
                    for (const [space, features] of searchable.entries()) {
                        const filteredFeatures = yield this.filterService.filterFeaturesForTerm(features, term);
                        results.set(space, filteredFeatures);
                    }
                    break;
                case SearchObjectType.TEMPLATE:
                    results = new Map();
                    for (const [zone, templates] of searchable) {
                        const templateResults = this.filterService.filterTemplatesForTerm(templates, term);
                        if (templateResults.length > 0) {
                            results.set(zone, templateResults);
                        }
                    }
                    break;
                default:
                    break;
            }
            return results;
        });
    }
    searchForTermForTypeInList(term, objectType, searchable) {
        return __awaiter(this, void 0, void 0, function* () {
            let results;
            switch (objectType) {
                case SearchObjectType.EQUIPMENT:
                    results = this.filterService.filterEquipmentsForTerm(searchable, term);
                    break;
                case SearchObjectType.TICKET:
                    yield Promise.all(searchable.map((ticket) => __awaiter(this, void 0, void 0, function* () {
                        const equips = yield this.equipmentService.getEquipmentsForTicket(ticket);
                        if (equips.length > 0) {
                            ticket.equipements = equips;
                        }
                    })));
                    results = this.filterService.filterTicketsForTerm(searchable, term);
                    break;
                case SearchObjectType.LOCATION:
                    results = this.filterService.filterLocationsForTerm(searchable, term);
                    break;
                case SearchObjectType.FEATURE:
                    results = this.filterService.filterFeaturesForTerm(searchable, term);
                    break;
                default:
                    break;
            }
            return results;
        });
    }
}
SearchService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SearchService, deps: [{ token: FilterService }, { token: EquipmentService }], target: i0.ɵɵFactoryTarget.Injectable });
SearchService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SearchService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SearchService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: FilterService }, { type: EquipmentService }]; } });

class SearchBarComponent {
    // formatter = (result: string) => result.toUpperCase();
    // search: OperatorFunction<string, readonly string[]> = (
    //     text$: Observable<string>,
    // ) =>
    //     text$.pipe(
    //         debounceTime(200),
    //         distinctUntilChanged(),
    //         map((term) =>
    //             term === ""
    //                 ? []
    //                 : this.searchable
    //                     .filter((v) =>
    //                         v.toLowerCase().includes(term.toLowerCase()),
    //                     )
    //                     .slice(0, 10),
    //         ),
    //     );
    // filter = (input: string[]) => string[];
    constructor(searchService) {
        this.searchService = searchService;
        this.searchEvent = new EventEmitter();
    }
    ngOnInit() {
        const input = document.querySelector("#searchbar");
        input.addEventListener("keydown", ({ key }) => {
            if (key === "Enter") {
                this.onSubmit();
            }
        });
    }
    onSubmit() {
        const input = document.querySelector("#searchbar");
        const searchValue = input.value.toLowerCase();
        if (searchValue !== "") {
            this.filter(searchValue);
        }
        else {
            this.searchEvent.emit(null);
        }
    }
    filter(term) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = yield this.searchService.searchForTermForTypeInMap(term, this.objectType, this.searchable);
            this.searchEvent.emit(results);
        });
    }
}
SearchBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SearchBarComponent, deps: [{ token: SearchService }], target: i0.ɵɵFactoryTarget.Component });
SearchBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: SearchBarComponent, selector: "lib-search-bar", inputs: { searchable: "searchable", objectType: "objectType" }, outputs: { searchEvent: "searchEvent" }, ngImport: i0, template: "<div class=\"col-md-8 searchbar\">\n    <div class=\"row depend\">\n        <div class=\"col-md-5\">\n            <input id=\"searchbar\" type=\"text\" class=\"form-control\" placeholder=\"keyword\" />\n        </div>\n        <div class=\"col-md-5\">\n            <button class=\"btn btn-outline-primary rounded-pill\" (click)=\"onSubmit()\">{{ 'Search' |\n                translate}}</button>\n        </div>\n    </div>\n</div>", styles: [".searchbar{margin-bottom:10px}\n"], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SearchBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-search-bar', template: "<div class=\"col-md-8 searchbar\">\n    <div class=\"row depend\">\n        <div class=\"col-md-5\">\n            <input id=\"searchbar\" type=\"text\" class=\"form-control\" placeholder=\"keyword\" />\n        </div>\n        <div class=\"col-md-5\">\n            <button class=\"btn btn-outline-primary rounded-pill\" (click)=\"onSubmit()\">{{ 'Search' |\n                translate}}</button>\n        </div>\n    </div>\n</div>", styles: [".searchbar{margin-bottom:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: SearchService }]; }, propDecorators: { searchable: [{
                type: Input
            }], objectType: [{
                type: Input
            }], searchEvent: [{
                type: Output
            }] } });

class DurationToStringPipe {
    constructor(translate) {
        this.translate = translate;
    }
    durationToString(duration) {
        const days = Math.floor(duration / 3600 / 24);
        const hours = Math.floor((duration - days * 24 * 3600) / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = Math.floor(duration % 60);
        const daysString = this.translate.instant("day(s)");
        const hoursString = this.translate.instant("hour(s)");
        const oneHourString = this.translate.instant("hour");
        const minutesString = this.translate.instant("minute(s)");
        const secondsString = this.translate.instant("second(s)");
        if (duration > 3600 * 24 * 7) {
            return `${days} ${daysString}`;
        }
        if (duration > 3600 * 24) {
            return `${days} ${daysString} ${hours} ${hoursString}`;
        }
        if (duration === 3600) {
            return `${hours} ${oneHourString}`;
        }
        if (duration > 3600) {
            if (minutes === 0) {
                return `${hours} ${hoursString}`;
            }
            return `${hours} ${hoursString} ${minutes} ${minutesString}`;
        }
        if (duration >= 60) {
            if (seconds === 0) {
                return `${minutes} ${minutesString}`;
            }
            return `${minutes} ${minutesString} ${seconds} ${secondsString}`;
        }
        return `${seconds} ${secondsString}`;
    }
    transform(duration) {
        let subscript;
        const dateObserver = new Observable((observer) => {
            subscript = this.translate.onLangChange.subscribe((event) => {
                observer.next(this.durationToString(duration));
            });
            observer.next(this.durationToString(duration));
            return {
                unsubscribe() {
                    subscript.unsubscribe();
                },
            };
        });
        return dateObserver;
    }
}
DurationToStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DurationToStringPipe, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
DurationToStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DurationToStringPipe, name: "durationToString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DurationToStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationToString'
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; } });

class HashtagService {
    constructor(apiInjected) {
        this.currentHashtags = [];
        this.API = apiInjected;
    }
    getHashtag(hashtagID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetHashtag(hashtagID);
        });
    }
    createHashtag(hashtag) {
        return __awaiter(this, void 0, void 0, function* () {
            const hashtagCreated = yield this.API.__proto__.CreateHashtag(hashtag);
            this.currentHashtags.push(hashtagCreated);
            return hashtagCreated;
        });
    }
    getHashtagsForSpace(spaceID = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!spaceID) {
                if (this.currentHashtags.length === 0 && this.currentSpaceID) {
                    return this.API.__proto__.HashtagsBySpace(this.currentSpaceID).then((response) => response.items);
                }
                return this.currentHashtags;
            }
            this.currentSpaceID = spaceID;
            return this.API.__proto__.HashtagsBySpace(spaceID).then((response) => response.items);
        });
    }
}
HashtagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: HashtagService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
HashtagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: HashtagService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: HashtagService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class HashtagFromIdPipe {
    constructor(hashtagService) {
        this.hashtagService = hashtagService;
    }
    transform(hashtagID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hashtagService.currentHashtags.length === 0) {
                return this.hashtagService.getHashtag(hashtagID).then((hashtag) => {
                    return hashtag.name;
                });
            }
            const hashtag = this.hashtagService.currentHashtags.find((_hashtag) => _hashtag.id === hashtagID);
            return hashtag ? hashtag.name : "";
        });
    }
}
HashtagFromIdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: HashtagFromIdPipe, deps: [{ token: HashtagService }], target: i0.ɵɵFactoryTarget.Pipe });
HashtagFromIdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: HashtagFromIdPipe, name: "hashtagFromID" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: HashtagFromIdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'hashtagFromID'
                }]
        }], ctorParameters: function () { return [{ type: HashtagService }]; } });

class SafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
SafeUrlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SafeUrlPipe, deps: [{ token: i1$3.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeUrlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SafeUrlPipe, name: "safeUrl" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SafeUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeUrl'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.DomSanitizer }]; } });

class TimeDateToLocalStringPipe {
    constructor(translate) {
        this.translate = translate;
    }
    /**
     * Return a string of a given date time in local format.
     * The format is determined by the current language.
     */
    dateTimeToLocalString(date, mode) {
        let lang = "en-EN";
        if (this.translate) {
            /** Get current language */
            lang = this.translate.currentLang
                ? this.translate.currentLang
                : this.translate.defaultLang;
            /** Transforme '_fr' to 'fr' */
            if (lang) {
                lang = lang.slice(1);
            }
        }
        let options;
        switch (mode) {
            case "day_numeric":
                options = { day: "numeric" };
                break;
            case "day":
                options = { weekday: "long" };
                break;
            case "date":
                options = { dateStyle: "long" };
                break;
            case "short_date_time":
                options = {
                    year: "2-digit",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                };
                break;
            case "time":
                options = { hour: "numeric", minute: "numeric" };
                break;
            case "time_zone":
                options = { hour: "numeric", minute: "numeric", timeZoneName: "shortOffset" };
                break;
            case "day_time_zone_weekday":
                options = {
                    weekday: "long",
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    timeZoneName: "shortOffset",
                };
                break;
            case "date_time_zone":
                options = {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "numeric",
                    minute: "numeric",
                    timeZoneName: "shortOffset",
                };
                break;
            default:
                options = {
                    dateStyle: "long",
                    timeStyle: "short",
                };
        }
        return new Date(date).toLocaleString(lang, options);
    }
    transform(date, mode) {
        let subscript;
        const dateObserver = new Observable$1((observer) => {
            subscript = this.translate.onLangChange.subscribe((event) => {
                observer.next(this.dateTimeToLocalString(date, mode));
            });
            observer.next(this.dateTimeToLocalString(date, mode));
            return {
                unsubscribe() {
                    subscript.unsubscribe();
                },
            };
        });
        return dateObserver;
    }
}
TimeDateToLocalStringPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TimeDateToLocalStringPipe, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Pipe });
TimeDateToLocalStringPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TimeDateToLocalStringPipe, name: "timeDateString" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TimeDateToLocalStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'timeDateString'
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; } });

class UsernameFromIdPipe {
    constructor(userService) {
        this.userService = userService;
    }
    transform(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (UsernameFromIdPipe.cache[userId] !== undefined) {
                return new Promise((resolve) => {
                    resolve(UsernameFromIdPipe.cache[userId]);
                });
            }
            const user = yield this.userService.userFromUserID(userId);
            // @ts-ignore
            UsernameFromIdPipe.cache[userId] = `${user.displayName}`;
            return UsernameFromIdPipe.cache[userId];
        });
    }
}
UsernameFromIdPipe.cache = {};
UsernameFromIdPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: UsernameFromIdPipe, deps: [{ token: BaseUserService }], target: i0.ɵɵFactoryTarget.Pipe });
UsernameFromIdPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: UsernameFromIdPipe, name: "usernameFromId" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: UsernameFromIdPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: "usernameFromId",
                }]
        }], ctorParameters: function () { return [{ type: BaseUserService }]; } });

function noEmptyValidator() {
    return (control) => {
        if (control.value && control.value !== '') {
            const data = control.value.replace(/ /g, '');
            return data === '' ? { isEmpty: control.value } : null;
        }
        else {
            return null;
        }
    };
}

function emailValidator() {
    return (control) => {
        const regex = /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/;
        return !regex.test(control.value) ? { email: control.value } : null;
    };
}

function textValidator() {
    return (control) => {
        const regex = /[a-zA-Z1-9]/;
        if (control.value && control.value !== '') {
            return !regex.test(control.value) ? { text: control.value } : null;
        }
        else {
            return null;
        }
    };
}

class SupportService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    /**
     * Open the support form
     */
    openSupportForm(formComponent) {
        this.modalReference = this.modalService.open(formComponent, {
            modalDialogClass: 'modal-padding',
        });
    }
    /**
     * Send support request to jira
     */
    sendSupport(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const response = yield API.post("helpEmail", "/jira-email/new", {
                    body: data,
                });
                if (response.err) {
                    resolve('error');
                }
                else {
                    resolve('send');
                }
            }));
        });
    }
}
SupportService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SupportService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
SupportService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SupportService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SupportService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class ValidatorsService {
    constructor() { }
    /**
     * return if control as error
     * @param control
     * @returns
     */
    isControlError(control) {
        return (control && control.invalid && control.touched);
    }
    /**
     * return error of control
     * @param control
     * @returns
     */
    getError(control) {
        if (control.errors) {
            if (control.errors.required) {
                return 'errorForm.required';
            }
            if (control.errors.isEmpty) {
                return 'errorForm.isEmpty';
            }
            if (control.errors.text) {
                return 'errorForm.text';
            }
            if (control.errors.email) {
                return 'errorForm.email';
            }
            if (control.errors.maxlength) {
                return 'errorForm.maxLength';
            }
            if (control.errors.number) {
                return 'errorForm.number';
            }
        }
        return '';
    }
}
ValidatorsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ValidatorsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ValidatorsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ValidatorsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ValidatorsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class LoaderComponent {
    constructor() {
        this.useLogo = true;
        this.color = "#53B6BB";
    }
    ngOnInit() {
        document.documentElement.style.setProperty('--color', this.color);
    }
}
LoaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: LoaderComponent, selector: "lib-loader", inputs: { useLogo: "useLogo", color: "color" }, ngImport: i0, template: "<div class=\"sk-fading-circle\">\n    <img *ngIf=\"useLogo\" src=\"../../../../assets/icons/smarterplan.svg\">\n    <div class=\"sk-circle1 sk-circle\"></div>\n    <div class=\"sk-circle2 sk-circle\"></div>\n    <div class=\"sk-circle3 sk-circle\"></div>\n    <div class=\"sk-circle4 sk-circle\"></div>\n    <div class=\"sk-circle5 sk-circle\"></div>\n    <div class=\"sk-circle6 sk-circle\"></div>\n    <div class=\"sk-circle7 sk-circle\"></div>\n    <div class=\"sk-circle8 sk-circle\"></div>\n    <div class=\"sk-circle9 sk-circle\"></div>\n    <div class=\"sk-circle10 sk-circle\"></div>\n    <div class=\"sk-circle11 sk-circle\"></div>\n    <div class=\"sk-circle12 sk-circle\"></div>\n</div>\n", styles: [".sk-fading-circle{width:88px;height:88px;position:relative}.sk-fading-circle img{width:2rem;position:absolute;left:calc(50% - 16px);top:calc(50% - 16px)}.sk-fading-circle .sk-circle{width:100%;height:100%;position:absolute;left:0;top:0}.sk-fading-circle .sk-circle:before{content:\"\";display:block;margin:0 auto;width:15%;height:15%;background-color:var(--color);border-radius:100%;animation:sk-circleFadeDelay 1.2s infinite ease-in-out both}.sk-fading-circle .sk-circle2{transform:rotate(30deg)}.sk-fading-circle .sk-circle3{transform:rotate(60deg)}.sk-fading-circle .sk-circle4{transform:rotate(90deg)}.sk-fading-circle .sk-circle5{transform:rotate(120deg)}.sk-fading-circle .sk-circle6{transform:rotate(150deg)}.sk-fading-circle .sk-circle7{transform:rotate(180deg)}.sk-fading-circle .sk-circle8{transform:rotate(210deg)}.sk-fading-circle .sk-circle9{transform:rotate(240deg)}.sk-fading-circle .sk-circle10{transform:rotate(270deg)}.sk-fading-circle .sk-circle11{transform:rotate(300deg)}.sk-fading-circle .sk-circle12{transform:rotate(330deg)}.sk-fading-circle .sk-circle2:before{animation-delay:-1.1s}.sk-fading-circle .sk-circle3:before{animation-delay:-1s}.sk-fading-circle .sk-circle4:before{animation-delay:-.9s}.sk-fading-circle .sk-circle5:before{animation-delay:-.8s}.sk-fading-circle .sk-circle6:before{animation-delay:-.7s}.sk-fading-circle .sk-circle7:before{animation-delay:-.6s}.sk-fading-circle .sk-circle8:before{animation-delay:-.5s}.sk-fading-circle .sk-circle9:before{animation-delay:-.4s}.sk-fading-circle .sk-circle10:before{animation-delay:-.3s}.sk-fading-circle .sk-circle11:before{animation-delay:-.2s}.sk-fading-circle .sk-circle12:before{animation-delay:-.1s}@keyframes sk-circleFadeDelay{0%,39%,to{opacity:0}40%{opacity:1}}\n"], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LoaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-loader', template: "<div class=\"sk-fading-circle\">\n    <img *ngIf=\"useLogo\" src=\"../../../../assets/icons/smarterplan.svg\">\n    <div class=\"sk-circle1 sk-circle\"></div>\n    <div class=\"sk-circle2 sk-circle\"></div>\n    <div class=\"sk-circle3 sk-circle\"></div>\n    <div class=\"sk-circle4 sk-circle\"></div>\n    <div class=\"sk-circle5 sk-circle\"></div>\n    <div class=\"sk-circle6 sk-circle\"></div>\n    <div class=\"sk-circle7 sk-circle\"></div>\n    <div class=\"sk-circle8 sk-circle\"></div>\n    <div class=\"sk-circle9 sk-circle\"></div>\n    <div class=\"sk-circle10 sk-circle\"></div>\n    <div class=\"sk-circle11 sk-circle\"></div>\n    <div class=\"sk-circle12 sk-circle\"></div>\n</div>\n", styles: [".sk-fading-circle{width:88px;height:88px;position:relative}.sk-fading-circle img{width:2rem;position:absolute;left:calc(50% - 16px);top:calc(50% - 16px)}.sk-fading-circle .sk-circle{width:100%;height:100%;position:absolute;left:0;top:0}.sk-fading-circle .sk-circle:before{content:\"\";display:block;margin:0 auto;width:15%;height:15%;background-color:var(--color);border-radius:100%;animation:sk-circleFadeDelay 1.2s infinite ease-in-out both}.sk-fading-circle .sk-circle2{transform:rotate(30deg)}.sk-fading-circle .sk-circle3{transform:rotate(60deg)}.sk-fading-circle .sk-circle4{transform:rotate(90deg)}.sk-fading-circle .sk-circle5{transform:rotate(120deg)}.sk-fading-circle .sk-circle6{transform:rotate(150deg)}.sk-fading-circle .sk-circle7{transform:rotate(180deg)}.sk-fading-circle .sk-circle8{transform:rotate(210deg)}.sk-fading-circle .sk-circle9{transform:rotate(240deg)}.sk-fading-circle .sk-circle10{transform:rotate(270deg)}.sk-fading-circle .sk-circle11{transform:rotate(300deg)}.sk-fading-circle .sk-circle12{transform:rotate(330deg)}.sk-fading-circle .sk-circle2:before{animation-delay:-1.1s}.sk-fading-circle .sk-circle3:before{animation-delay:-1s}.sk-fading-circle .sk-circle4:before{animation-delay:-.9s}.sk-fading-circle .sk-circle5:before{animation-delay:-.8s}.sk-fading-circle .sk-circle6:before{animation-delay:-.7s}.sk-fading-circle .sk-circle7:before{animation-delay:-.6s}.sk-fading-circle .sk-circle8:before{animation-delay:-.5s}.sk-fading-circle .sk-circle9:before{animation-delay:-.4s}.sk-fading-circle .sk-circle10:before{animation-delay:-.3s}.sk-fading-circle .sk-circle11:before{animation-delay:-.2s}.sk-fading-circle .sk-circle12:before{animation-delay:-.1s}@keyframes sk-circleFadeDelay{0%,39%,to{opacity:0}40%{opacity:1}}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { useLogo: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class SupportModalComponent {
    constructor(supportService, activeModal, formBuilder, userService, validatorsService) {
        this.supportService = supportService;
        this.activeModal = activeModal;
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.validatorsService = validatorsService;
        this.status = 'new';
        this.loading = true;
    }
    ngOnInit() {
        this.iniForm();
    }
    onClose() {
        this.activeModal.close();
    }
    getCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const cau = yield Auth.currentAuthenticatedUser();
                    resolve(yield this.userService.current(cau));
                }
                catch (error) {
                    resolve(undefined);
                }
            }));
        });
    }
    iniForm() {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentUser = yield this.getCurrentUser();
            this.supportForm = this.formBuilder.group({
                title: ['', [Validators.required, Validators.maxLength(255), noEmptyValidator(), textValidator()]],
                email: [(this.currentUser ? this.currentUser.email : ''), [Validators.required, emailValidator(), Validators.maxLength(255), textValidator()]],
                description: ['', [Validators.required, noEmptyValidator(), textValidator()]],
            });
            this.loading = false;
        });
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.supportForm.valid) {
                this.loading = true;
                this.status = yield this.supportService.sendSupport(this.supportForm.value);
                this.loading = false;
            }
        });
    }
}
SupportModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SupportModalComponent, deps: [{ token: SupportService }, { token: i1$2.NgbActiveModal }, { token: i3.FormBuilder }, { token: BaseUserService }, { token: ValidatorsService }], target: i0.ɵɵFactoryTarget.Component });
SupportModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: SupportModalComponent, selector: "app-support-modal", ngImport: i0, template: "<div class=\"modal-header\">\n    <h5 class=\"modal-title\" translate=\"Help\"></h5>\n</div>\n<div class=\"modal-body\">\n    <div class=\"support-loader-container\">\n        <lib-loader *ngIf=\"loading\"></lib-loader>\n    </div>\n    <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"supportForm\" style=\"margin-top:1rem;\" *ngIf=\"!loading && status==='new'\">\n        <div>\n            <label>{{'Title' | translate}} *</label>\n            <div>\n                <input type=\"text\" class=\"form-control\" formControlName=\"title\" data-testid=\"new-support-title\"\n                    [ngClass]=\"{'is-invalid' : validatorsService.isControlError(supportForm.controls['title'])}\"\n                    maxlength=\"255\">\n            </div>\n            <div class=\"invalid-feedback\">\n                <span data-testid=\"new-support-title-invalid\" [translate]=\"validatorsService.getError(supportForm.controls['title'])\"\n                    *ngIf=\" validatorsService.isControlError(supportForm.controls['title'])\"></span>\n            </div>\n        </div>\n        <div *ngIf=\"!currentUser\">\n            <label>{{'Email' | translate}} *</label>\n            <div>\n                <input type=\"email\" class=\"form-control\" formControlName=\"email\" data-testid=\"new-support-email\"\n                    [ngClass]=\"{'is-invalid' : validatorsService.isControlError(supportForm.controls['email'])}\"\n                    maxlength=\"255\">\n            </div>\n            <div class=\"invalid-feedback\">\n                <span data-testid=\"new-support-email-invalid\" [translate]=\"validatorsService.getError(supportForm.controls['email'])\"\n                    *ngIf=\" validatorsService.isControlError(supportForm.controls['email'])\"></span>\n            </div>\n        </div>\n        <div>\n            <label>{{'Description' | translate}} *</label>\n            <div>\n                <textarea formControlName=\"description\" class=\"form-control\"\n                    data-testid=\"new-support-description\"\n                    [ngClass]=\"{'is-invalid' : validatorsService.isControlError(supportForm.controls['description'])}\"></textarea>\n            </div>\n            <div class=\"invalid-feedback\" >\n                <span data-testid=\"new-support-description-invalid\" [translate]=\" validatorsService.getError(supportForm.controls['description'])\"\n                *ngIf=\"validatorsService.isControlError(supportForm.controls['description'])\"></span>\n            </div>\n        </div>\n    </form>\n\n    <div *ngIf=\"status ==='send'\" translate=\"Your request has been registered\" data-testid=\"new-support-send-info\">\n    </div>\n    <div *ngIf=\"status ==='error'\" translate=\"An error has occurred, please renew your request\"\n        data-testid=\"new-support-error-info\">\n\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn rounded-pill btn-museum\" data-dismiss=\"modal\" translate=\"Close\" (click)=\"onClose()\"\n        data-testid=\"new-support-close-btn\"></button>\n    <button *ngIf=\"!loading && status==='new'\" type=\"button\" class=\"btn rounded-pill btn-museum\" translate=\"Submit\"\n        (click)=\"onSubmit()\" [disabled]=\"!supportForm.valid\" data-testid=\"new-support-submit-btn\"></button>\n</div>", styles: [".support-loader-container{width:88px;margin:auto}.invalid-feedback{height:16px}\n"], components: [{ type: LoaderComponent, selector: "lib-loader", inputs: ["useLogo", "color"] }], directives: [{ type: i1.TranslateDirective, selector: "[translate],[ngx-translate]", inputs: ["translate", "translateParams"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i3.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SupportModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-support-modal', template: "<div class=\"modal-header\">\n    <h5 class=\"modal-title\" translate=\"Help\"></h5>\n</div>\n<div class=\"modal-body\">\n    <div class=\"support-loader-container\">\n        <lib-loader *ngIf=\"loading\"></lib-loader>\n    </div>\n    <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"supportForm\" style=\"margin-top:1rem;\" *ngIf=\"!loading && status==='new'\">\n        <div>\n            <label>{{'Title' | translate}} *</label>\n            <div>\n                <input type=\"text\" class=\"form-control\" formControlName=\"title\" data-testid=\"new-support-title\"\n                    [ngClass]=\"{'is-invalid' : validatorsService.isControlError(supportForm.controls['title'])}\"\n                    maxlength=\"255\">\n            </div>\n            <div class=\"invalid-feedback\">\n                <span data-testid=\"new-support-title-invalid\" [translate]=\"validatorsService.getError(supportForm.controls['title'])\"\n                    *ngIf=\" validatorsService.isControlError(supportForm.controls['title'])\"></span>\n            </div>\n        </div>\n        <div *ngIf=\"!currentUser\">\n            <label>{{'Email' | translate}} *</label>\n            <div>\n                <input type=\"email\" class=\"form-control\" formControlName=\"email\" data-testid=\"new-support-email\"\n                    [ngClass]=\"{'is-invalid' : validatorsService.isControlError(supportForm.controls['email'])}\"\n                    maxlength=\"255\">\n            </div>\n            <div class=\"invalid-feedback\">\n                <span data-testid=\"new-support-email-invalid\" [translate]=\"validatorsService.getError(supportForm.controls['email'])\"\n                    *ngIf=\" validatorsService.isControlError(supportForm.controls['email'])\"></span>\n            </div>\n        </div>\n        <div>\n            <label>{{'Description' | translate}} *</label>\n            <div>\n                <textarea formControlName=\"description\" class=\"form-control\"\n                    data-testid=\"new-support-description\"\n                    [ngClass]=\"{'is-invalid' : validatorsService.isControlError(supportForm.controls['description'])}\"></textarea>\n            </div>\n            <div class=\"invalid-feedback\" >\n                <span data-testid=\"new-support-description-invalid\" [translate]=\" validatorsService.getError(supportForm.controls['description'])\"\n                *ngIf=\"validatorsService.isControlError(supportForm.controls['description'])\"></span>\n            </div>\n        </div>\n    </form>\n\n    <div *ngIf=\"status ==='send'\" translate=\"Your request has been registered\" data-testid=\"new-support-send-info\">\n    </div>\n    <div *ngIf=\"status ==='error'\" translate=\"An error has occurred, please renew your request\"\n        data-testid=\"new-support-error-info\">\n\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn rounded-pill btn-museum\" data-dismiss=\"modal\" translate=\"Close\" (click)=\"onClose()\"\n        data-testid=\"new-support-close-btn\"></button>\n    <button *ngIf=\"!loading && status==='new'\" type=\"button\" class=\"btn rounded-pill btn-museum\" translate=\"Submit\"\n        (click)=\"onSubmit()\" [disabled]=\"!supportForm.valid\" data-testid=\"new-support-submit-btn\"></button>\n</div>", styles: [".support-loader-container{width:88px;margin:auto}.invalid-feedback{height:16px}\n"] }]
        }], ctorParameters: function () { return [{ type: SupportService }, { type: i1$2.NgbActiveModal }, { type: i3.FormBuilder }, { type: BaseUserService }, { type: ValidatorsService }]; } });

class LocaleService {
    constructor(translate) {
        this.translate = translate;
        this.currentLocale = "en";
        // Observable string sources
        this.showModalSource = new Subject();
        this.showModal$ = this.showModalSource.asObservable();
    }
    modal() {
        this.showModalSource.next(true);
    }
    /**
     * Reload the app to another language.
     *
     * Navigation is required because of the way angular localizes: locales are
     * completely different compilation bundles, in separate directories, hence
     * you need to reload.
     *
     * @param lang
     */
    change(lang) {
        console.log("Switching to", lang);
        this.currentLocale = lang;
        this.translate.use(`_${lang}`); // because files are "_en.json"
    }
    getLocale() {
        const lang = this.translate.currentLang
            ? this.translate.currentLang
            : this.translate.defaultLang;
        return lang.slice(1);
    }
}
LocaleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LocaleService, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
LocaleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LocaleService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LocaleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; } });

/* eslint-disable class-methods-use-this */
var CacheKeys;
(function (CacheKeys) {
    CacheKeys["INSTRUCTIONS_SHOWN"] = "instructions_shown";
})(CacheKeys || (CacheKeys = {}));
class AmplifyCacheService {
    constructor() {
        const config = {
            itemMaxSize: 3000,
            defaultTTL: 36000000, // one hour
        };
        Cache.configure(config);
        // this.getAllKeys();
    }
    /**
     * Puts item in cache under a key
     * @param key : string. Key for lookup.
     * @param value : Iem to put (number, string, boolean, array or object)
     * @param expires : number. Time in future in milliseconds Date.getTime()
     * @param priority : number from 0 to 5. the cached item with the higher number will be expired first.
     */
    putInCache(key, value, expires = null, priority = 5) {
        const options = {
            priority,
            expires,
        };
        if (!expires) {
            delete options.expires;
        }
        Cache.setItem(key, value, options);
    }
    /**
     * Retrieves an item from the cache. It will return null if the item doesn’t exist or it has expired.
     * @param key string. Lookup key.
     * @returns any or null if nothing found.
     */
    getFromCache(key) {
        return Cache.getItem(key);
    }
    /**
     * Removes item from cache.
     * @param key string. Key to remove.
     */
    removeFromCache(key) {
        Cache.removeItem(key);
    }
    /**
     * Removes all of the items in the cache.
     */
    clearCache() {
        Cache.clear();
    }
    /**
     * Returns all of the keys available in the cache.
     * @returns string[]
     */
    getAllKeys() {
        return Cache.getAllKeys();
    }
}
AmplifyCacheService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AmplifyCacheService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
AmplifyCacheService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AmplifyCacheService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AmplifyCacheService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class FormatDateNumberToDigitsPipe {
    constructor(formatter) {
        this.formatter = formatter;
    }
    transform(date) {
        let [day, month, year] = this.formatter.format(date).split("/");
        if (day) {
            const nDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            const result = nDate.toLocaleDateString(undefined, {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
            });
            return result;
        }
        return this.formatter.format(date);
    }
}
FormatDateNumberToDigitsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FormatDateNumberToDigitsPipe, deps: [{ token: i1$2.NgbDateParserFormatter }], target: i0.ɵɵFactoryTarget.Pipe });
FormatDateNumberToDigitsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FormatDateNumberToDigitsPipe, name: "formatDateNumberToDigits" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FormatDateNumberToDigitsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'formatDateNumberToDigits'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbDateParserFormatter }]; } });

class RangeDatePickerComponent {
    constructor(calendar, formatter, filterService, cacheService) {
        this.calendar = calendar;
        this.formatter = formatter;
        this.filterService = filterService;
        this.cacheService = cacheService;
        this.hoveredDate = null;
        this.isDateFilterApplied = false;
        this.dateChanged = false;
        // this.fromDate = calendar.getPrev(calendar.getToday(), "d", 30);
        // this.toDate = calendar.getToday();
    }
    ngOnInit() {
        if (this.cacheName) {
            this.cache = this.cacheService.getFromCache(this.cacheName);
        }
        if (this.cache) {
            this.isDateFilterApplied = true;
            let { from, to } = this.cache;
            this.toDate = this.getNgbDate(to);
            this.fromDate = this.getNgbDate(from);
            localStorage.setItem('startDate', from.toString());
            localStorage.setItem('endDate', to.toString());
            this.filterService.dateFilterUpdated([new Date(from), new Date(to)]);
        }
        else {
            const currentDate = new Date().getTime(); //get current timestamp
            const thirtyDaysAgoDate = currentDate - 30 * 24 * 60 * 60 * 1000; //substract 30 days in miliseconds from the current timestamp
            // add dates to localstorage for retool urlsParams
            localStorage.setItem('startDate', thirtyDaysAgoDate.toString());
            localStorage.setItem('endDate', currentDate.toString());
            // updates date range dates to last 30 days ranges from today
            this.fromDate = this.getNgbDate(thirtyDaysAgoDate);
            this.toDate = this.getNgbDate(currentDate);
            this.filterService.dateFilterUpdated([
                new Date(thirtyDaysAgoDate.toString()),
                new Date(currentDate.toString()),
            ]);
        }
    }
    getNgbDate(date) {
        let dt = new Date(date);
        dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset()); // convert to UTC
        return new NgbDate(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
    }
    onDateSelection(date) {
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        }
        else if (this.fromDate &&
            !this.toDate &&
            date &&
            date.after(this.fromDate)) {
            this.toDate = date;
        }
        else {
            this.toDate = null;
            this.fromDate = date;
        }
        this.isDateChanged();
    }
    isDateChanged() {
        if (this.fromDate && this.toDate) {
            if (this.cache) {
                this.dateChanged =
                    !this.fromDate.equals(this.getNgbDate(this.cache.from)) ||
                        !this.toDate.equals(this.getNgbDate(this.cache.to));
            }
        }
    }
    isHovered(date) {
        return (this.fromDate &&
            !this.toDate &&
            this.hoveredDate &&
            date.after(this.fromDate) &&
            date.before(this.hoveredDate));
    }
    isInside(date) {
        return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }
    isRange(date) {
        return (date.equals(this.fromDate) ||
            (this.toDate && date.equals(this.toDate)) ||
            this.isInside(date) ||
            this.isHovered(date));
    }
    validateInput(currentValue, input) {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed))
            ? NgbDate.from(parsed)
            : currentValue;
    }
    emitRange() {
        if (this.fromDate && this.toDate) {
            const from = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
            const to = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day, 23, 59);
            this.cacheService.putInCache(this.cacheName, {
                from: from.getTime(),
                to: to.getTime(),
            });
            this.filterService.dateFilterUpdated([from, to]);
            this.isDateFilterApplied = true;
            this.dateChanged = false;
        }
    }
    onClearDates() {
        this.fromDate = null;
        this.toDate = null;
        this.isDateFilterApplied = false;
        this.cacheService.removeFromCache(this.cacheName);
        this.filterService.dateFilterUpdated(null);
    }
    onApply() {
        if (this.fromDate && this.toDate) {
            this.emitRange();
        }
        //transform ngbDate to date objet then put dates in timestamp in localStorage to share it with Retool
        if (this.fromDate) {
            const startDate = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
            localStorage.setItem('startDate', startDate.getTime().toString());
            console.log('test setItem from : ' + startDate.getTime().toString());
        }
        if (this.toDate) {
            const endDate = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
            localStorage.setItem('endDate', endDate.getTime().toString());
        }
    }
}
RangeDatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: RangeDatePickerComponent, deps: [{ token: i1$2.NgbCalendar }, { token: i1$2.NgbDateParserFormatter }, { token: FilterService }, { token: AmplifyCacheService }], target: i0.ɵɵFactoryTarget.Component });
RangeDatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: RangeDatePickerComponent, selector: "lib-range-date-picker", inputs: { cacheName: "cacheName" }, ngImport: i0, template: "<form class=\"form-inline\">\r\n    <div class=\"mb-3 hidden\">\r\n        <div class=\"input-group\">\r\n            <input name=\"datepicker\" class=\"form-control\" ngbDatepicker #datepicker=\"ngbDatepicker\"\r\n                [autoClose]=\"'outside'\" (dateSelect)=\"onDateSelection($event)\" [displayMonths]=\"2\" [dayTemplate]=\"t\"\r\n                outsideDays=\"hidden\" [startDate]=\"fromDate!\" tabindex=\"-1\">\r\n            <ng-template #t let-date let-focused=\"focused\">\r\n                <span class=\"custom-day\" [class.focused]=\"focused\" [class.range]=\"isRange(date)\"\r\n                    [class.faded]=\"isHovered(date) || isInside(date)\" (mouseenter)=\"hoveredDate = date\"\r\n                    (mouseleave)=\"hoveredDate = null\">\r\n                    {{ date.day }}\r\n                </span>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n    <div>\r\n        <div class=\"input-group\">\r\n            <input #dpFromDate class=\"form-control\" placeholder=\"dd/MM/yyyy\" name=\"dpFromDate\"\r\n                [value]=\"fromDate | formatDateNumberToDigits\"\r\n                (input)=\"fromDate = validateInput(fromDate, dpFromDate.value)\">\r\n            <div class=\"input-group-append\">\r\n                <button class=\"btn btn-outline-secondary calendar\" (click)=\"datepicker.toggle()\" type=\"button\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"mb-3 ms-2\">\r\n        <div class=\"input-group\">\r\n            <input #dpToDate class=\"form-control\" placeholder=\"dd/MM/yyyy\" name=\"dpToDate\"\r\n                [value]=\"toDate | formatDateNumberToDigits\" (input)=\"toDate = validateInput(toDate, dpToDate.value)\">\r\n            <div class=\"input-group-append\">\r\n                <button class=\"btn btn-outline-secondary calendar\" (click)=\"datepicker.toggle()\" type=\"button\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <button class=\"btn btn-outline-primary rounded-pill ms-3\" (click)=\"onApply()\"\r\n        *ngIf=\"!isDateFilterApplied || dateChanged\">\r\n        {{'Apply' | translate}}\r\n    </button>\r\n    <span class=\"appliedText ms-3\" *ngIf=\"isDateFilterApplied && !dateChanged\">\r\n        <span class=\"iconify\" data-icon=\"ion:checkmark\" data-width=\"15\" data-height=\"15\"></span>\r\n        {{\"Applied\" | translate}}\r\n    </span>\r\n    <button class=\"btn btn-outline-primary rounded-pill ms-3\" (click)=\"onClearDates()\">{{'Clear' |\r\n        translate}}</button>\r\n</form>", styles: [".mb-3.hidden{width:0;margin:0;border:none;padding:0}.custom-day{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.custom-day.focused{background-color:#e6e6e6}.custom-day.range,.custom-day:hover{background-color:var(--smarterplan-primary-lighter);color:#fff}.custom-day.faded{background-color:var(--smarterplan-primary-transparent)}.calendar{height:100%}.appliedText,.appliedText span{color:var(--smarterplan-primary)}\n"], directives: [{ type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "formatDateNumberToDigits": FormatDateNumberToDigitsPipe, "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: RangeDatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-range-date-picker', template: "<form class=\"form-inline\">\r\n    <div class=\"mb-3 hidden\">\r\n        <div class=\"input-group\">\r\n            <input name=\"datepicker\" class=\"form-control\" ngbDatepicker #datepicker=\"ngbDatepicker\"\r\n                [autoClose]=\"'outside'\" (dateSelect)=\"onDateSelection($event)\" [displayMonths]=\"2\" [dayTemplate]=\"t\"\r\n                outsideDays=\"hidden\" [startDate]=\"fromDate!\" tabindex=\"-1\">\r\n            <ng-template #t let-date let-focused=\"focused\">\r\n                <span class=\"custom-day\" [class.focused]=\"focused\" [class.range]=\"isRange(date)\"\r\n                    [class.faded]=\"isHovered(date) || isInside(date)\" (mouseenter)=\"hoveredDate = date\"\r\n                    (mouseleave)=\"hoveredDate = null\">\r\n                    {{ date.day }}\r\n                </span>\r\n            </ng-template>\r\n        </div>\r\n    </div>\r\n    <div>\r\n        <div class=\"input-group\">\r\n            <input #dpFromDate class=\"form-control\" placeholder=\"dd/MM/yyyy\" name=\"dpFromDate\"\r\n                [value]=\"fromDate | formatDateNumberToDigits\"\r\n                (input)=\"fromDate = validateInput(fromDate, dpFromDate.value)\">\r\n            <div class=\"input-group-append\">\r\n                <button class=\"btn btn-outline-secondary calendar\" (click)=\"datepicker.toggle()\" type=\"button\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"mb-3 ms-2\">\r\n        <div class=\"input-group\">\r\n            <input #dpToDate class=\"form-control\" placeholder=\"dd/MM/yyyy\" name=\"dpToDate\"\r\n                [value]=\"toDate | formatDateNumberToDigits\" (input)=\"toDate = validateInput(toDate, dpToDate.value)\">\r\n            <div class=\"input-group-append\">\r\n                <button class=\"btn btn-outline-secondary calendar\" (click)=\"datepicker.toggle()\" type=\"button\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <button class=\"btn btn-outline-primary rounded-pill ms-3\" (click)=\"onApply()\"\r\n        *ngIf=\"!isDateFilterApplied || dateChanged\">\r\n        {{'Apply' | translate}}\r\n    </button>\r\n    <span class=\"appliedText ms-3\" *ngIf=\"isDateFilterApplied && !dateChanged\">\r\n        <span class=\"iconify\" data-icon=\"ion:checkmark\" data-width=\"15\" data-height=\"15\"></span>\r\n        {{\"Applied\" | translate}}\r\n    </span>\r\n    <button class=\"btn btn-outline-primary rounded-pill ms-3\" (click)=\"onClearDates()\">{{'Clear' |\r\n        translate}}</button>\r\n</form>", styles: [".mb-3.hidden{width:0;margin:0;border:none;padding:0}.custom-day{text-align:center;padding:.185rem .25rem;display:inline-block;height:2rem;width:2rem}.custom-day.focused{background-color:#e6e6e6}.custom-day.range,.custom-day:hover{background-color:var(--smarterplan-primary-lighter);color:#fff}.custom-day.faded{background-color:var(--smarterplan-primary-transparent)}.calendar{height:100%}.appliedText,.appliedText span{color:var(--smarterplan-primary)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbCalendar }, { type: i1$2.NgbDateParserFormatter }, { type: FilterService }, { type: AmplifyCacheService }]; }, propDecorators: { cacheName: [{
                type: Input
            }] } });

const cache = {};
class AvatarComponent {
    constructor(userService, profileService) {
        this.userService = userService;
        this.profileService = profileService;
        this.size = 45;
        this.userSub = this.userService.isChanged.subscribe((connected) => {
            if (connected) {
                this.currentUser = this.userService.cu;
                this.setAvatar(this.currentUser);
            }
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.userID) {
                const profile = yield this.profileService.getProfile(this.userID);
                if (profile) {
                    const user = new ProfileEntity(profile);
                    this.setAvatar(user);
                }
            }
            else {
                this.currentUser = this.userService.cu;
                this.setAvatar(this.currentUser);
            }
        });
    }
    ngOnDestroy() {
        if (this.userSub) {
            this.userSub.unsubscribe();
        }
    }
    setAvatar(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id, avatar, email } = user;
            // If avatar is not cached, check first if we have an avatar URL to fetch
            // from S3. If not, retrieve it from libravatar.
            // TODO use in a Service to be able to change/upload freely.
            if (!cache.hasOwnProperty(id)) {
                if (!avatar && email) {
                    const md5 = new Md5();
                    const md5hash = md5.appendStr(email).end();
                    const avatar = `https://seccdn.libravatar.org/avatar/${md5hash}?s=${this.size}&default=identicon`;
                    const url = yield fetch(avatar)
                        .then((res) => res.blob())
                        .then((blob) => {
                        const file = new File([blob], "avatar.jpeg", {
                            type: "image/jpeg",
                        });
                        return uploadFileToS3("avatars/", file, id);
                    });
                    yield this.profileService.updateProfile({ id, avatar: url });
                    user.avatar = url;
                    cache[id] = avatar;
                }
                if (avatar) {
                    // TODO generating signed urls for avatar makes NO SENSE ($$$)
                    // Sorry got to copypaste that, but really need to get rid of
                    cache[id] = yield getSignedImageUrlForProfile(user);
                }
            }
            this.avatar = cache[id];
        });
    }
}
AvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AvatarComponent, deps: [{ token: BaseUserService }, { token: ProfileService }], target: i0.ɵɵFactoryTarget.Component });
AvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: AvatarComponent, selector: "lib-avatar", inputs: { size: "size", userID: "userID" }, ngImport: i0, template: `<img [src]="avatar" />`, isInline: true, styles: ["img{max-width:100%;max-height:100%;height:100%;width:100%;border-radius:50%}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-avatar', template: `<img [src]="avatar" />`, styles: ["img{max-width:100%;max-height:100%;height:100%;width:100%;border-radius:50%}\n"] }]
        }], ctorParameters: function () { return [{ type: BaseUserService }, { type: ProfileService }]; }, propDecorators: { size: [{
                type: Input
            }], userID: [{
                type: Input
            }] } });

class CaptureService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    getCapturesBySpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.CapturesBySpace(spaceID).then((cap) => cap.items);
        });
    }
    getCapture(captureID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetCapture(captureID);
        });
    }
    deleteCapture(captureID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteCapture({ id: captureID });
        });
    }
    updateCapture(capture) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateCapture(capture);
        });
    }
    createCapture(capture) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateCapture(capture);
        });
    }
}
CaptureService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CaptureService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
CaptureService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CaptureService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CaptureService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class NodeService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    updateNode(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateNode(input);
        });
    }
    deleteNode(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteNode({ id });
        });
    }
    getNode(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetNode(id);
        });
    }
    createNode(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateNode(input);
        });
    }
}
NodeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NodeService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
NodeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NodeService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NodeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

function getCoefficientsForImage(img, rectangle) {
    let coeffY;
    let coeffX;
    const imgRatio = img.width / img.height;
    const rectRatio = rectangle.width / rectangle.height;
    // console.log("image", img.width, img.height);
    // console.log("rectangle", rectangle.width, rectangle.height);
    // console.log(imgRatio, rectRatio);
    if (imgRatio > rectRatio) {
        // img is fitted in rectangle by width
        coeffX = img.width / rectangle.width;
        const effectiveImageHeight = rectangle.width / imgRatio;
        coeffY = img.height / effectiveImageHeight;
    }
    else {
        coeffY = img.height / rectangle.height;
        const effectiveImageWidth = rectangle.height * imgRatio;
        coeffX = img.width / effectiveImageWidth;
    }
    // console.log(coeffX, coeffY);
    return { coeffX, coeffY };
}
function styleButton(button) {
    button.style.backgroundImage = `url("https://api.iconify.design/mdi:adjust.svg?color=green&height=17&width=17")`;
    button.style.backgroundColor = "transparent";
    button.style.position = "absolute";
    button.style.border = "none";
    button.style.width = "17px";
    button.style.height = "17px";
    button.disabled = true;
}
const showScanPointsOnPlanInDiv = (plan, divPlan, navigations) => __awaiter(void 0, void 0, void 0, function* () {
    if (!divPlan || !plan.filepath) {
        return [];
    }
    const calibrage = JSON.parse(plan.calibration);
    const img = yield getMetaForImage(plan.filepath);
    divPlan.style.backgroundImage = `url(${plan.filepath})`;
    divPlan.style.backgroundSize = "contain";
    divPlan.style.backgroundRepeat = "no-repeat";
    yield wait(1500); // while image is loaded to div
    divPlan.innerHTML = ""; // remove all previous buttons if exist
    const rect = divPlan.getBoundingClientRect();
    const { coeffX, coeffY } = getCoefficientsForImage(img, rect);
    const buttons = [];
    yield Promise.all(navigations.map((navigation) => __awaiter(void 0, void 0, void 0, function* () {
        const element = document.createElement("button");
        styleButton(element);
        element.id = navigation.matterportSweepID;
        if (calibrage.new) {
            // new procedure of calibrage
            // find position for a given plan
            const positionsOnPlan = navigation.positionOnPlan.map((entry) => JSON.parse(entry));
            const positionOnPlan = positionsOnPlan.find((data) => data.planID === plan.id);
            if (positionOnPlan) {
                const realWidth = img.width / coeffX;
                const realHeight = img.height / coeffY;
                element.style.top = `${(positionOnPlan.y * realHeight) / calibrage.imgHeight -
                    10}px`;
                element.style.left = `${(positionOnPlan.x * realWidth) / calibrage.imgWidth - 10}px`;
            }
        }
        else {
            const position = JSON.parse(navigation.position);
            const x = calibrage.offsetX + position.x * calibrage.x;
            const y = calibrage.offsetY + position.z * calibrage.y;
            element.style.top = `${y / coeffY - 10}px`;
            element.style.left = `${x / coeffX - 10}px`;
        }
        divPlan.append(element);
        buttons.push(element);
    })));
    return buttons;
});

class CommentService {
    constructor(apiInjected, poiService) {
        this.poiService = poiService;
        this.API = apiInjected;
    }
    getCommentsFromTicketID(ticketID) {
        return this.API.__proto__.CommentsByTicket(ticketID).then((res) => res.items);
    }
    getCommentsBySpaceID(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CommentsBySpace(spaceID).then((comments) => comments.items);
        });
    }
    readCommentAsMeasurement(commentID) {
        return __awaiter(this, void 0, void 0, function* () {
            const comment = yield this.getComment(commentID);
            if (comment.ticketID && !comment.ticket) {
                comment.ticket = yield this.API.__proto__.GetTicket(comment.ticketID);
            }
            const values = comment.dimensions;
            const numberPoints = values.length + 1;
            const poi = yield this.poiService.getPoiByElementId(commentID);
            const measure = {
                id: comment.id,
                comment,
                poi,
                numberPoints,
                values,
            };
            return measure;
        });
    }
    /**
     * CRUD
     *
     */
    getComment(commentID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetComment(commentID);
        });
    }
    deleteComment(commentID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteComment({ id: commentID });
        });
    }
    createComment(comment) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateComment(comment);
        });
    }
    updateComment(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateComment(input);
        });
    }
    uploadFileForComment(file, id = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return uploadFileToS3("comments/", file, id);
        });
    }
    /** Create a new comment with an existing Annexe */
    createCommentWithFileURL(comment, url) {
        return __awaiter(this, void 0, void 0, function* () {
            const newComment = comment;
            newComment.annexe = url;
            return this.createComment(newComment);
        });
    }
    createCommentWithFile(comment, file) {
        return __awaiter(this, void 0, void 0, function* () {
            let createdComment = yield this.createComment(comment);
            if (file) {
                const url = yield this.uploadFileForComment(file, createdComment.id);
                createdComment = yield this.updateComment({
                    id: createdComment.id,
                    annexe: url,
                });
            }
            return createdComment;
        });
    }
    setCommentAsCoverForFeature(commentID, feature) {
        return __awaiter(this, void 0, void 0, function* () {
            const updatedComment = yield this.updateComment({
                id: commentID,
                isCoverImage: true,
            });
            yield Promise.all(feature.comments.items.map((image) => __awaiter(this, void 0, void 0, function* () {
                if (image.type === CommentType.IMAGE &&
                    image.id !== commentID) {
                    yield this.updateComment({
                        id: image.id,
                        isCoverImage: false,
                    });
                }
            })));
            return updatedComment;
        });
    }
}
CommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CommentService, deps: [{ token: 'currentAPIService' }, { token: PoiService }], target: i0.ɵɵFactoryTarget.Injectable });
CommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CommentService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: CommentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: PoiService }];
    } });

class ContentService {
    constructor(modalService, router, commentService) {
        this.modalService = modalService;
        this.router = router;
        this.commentService = commentService;
        this.closeModal = new Subject();
        this.nextSlide = new Subject();
    }
    presentVideoModal(video, videoComponent, modalDialogClass) {
        this.modalReference = this.modalService.open(videoComponent, {
            modalDialogClass: modalDialogClass,
        });
        this.modalReference.componentInstance.video = video;
        this.modalReference.dismissed.subscribe(() => {
            this.emitCloseModal();
        });
        this.modalReference.closed.subscribe(() => {
            this.emitCloseModal();
        });
    }
    presentAudioModal(audioCommentID, audioComponent, modalDialogClass) {
        return __awaiter(this, void 0, void 0, function* () {
            const audioComment = yield this.commentService.getComment(audioCommentID);
            const audioMediaContent = {
                path: audioComment.annexe,
                title: audioComment.title,
                description: audioComment.description,
            };
            this.modalReference = this.modalService.open(audioComponent, {
                modalDialogClass: modalDialogClass,
            });
            this.modalReference.componentInstance.audio = audioMediaContent;
            this.modalReference.dismissed.subscribe(() => {
                this.emitCloseModal();
            });
            this.modalReference.closed.subscribe(() => {
                this.emitCloseModal();
            });
        });
    }
    presentImageCarouselModal(featureID, carouselComponent, modalDialogClass, fromTag = true, selectedImageIndex = '0') {
        this.modalReference = this.modalService.open(carouselComponent, {
            modalDialogClass: modalDialogClass,
        });
        this.modalReference.componentInstance.featureID = featureID;
        this.modalReference.componentInstance.fromTag = fromTag;
        this.modalReference.componentInstance.selectedImageIndex = selectedImageIndex;
        this.modalReference.dismissed.subscribe(() => {
            this.emitCloseModal();
        });
        this.modalReference.closed.subscribe(() => {
            this.emitCloseModal();
        });
        this.modalReference.componentInstance.slideChanged.subscribe((slide) => {
            this.nextSlide.next(slide.current);
        });
    }
    presentPdfModal(url, pdfComponent, modalDialogClass) {
        this.modalReference = this.modalService.open(pdfComponent, {
            modalDialogClass: modalDialogClass,
        });
        this.modalReference.componentInstance.url = url;
        this.modalReference.dismissed.subscribe(() => {
            this.emitCloseModal();
        });
        this.modalReference.closed.subscribe(() => {
            this.emitCloseModal();
        });
    }
    presentMuseumImageCarouselModal(carouselComponent, modalDialogClass, fromTag = true, selectedImageIndex = "0", images = null, commentImageID = null) {
        this.modalReference = this.modalService.open(carouselComponent, {
            modalDialogClass,
        });
        this.modalReference.componentInstance.fromTag = fromTag;
        this.modalReference.componentInstance.selectedImageIndex =
            selectedImageIndex;
        this.modalReference.componentInstance.images = images;
        this.modalReference.componentInstance.commentID = commentImageID;
        this.modalReference.dismissed.subscribe(() => {
            this.emitCloseModal();
        });
        this.modalReference.closed.subscribe(() => {
            this.emitCloseModal();
        });
        this.modalReference.componentInstance.slideChanged.subscribe((slide) => {
            this.nextSlide.next(slide.current);
        });
    }
    toogleAudioElement(url) {
        if (!this.currentAudio || this.currentAudio.src !== url) {
            this.currentAudio = new Audio(url);
        }
        if (this.currentAudio.duration > 0 && !this.currentAudio.paused) {
            // it is playing, we stop it
            this.currentAudio.pause();
        }
        else {
            this.currentAudio.play();
        }
    }
    showFullscreenCarouselForFeature(featureID, fromTag = false) {
        const url = this.router.serializeUrl(this.router.createUrlTree([`/fullscreen/${featureID}`], {
            queryParams: { fromTag },
        }));
        window.open(url, "_blank");
    }
    emitCloseModal() {
        this.modalReference = null;
        this.closeModal.next(true);
    }
    forceCloseCurrentModal() {
        if (this.modalReference) {
            this.modalReference.dismiss("forced");
        }
    }
    moveToSlide(slide) {
        if (this.modalReference) {
            this.modalReference.componentInstance.navigateToSlide(slide);
        }
    }
}
ContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ContentService, deps: [{ token: i1$2.NgbModal }, { token: i1$1.Router }, { token: CommentService }], target: i0.ɵɵFactoryTarget.Injectable });
ContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ContentService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: ContentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: i1$1.Router }, { type: CommentService }]; } });

class PlanService {
    constructor(apiInjected, zoneService, navigationService, 
    // tagService: BaseTagService,
    viewerService, router, matterportService, 
    // private config: AppConfig,
    visibilityService, contentService) {
        this.zoneService = zoneService;
        this.navigationService = navigationService;
        this.viewerService = viewerService;
        this.router = router;
        this.matterportService = matterportService;
        this.visibilityService = visibilityService;
        this.contentService = contentService;
        this.isReady = false;
        this.detailTagDivIsHover = false;
        this.btnTagIsHover = false;
        this.resizePlanSubscription = new Subject();
        this.lastTouchTime = 0;
        this.delayDblTouch = 500;
        this.lastRotation = 0;
        this.htmlContentToInject = [];
        this.focusMouseTagDiv = false;
        this.API = apiInjected;
        this.matterportService.currentCameraPose.subscribe((pose) => {
            this.updateRotation(pose.rotation.y);
        });
    }
    createPlan(planInput) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreatePlan(planInput);
        });
    }
    deletePlan(plan) {
        return __awaiter(this, void 0, void 0, function* () {
            // await deleteFromS3(plan.annexe);
            return this.API.__proto__.DeletePlan({ id: plan.id });
        });
    }
    getPlansForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .PlansBySpace(spaceID)
                .then((response) => response.items);
        });
    }
    getPlansForZone(zoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__
                .PlansByZone(zoneID)
                .then((response) => response.items);
        });
    }
    getSingedPlansForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const plansFromDB = yield this.getPlansForSpace(spaceID);
            // console.log(plansFromDB);
            const plans = [];
            if (plansFromDB.length > 0) {
                yield Promise.all(plansFromDB.map((plan) => __awaiter(this, void 0, void 0, function* () {
                    const planObject = Object.assign({}, plan);
                    // annexe looks like visits/modelID/plans/file.extension
                    const signed = yield getSignedFile(plan.annexe);
                    if (signed) {
                        planObject.filepath = signed;
                    }
                    if (plan.annexe) {
                        const [, modelID, , filenameWithExtension] = plan.annexe.split('/');
                        const [, extention] = filenameWithExtension.split('.');
                        planObject.model3d = modelID;
                        planObject.extension = extention;
                        plans.push(planObject);
                    }
                    else {
                        console.log(`Error plan have not annexe => `);
                        console.log(plan.id);
                    }
                })));
            }
            return plans;
        });
    }
    getPlansWithZonesForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const plans = yield this.getPlansForSpace(spaceID);
            const plansZones = plans.filter((plan) => plan.zone && plan.calibration);
            return plansZones;
        });
    }
    setChosenPlan(chosenPlan) {
        this.chosenPlan = chosenPlan;
    }
    getChosenPlan() {
        return this.chosenPlan;
    }
    setPlanFileCache(planFileCache) {
        this.planFileCache = planFileCache;
        return Promise.resolve();
    }
    getPlanFileCache() {
        return this.planFileCache;
    }
    createPlanWithAnnexe(plan, file) {
        return __awaiter(this, void 0, void 0, function* () {
            const createdPlan = yield this.createPlan(plan);
            const model3D = yield this.zoneService.getModel3DForZone(plan.zoneID);
            const url = yield uploadFileToS3(`visits/${model3D}/plans/`, file, createdPlan.id);
            if (url) {
                return this.API.__proto__.UpdatePlan({ id: createdPlan.id, annexe: url });
            }
            return createdPlan;
        });
    }
    updatePlan(plan) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdatePlan(plan);
        });
    }
    updatePlanFile() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.chosenPlan && this.planFileCache) {
                const model3D = yield this.zoneService.getModel3DForZone(this.chosenPlan.zoneID);
                return uploadFileToS3(`visits/${model3D}/plans/`, this.planFileCache, this.chosenPlan.id);
            }
            return Promise.reject();
        });
    }
    setAllPlansForZoneNotCurrent(zoneID, currentPlanID) {
        return __awaiter(this, void 0, void 0, function* () {
            const plans = yield this.API.__proto__.ListPlans({
                zoneID: { eq: zoneID },
            });
            yield Promise.all(plans.items.map((plan) => __awaiter(this, void 0, void 0, function* () {
                if (plan.isCurrentForZone && plan.id !== currentPlanID) {
                    yield this.updatePlan({
                        id: plan.id,
                        isCurrentForZone: false,
                    });
                }
            })));
        });
    }
    configurePlan(currentPlan, divId = 'planDivPane', divContentId = 'planDivPaneContent') {
        return __awaiter(this, void 0, void 0, function* () {
            this.isReady = false;
            if (!this.detailTagDiv) {
                this.detailTagDiv = document.querySelector(`#detailTagDiv`);
            }
            this.detailTagDiv.addEventListener('mouseenter', () => {
                this.focusMouseTagDiv = true;
            });
            this.detailTagDiv.addEventListener('mouseleave', () => {
                this.btnTagIsHover = false;
                this.detailTagDiv.style.display = 'none';
                this.focusMouseTagDiv = false;
            });
            this.calibrationPlan = JSON.parse(currentPlan.calibration);
            this.currentPlan = currentPlan;
            this.planDiv = document.querySelector(`#${divId}`);
            this.planDivContent = document.querySelector(`#${divContentId}`);
            this.planDiv.addEventListener('touchstart', this.handleTouch.bind(this));
            this.planDiv.addEventListener('dblclick', this.onDblClickPlan.bind(this));
            if (!currentPlan.annexe.includes('pdf')) {
                this.imgPlan = yield getMetaForImage(currentPlan.filepath);
                //Rect use offsetWidth : height, not actual boundingClientRect because will be modified by the zoom.
                const rect = {
                    width: this.planDivContent.offsetWidth,
                    height: this.planDivContent.offsetHeight,
                };
                const { coeffX, coeffY } = getCoefficientsForImage(this.imgPlan, rect);
                this.coeffPlanX = coeffX;
                this.coeffPlanY = coeffY;
                this.planDivContent.style.backgroundImage = `url(${currentPlan.filepath})`;
            }
            else {
                yield this.drawPdf(currentPlan);
            }
            this.planDivContent.style.backgroundSize = 'contain';
            this.planDivContent.style.backgroundRepeat = 'no-repeat';
            this.panzoom = panzoom(this.planDiv, {
                bounds: true,
                boundsPadding: 0,
                maxZoom: 4,
                zoomDoubleClickSpeed: 1, //disables double click zoom
                //initialZoom: 4
            });
            this.panzoom.zoomAbs(0, 0, 4);
            setTimeout(() => {
                this.updateRotation(this.lastRotation);
            }, 200);
            return true;
        });
    }
    clearPlanImage() {
        if (this.planDivContent) {
            this.planDivContent.style.backgroundImage = null;
        }
    }
    drawPdf(currentPlan) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                const pdfjsWorker = yield import('pdfjs-dist/build/pdf.worker.entry');
                GlobalWorkerOptions.workerSrc = pdfjsWorker;
                const pdf = yield getDocument(currentPlan.filepath).promise;
                const page = yield pdf.getPage(1);
                const viewPortParameters = { scale: 1.5 };
                const viewport = page.getViewport(viewPortParameters);
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                const renderContext = {
                    canvasContext: context,
                    viewport,
                };
                const renderTask = page.render(renderContext).promise;
                renderTask.then(() => __awaiter(this, void 0, void 0, function* () {
                    const imgUrl = canvas.toDataURL('image/png');
                    this.imgPlan = yield getMetaForImage(imgUrl);
                    const rect = {
                        width: this.planDivContent.offsetWidth,
                        height: this.planDivContent.offsetHeight,
                    };
                    const { coeffX, coeffY } = getCoefficientsForImage(this.imgPlan, rect);
                    this.coeffPlanX = coeffX;
                    this.coeffPlanY = coeffY;
                    this.planDiv.style.backgroundImage = `url(${imgUrl})`;
                    resolve();
                }));
            }));
        });
    }
    drawElement(element, tagType, currentPlan, tagService, config, sizeButton = 10) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const [poi] = element.pois.items;
            if (poi && poi.coordinate && currentPlan) {
                const { zone } = currentPlan;
                if (zone) {
                    const position = JSON.parse(poi.coordinate);
                    const button = document.createElement('button');
                    let elementTitle;
                    const url = tagService.getUrlForSeeDetails(element, tagType);
                    let tagIconImage;
                    switch (tagType) {
                        case PoiType.TICKET: {
                            tagIconImage = config.my_config.icon_ticket;
                            break;
                        }
                        case PoiType.EQUIPMENT: {
                            tagIconImage = config.my_config.icon_equipment;
                            break;
                        }
                        case PoiType.MEASURE:
                            tagIconImage = config.my_config.icon_measure;
                            break;
                        case PoiType.OBJECT3D:
                            tagIconImage = config.my_config.icon_object3d;
                            break;
                        case PoiType.DATA:
                            tagIconImage = config.my_config.icon_data;
                            break;
                        case PoiType.DESK:
                            tagIconImage = config.my_config.icon_data;
                            break;
                        default:
                            return;
                    }
                    if (poi.tagIcon) {
                        const tagIcon = JSON.parse(poi.tagIcon);
                        if (tagType === PoiType.DATA &&
                            element.type === FeatureType.INDICATOR_TEMP) {
                            tagIcon.src = tagService.getIconTagImageForFeature(element, poi);
                        }
                        // poi.tagIcon = tagIcon;
                        if (tagIcon.src) {
                            const source = yield getSignedFile(tagIcon.src);
                            if (source) {
                                tagIconImage = source;
                            }
                        }
                    }
                    this.styleButton(button, tagIconImage, sizeButton);
                    button.id = element.id;
                    this.planDivContent.append(button);
                    let x;
                    let y;
                    if (this.calibrationPlan.new) {
                        // alert("new calibration plan: positioning not ready yet");
                        const position2D = this.transformPosition3DForNewCalibration(position);
                        x = position2D.x;
                        y = position2D.y;
                        button.style.top = `${y / position2D.coeffY - 5}px`;
                        button.style.left = `${x / position2D.coeffX - 5}px`;
                    }
                    else {
                        // to remove when all calibrations are new
                        x =
                            this.calibrationPlan.offsetX + position.x * this.calibrationPlan.x;
                        y =
                            this.calibrationPlan.offsetY + position.z * this.calibrationPlan.y;
                        button.style.top = `${y / this.coeffPlanY - 5}px`;
                        button.style.left = `${x / this.coeffPlanX - 5}px`;
                    }
                    const html = yield tagService.getHtmlToInject(tagType, element);
                    if (html != '') {
                        this.htmlContentToInject.push({
                            elementID: element.id,
                            title: '',
                            content: html,
                            y,
                            x,
                            tagIcon: tagIconImage,
                            url,
                        });
                    }
                    else {
                        // when we don't have html => case of EMBED Comment type
                        const commentEmbed = (_a = element.comments) === null || _a === void 0 ? void 0 : _a.items.find((com) => com.type === CommentType.EMBED && com.shownInTag);
                        if (commentEmbed) {
                            this.htmlContentToInject.push({
                                elementID: element.id,
                                title: element.title,
                                content: `<iframe src=${commentEmbed.externalLink} height="200px" width="100%"></iframe>`,
                                y,
                                x,
                                tagIcon: tagIconImage,
                                url,
                            });
                        }
                    }
                    this.addListenersToButton(button, url, tagService, element);
                    this.updateRotation(this.lastRotation);
                }
            }
        });
    }
    drawUserPosition(currentSweep = this.currentSweep, sizeButton = 10) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.currentSweep = currentSweep;
            if (this.calibrationPlan && currentSweep) {
                const position = (_a = this.matterportService.getCurrentCameraPosition()) === null || _a === void 0 ? void 0 : _a.position;
                if (position) {
                    if (!this.userPositionBtn) {
                        this.userPositionBtn = document.createElement('button');
                        this.userPositionBtn.id = 'currentPosition';
                        this.planDivContent.append(this.userPositionBtn);
                        this.userPositionBtn.title = 'You are here';
                        this.styleButton(this.userPositionBtn, 'https://api.iconify.design/bx:bxs-user-circle.svg?color=green&height=17&width=17', sizeButton);
                    }
                    let x;
                    let y;
                    if (this.calibrationPlan.new) {
                        const position2D = this.transformPosition3DForNewCalibration(position);
                        x = position2D.x / position2D.coeffX - 5;
                        y = position2D.y / position2D.coeffY - 5;
                    }
                    else {
                        x =
                            (this.calibrationPlan.offsetX +
                                position.x * this.calibrationPlan.x) /
                                this.coeffPlanX;
                        y =
                            (this.calibrationPlan.offsetY +
                                position.z * this.calibrationPlan.y) /
                                this.coeffPlanY;
                    }
                    this.userPositionBtn.style.top = `${y}px`;
                    this.userPositionBtn.style.left = `${x}px`;
                    this.moveOnPoint({ x: x + 5, y: y + 5 });
                }
            }
        });
    }
    /**
     * Center the view of the plan on coordinates
     * @param coordinate Coordinate on the plan
     */
    moveOnPoint(coordinate) {
        if (this.planDiv) {
            const scale = this.panzoom.getTransform().scale;
            const moveX = this.planDiv.clientWidth / 2 - coordinate.x * scale;
            const moveY = this.planDiv.clientHeight / 2 - coordinate.y * scale;
            this.panzoom.moveTo(moveX, moveY);
            this.planDivContent.style.transformOrigin = `${coordinate.x}px ${coordinate.y}px`;
        }
    }
    /**
     * Apply a rotation to the plan
     * Buttons will remain in the correct rotation
     * @param rotation
     */
    updateRotation(rotation) {
        this.lastRotation = rotation;
        if (this.planDivContent) {
            this.planDivContent.style.transform = `rotate(${rotation}deg)`;
            const buttons = this.planDivContent.querySelectorAll('button');
            let rotationRegex = /(rotate\(-?\d*\.?\d+deg\))/g;
            // eslint-disable-next-line unicorn/no-array-for-each
            buttons.forEach((button) => {
                button.style.transform = button.style.transform.replace(rotationRegex, "") + ` rotate(${-rotation}deg)`;
            });
        }
    }
    removeCurrentPosition() {
        const button = document.querySelector('#currentPosition');
        if (button) {
            button.remove();
            this.userPositionBtn = null;
        }
    }
    styleButton(button, url, sizeButton = 10) {
        button.style.backgroundImage = `url(${url})`;
        button.style.backgroundColor = 'transparent';
        button.style.position = 'absolute';
        button.style.border = 'none';
        button.style.width = `10px`;
        button.style.height = `10px`;
        button.disabled = false;
        button.style.backgroundSize = 'contain';
        button.style.backgroundRepeat = 'no-repeat';
        button.style.transform = `scale(${sizeButton / 10})`;
    }
    addListenersToButton(button, url, tagService = null, element = null) {
        let videoJsPlayer;
        button.addEventListener('mouseenter', (event) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const contentForButton = this.htmlContentToInject.find((object) => object.elementID === button.id);
            this.btnTagIsHover = true;
            const title = document.querySelector(`#titleTagDiv`);
            if (contentForButton.title) {
                title.style.display = 'inline';
                title.innerHTML = contentForButton.title;
            }
            else {
                title.style.display = 'none';
            }
            const content = document.querySelector(`#htmlTagDiv`);
            this.detailTagDiv.style.top = `${event.clientY + 10}px`;
            this.detailTagDiv.style.left = `${event.clientX < 120 ? 0 : event.clientX - 120}px`;
            this.detailTagDiv.style.display = 'block';
            // console.log(contentForButton.content);
            content.innerHTML = contentForButton.content;
            const detailButton = content.querySelector('#detailBtn');
            if (detailButton) {
                detailButton.addEventListener('click', () => {
                    this.visibilityService.detailShowing.next(true);
                    this.router.navigate([url]);
                });
            }
            // handle image carousel fullscreen button
            const imageFullscreenBtn = content.querySelector('#image-footer');
            if (imageFullscreenBtn) {
                imageFullscreenBtn.addEventListener('click', function () {
                    if (tagService) {
                        tagService.onActionImageClick(contentForButton.elementID);
                    }
                });
            }
            // handle booking fullscreen button
            const bookingButton = content.querySelector('#bookingBtn');
            if (bookingButton) {
                bookingButton.addEventListener('click', () => {
                    this.visibilityService.detailShowing.next(true);
                    this.router.navigate([url]);
                });
            }
            // handle document pdf fullscreen button
            const docFullscreenBtn = content.querySelector('#doc-footer');
            if (docFullscreenBtn && element) {
                const documentUrl = tagService.getAnnexeForCommentTypeInFeature(element, CommentType.DOCUMENT);
                docFullscreenBtn.addEventListener('click', function () {
                    if (tagService) {
                        tagService.onActionDocClick(documentUrl);
                    }
                });
            }
            // handle video fullscreen button
            const videoFullscreenBtn = content.querySelector('#btn-video-fullscreen');
            if (videoFullscreenBtn && element) {
                const videoUrl = tagService.getAnnexeForCommentTypeInFeature(element, CommentType.VIDEO);
                videoFullscreenBtn.addEventListener('click', function () {
                    if (tagService) {
                        tagService.onActionVideoClick(videoUrl);
                    }
                });
            }
            // handle Youtube video fullscreen button
            const youtubeFullScreen = content.querySelector('#btn-video-fullscreen-youtube');
            if (youtubeFullScreen && element) {
                const youtubeUrl = tagService.getAnnexeForCommentTypeInFeature(element, CommentType.YOUTUBE);
                youtubeFullScreen.addEventListener('click', function () {
                    if (tagService) {
                        tagService.onActionYoutubeClick(youtubeUrl);
                    }
                });
            }
            // handle mute video button
            const btnMute = document.getElementById('btn-mute');
            const imgOn = document.getElementById('sound-on');
            const imgOff = document.getElementById('sound-off');
            const playerElement = document.getElementById("mus-video-tag");
            if (playerElement) {
                videoJsPlayer = videojs("mus-video-tag");
                if (btnMute && videoJsPlayer) {
                    btnMute.addEventListener('click', function () {
                        if (videoJsPlayer.muted()) {
                            videoJsPlayer.muted(false);
                            if (imgOn && imgOff) {
                                imgOn.style.display = 'inline-block';
                                imgOff.style.display = 'none';
                            }
                        }
                        else {
                            videoJsPlayer.muted(true);
                            if (imgOn && imgOff) {
                                imgOn.style.display = 'none';
                                imgOff.style.display = 'inline-block';
                            }
                        }
                    });
                }
            }
            // handle audio player buttons
            const playerButton = document.querySelector('.audio-play-button');
            const audio = document.getElementById('audio-tag');
            const timeline = document.querySelector('.timeline-tag');
            // const timelineValue = document.querySelector('.timeline-tag').value;
            const soundButton = document.querySelector('.audio-sound-btn');
            const playAudio = document.getElementById('play');
            const pauseAudio = document.getElementById('pause');
            const imgSoundOn = document.getElementById('audio-sound-on');
            const imgSoundOff = document.getElementById('audio-sound-off');
            const audioModal = document.getElementById('btn-audio-modal');
            if (audio && playerButton && timeline) {
                playerButton.addEventListener('click', function () {
                    if (audio.paused) {
                        audio.play();
                        pauseAudio.style.display = 'inline-block';
                        playAudio.style.display = 'none';
                    }
                    else {
                        audio.pause();
                        pauseAudio.style.display = 'none';
                        playAudio.style.display = 'inline-block';
                    }
                });
                soundButton.addEventListener('click', function () {
                    if (audio.muted) {
                        audio.muted = false;
                        imgSoundOn.style.display = 'inline-block';
                        imgSoundOff.style.display = 'none';
                    }
                    else {
                        audio.muted = true;
                        imgSoundOn.style.display = 'none';
                        imgSoundOff.style.display = 'inline-block';
                    }
                });
                function changeTimelinePosition() {
                    if (audio.duration) {
                        const percentagePosition = (100 * audio.currentTime) / audio.duration;
                        const percentagePositionString = percentagePosition + '%';
                        timeline.style.backgroundSize = percentagePositionString + ' 100%';
                        timeline.value = percentagePosition.toString();
                    }
                }
                audio.ontimeupdate = changeTimelinePosition;
                function changeSeek() {
                    const time = (parseInt(timeline.value) * audio.duration) / 100;
                    audio.currentTime = time;
                }
                timeline.addEventListener('change', changeSeek);
                timeline.addEventListener('input', changeSeek);
                // handle audio click
                if (audioModal && element) {
                    const audioComment = (_a = element.comments) === null || _a === void 0 ? void 0 : _a.items.find((com) => com.type === CommentType.AUDIO && com.shownInTag);
                    const audioCommentID = audioComment ? audioComment.id : '';
                    audioModal.addEventListener('click', function () {
                        if (tagService) {
                            tagService.onActionAudioClick(audioCommentID);
                        }
                    });
                }
            }
        }));
        button.addEventListener('mouseleave', () => __awaiter(this, void 0, void 0, function* () {
            // we wait if user hovers on to div of the tag (changes this.focusMouseTagDiv)
            this.btnTagIsHover = false;
            setTimeout(() => {
                if (!this.focusMouseTagDiv && !this.btnTagIsHover) {
                    this.detailTagDiv.style.display = 'none';
                    if (videoJsPlayer) {
                        videoJsPlayer.dispose();
                    }
                }
            }, 100);
        }));
        button.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
            this.detailTagDiv.style.display = 'none';
            if (videoJsPlayer) {
                videoJsPlayer.dispose();
            }
            yield this.viewerService.action_move_to_tag(button.id);
            this.visibilityService.detailShowing.next(true);
            this.router.navigate([url]);
        }));
    }
    clearBtn(idList) {
        for (const id of idList) {
            const button = document.getElementById(id);
            if (button) {
                button.remove();
            }
        }
    }
    clearAllButtons() {
        if (this.planDivContent) {
            const buttons = this.planDivContent.querySelectorAll('button');
            // eslint-disable-next-line unicorn/no-array-for-each
            buttons.forEach(function (currentValue) {
                currentValue.remove();
            });
            this.userPositionBtn = null;
        }
    }
    updateAllButtonsStyle(properties, values) {
        if (this.planDivContent) {
            const buttons = this.planDivContent.querySelectorAll('button');
            // eslint-disable-next-line unicorn/no-array-for-each
            buttons.forEach(function (currentValue) {
                properties.forEach((property, i) => {
                    if (property === "transform") {
                        //For saving the rotation and adding scale
                        let rotationRegex = /(rotate\(-?\d*\.?\d+deg\))/g;
                        let rotationMatch = currentValue.style[property].match(rotationRegex);
                        if (rotationMatch.length > 0) {
                            currentValue.style[property] = `${values[i]} ${rotationMatch[0]}`;
                        }
                    }
                    else {
                        currentValue.style[property] = values[i];
                    }
                });
            });
        }
    }
    onPlanRemove() {
        this.userPositionBtn = null;
        this.calibrationPlan = null;
        this.currentSweep = null;
        this.detailTagDiv = null;
    }
    resizePlan(isRemoving) {
        return __awaiter(this, void 0, void 0, function* () {
            this.resizePlanSubscription.next(false);
            if (isRemoving) {
                return;
            }
            console.log('in resizePlan');
            if (this.planDiv && this.currentSweep) {
                this.panzoom = panzoom(this.planDiv, {
                    bounds: true,
                    boundsPadding: 0,
                    maxZoom: 4,
                });
                setTimeout(() => {
                    const rect = {
                        width: this.planDivContent.offsetWidth,
                        height: this.planDivContent.offsetHeight,
                    };
                    const { coeffX, coeffY } = getCoefficientsForImage(this.imgPlan, rect);
                    this.coeffPlanX = coeffX;
                    this.coeffPlanY = coeffY;
                    this.panzoom.zoomAbs(0, 0, 4);
                    this.resizePlanSubscription.next(true);
                }, 200);
            }
        });
    }
    handleTouch(event) {
        const now = Date.now();
        if (now - this.lastTouchTime < this.delayDblTouch) {
            this.lastTouchTime = 0;
            // this.onDblClickPlan(event);
            /** Simulate a dblclick for phone (we don't get offsetX/Y on touchevent) */
            const newEvent = document.createEvent('MouseEvents');
            const touch = event.changedTouches[0];
            newEvent.initMouseEvent('dblclick', true, true, event.target.ownerDocument.defaultView, 0, touch.screenX, touch.screenY, touch.clientX, touch.clientY, event.ctrlKey, event.altKey, event.shirtKey, event.metaKey, 0, null);
            event.target.dispatchEvent(newEvent);
        }
        else {
            this.lastTouchTime = now;
        }
    }
    onDblClickPlan(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const clickX = event.offsetX;
            const clickY = event.offsetY;
            const zonePlan = this.currentPlan.zone;
            if (zonePlan) {
                const navigations = yield this.navigationService.getNavigationsForZone(zonePlan);
                if (navigations.length > 0) {
                    yield Promise.all(navigations.map((nav) => __awaiter(this, void 0, void 0, function* () {
                        const position = JSON.parse(nav.position);
                        let x;
                        let y;
                        if (this.calibrationPlan.new) {
                            const position2D = this.transformPosition3DForNewCalibration(position);
                            x = position2D.x / position2D.coeffX;
                            y = position2D.y / position2D.coeffY;
                        }
                        else {
                            x =
                                (this.calibrationPlan.offsetX +
                                    position.x * this.calibrationPlan.x) /
                                    this.coeffPlanX;
                            y =
                                (this.calibrationPlan.offsetY +
                                    position.z * this.calibrationPlan.y) /
                                    this.coeffPlanY;
                        }
                        const distX = Math.abs(clickX - x);
                        const distY = Math.abs(clickY - y);
                        nav.dist = Math.sqrt(Math.pow(distX, 2) + Math.pow(distY, 2));
                    })));
                    navigations.sort((a, b) => {
                        return a.dist - b.dist;
                    });
                    this.matterportService.action_go_to_sweep(navigations[0].matterportSweepID);
                }
            }
        });
    }
    /**
     * Configures plan from cache (previous plan).
     */
    uploadPlanFromCache() {
        return __awaiter(this, void 0, void 0, function* () {
            this.htmlContentToInject = this.cache.htmlContent;
            yield this.configurePlan(this.cache.plan);
            return Promise.resolve();
        });
    }
    /**
     * Puts buttons (tags) from cache according to passed element IDs (for filter if any)
     * @param elementIDs elements (tickets, equipments, etc) to be shown on plan
     */
    uploadTagsFromCache(sizeButton = 10) {
        // console.log("uploading tags from cache");
        for (const cached of this.cache.htmlContent) {
            const button = document.createElement('button');
            this.styleButton(button, cached.tagIcon, sizeButton);
            button.id = cached.elementID;
            this.planDivContent.append(button);
            if (this.calibrationPlan.new) {
                const newCoeffX = this.coeffPlanX /
                    (this.imgPlan.width / this.calibrationPlan.imgWidth);
                const newCoeffY = this.coeffPlanY /
                    (this.imgPlan.height / this.calibrationPlan.imgHeight);
                button.style.top = `${cached.y / newCoeffY - 5}px`;
                button.style.left = `${cached.x / newCoeffX - 5}px`;
            }
            else {
                button.style.top = `${cached.y / this.coeffPlanY - 5}px`;
                button.style.left = `${cached.x / this.coeffPlanX - 5}px`;
            }
            this.addListenersToButton(button, cached.url);
        }
    }
    getCalibratedPlanForZone(zone) {
        return __awaiter(this, void 0, void 0, function* () {
            let plans = (yield this.API.PlansByZone(zone.id)).items;
            let parentZone = null;
            if (plans.length === 0) {
                // try to find parent zone
                parentZone = yield this.API.GetZone(zone.parentID);
                plans = (yield this.API.PlansByZone(zone.parentID)).items;
            }
            const calibratedPlan = plans.find((plan) => plan.calibration && plan.isCurrentForZone);
            if (calibratedPlan) {
                const signed = yield getSignedFile(calibratedPlan.annexe);
                if (signed) {
                    calibratedPlan.filepath = signed;
                }
                calibratedPlan.navigationIDs = parentZone
                    ? parentZone.sweepIDs
                    : zone.sweepIDs;
            }
            return calibratedPlan || null;
        });
    }
    transformPosition3DForNewCalibration(position) {
        const positionX = this.calibrationPlan.nameXAxis === 'x' ? position.x : position.z;
        const positionY = this.calibrationPlan.nameYAxis === 'x' ? position.x : position.z;
        let x = this.calibrationPlan.offsetX + positionX * this.calibrationPlan.scaleX;
        let y = this.calibrationPlan.offsetY + positionY * this.calibrationPlan.scaleY;
        const newCoeffX = this.coeffPlanX / (this.imgPlan.width / this.calibrationPlan.imgWidth);
        // console.log("newCoeffX", newCoeffX);
        const newCoeffY = this.coeffPlanY / (this.imgPlan.height / this.calibrationPlan.imgHeight);
        x = (x - this.calibrationPlan.offsetXPlan) / this.calibrationPlan.scalePlan;
        y = (y - this.calibrationPlan.offsetYPlan) / this.calibrationPlan.scalePlan;
        // console.log(x, y);
        return { x, y, coeffX: newCoeffX, coeffY: newCoeffY };
    }
}
PlanService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PlanService, deps: [{ token: 'currentAPIService' }, { token: ZoneService }, { token: NavigationService }, { token: ViewerService }, { token: i1$1.Router }, { token: MatterportService }, { token: BaseVisibilityService }, { token: ContentService }], target: i0.ɵɵFactoryTarget.Injectable });
PlanService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PlanService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: PlanService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: ZoneService }, { type: NavigationService }, { type: ViewerService }, { type: i1$1.Router }, { type: MatterportService }, { type: BaseVisibilityService }, { type: ContentService }];
    } });

class VisitService {
    constructor(captureService, nodeService, navigationService, zoneService, planService, userService) {
        this.captureService = captureService;
        this.nodeService = nodeService;
        this.navigationService = navigationService;
        this.zoneService = zoneService;
        this.planService = planService;
        this.userService = userService;
    }
    getVisitsForSpaceForUser(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const visits = [];
            const missionsForSpace = this.userService.currentMissions.filter((mis) => mis.spaceID === spaceID);
            const allAllowed = this.userService.userHasAccessToAllZonesInSpace(spaceID);
            const captures = yield this.captureService.getCapturesBySpace(spaceID);
            const nodes = captures.flatMap((cap) => cap.nodes.items);
            let allAllowedNodes = nodes;
            let allowedNodeIDs = [];
            if (!allAllowed) {
                const allowedZones = missionsForSpace.map((mis) => mis.zone);
                for (const zone of allowedZones) {
                    allowedNodeIDs = [...allowedNodeIDs, ...zone.nodeIDs];
                }
                allowedNodeIDs = [...new Set(allowedNodeIDs)]; // to make unique
                allAllowedNodes = allAllowedNodes.filter((node) => allowedNodeIDs.includes(node.id));
            }
            for (const node of allAllowedNodes) {
                // console.log(node)
                const folder = `visits/${node.model3D}/sweeps/`;
                const files = yield listFilesInFolder(folder);
                const nmbImages = files.length;
                const capture = captures.find((cap) => cap.nodes.items.includes(node));
                const visit = {
                    captureID: node.captureID,
                    model3d: node.model3D,
                    takenAt: capture.takenAt,
                    spaceID,
                    viewer: capture.viewer,
                    surface: capture.surface,
                    node,
                    name: node.metadata,
                    nmbImagesImported: nmbImages,
                };
                visits.push(visit);
            }
            return visits;
        });
    }
    deleteVisit(visit, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.nodeService.deleteNode(visit.node.id);
            const capture = yield this.captureService.getCapture(visit.captureID);
            if (capture.nodes.items.length === 0) {
                yield this.captureService.deleteCapture(visit.captureID);
            }
            const navigations = yield this.navigationService.getNavigationsForNode(visit.node.id);
            const zonesToDelete = yield this.zoneService.getZonesForNodeForSpace(visit.node.id, spaceID);
            yield Promise.all(navigations.map((navig) => __awaiter(this, void 0, void 0, function* () {
                yield this.navigationService.deleteNavigation(navig.id);
            })));
            if (zonesToDelete.length > 0) {
                yield Promise.all(zonesToDelete.map((zone) => __awaiter(this, void 0, void 0, function* () {
                    const plans = yield this.planService.getPlansForZone(zone.id);
                    if (plans.length > 0) {
                        yield Promise.all(plans.map((plan) => __awaiter(this, void 0, void 0, function* () {
                            yield this.planService.deletePlan(plan);
                        })));
                    }
                    yield this.zoneService.deleteZone(zone.id);
                })));
            }
            // we cannot delete the images, because the folder of the visit can be used by another location
            // removeAllFilesFromFolderS3(`visits/${visit.model3d}/sweeps`); 
            return visit;
        });
    }
    loadImagesForSpace(space) {
        return __awaiter(this, void 0, void 0, function* () {
            const list = [];
            return this.getVisitsForSpaceForUser(space.id).then((visits) => __awaiter(this, void 0, void 0, function* () {
                if (visits) {
                    space.visits = visits;
                    yield Promise.all(visits.map((visit) => __awaiter(this, void 0, void 0, function* () {
                        const folder = `visits/${visit.model3d}/sweeps/`;
                        const files = yield listFilesInFolder(folder);
                        yield Promise.all(files.map((file) => __awaiter(this, void 0, void 0, function* () {
                            const signed = yield getSignedFile(file.key);
                            const filename = file.key.split("/")[3];
                            list.push({
                                path: signed,
                                filename,
                                visit,
                            });
                        })));
                    })));
                    return list;
                }
                return list;
            }));
        });
    }
    getDefaultZoneForVisit(visit) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.zoneService
                .getZonesBySpace(visit.spaceID)
                .then((zones) => __awaiter(this, void 0, void 0, function* () {
                const zonesWithVisitName = zones.filter((zone) => zone.name === visit.name &&
                    zone.layer &&
                    zone.layer.name === "BUILDING");
                if (zonesWithVisitName.length === 1) {
                    return zonesWithVisitName[0];
                }
                const parentZone = zones.find((zone) => !zone.parentID);
                return parentZone;
            }));
        });
    }
}
VisitService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: VisitService, deps: [{ token: CaptureService }, { token: NodeService }, { token: NavigationService }, { token: ZoneService }, { token: PlanService }, { token: BaseUserService }], target: i0.ɵɵFactoryTarget.Injectable });
VisitService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: VisitService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: VisitService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return [{ type: CaptureService }, { type: NodeService }, { type: NavigationService }, { type: ZoneService }, { type: PlanService }, { type: BaseUserService }]; } });

class FeatureService extends BaseObjectService {
    constructor(apiInjected, navigatorService, filterService, poiService, commentService, userService, navigationService, hashtagService, zoneChangeService) {
        super(poiService, navigationService);
        this.navigatorService = navigatorService;
        this.filterService = filterService;
        this.commentService = commentService;
        this.userService = userService;
        this.hashtagService = hashtagService;
        this.zoneChangeService = zoneChangeService;
        this.featureUpdated = new Subject();
        this.currentFeatures = {
            space: [],
            zone: [],
        };
        this.featureTags = new Subject();
        this.featureFiltered = [];
        this.updateDone = new Subject();
        this.updating = new Subject();
        this.isUpdating = false;
        this.featureDomainFilter = null;
        this.deskDomainFilter = null;
        this.deskBookingsUpdated = new Subject();
        this.currentHashtags = [];
        this.createObservable = new Subject();
        this.deleteObservable = new Subject();
        this.API = apiInjected;
        this.featureUpdated.subscribe((list) => {
            this.currentFeatures = list;
        });
        this.zoneChangeService.zoneChange.subscribe((zone) => {
            this.currentSpaceID = this.navigatorService.currentSpaceID;
            if (!this.currentSpaceID) {
                this.featureTags.next(null);
                this.featureUpdated.next({ space: [], zone: null });
                this.zoneIDFilter = null;
            }
            else if (zone.id !== this.zoneIDFilter && !this.userService.isMuseumUser(this.currentSpaceID)) {
                this.zoneIDFilter = zone.id;
                this.initFeatures();
            }
        });
        this.updateDone.subscribe(() => {
            if (this.currentSpaceID) {
                this.initFeatures();
            }
        });
        this.deleteObservable.subscribe((feature) => {
            if (this.currentSpaceID) {
                this.updateDueToDelete(feature);
            }
        });
        this.createObservable.subscribe((feature) => {
            if (this.currentSpaceID) {
                this.updateDueToCreate(feature);
            }
        });
    }
    /*
    * CRUD
    */
    createFeature(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateFeature(feature);
        });
    }
    deleteFeature(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            const deleted = yield this.API.__proto__.DeleteFeature({ id: feature.id });
            if (deleted) {
                const poi = yield this.poiService.getPoiByElementId(feature.id);
                if (poi) {
                    yield this.poiService.deletePoi(poi.id);
                }
                // delete comments
                for (const comment of deleted.comments.items) {
                    yield this.commentService.deleteComment(comment.id);
                }
            }
            return deleted;
        });
    }
    updateFeature(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateFeature(feature);
        });
    }
    getFeature(id) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const feature = (yield this.API.__proto__.GetFeature(id));
            (_a = feature.events) === null || _a === void 0 ? void 0 : _a.items.sort((a, b) => b.realStartDate - a.realStartDate);
            this.setCoverImage(feature);
            this.setImages(feature);
            this.setVideos(feature);
            this.setDocuments(feature);
            this.setAudio(feature);
            this.setExternalLinks(feature);
            this.setEmbeds(feature);
            this.isBookingPlace(feature);
            return feature;
        });
    }
    initFeatures() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.currentSpaceID) {
                return;
            }
            this.updating.next(true);
            this.isUpdating = true;
            const featureList = yield this.getFeaturesForSpace(this.currentSpaceID);
            this.currentHashtags = yield this.hashtagService.getHashtagsForSpace(this.currentSpaceID);
            // console.log(this.currentHashtags);
            if (featureList.length > 0) {
                let filteredFeatures = [...featureList];
                let filteredPointInterest = filteredFeatures.filter((feature) => feature.type !== FeatureType.DESK);
                let filteredDesks = filteredFeatures.filter((feature) => feature.type === FeatureType.DESK);
                if (this.featureDomainFilter) {
                    filteredPointInterest = filteredPointInterest.filter((feature) => this.featureDomainFilter.find((domain) => feature.domain && domain === feature.domain.id));
                }
                if (this.deskDomainFilter) {
                    filteredDesks = filteredDesks.filter((feature) => this.deskDomainFilter.find((domain) => feature.domain && domain === feature.domain.id));
                }
                filteredFeatures = [...filteredPointInterest, ...filteredDesks];
                this.currentFeatures.space = filteredFeatures.sort((a, b) => a.index - b.index);
                // emit on tags should be after setting current.space !!
                this.featureTags.next(filteredFeatures); // for tags update without zone filtering
                if (this.zoneIDFilter) {
                    filteredFeatures =
                        (yield this.filterService.filterObjectsForZone(filteredFeatures, this.zoneIDFilter));
                }
                this.currentFeatures.zone = filteredFeatures.sort((a, b) => a.index - b.index);
                // console.log(this.currentFeatures);
                this.featureUpdated.next(this.currentFeatures); // for lateral menu
            }
            else {
                this.featureUpdated.next({ space: [], zone: [] }); // for lateral menu
            }
            this.updating.next(false);
            this.isUpdating = false;
        });
    }
    getFeaturesForSpace(spaceID, keepArchived = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const features = yield this.API.__proto__.FeaturesBySpace(spaceID).then((response) => response.items);
            let featuresForUser = yield this.filterService.filterFeaturesForCurrentUserInSpace(features, spaceID);
            if (!keepArchived) {
                featuresForUser = featuresForUser.filter((feature) => !this.isArchived(feature));
            }
            for (const feature of featuresForUser) {
                this.setCoverImage(feature);
                this.isBookingPlace(feature);
            }
            return featuresForUser;
        });
    }
    getFeaturesBySpaceWithoutFiltering(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            let features = yield this.API.__proto__.FeaturesBySpace(spaceID).then((response) => response.items);
            features = features.filter((feature) => !this.isArchived(feature));
            for (const feature of features) {
                this.setCoverImage(feature);
                this.isBookingPlace(feature);
            }
            return features;
        });
    }
    isBookingPlace(feature) {
        feature.isBookingPlace = feature.type === FeatureType.DESK;
    }
    setCoverImage(feature) {
        const coverImage = feature.comments.items.find((com) => com.isCoverImage);
        if (coverImage) {
            feature.coverImageUrl = coverImage.annexe;
            return;
        }
        if (feature.comments.items.some((com) => com.type === CommentType.YOUTUBE)) {
            const youtubeComment = feature.comments.items.find((com) => com.type === CommentType.YOUTUBE);
            // we can use the preview image of youtube
            feature.coverImageUrl = `https://img.youtube.com/vi/${youtubeComment.externalLink}/0.jpg`;
            return;
        }
        if (feature.comments.items.some((com) => com.type === CommentType.IMAGE)) {
            const imageComment = feature.comments.items.find((com) => com.type === CommentType.IMAGE);
            feature.coverImageUrl = imageComment.annexe;
        }
    }
    updateFeatureLocation(feature, tagData, spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const poiInput = {
                coordinate: tagData.getCoordinateString(),
                type: feature.isBookingPlace ? PoiType.DESK : PoiType.DATA,
                elementID: feature.id,
                metadata: tagData.getMetadataString(),
                matterportSweepID: tagData.getSweepID(),
            };
            const poi = yield this.poiService.createPOIForSpaceID(poiInput);
            return poi;
        });
    }
    setImages(feature) {
        const imagesComments = feature.comments.items
            .filter((com) => com.type === CommentType.IMAGE)
            .sort((a, b) => a.index - b.index);
        const images = [];
        for (const image of imagesComments) {
            images.push({
                path: image.annexe,
                title: image.title,
                description: image.description,
                showInTag: image.shownInTag,
            });
        }
        feature.images = images;
    }
    setVideos(feature) {
        const videosComments = feature.comments.items
            .filter((com) => com.type === CommentType.VIDEO || com.type === CommentType.YOUTUBE)
            .sort((a, b) => a.index - b.index);
        const videos = [];
        for (const video of videosComments) {
            videos.push({
                path: video.type === CommentType.YOUTUBE ? 'https://www.youtube.com/embed/' + video.externalLink : video.annexe,
                title: video.title,
                description: video.description,
                type: video.type,
            });
        }
        feature.videos = videos;
    }
    setDocuments(feature) {
        const documentComments = feature.comments.items
            .filter((com) => com.type === CommentType.DOCUMENT)
            .sort((a, b) => a.index - b.index);
        const docs = [];
        for (const document of documentComments) {
            docs.push({
                path: document.annexe,
                title: document.title,
                description: document.description,
            });
        }
        feature.documents = docs;
    }
    setAudio(feature) {
        const audioComments = feature.comments.items
            .filter((com) => com.type === CommentType.AUDIO)
            .sort((a, b) => a.index - b.index);
        const audios = [];
        for (const audio of audioComments) {
            audios.push({
                path: audio.annexe,
                title: audio.title,
                description: audio.description,
            });
        }
        feature.audios = audios;
    }
    setExternalLinks(feature) {
        const linksComments = feature.comments.items
            .filter((com) => com.type === CommentType.URL)
            .sort((a, b) => a.index - b.index);
        const externalLinks = [];
        for (const link of linksComments) {
            externalLinks.push({
                path: link.externalLink,
                title: link.title,
                description: link.description,
                showInTag: link.shownInTag,
            });
        }
        feature.externalLinks = externalLinks;
    }
    setEmbeds(feature) {
        const embedComments = feature.comments.items
            .filter((com) => com.type === CommentType.EMBED)
            .sort((a, b) => a.index - b.index);
        const embeds = [];
        for (const embed of embedComments) {
            embeds.push({
                path: embed.externalLink,
                title: embed.title,
                description: embed.description,
                showInTag: embed.shownInTag,
            });
        }
        feature.embeds = embeds;
    }
    getFirstFeatureForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const features = yield this.getFeaturesForSpace(spaceID);
            const first = features.find((feat) => feat.index === 1);
            return first;
        });
    }
    updateIconForAllFeaturesInSpace(tagIcon, spaceID, categoryID = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let features = yield this.getFeaturesForSpace(spaceID);
            if (categoryID) {
                features = features.filter((feature) => feature.domainID === categoryID);
            }
            const pois = yield this.updateIconForAllObjects(features, tagIcon);
            return { features, pois };
        });
    }
    getCreatedIndicesForFeaturesInSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            let features = (yield this.API.__proto__.FeaturesBySpace(spaceID)).items;
            features = features.filter((feat) => feat.index);
            return features.map((feat) => feat.index);
        });
    }
    getDesksForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const features = yield this.getFeaturesForSpace(spaceID);
            return features.filter((feat) => feat.isBookingPlace);
        });
    }
    /** Return true if the current user has archived this feature */
    isArchived(feature) {
        return feature.archivedForMissionID
            ? feature.archivedForMissionID.includes(this.userService.currentMission(feature.spaceID).id)
            : false;
    }
    setArchived(feature, archived) {
        let archivedList = feature.archivedForMissionID
            ? feature.archivedForMissionID
            : [];
        const missionID = this.userService.currentMission(feature.spaceID).id;
        archivedList = archivedList.filter((m) => m !== missionID);
        if (archived) {
            archivedList.push(missionID);
        }
        return this.updateFeature({
            id: feature.id,
            archivedForMissionID: archivedList,
        });
    }
    updateDueToCreate(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentFeatures.space.unshift(feature);
            this.currentFeatures.zone.unshift(feature);
            this.featureUpdated.next({
                space: this.currentFeatures.space,
                zone: this.currentFeatures.zone,
            }); // for lateral menu
        });
    }
    updateDueToDelete(deletedFeature) {
        return __awaiter(this, void 0, void 0, function* () {
            const feature = this.currentFeatures.space.find((_feature) => _feature.id === deletedFeature.id);
            if (feature) {
                const index = this.currentFeatures.space.indexOf(feature);
                this.currentFeatures.space.splice(index, 1);
            }
            const zoneFeature = this.currentFeatures.zone.find((_feature) => _feature.id === deletedFeature.id);
            if (zoneFeature) {
                const index = this.currentFeatures.zone.indexOf(zoneFeature);
                this.currentFeatures.zone.splice(index, 1);
            }
            this.featureUpdated.next({
                space: this.currentFeatures.space,
                zone: this.currentFeatures.zone,
            }); // for lateral menu
        });
    }
}
FeatureService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FeatureService, deps: [{ token: 'currentAPIService' }, { token: NavigatorService }, { token: FilterService }, { token: PoiService }, { token: CommentService }, { token: BaseUserService }, { token: NavigationService }, { token: HashtagService }, { token: ZoneChangeService }], target: i0.ɵɵFactoryTarget.Injectable });
FeatureService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FeatureService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: FeatureService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: NavigatorService }, { type: FilterService }, { type: PoiService }, { type: CommentService }, { type: BaseUserService }, { type: NavigationService }, { type: HashtagService }, { type: ZoneChangeService }];
    } });

class MeasurementService {
    constructor(awsKinesisAnalyticsInjected, navigatorService, filterService, commentService, poiService, userService, zoneChangeService, navigationService) {
        this.navigatorService = navigatorService;
        this.filterService = filterService;
        this.commentService = commentService;
        this.poiService = poiService;
        this.userService = userService;
        this.zoneChangeService = zoneChangeService;
        this.navigationService = navigationService;
        this.path = 'measurements/';
        this.currentMeasurements = { space: [], zone: [] };
        this.measurementsTags = new Subject();
        this.measurementsUpdated = new Subject();
        this.measurementFilter = false; // if false means no filtering, everything is allowed
        this.updateDone = new Subject();
        this.updating = new Subject();
        this.floorsPerSpace = null;
        this.selectedFloor = null;
        this.destroy$ = new Subject();
        this.awsKinesisAnalytics = awsKinesisAnalyticsInjected;
        const isMuseumUser = this.userService.hasOnlyMuseumRole();
        if (!isMuseumUser) {
            this.zoneChangeService.zoneChange.subscribe((zone) => {
                this.currentSpaceID = this.navigatorService.currentSpaceID;
                if (!this.currentSpaceID) {
                    this.measurementsTags.next(null);
                    this.measurementsUpdated.next({ space: [], zone: null });
                    this.measurementFilter = null;
                    this.zoneIDFilter = null;
                }
                else if (zone.id !== this.zoneIDFilter) {
                    this.zoneIDFilter = zone.id;
                    // console.log("going to init measurements from zone");
                    this.initMeasurements();
                }
            });
            this.filterService.subscribeToDataFilterUpdate((dateRange) => {
                this.dateFilter = dateRange;
                this.initMeasurements();
            });
            this.dateFilter = this.filterService.currentDateFilter;
            this.updateDone.subscribe(() => this.initMeasurements());
        }
        this.zoneChangeService.floorHasChanged.subscribe((floor) => {
            if (floor) {
                this.selectedFloor = floor;
            }
        });
    }
    initMeasurements() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentSpaceID) {
                this.updating.next(true);
                let measurements = yield this.getMeasurementsForSpaceForUser(this.currentSpaceID);
                if (measurements.length > 0) {
                    if (this.dateFilter) {
                        measurements = this.filterService.filterMeasurementsForDateRange(measurements, this.dateFilter);
                    }
                    if (this.measurementFilter) {
                        measurements = [];
                    }
                    this.currentMeasurements.space = measurements;
                    // emit on tags should be after setting current.space !!
                    this.measurementsTags.next(measurements.map((m) => m.comment));
                    if (this.zoneIDFilter) {
                        const commentsZone = yield this.filterService.filterObjectsForZone(measurements.map((measure) => measure.comment), this.zoneIDFilter);
                        measurements = measurements.filter((measure) => commentsZone.includes(measure.comment));
                    }
                    measurements.sort((a, b) => {
                        return (
                        // @ts-ignore
                        new Date(b.comment.createdAt) -
                            // @ts-ignore
                            new Date(a.comment.createdAt));
                    });
                    this.currentMeasurements.zone = measurements;
                    this.measurementsUpdated.next(this.currentMeasurements);
                }
                else {
                    this.currentMeasurements.space = [];
                    this.currentMeasurements.zone = [];
                    this.measurementsUpdated.next({ space: [], zone: [] }); // for lateral menu
                }
            }
            else {
                this.measurementsTags.next(null);
            }
            this.updating.next(false);
        });
    }
    deleteMeasurement(measurement) {
        return __awaiter(this, void 0, void 0, function* () {
            const deletedComment = yield this.commentService.deleteComment(measurement.comment.id);
            if (deletedComment) {
                yield this.poiService.deletePoi(measurement.poi.id);
                const prefix = `${measurement.comment.id.slice(0, 8)}_`;
                const path = `${this.path + prefix}mesure.jpeg`;
                yield deleteFromS3(path);
            }
            return deletedComment;
        });
    }
    createMeasurementForSpace(commentInput, dataMeasurements, screenshot, spaceID) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const lastMeasure = dataMeasurements.measure;
            const sweepID = dataMeasurements.sweep;
            const lastPoint = lastMeasure[lastMeasure.length - 1];
            let comment = yield this.commentService.createComment(commentInput);
            const poiInput = {
                coordinate: JSON.stringify({
                    x: lastPoint.x,
                    y: lastPoint.y,
                    z: lastPoint.z,
                }),
                type: PoiType.MEASURE,
                elementID: comment.id,
                matterportSweepID: sweepID,
            };
            const poi = yield this.poiService.createPOIForSpaceID(poiInput);
            const screen = yield fetch(screenshot);
            const blob = yield screen.blob();
            const file = new File([blob], 'mesure.jpeg', { type: 'image/jpeg' });
            const url = yield uploadFileToS3(this.path, file, comment.id);
            if (url) {
                comment = yield this.commentService.updateComment({
                    id: comment.id,
                    annexe: url,
                });
            }
            const measurement = {
                comment,
                poi,
            };
            if (!!this.awsKinesisAnalytics && !!this.awsKinesisAnalytics.record && this.awsKinesisAnalytics.record()) {
                this.awsKinesisAnalytics.getInstance().record(
                // @ts-ignore
                {
                    data: {
                        eventType: 'Object Creation',
                        objectType: 'measurement',
                        measurement: measurement,
                        //zoneId: spaceID,
                        user: this.userService.cu,
                        locationId: this.currentSpaceID,
                        timestamp: new Date(),
                        zoneId: this.zoneIDFilter,
                        floorId: (_a = this.selectedFloor) === null || _a === void 0 ? void 0 : _a.id,
                    },
                    streamName: 'smarterplanKinesis-analytics',
                    // partitionKey: "",
                }, 'AWSKinesis');
            }
            return measurement;
        });
    }
    getModel3DForMeasurement(measurement) {
        return __awaiter(this, void 0, void 0, function* () {
            const poi = yield this.poiService.getPoiByElementId(measurement.comment.id);
            if (poi && poi.matterportSweepID) {
                const navigations = yield this.navigationService.getNavigationsForMatterportIDForSpace(poi.matterportSweepID, measurement.comment.spaceID);
                const [poiNavigation] = navigations;
                return poiNavigation.node.model3D;
            }
            return null;
        });
    }
    getMeasurementsForSpaceForUser(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            let comments = yield this.commentService.getCommentsBySpaceID(spaceID);
            comments = yield this.filterService.filterMeasurementsForCurrentUserInSpace(spaceID, comments);
            let measurements = [];
            if (comments.length > 0) {
                yield Promise.all(comments.map((comment) => __awaiter(this, void 0, void 0, function* () {
                    const measurement = yield this.commentService.readCommentAsMeasurement(comment.id);
                    measurements.push(measurement);
                })));
            }
            return measurements;
        });
    }
    unsubscribe() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
MeasurementService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MeasurementService, deps: [{ token: 'currentAwsKinesisAnalyticsService' }, { token: NavigatorService }, { token: FilterService }, { token: CommentService }, { token: PoiService }, { token: BaseUserService }, { token: ZoneChangeService }, { token: NavigationService }], target: i0.ɵɵFactoryTarget.Injectable });
MeasurementService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MeasurementService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MeasurementService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAwsKinesisAnalyticsService']
                    }] }, { type: NavigatorService }, { type: FilterService }, { type: CommentService }, { type: PoiService }, { type: BaseUserService }, { type: ZoneChangeService }, { type: NavigationService }];
    } });

class SpaceService {
    constructor(visitService, userService, propertyService, captureService, missionService, ticketService, equipService, featureService, measurementService, apiInjected) {
        this.visitService = visitService;
        this.userService = userService;
        this.propertyService = propertyService;
        this.captureService = captureService;
        this.missionService = missionService;
        this.ticketService = ticketService;
        this.equipService = equipService;
        this.featureService = featureService;
        this.measurementService = measurementService;
        this.locationsForUser = [];
        this.locationUpdated = new Subject();
        this.API = apiInjected;
    }
    listSpaces() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ListSpaces().then((spaces) => spaces.items.filter((sp) => !sp.deletedAt));
        });
    }
    getLocationsForCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            const missions = this.userService.currentMissions;
            if (!missions)
                return [];
            let locations = [];
            yield Promise.all(missions.map((mission) => __awaiter(this, void 0, void 0, function* () {
                if (mission.space && !mission.space.deletedAt) {
                    const space = yield this.getSpace(mission.space.id);
                    yield this.signUrlForSpace(space);
                    yield this.visitService
                        .getVisitsForSpaceForUser(space.id)
                        .then((visits) => {
                        if (visits) {
                            space.visits = visits;
                        }
                    });
                    locations.push(space);
                }
            })));
            if (locations.length > 0) {
                locations = sortAlphabeticallyOnName(filterUniqueArrayByID(locations));
            }
            this.locationsForUser = locations;
            this.locationUpdated.next(locations);
            return locations;
        });
    }
    signUrlForSpace(loc) {
        return __awaiter(this, void 0, void 0, function* () {
            if (loc.annexes) {
                getSignedImageUrlForSpace(loc).then((url) => {
                    if (url) {
                        loc.annexes = url;
                    }
                });
            }
        });
    }
    getAllowedSpacesForOrg(orgID, userOrgID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (userOrgID === "6e28201f-4679-4c29-9d2d-8a325f57cee9" ||
                orgID === "6e28201f-4679-4c29-9d2d-8a325f57cee9") {
                return this.listSpaces();
            }
            return this.getSpacesForOrg(userOrgID);
        });
    }
    getSpacesForOrg(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            const properties = yield this.propertyService.getPropertiesForOrganisation(orgID);
            if (properties.length > 0) {
                const spaces = [];
                for (const property of properties) {
                    if (property.space && !property.space.deletedAt) {
                        spaces.push(property.space);
                    }
                }
                return spaces;
            }
            return null;
        });
    }
    createSpace(values, layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const loc = yield this.API.__proto__.CreateSpace(values);
            const zoneInput = {
                name: values.name,
                spaceID: loc.id,
                surface: 0,
                layerID: layer ? layer.id : null,
            };
            yield this.API.__proto__.CreateZone(zoneInput);
            return loc;
        });
    }
    updateSpace(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateSpace(input);
        });
    }
    getSpace(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetSpace(id);
        });
    }
    getModel3DForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const captures = yield this.captureService.getCapturesBySpace(spaceID);
            if (captures.length > 0 && captures[0].nodes.items.length > 0) {
                return captures[0].nodes.items[0].model3D;
            }
            return null;
        });
    }
    getAllowedModel3DForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const visits = yield this.visitService.getVisitsForSpaceForUser(spaceID);
            if (visits.length > 0) {
                return visits[0].model3d;
            }
            return null;
        });
    }
    softDeleteSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateSpace({
                id: spaceID,
                deletedAt: Date.now(),
            });
            const missions = yield this.missionService.getMissionsForSpace(spaceID);
            const properties = yield this.propertyService.listPropertiesForSpace(spaceID);
            if (this.userService.isSPAdmin()) {
                // delete all properties
                yield Promise.all(properties.map((property) => __awaiter(this, void 0, void 0, function* () {
                    yield this.propertyService.deleteProperty(property.id);
                })));
                // delete all missions
                yield Promise.all(missions.map((mission) => __awaiter(this, void 0, void 0, function* () {
                    yield this.missionService.update({
                        id: mission.id,
                        deletedAt: Date.now(),
                    });
                })));
            }
            else {
                // delete property for current Org
                const currentOrg = this.userService.currentOrganisation(spaceID);
                const propertyToDelete = properties.find((property) => property.organisationID === currentOrg.id);
                if (propertyToDelete) {
                    yield this.propertyService.deleteProperty(propertyToDelete.id);
                }
                const missionsToDelete = missions.filter((mission) => mission.organisationID === currentOrg.id ||
                    mission.orderedOrganisationID === currentOrg.id);
                yield Promise.all(missionsToDelete.map((mission) => __awaiter(this, void 0, void 0, function* () {
                    yield this.missionService.update({
                        id: mission.id,
                        deletedAt: Date.now(),
                    });
                })));
            }
            const tickets = yield this.ticketService.getTicketsBySpace(spaceID);
            yield Promise.all(tickets.map((ticket) => __awaiter(this, void 0, void 0, function* () {
                yield this.ticketService.deleteTicket(ticket);
            })));
            const equips = yield this.equipService.getEquipmentsForSpace(spaceID);
            yield Promise.all(equips.map((eq) => __awaiter(this, void 0, void 0, function* () {
                yield this.equipService.deleteEquipment(eq);
            })));
            const features = yield this.featureService.getFeaturesForSpace(spaceID);
            yield Promise.all(features.map((feature) => __awaiter(this, void 0, void 0, function* () {
                yield this.featureService.deleteFeature(feature);
            })));
            // measurements
            const measures = yield this.measurementService.getMeasurementsForSpaceForUser(spaceID);
            yield Promise.all(measures.map((measure) => __awaiter(this, void 0, void 0, function* () {
                yield this.measurementService.deleteMeasurement(measure);
            })));
            // remove from list
            this.locationsForUser = this.locationsForUser.filter((space) => space.id !== spaceID);
            this.locationUpdated.next(this.locationsForUser);
        });
    }
    /**
     * If current user can archive a space (only if his organisation is owning the property (PropertyType.PROPERTY))
     * @param spaceID
     * @returns
     */
    canArchiveSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentOrg = this.userService.currentOrganisation(spaceID);
            const orgProperties = yield this.propertyService.getPropertiesForOrganisation(currentOrg.id);
            const property = orgProperties.find((property_) => property_.spaceID === spaceID);
            if (property.type === PropertyType.PROPERTY) {
                return true;
            }
            return false;
        });
    }
}
SpaceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SpaceService, deps: [{ token: VisitService }, { token: BaseUserService }, { token: PropertyService }, { token: CaptureService }, { token: MissionService }, { token: TicketsService }, { token: EquipmentService }, { token: FeatureService }, { token: MeasurementService }, { token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
SpaceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SpaceService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: SpaceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: VisitService }, { type: BaseUserService }, { type: PropertyService }, { type: CaptureService }, { type: MissionService }, { type: TicketsService }, { type: EquipmentService }, { type: FeatureService }, { type: MeasurementService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class NavigationBarComponent {
    constructor(awsKinesisAnalyticsInjected, router, spaceService, userService, zoneService, visitService, viewerService, navigatorService, zoneChangeService) {
        this.router = router;
        this.spaceService = spaceService;
        this.userService = userService;
        this.zoneService = zoneService;
        this.visitService = visitService;
        this.viewerService = viewerService;
        this.navigatorService = navigatorService;
        this.zoneChangeService = zoneChangeService;
        this.selectedLocation = null;
        this.selectedFloor = null;
        this.selectedZone = null;
        this.selectedChildZone = null;
        this.visitsPerSpace = null;
        this.floorsPerSpace = null;
        this.zonesPerSpace = null;
        this.zonesPerFloor = null;
        this.childrenZones = null;
        this.destroy$ = new Subject();
        this.awsKinesisAnalytics = awsKinesisAnalyticsInjected;
        this.spaceService.locationUpdated
            .pipe(takeUntil(this.destroy$))
            .subscribe((locs) => {
            this.locations = locs;
            if (this.selectedLocation) {
                this.selectedLocation = this.findLocationByID(this.selectedLocation.id); // Update Object (object address will change);
            }
        });
        this.viewerService.viewerIsOn
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
            // console.log('menu navigation received update', data);
            this.currentLocationID = data.spaceID;
            this.currentModel3d = data.model3D;
            if (!data.spaceID) {
                this.selectedLocation = null;
                localStorage.removeItem('locationId');
                this.sendUpdateLocationEvent();
                return;
            }
            if ((!this.selectedLocation ||
                this.selectedLocation.id !== data.spaceID) &&
                this.locations) {
                this.selectedLocation = this.findLocationByID(data.spaceID);
                this.sendUpdateLocationEvent();
            }
        });
        /**
         * We listen for Location change event
         */
        this.navigatorService.locationIDChange
            .pipe(takeUntil(this.destroy$))
            .subscribe((id) => {
            this.clearData();
            this.currentLocationID = id;
            this.selectedLocation = this.findLocationByID(id);
            this.navigatorService.currentNavBarLocationID = id;
            this.onSelectedLocationChanged().catch((e) => console.log(e.message));
        });
        this.zoneChangeService.zonesForUserChange
            .pipe(takeUntil(this.destroy$))
            .subscribe((zones) => __awaiter(this, void 0, void 0, function* () {
            if (zones) {
                yield waitUntil(() => this.floorsPerSpace !== null);
                const floorZone = zones.find((zone) => zone.layer && zone.layer.name === 'FLOOR');
                if (floorZone) {
                    this.selectedFloor = this.floorsPerSpace.find((f) => f.id === floorZone.id);
                    // Emit event to dispatch value of  this.selectedFloor in all poi/ticket/equipment/measure services
                    this.zoneChangeService.floorHasChanged.emit(this.selectedFloor);
                    this.onFloorClick(false).catch((e) => console.log(e.message));
                }
            }
        }));
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.initLocations();
            this.handleStartUrl();
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    // Capture the "id" in localisation/:id routes
    handleStartUrl() {
        if (this.router.url.includes('localisation/')) {
            const paths = this.router.url.split('/'); // /dashboard/localisation/fc0aadb7-3c89-4349-ad1f-bfe9b44916c0
            // eslint-disable-next-line prefer-destructuring
            const locID = paths[3];
            if (this.currentLocationID !== locID) {
                this.clearData();
                this.currentLocationID = locID;
                this.selectedLocation = this.findLocationByID(locID);
                this.navigatorService.currentNavBarLocationID = locID;
                this.onSelectedLocationChanged().catch((e) => console.log(e.message));
            }
        }
    }
    initLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            this.locations = this.spaceService.locationsForUser;
            if (this.locations.length === 0) {
                this.locations = yield this.spaceService.getLocationsForCurrentUser();
            }
            if (this.currentLocationID && this.locations.length > 0) {
                this.selectedLocation = this.findLocationByID(this.currentLocationID);
                if (this.selectedLocation) {
                    this.sendUpdateLocationEvent();
                }
            }
        });
    }
    /**
     * Find a location with a given ID
     * @param id ID for the location
     * @returns The location or null if no location were found
     */
    findLocationByID(id) {
        const space = this.locations.find((loc) => loc.id === id);
        return space || null; /** Convert to null if undefined */
    }
    clearData(clearVisits = true) {
        this.floorsPerSpace = null;
        this.selectedFloor = null;
        this.zonesPerFloor = null;
        this.childrenZones = null;
        this.selectedModel3d = null;
        this.sweepToGo = null;
        this.floorToGo = null;
        this.selectedZone = null;
        this.selectedChildZone = null;
        if (clearVisits) {
            this.visitsPerSpace = null;
            this.zonesPerSpace = null;
        }
        localStorage.removeItem('locationId');
        localStorage.removeItem('floorId');
        localStorage.removeItem('zoneId');
        localStorage.removeItem('childZoneId');
    }
    /**
     * When the selectedLocation changes
     * Send a event to locationIDChange from NavigatorService
     * The event will be catch by this component and the filter bar will be update
     */
    sendUpdateLocationEvent() {
        const locationID = this.selectedLocation ? this.selectedLocation.id : null;
        this.navigatorService.locationIDChange.next(locationID);
        if (this.selectedLocation) {
            localStorage.setItem('locationId', this.selectedLocation.id);
        }
        else {
            localStorage.removeItem('locationId');
        }
    }
    onSelectedLocationChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.selectedLocation) {
                return;
            }
            try {
                this.visitsPerSpace = yield this.visitService.getVisitsForSpaceForUser(this.selectedLocation.id);
                this.zonesPerSpace = yield this.zoneService.getZonesBySpaceForUser(this.selectedLocation.id);
                if (this.visitsPerSpace.length === 1) {
                    this.selectedModel3d = this.visitsPerSpace[0].model3d;
                    this.floorsPerSpace = this.zonesPerSpace.filter((zone) => zone.layer && zone.layer.name.includes('FLOOR'));
                    // sort from highest floor to lowest
                    this.floorsPerSpace.sort((a, b) => {
                        if (a.metadata && b.metadata) {
                            const metadataA = JSON.parse(a.metadata);
                            const metadataB = JSON.parse(b.metadata);
                            return (metadataB.matterportFloorSequence -
                                metadataA.matterportFloorSequence);
                        }
                        return a.name.localeCompare(b.name);
                    });
                    const multiFloorZones = this.zonesPerSpace.filter((zone) => zone.isMultipleFloorZone);
                    // sort alphabetically
                    multiFloorZones.sort((a, b) => a.name.localeCompare(b.name));
                    // merge multiFloor and Floors
                    this.floorsPerSpace = [...this.floorsPerSpace, ...multiFloorZones];
                    if (this.floorsPerSpace.length === 1) {
                        [this.selectedFloor] = this.floorsPerSpace;
                        this.onFloorClick(false).catch((e) => console.log(e.message));
                    }
                }
            }
            catch (error) {
                console.log('error onChosenLocation', error);
            }
        });
    }
    onLocationClick() {
        this.clearData();
        this.sendUpdateLocationEvent();
    }
    onFloorClick(emitEvent = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selectedFloor) {
                localStorage.setItem('floorId', this.selectedFloor.id);
            }
            else {
                localStorage.removeItem('floorId');
            }
            if (this.selectedFloor && this.selectedFloor.isMultipleFloorZone) {
                this.selectedZone = this.selectedFloor;
                this.onZoneClick().catch((e) => console.log(e.message));
                return;
            }
            else {
                this.onZoneClick().catch((e) => console.log(e.message));
            }
            this.sweepToGo = null;
            this.selectedZone = null;
            this.selectedChildZone = null;
            localStorage.removeItem('zoneId');
            localStorage.removeItem('childZoneId');
            if (this.selectedFloor === null) {
                this.navigatorService.navBarZoneIDChange.next(null);
                this.navigatorService.currentNavBarZoneID = null;
                return;
            }
            if (emitEvent) {
                this.navigatorService.navBarZoneIDChange.next(this.selectedFloor.id);
            }
            this.navigatorService.currentNavBarZoneID = this.selectedFloor.id;
            yield waitUntil(() => this.zonesPerSpace !== null && this.zonesPerSpace !== undefined);
            this.zonesPerFloor = this.zonesPerSpace.filter((zone) => 
            // zone.id === this.selectedFloor.id ||
            zone.parentID === this.selectedFloor.id);
            this.zonesPerFloor.sort((a, b) => {
                const Collator = new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'accent',
                });
                return (Collator.compare(a.code_ref, b.code_ref) ||
                    Collator.compare(a.name, b.name));
            });
        });
    }
    onZoneClick() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            this.selectedChildZone = null;
            localStorage.removeItem('childZoneId');
            if (this.selectedZone) {
                localStorage.setItem('zoneId', this.selectedZone.id);
            }
            else {
                localStorage.removeItem('zoneId');
            }
            if (this.selectedZone === null) {
                if (this.selectedFloor === null) {
                    this.navigatorService.navBarZoneIDChange.next(null);
                    this.navigatorService.currentNavBarZoneID = null;
                }
                else {
                    this.navigatorService.navBarZoneIDChange.next(this.selectedFloor.id);
                    this.navigatorService.currentNavBarZoneID = this.selectedFloor.id;
                }
                this.sendKinesisAnalyticsEventForZone((_a = this.selectedZone) === null || _a === void 0 ? void 0 : _a.id, (_b = this.selectedZone) === null || _b === void 0 ? void 0 : _b.name).catch((e) => console.log(e.message));
                return;
            }
            this.childrenZones = this.zonesPerSpace.filter((zone) => zone.parentID === this.selectedZone.id);
            this.navigatorService.navBarZoneIDChange.next(this.selectedZone.id);
            this.navigatorService.currentNavBarZoneID = this.selectedZone.id;
            this.sendKinesisAnalyticsEventForZone((_c = this.selectedZone) === null || _c === void 0 ? void 0 : _c.id, (_d = this.selectedZone) === null || _d === void 0 ? void 0 : _d.name).catch((e) => console.log(e.message));
        });
    }
    onChildZoneClick() {
        var _a;
        if (this.selectedChildZone) {
            localStorage.setItem('childZoneId', (_a = this.selectedChildZone) === null || _a === void 0 ? void 0 : _a.id);
        }
        else {
            localStorage.removeItem('childZoneId');
        }
    }
    sendKinesisAnalyticsEventForZone(zoneId, zoneName) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            if (!!this.awsKinesisAnalytics && !!this.awsKinesisAnalytics.record && this.awsKinesisAnalytics.record()) {
                this.awsKinesisAnalytics.getInstance().record(
                // @ts-ignore
                {
                    data: {
                        eventType: 'Zone Change',
                        zoneId: zoneId,
                        zoneName: zoneName,
                        locationId: (_a = this.selectedLocation) === null || _a === void 0 ? void 0 : _a.id,
                        locationName: (_b = this.selectedLocation) === null || _b === void 0 ? void 0 : _b.name,
                        user: (_c = this.userService) === null || _c === void 0 ? void 0 : _c.cu,
                        timestamp: new Date(),
                        floorId: (_d = this.selectedFloor) === null || _d === void 0 ? void 0 : _d.id,
                        childZoneId: (_e = this.selectedChildZone) === null || _e === void 0 ? void 0 : _e.id,
                    },
                    streamName: 'smarterplanKinesis-analytics',
                    // partitionKey: "",
                }, 'AWSKinesis');
            }
        });
    }
    onVisitClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearData(false);
            const index = event.target.value;
            const visit = this.visitsPerSpace[index];
            this.selectedModel3d = visit.model3d;
            const parentZoneForVisit = yield this.visitService.getDefaultZoneForVisit(visit);
            this.floorsPerSpace = this.zonesPerSpace.filter((zone) => zone.layer &&
                zone.layer.name.includes('FLOOR') &&
                zone.parentID === parentZoneForVisit.id);
        });
    }
    goTo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selectedZone && !this.selectedZone.virtual) {
                this.sweepToGo = this.selectedZone.startSweepID
                    ? this.selectedZone.startSweepID
                    : this.selectedZone.sweepIDs[0];
            }
            if (this.selectedFloor && !this.selectedZone) {
                this.floorToGo = this.selectedFloor;
            }
            if (this.isWithinSameVisit()) {
                this.goToSweepOrFloor();
            }
            else {
                if (this.sweepToGo) {
                    this.viewerService.setSweepToMove(this.sweepToGo);
                }
                if (this.floorToGo && this.floorsPerSpace.length !== 1) {
                    this.navigatorService.floorToGo = this.floorToGo;
                }
                this.router
                    .navigate(['visit', this.selectedLocation.id], {
                    queryParams: { model3D: this.selectedModel3d },
                })
                    .catch((e) => console.log(e.message));
            }
        });
    }
    isWithinSameVisit() {
        return (this.currentLocationID === this.selectedLocation.id &&
            this.selectedModel3d === this.currentModel3d);
    }
    goToSweepOrFloor() {
        if (this.sweepToGo) {
            this.navigatorService.goToSweepWithRotation(this.sweepToGo);
        }
        if (this.floorToGo) {
            this.navigatorService.goToFloor(this.floorToGo);
        }
    }
    // hasHistory(): boolean {
    //     return this.navigatorService.modelHasHistory(this.selectedModel3d);
    // }
    canGo() {
        const viewerIsReady = this.viewerService.isLoaded && this.viewerService.showingViewer;
        const noViewer = !this.viewerService.showingViewer;
        return viewerIsReady || noViewer;
    }
    showLocation() {
        if (window.innerWidth < 750 &&
            this.navbarSelectMenu &&
            this.navbarSelectMenu.nativeElement.className.search('show') === -1 &&
            this.selectedLocation) {
            return this.selectedLocation.name;
        }
        return '';
    }
}
NavigationBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigationBarComponent, deps: [{ token: 'currentAwsKinesisAnalyticsService' }, { token: i1$1.Router }, { token: SpaceService }, { token: BaseUserService }, { token: ZoneService }, { token: VisitService }, { token: ViewerService }, { token: NavigatorService }, { token: ZoneChangeService }], target: i0.ɵɵFactoryTarget.Component });
NavigationBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: NavigationBarComponent, selector: "lib-navigation-bar", viewQueries: [{ propertyName: "navbarSelectMenu", first: true, predicate: ["navbarSelectMenu"], descendants: true }], ngImport: i0, template: "<nav class=\"navbar navbar-expand-md navbar-dark navbar-inverse second-nav\">\n    <div class=\"d-flex col-12\">\n        <div #navbarSelectMenu class=\"collapse navbar-collapse\" id=\"nav-item-container-blue\">\n            <div class=\"d-flex flex-column flex-md-row \">\n                <select class=\"form-control flex-fill location select-menu\" [(ngModel)]=\"selectedLocation\"\n                    (ngModelChange)=\"onLocationClick()\">\n                    <option [ngValue]=\"null\" selected>{{ 'Location' | translate }}</option>\n                    <option *ngFor=\"let loc of locations; index as index\" [ngValue]=\"loc\"> {{ loc.name }}</option>\n                </select>\n                <select class=\"form-control flex-fill select-menu\" (change)=\"onVisitClick($event)\"\n                    *ngIf=\"visitsPerSpace && visitsPerSpace.length > 1\">\n                    <option value=\"default\" selected disabled hidden>{{'Visit' | translate}}</option>\n                    <option *ngFor=\"let visit of visitsPerSpace; index as index\" value=\"{{index}}\">{{ visit.name}}\n                    </option>\n                </select>\n                <select class=\"form-control flex-fill floor select-menu\" [(ngModel)]=\"selectedFloor\"\n                    (ngModelChange)=\"onFloorClick()\">\n                    <option [ngValue]=\"null\" selected>{{'Floor' | translate}}</option>\n                    <option *ngFor=\"let floor of floorsPerSpace\" [ngValue]=\"floor\">{{ floor.name}}</option>\n                </select>\n                <select class=\"form-control flex-fill select-menu zone\" [(ngModel)]=\"selectedZone\"\n                    (ngModelChange)=\"onZoneClick()\">\n                    <option [ngValue]=\"null\" selected>{{'Zone' | translate}}</option>\n                    <option *ngFor=\"let zone of zonesPerFloor\" [ngValue]=\"zone\"><span\n                            *ngIf=\"zone.code_ref\">{{zone.code_ref}}_</span>{{zone.name}}</option>\n                </select>\n                <select class=\"form-control flex-fill select-menu\" [(ngModel)]=\"selectedChildZone\"\n                    *ngIf=\"childrenZones && childrenZones.length>0\" (ngModelChange)=\"onChildZoneClick()\">\n                    <option [ngValue]=\"null\" selected disabled>{{'Zone' | translate}}</option>\n                    <option *ngFor=\"let zone of childrenZones\" [ngValue]=\"zone\">{{ zone.name}}</option>\n                </select>\n                <!-- <select class=\"form-control flex-fill\">\n                    <option i18n>{{'Favorites' | translate}}</option>\n                </select> -->\n            </div>\n            <div class=\"row\" style=\"margin-left: 0;\">\n                <div class=\"outer_circle\">\n                    <button id='btn-icon' [disabled]=\"!selectedLocation || !selectedModel3d || !canGo()\"\n                        (click)=\"goTo()\"></button>\n                </div>\n                <button (click)=\"goTo()\" class=\"btn rounded-pill btn-3d\"\n                    [disabled]=\"!selectedLocation || !selectedModel3d || !canGo()\">{{'3D visit' | translate}}</button>\n            </div>\n        </div>\n\n        <h4 style=\"line-height: 29px;margin: 0;\" *ngIf=\"showLocation()\">\n            {{ showLocation() }}\n        </h4>\n    </div>\n</nav>", styles: [":host{position:sticky;top:0;height:123px}.navbar{z-index:200;padding:.4rem 1rem}.navbar.second-nav{z-index:199;background-color:var(--smarterplan-primary)}input,select{margin-right:15px}.select{background:transparent;border:none;color:#fff;margin:6px 20px 0}.form-control{width:auto;min-width:80px;max-width:18%}.location{width:auto;max-width:35%}.floor,.zone{width:auto;max-width:30%}button{color:#fff;padding:5px 10px;font-size:1.1em}.btn-3d:active:hover:not([disabled]){color:var(--smarterplan-secondary)}.btn-3d[disabled]:hover{color:#fff}.navbar-toggler{margin-right:1em}.select-menu{max-width:inherit}#btn-icon{width:30px;height:30px;background:url(../../../../../assets/icons/goTo3d.svg);border:none;vertical-align:middle}#btn-icon:hover{background:url(../../../../../assets/icons/goTo3d-over.svg)}#btn-icon[disabled]:hover{background:url(../../../../../assets/icons/goTo3d.svg)}.outer_circle{background-color:#ebebeb;border-radius:50%;width:32px;height:32px;padding:1px}\n"], directives: [{ type: i1$2.NgbNavbar, selector: ".navbar" }, { type: i3.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i3.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i3.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NavigationBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-navigation-bar', template: "<nav class=\"navbar navbar-expand-md navbar-dark navbar-inverse second-nav\">\n    <div class=\"d-flex col-12\">\n        <div #navbarSelectMenu class=\"collapse navbar-collapse\" id=\"nav-item-container-blue\">\n            <div class=\"d-flex flex-column flex-md-row \">\n                <select class=\"form-control flex-fill location select-menu\" [(ngModel)]=\"selectedLocation\"\n                    (ngModelChange)=\"onLocationClick()\">\n                    <option [ngValue]=\"null\" selected>{{ 'Location' | translate }}</option>\n                    <option *ngFor=\"let loc of locations; index as index\" [ngValue]=\"loc\"> {{ loc.name }}</option>\n                </select>\n                <select class=\"form-control flex-fill select-menu\" (change)=\"onVisitClick($event)\"\n                    *ngIf=\"visitsPerSpace && visitsPerSpace.length > 1\">\n                    <option value=\"default\" selected disabled hidden>{{'Visit' | translate}}</option>\n                    <option *ngFor=\"let visit of visitsPerSpace; index as index\" value=\"{{index}}\">{{ visit.name}}\n                    </option>\n                </select>\n                <select class=\"form-control flex-fill floor select-menu\" [(ngModel)]=\"selectedFloor\"\n                    (ngModelChange)=\"onFloorClick()\">\n                    <option [ngValue]=\"null\" selected>{{'Floor' | translate}}</option>\n                    <option *ngFor=\"let floor of floorsPerSpace\" [ngValue]=\"floor\">{{ floor.name}}</option>\n                </select>\n                <select class=\"form-control flex-fill select-menu zone\" [(ngModel)]=\"selectedZone\"\n                    (ngModelChange)=\"onZoneClick()\">\n                    <option [ngValue]=\"null\" selected>{{'Zone' | translate}}</option>\n                    <option *ngFor=\"let zone of zonesPerFloor\" [ngValue]=\"zone\"><span\n                            *ngIf=\"zone.code_ref\">{{zone.code_ref}}_</span>{{zone.name}}</option>\n                </select>\n                <select class=\"form-control flex-fill select-menu\" [(ngModel)]=\"selectedChildZone\"\n                    *ngIf=\"childrenZones && childrenZones.length>0\" (ngModelChange)=\"onChildZoneClick()\">\n                    <option [ngValue]=\"null\" selected disabled>{{'Zone' | translate}}</option>\n                    <option *ngFor=\"let zone of childrenZones\" [ngValue]=\"zone\">{{ zone.name}}</option>\n                </select>\n                <!-- <select class=\"form-control flex-fill\">\n                    <option i18n>{{'Favorites' | translate}}</option>\n                </select> -->\n            </div>\n            <div class=\"row\" style=\"margin-left: 0;\">\n                <div class=\"outer_circle\">\n                    <button id='btn-icon' [disabled]=\"!selectedLocation || !selectedModel3d || !canGo()\"\n                        (click)=\"goTo()\"></button>\n                </div>\n                <button (click)=\"goTo()\" class=\"btn rounded-pill btn-3d\"\n                    [disabled]=\"!selectedLocation || !selectedModel3d || !canGo()\">{{'3D visit' | translate}}</button>\n            </div>\n        </div>\n\n        <h4 style=\"line-height: 29px;margin: 0;\" *ngIf=\"showLocation()\">\n            {{ showLocation() }}\n        </h4>\n    </div>\n</nav>", styles: [":host{position:sticky;top:0;height:123px}.navbar{z-index:200;padding:.4rem 1rem}.navbar.second-nav{z-index:199;background-color:var(--smarterplan-primary)}input,select{margin-right:15px}.select{background:transparent;border:none;color:#fff;margin:6px 20px 0}.form-control{width:auto;min-width:80px;max-width:18%}.location{width:auto;max-width:35%}.floor,.zone{width:auto;max-width:30%}button{color:#fff;padding:5px 10px;font-size:1.1em}.btn-3d:active:hover:not([disabled]){color:var(--smarterplan-secondary)}.btn-3d[disabled]:hover{color:#fff}.navbar-toggler{margin-right:1em}.select-menu{max-width:inherit}#btn-icon{width:30px;height:30px;background:url(../../../../../assets/icons/goTo3d.svg);border:none;vertical-align:middle}#btn-icon:hover{background:url(../../../../../assets/icons/goTo3d-over.svg)}#btn-icon[disabled]:hover{background:url(../../../../../assets/icons/goTo3d.svg)}.outer_circle{background-color:#ebebeb;border-radius:50%;width:32px;height:32px;padding:1px}\n"] }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAwsKinesisAnalyticsService']
                    }] }, { type: i1$1.Router }, { type: SpaceService }, { type: BaseUserService }, { type: ZoneService }, { type: VisitService }, { type: ViewerService }, { type: NavigatorService }, { type: ZoneChangeService }];
    }, propDecorators: { navbarSelectMenu: [{
                type: ViewChild,
                args: ['navbarSelectMenu']
            }] } });

class MenuBarComponent {
    constructor(router, localeService, userService, navigatorService, supportService, baseVisibilityService) {
        this.router = router;
        this.localeService = localeService;
        this.userService = userService;
        this.navigatorService = navigatorService;
        this.supportService = supportService;
        this.baseVisibilityService = baseVisibilityService;
        this.isVisitor = true;
        this.isVisible = false;
        this.isChangePositionVisible = false;
        this.userSubscription = this.userService.isChanged.subscribe((isChanged) => {
            if (isChanged) {
                this.update();
            }
        });
        this.navSubscription = this.navigatorService.isVisibleChanged.subscribe((data) => {
            this.isVisible = data;
        });
        this.baseVisibilityService.isChangePositionVisible.subscribe((data) => {
            this.isChangePositionVisible = data;
        });
    }
    ngOnInit() {
        this.update();
    }
    ngAfterViewInit() {
        const input = document.querySelector('#mainSearchBar');
        if (input) {
            input.addEventListener('keydown', ({ key }) => {
                if (key === 'Enter') {
                    this.onSubmit();
                }
            });
        }
    }
    ngOnDestroy() {
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
        if (this.navSubscription) {
            this.navSubscription.unsubscribe();
        }
    }
    signOut() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.userService.logoutCurrentAndSignOutAuth();
            this.router.navigate(['auth']);
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.user = this.userService.cu;
            this.mission = this.userService.currentMissions[0];
            this.isManager = this.userService.hasManagerRoleInAnyMission();
            this.isVisitor = this.userService.isVisitor();
            if (!this.isVisitor) {
                this.isVisible = true;
            }
        });
    }
    // eslint-disable-next-line class-methods-use-this
    onSubmit() {
        const input = document.querySelector('#mainSearchBar');
        const searchValue = input.value.toLowerCase();
        if (searchValue !== '') {
            const baseUrl = location.origin;
            window.open(`${baseUrl}/dashboard/search?term=${searchValue}`, '_blank');
        }
    }
    onToggleVisible() {
        this.isVisible = !this.isVisible;
    }
    openSupportForm() {
        this.supportService.openSupportForm(SupportModalComponent);
    }
    onChangePositionClick() {
        this.baseVisibilityService.isChangePositionVisible.next(!this.isChangePositionVisible);
    }
}
MenuBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MenuBarComponent, deps: [{ token: i1$1.Router }, { token: LocaleService }, { token: BaseUserService }, { token: NavigatorService }, { token: SupportService }, { token: BaseVisibilityService }], target: i0.ɵɵFactoryTarget.Component });
MenuBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.7", type: MenuBarComponent, selector: "lib-menu-bar", ngImport: i0, template: "<div id=\"menu-bar\">\r\n  <div *ngIf=\"!isVisitor\">\r\n    <nav class=\"navbar navbar-expand-md navbar-light p-0\">\r\n      <div class=\"container-fluid\" *ngIf=\"isVisible\">\r\n        <div class=\"navbar-brand\" [routerLink]=\"['/dashboard']\">\r\n          <img alt=\"\" src=\"../assets/images/logos/logo-rvb-straight.png\">\r\n        </div>\r\n        <!-- <button class=\"navbar-toggler\" data-bs-target=\".navbar-collapse\" data-bs-toggle=\"collapse\" type=\"button\">\r\n          <span class=\"navbar-toggler-icon\"></span>\r\n        </button> -->\r\n        <div class=\"collapse navbar-collapse\">\r\n          <form class=\"form-inline ms-3\">\r\n            <input class=\"form-control search-button\" placeholder=\"keyword\" id=\"mainSearchBar\" type=\"text\">\r\n            <button class=\"btn btn-outline-primary rounded-pill me-2\" (click)=\"onSubmit()\">{{'Search' |\r\n              translate}}</button>\r\n            <lib-range-date-picker cacheName=\"mainDate\"></lib-range-date-picker>\r\n            <div class=\"change-position-button\">\r\n              <input type=\"checkbox\" class=\"btn-check\" id=\"btn-check-outlined\" autocomplete=\"off\">\r\n              <label class=\"btn btn-outline-primary\" (click)=\"onChangePositionClick()\"\r\n                for=\"btn-check-outlined\">{{\"Change position\" | translate}}</label>\r\n            </div>\r\n          </form>\r\n          <div class=\"ms-auto nav-item dropdown\">\r\n            <div class=\"profile_pic dropdown-toggle\" data-testid=\"dropdown-menu-button\" data-bs-toggle=\"dropdown\">\r\n              <lib-avatar></lib-avatar>\r\n            </div>\r\n            <div class=\"dropdown-menu dropdown-menu-right\">\r\n              <p *ngIf=\"user && mission\" class=\"p-2\">\r\n                <span class=\"username\">{{ user.displayName }}</span><br />\r\n                <span class=\"user-role\">{{ mission.role }}</span><br />\r\n                <span class=\"org\">{{ mission.organisation ? mission.organisation.name : \"No organisation\" |\r\n                  translate}}</span>\r\n              </p>\r\n              <div class=\"dropdown-divider\"></div>\r\n              <!-- <a class=\"dropdown-item\" routerLink=\"/debug\" *ngIf=\"isManager\">Debug</a> -->\r\n              <a class=\"dropdown-item\" (click)=\"localeService.modal()\">{{'Language' | translate}}</a>\r\n              <a class=\"dropdown-item\" routerLink=\"/dashboard\">{{'Data management' | translate}}</a>\r\n              <a class=\"dropdown-item\" data-testid=\"user-management-btn\" routerLink=\"/admin\" *ngIf=\"isManager\">\r\n                {{'Users management' | translate}}</a>\r\n              <a class=\"dropdown-item\" routerLink=\"/profile\">\r\n                {{'Profile' | translate}}</a>\r\n              <div class=\"dropdown-divider\"></div>\r\n              <button class=\"dropdown-item\" (click)=\"openSupportForm()\">{{\"Help\" | translate}}</button>\r\n              <button data-testid=\"logout-auth-btn\" class=\"dropdown-item\" (click)=\"signOut()\">{{\"Logout\" |\r\n                translate}}</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </nav>\r\n    <lib-navigation-bar *ngIf=\"isVisible && isChangePositionVisible\"></lib-navigation-bar>\r\n  </div>\r\n  <div *ngIf=\"isVisitor && isVisible\">\r\n    <div class=\"visitor-div\">\r\n      <div class=\"logo-container\" data-testid=\"dropdown-menu-button\">\r\n        <img class=\"img-logo\" alt=\"SmarterPlanLogo\" src=\"../assets/images/logos/logo-reserve.png\">\r\n      </div>\r\n      <div class=\"avatar-container-menu\">\r\n        <div class=\"profile_pic dropdown-toggle\" data-bs-toggle=\"dropdown\">\r\n          <lib-avatar></lib-avatar>\r\n        </div>\r\n        <div class=\"dropdown-menu dropdown-menu-right\">\r\n          <button class=\"dropdown-item\" (click)=\"localeService.modal()\">{{'Language' | translate}}</button>\r\n          <button class=\"dropdown-item\" (click)=\"openSupportForm()\">{{\"Help\" | translate}}</button>\r\n          <button data-testid=\"logout-auth-btn\" class=\"dropdown-item\" (click)=\"signOut()\">{{\"Logout\" |\r\n            translate}}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [":host{position:sticky;top:0;z-index:200}.navbar{z-index:200}.navbar-brand{padding-top:5px;padding-bottom:5px;cursor:pointer}.navbar-brand img{height:70px}.profile_pic{border-radius:50%;height:45px;width:45px;margin:8px;border:.2px solid #969696}.navbar-nav .profile-pic-container .dropdown-menu{position:absolute}.navbar.second-nav{z-index:199;background-color:var(--smarterplan-primary)}.profile_pic.dropdown-toggle:after{display:none}.navbar-light{border-bottom:1px solid var(--smarterplan-primary);background-color:#fff}input,select{margin-right:15px}.select{background:transparent;border:none;color:#fff;margin:6px 20px 0;width:auto}button{background-color:#fff;color:var(--smarterplan-primary);padding:5px 10px}button:disabled,button[disabled]{color:#c04f4f}.navbar-toggler{margin-right:1em}.icon{height:40px;width:40px;color:var(--smarterplan-primary)}.search-button{width:auto}.visitor-div{background-color:var(--smarterplan-primary);height:60px;display:flex;justify-content:space-between}.logo-container,.img-logo{height:100%}.change-position-button{margin-left:2rem}.change-position-button label,.change-position-button .btn-check:checked,.change-position-button .btn-check:focus,.change-position-button .btn-outline-primary,.change-position-button .btn{box-shadow:none!important;outline:0}.change-position-button label{border-radius:16px}.change-position-button .btn-check:checked+.btn{background-color:var(--smarterplan-primary);color:#fff!important}\n"], components: [{ type: RangeDatePickerComponent, selector: "lib-range-date-picker", inputs: ["cacheName"] }, { type: AvatarComponent, selector: "lib-avatar", inputs: ["size", "userID"] }, { type: NavigationBarComponent, selector: "lib-navigation-bar" }], directives: [{ type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbNavbar, selector: ".navbar" }, { type: i1$1.RouterLink, selector: ":not(a):not(area)[routerLink]", inputs: ["queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i3.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i3.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i3.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i1$1.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MenuBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-menu-bar', template: "<div id=\"menu-bar\">\r\n  <div *ngIf=\"!isVisitor\">\r\n    <nav class=\"navbar navbar-expand-md navbar-light p-0\">\r\n      <div class=\"container-fluid\" *ngIf=\"isVisible\">\r\n        <div class=\"navbar-brand\" [routerLink]=\"['/dashboard']\">\r\n          <img alt=\"\" src=\"../assets/images/logos/logo-rvb-straight.png\">\r\n        </div>\r\n        <!-- <button class=\"navbar-toggler\" data-bs-target=\".navbar-collapse\" data-bs-toggle=\"collapse\" type=\"button\">\r\n          <span class=\"navbar-toggler-icon\"></span>\r\n        </button> -->\r\n        <div class=\"collapse navbar-collapse\">\r\n          <form class=\"form-inline ms-3\">\r\n            <input class=\"form-control search-button\" placeholder=\"keyword\" id=\"mainSearchBar\" type=\"text\">\r\n            <button class=\"btn btn-outline-primary rounded-pill me-2\" (click)=\"onSubmit()\">{{'Search' |\r\n              translate}}</button>\r\n            <lib-range-date-picker cacheName=\"mainDate\"></lib-range-date-picker>\r\n            <div class=\"change-position-button\">\r\n              <input type=\"checkbox\" class=\"btn-check\" id=\"btn-check-outlined\" autocomplete=\"off\">\r\n              <label class=\"btn btn-outline-primary\" (click)=\"onChangePositionClick()\"\r\n                for=\"btn-check-outlined\">{{\"Change position\" | translate}}</label>\r\n            </div>\r\n          </form>\r\n          <div class=\"ms-auto nav-item dropdown\">\r\n            <div class=\"profile_pic dropdown-toggle\" data-testid=\"dropdown-menu-button\" data-bs-toggle=\"dropdown\">\r\n              <lib-avatar></lib-avatar>\r\n            </div>\r\n            <div class=\"dropdown-menu dropdown-menu-right\">\r\n              <p *ngIf=\"user && mission\" class=\"p-2\">\r\n                <span class=\"username\">{{ user.displayName }}</span><br />\r\n                <span class=\"user-role\">{{ mission.role }}</span><br />\r\n                <span class=\"org\">{{ mission.organisation ? mission.organisation.name : \"No organisation\" |\r\n                  translate}}</span>\r\n              </p>\r\n              <div class=\"dropdown-divider\"></div>\r\n              <!-- <a class=\"dropdown-item\" routerLink=\"/debug\" *ngIf=\"isManager\">Debug</a> -->\r\n              <a class=\"dropdown-item\" (click)=\"localeService.modal()\">{{'Language' | translate}}</a>\r\n              <a class=\"dropdown-item\" routerLink=\"/dashboard\">{{'Data management' | translate}}</a>\r\n              <a class=\"dropdown-item\" data-testid=\"user-management-btn\" routerLink=\"/admin\" *ngIf=\"isManager\">\r\n                {{'Users management' | translate}}</a>\r\n              <a class=\"dropdown-item\" routerLink=\"/profile\">\r\n                {{'Profile' | translate}}</a>\r\n              <div class=\"dropdown-divider\"></div>\r\n              <button class=\"dropdown-item\" (click)=\"openSupportForm()\">{{\"Help\" | translate}}</button>\r\n              <button data-testid=\"logout-auth-btn\" class=\"dropdown-item\" (click)=\"signOut()\">{{\"Logout\" |\r\n                translate}}</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </nav>\r\n    <lib-navigation-bar *ngIf=\"isVisible && isChangePositionVisible\"></lib-navigation-bar>\r\n  </div>\r\n  <div *ngIf=\"isVisitor && isVisible\">\r\n    <div class=\"visitor-div\">\r\n      <div class=\"logo-container\" data-testid=\"dropdown-menu-button\">\r\n        <img class=\"img-logo\" alt=\"SmarterPlanLogo\" src=\"../assets/images/logos/logo-reserve.png\">\r\n      </div>\r\n      <div class=\"avatar-container-menu\">\r\n        <div class=\"profile_pic dropdown-toggle\" data-bs-toggle=\"dropdown\">\r\n          <lib-avatar></lib-avatar>\r\n        </div>\r\n        <div class=\"dropdown-menu dropdown-menu-right\">\r\n          <button class=\"dropdown-item\" (click)=\"localeService.modal()\">{{'Language' | translate}}</button>\r\n          <button class=\"dropdown-item\" (click)=\"openSupportForm()\">{{\"Help\" | translate}}</button>\r\n          <button data-testid=\"logout-auth-btn\" class=\"dropdown-item\" (click)=\"signOut()\">{{\"Logout\" |\r\n            translate}}</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>", styles: [":host{position:sticky;top:0;z-index:200}.navbar{z-index:200}.navbar-brand{padding-top:5px;padding-bottom:5px;cursor:pointer}.navbar-brand img{height:70px}.profile_pic{border-radius:50%;height:45px;width:45px;margin:8px;border:.2px solid #969696}.navbar-nav .profile-pic-container .dropdown-menu{position:absolute}.navbar.second-nav{z-index:199;background-color:var(--smarterplan-primary)}.profile_pic.dropdown-toggle:after{display:none}.navbar-light{border-bottom:1px solid var(--smarterplan-primary);background-color:#fff}input,select{margin-right:15px}.select{background:transparent;border:none;color:#fff;margin:6px 20px 0;width:auto}button{background-color:#fff;color:var(--smarterplan-primary);padding:5px 10px}button:disabled,button[disabled]{color:#c04f4f}.navbar-toggler{margin-right:1em}.icon{height:40px;width:40px;color:var(--smarterplan-primary)}.search-button{width:auto}.visitor-div{background-color:var(--smarterplan-primary);height:60px;display:flex;justify-content:space-between}.logo-container,.img-logo{height:100%}.change-position-button{margin-left:2rem}.change-position-button label,.change-position-button .btn-check:checked,.change-position-button .btn-check:focus,.change-position-button .btn-outline-primary,.change-position-button .btn{box-shadow:none!important;outline:0}.change-position-button label{border-radius:16px}.change-position-button .btn-check:checked+.btn{background-color:var(--smarterplan-primary);color:#fff!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }, { type: LocaleService }, { type: BaseUserService }, { type: NavigatorService }, { type: SupportService }, { type: BaseVisibilityService }]; } });

class NgxSmarterplanCoreModule {
    static forRoot(config) {
        return {
            ngModule: NgxSmarterplanCoreModule,
            providers: [
                {
                    provide: 'config',
                    useValue: config
                }
            ]
        };
    }
}
NgxSmarterplanCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgxSmarterplanCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreModule, declarations: [TimeDateToLocalStringPipe,
        SafeUrlPipe,
        HashtagFromIdPipe,
        DurationToStringPipe,
        CsvExportComponent,
        SearchBarComponent,
        UsernameFromIdPipe,
        ModalSwitchVisitComponent,
        MenuBarComponent,
        AvatarComponent,
        NavigationBarComponent,
        RangeDatePickerComponent,
        LoaderComponent,
        SupportModalComponent,
        FormatDateNumberToDigitsPipe], imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule,
        RouterModule,
        NgbModule, i1.TranslateModule], exports: [CsvExportComponent,
        SearchBarComponent,
        TimeDateToLocalStringPipe,
        SafeUrlPipe,
        HashtagFromIdPipe,
        DurationToStringPipe,
        UsernameFromIdPipe,
        MenuBarComponent,
        LoaderComponent,
        SupportModalComponent,
        AvatarComponent] });
NgxSmarterplanCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreModule, imports: [[
            FormsModule,
            ReactiveFormsModule,
            CommonModule,
            RouterModule,
            NgbModule,
            TranslateModule.forChild({
                extend: true
            })
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: NgxSmarterplanCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TimeDateToLocalStringPipe,
                        SafeUrlPipe,
                        HashtagFromIdPipe,
                        DurationToStringPipe,
                        CsvExportComponent,
                        SearchBarComponent,
                        UsernameFromIdPipe,
                        ModalSwitchVisitComponent,
                        MenuBarComponent,
                        AvatarComponent,
                        NavigationBarComponent,
                        RangeDatePickerComponent,
                        LoaderComponent,
                        SupportModalComponent,
                        FormatDateNumberToDigitsPipe
                    ],
                    imports: [
                        FormsModule,
                        ReactiveFormsModule,
                        CommonModule,
                        RouterModule,
                        NgbModule,
                        TranslateModule.forChild({
                            extend: true
                        })
                    ],
                    exports: [
                        CsvExportComponent,
                        SearchBarComponent,
                        TimeDateToLocalStringPipe,
                        SafeUrlPipe,
                        HashtagFromIdPipe,
                        DurationToStringPipe,
                        UsernameFromIdPipe,
                        MenuBarComponent,
                        LoaderComponent,
                        SupportModalComponent,
                        AvatarComponent,
                    ]
                }]
        }] });

class BaseTagService {
    constructor() { }
    getHtmlToInject(tagType, object) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`getHtmlToInject is not implemented in the base class. 
        Please override this method in your extended class.`);
        });
    }
    getUrlForSeeDetails(object, tagType) {
        switch (tagType) {
            case PoiType.TICKET: {
                return `visit/${object.spaceID}/detail/${object.id}`;
            }
            case PoiType.EQUIPMENT: {
                return `visit/${object.spaceID}/equip/${object.id}`;
            }
            case PoiType.MEASURE: {
                return `visit/${object.spaceID}/measurement/${object.id}`;
            }
            case PoiType.DATA: {
                return `visit/${object.spaceID}/feature/${object.id}`;
            }
            case PoiType.DESK: {
                return `visit/${object.spaceID}/add_booking/${object.id}`;
            }
            default:
                return '';
        }
    }
    prepareEquipmentHtml(equip) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`prepareEquipmentHtml is not implemented in the base class. 
        Please override this method in your extended class.`);
        });
    }
    prepareTicketHtml(ticket) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`prepareTicketHtml is not implemented in the base class. 
                         Please override this method in your extended class.`);
        });
    }
    prepareFeatureHtml(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`prepareFeatureHtml is not implemented in the base class. 
                         Please override this method in your extended class.`);
        });
    }
    prepareMeasurementHtml(measure) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`prepareMeasurementHtml is not implemented in the base class. 
                         Please override this method in your extended class.`);
        });
    }
    prepareDeskHtml(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`prepareDeskHtml is not implemented in the base class. 
                         Please override this method in your extended class.`);
        });
    }
    prepareIndicatorHtml(feature) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`prepareDeskHtml is not implemented in the base class. 
                         Please override this method in your extended class.`);
        });
    }
    getSignedTagIconSource(tagIconSrc) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error(`getSignedTagIconSource is not implemented in the base class.`);
        });
    }
    getIconTagImageForFeature(feature, poi) {
        // const tagIcon = JSON.parse(poi.tagIcon);
        // return tagIcon.src;
        throw new Error(`getIconTagImageForFeature is not implemented in the base class. 
                         Please override this method in your extended class.`);
    }
    getScriptForTag(object, tagType) {
        throw new Error(`getScriptForTag is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    getAnnexeForCommentTypeInFeature(feature, commentType) {
        throw new Error(`getAnnexeForCommentTypeInFeature is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    getBillboardMediaToEmbed(object) {
        throw new Error(`getBillboardMediaToEmbed is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    onActionDetailClick(url) {
        throw new Error(`onActionDetailClick is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    onActionAudioClick(audioCommentID) {
        throw new Error(`onActionDetailClick is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    onActionVideoClick(url) {
        throw new Error(`onActionVideoClick is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    onActionImageClick(imageCommentID) {
        throw new Error(`onActionImageClick is not implemented in the base class.
        Please override this method in your extended class.`);
    }
    onActionDocClick(url) {
        throw new Error(`onActionDocClick is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
    onActionYoutubeClick(url) {
        throw new Error(`onActionYoutubeClick is not implemented in the base class. 
        Please override this method in your extended class.`);
    }
}
BaseTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseTagService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaseTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseTagService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseTagService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class BaseLateralTabService {
    constructor() {
        this.activeTab = "tickets";
        this.firstLoad = true;
    }
    storeTabHistory(tab) {
        this.activeTab = tab;
    }
    getTabHistory() {
        // throw new Error("Method 'getTabHistory' not implemented.");
        return this.activeTab;
    }
}
BaseLateralTabService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseLateralTabService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaseLateralTabService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseLateralTabService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: BaseLateralTabService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () { return []; } });

class LayerService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    getLayerForOrganisation(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.LayersByOrganisation(orgID).then((list) => list.items);
        });
    }
    createLayerForOrganisation(layerName, orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateLayer({
                name: layerName.toUpperCase(),
                organisationID: orgID,
            });
        });
    }
    getLayerByNameForOrganisation(layerName, orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.LayersByOrganisation(orgID, null, {
                name: { eq: layerName.toUpperCase() },
            }).then((list) => list.items);
        });
    }
}
LayerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LayerService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
LayerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LayerService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: LayerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class MatterportImportService {
    constructor(navigationService, zoneService, viewerService, layerService, userService, planService) {
        this.navigationService = navigationService;
        this.zoneService = zoneService;
        this.viewerService = viewerService;
        this.layerService = layerService;
        this.userService = userService;
        this.planService = planService;
        this.stop = false;
        this.importingImages = new Subject();
        this.sweepProcessedCount = new Subject();
        this.totalSweepsCount = new Subject();
        this.MAX_SCANS_RELOAD = 10;
    }
    get spaceID() {
        return this._spaceID;
    }
    set spaceID(value) {
        this._spaceID = value;
    }
    get modelID() {
        return this._modelID;
    }
    set modelID(value) {
        this._modelID = value;
    }
    initSdkForModel(modelID) {
        return __awaiter(this, void 0, void 0, function* () {
            this.stop = false;
            // Load SDK
            console.log('Loading Matterport SDK');
            this.modelID = modelID;
            const iframe = document.createElement('iframe');
            if (!iframe) {
                throw new Error('Cannot create iframe');
            }
            this.viewerService.setTourUrl(modelID);
            const url = this.viewerService.getTourUrl();
            iframe.setAttribute('src', url);
            iframe.allow = 'xr-spatial-tracking';
            iframe.height = '100%';
            iframe.width = '100%';
            iframe.id = 'viewer-module';
            const element = document.querySelector('#viewer-frame');
            element.append(iframe);
            this.currentFrame = iframe;
            const showcaseWindow = iframe.contentWindow;
            return new Promise((res, rej) => {
                iframe.addEventListener('load', () => __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.sdk = yield showcaseWindow.MP_SDK.connect(iframe, 'qn9wsasuy5h2fzrbrn1nzr0id', '3.11');
                        // Subscribe to Floor data
                        this.sdk.Floor.data.subscribe({
                            onCollectionUpdated: function upd(collection) {
                                // console.log("Floors", collection);
                                this.floors = collection;
                            }.bind(this),
                        });
                        // Subscribe to current Floor
                        this.sdk.Floor.current.subscribe(function upd(currentFloor) {
                            this.currentFloor = currentFloor;
                        }.bind(this));
                        // Subscribe to Sweep data
                        this.sdk.Sweep.data.subscribe({
                            onCollectionUpdated: function upd(collection) {
                                console.log('the entire up-to-date collection', collection);
                                this.sweeps = collection;
                            }.bind(this),
                        });
                        // remove labels
                        yield this.sdk.Settings.update('labels', false);
                        let timeoutExpired = false;
                        // start timeout
                        setTimeout(() => (timeoutExpired = true), 7000);
                        yield waitUntil(() => (this.sweeps !== undefined && this.floors !== undefined) ||
                            timeoutExpired === true);
                        if (timeoutExpired) {
                            // we are likely in matterport error case (that we cannot catch!)
                            console.log('timeout intitialising Matterport');
                            return rej(new Error('error init Matterport'));
                        }
                        console.log('init done');
                        return res(true);
                    }
                    catch (e) {
                        console.error(e);
                        rej(new Error('error init Matterport'));
                    }
                }));
            });
        });
    }
    importData(spaceID, surface, reloading = false, node = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.sweeps) {
                return Promise.reject(new Error('no sweeps initialized'));
            }
            let appIsLoaded = false;
            this.sdk.App.state.subscribe(function (appState) {
                // app state has changed
                console.log('The current phase: ', appState.phase);
                if (appState.phase === 'appphase.playing') {
                    console.log('The app is playing');
                    appIsLoaded = true;
                }
            });
            yield waitUntil(() => appIsLoaded === true);
            if (reloading) {
                // perform only 360 import since we are reloading
                yield this.import360images();
                return Promise.resolve(true);
            }
            this.cleanLocalStorage(); // we are importing new visit
            this.spaceID = spaceID;
            let floorZones = [];
            const zones = yield this.zoneService.getZonesBySpace(spaceID);
            const mainZone = zones.find((z) => !z.parentID);
            if (!mainZone) {
                return Promise.reject(new Error('missing data (no main Building Zone)'));
            }
            console.log('importing data from matterport');
            // save sweeps data as json
            const json = JSON.stringify(Object.values(this.sweeps));
            yield uploadJsonToS3(`visits/${this.modelID}/inventory/`, json, 'data.json');
            // check layer of building type
            const layerBuilding = yield this.getLayerByName('BUILDING');
            const createdDefaultZone = yield this.createZone(node.metadata, layerBuilding.id, surface, mainZone.id, Object.keys(this.sweeps), node);
            if (!createdDefaultZone) {
                return Promise.resolve(false);
            }
            if (this.floors) {
                floorZones = yield this.importFloorData(createdDefaultZone.id, node);
            }
            // console.log(floorZones);
            yield Promise.all(Object.keys(this.sweeps).map((key) => __awaiter(this, void 0, void 0, function* () {
                const sweepInfo = this.sweeps[key];
                const navigationInput = {
                    matterportSweepID: sweepInfo.uuid,
                    position: JSON.stringify(sweepInfo.position),
                    rotation: JSON.stringify(sweepInfo.rotation),
                    level: LevelStatus.LOW,
                    nodeID: node.id,
                    spaceID,
                };
                const nav = yield this.navigationService.createNavigation(navigationInput);
                if (!nav) {
                    console.log('could create navigation', navigationInput.id);
                }
            })));
            yield this.import360images();
            return Promise.resolve(true);
        });
    }
    createZone(name, layerID, surface = null, parentID = null, sweeps = [], node = null, metadata = null) {
        return __awaiter(this, void 0, void 0, function* () {
            const zoneInput = {
                name,
                spaceID: this.spaceID,
                layerID,
                sweepIDs: sweeps,
                nodeIDs: node ? [node.id] : null,
            };
            removeNullKeysFromObject(zoneInput);
            if (surface) {
                zoneInput.surface = surface;
            }
            if (parentID) {
                zoneInput.parentID = parentID;
            }
            if (metadata) {
                zoneInput.metadata = metadata;
            }
            const newLocal = yield this.zoneService.create(zoneInput);
            return newLocal;
        });
    }
    import360images() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('Importing 360 images');
            this.importingImages.next(true);
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                const scans = Object.values(this.sweeps);
                let maxScan;
                let indexScan;
                const nmbScans = Object.keys(scans).length;
                console.log('Total number of scan points :', nmbScans);
                this.totalSweepsCount.next(nmbScans);
                // check if we started to load images already
                if (localStorage.getItem('indexScanLoad')) {
                    console.log('retaking import from scan', localStorage.getItem('indexScanLoad'));
                    indexScan = +localStorage.getItem('indexScanLoad');
                    nmbScans < indexScan + this.MAX_SCANS_RELOAD
                        ? (maxScan = nmbScans)
                        : (maxScan = indexScan + this.MAX_SCANS_RELOAD);
                }
                else {
                    indexScan = 0;
                    nmbScans < this.MAX_SCANS_RELOAD
                        ? (maxScan = nmbScans)
                        : (maxScan = this.MAX_SCANS_RELOAD);
                }
                for (let index = indexScan; index < maxScan; index += 1) {
                    if (!this.stop) {
                        yield new Promise((res) => {
                            setTimeout(() => {
                                res(null);
                            }, 1000);
                        });
                        yield this.sdk.Sweep.moveTo(scans[index].uuid);
                        yield this.sdk.Camera.setRotation({
                            x: 0,
                            y: 0,
                        });
                        const img = yield this.sdk.Renderer.takeEquirectangular({ width: 2048, height: 1024 }, { mattertags: false, sweeps: true });
                        yield uploadBase64Image(img, scans[index].uuid, `visits/${this.modelID}/sweeps/`, 'sweep');
                        this.sweepProcessedCount.next(index);
                        localStorage.setItem('indexScanLoad', index.toString());
                    }
                    else {
                        console.log('Abandoning import because it was cancelled');
                        resolve(false);
                        break;
                    }
                }
                if (maxScan === nmbScans) {
                    console.log('Import 360 done');
                    this.cleanLocalStorage();
                    this.removeFrame();
                    this.stop = true;
                    resolve(true);
                }
                else if (!this.stop) {
                    // to restart the procedure from where we left of
                    localStorage.setItem('indexScanLoad', maxScan.toString());
                    localStorage.setItem('visitInImport', this.modelID);
                    this.removeFrame();
                    window.location.reload();
                }
            }));
        });
    }
    moveToFloor(floorName, matterportFloorSequence = null) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.floors) {
                console.log('Floor are not loaded yet');
                return;
            }
            // look up for sequence number (the safest method)
            let floorMatterport = Object.values(this.floors).find((floor) => floor.sequence === matterportFloorSequence);
            if (!floorMatterport) {
                floorMatterport = Object.values(this.floors).find((floor) => floorName.includes(floor.name) && floor.name != '');
            }
            if (!floorMatterport) {
                floorMatterport = Object.values(this.floors).find((floor) => floorName.includes(floor.id));
            }
            // console.log(floorMatterport)
            if (floorMatterport) {
                let retry = true;
                while (retry) {
                    try {
                        const floorIndex = yield this.sdk.Floor.moveTo(floorMatterport.sequence);
                        // console.log("moved to floorIndex", floorIndex);
                        retry = false;
                    }
                    catch (error) {
                        console.log('Cannot move to Floor', error);
                        yield wait(100);
                    }
                }
            }
            else {
                console.warn('No matterport floor found to move to');
            }
        });
    }
    importFloorData(defautZoneID, node) {
        return __awaiter(this, void 0, void 0, function* () {
            const zones = [];
            yield this.sdk.Mode.moveTo(this.sdk.Mode.Mode.FLOORPLAN);
            const nmbFloors = Object.keys(this.floors).length;
            console.log('Total number of floors', nmbFloors);
            for (let index = 0; index < nmbFloors; index += 1) {
                // eslint-disable-next-line no-await-in-loop
                console.log('Importing floor', index);
                yield this.sdk.Floor.moveTo(index).then(() => __awaiter(this, void 0, void 0, function* () {
                    yield wait(700);
                    // console.log("about to save the floor", index);
                    const zone = yield this.saveFloor(defautZoneID, node);
                    // console.log("received floor zone", zone);
                    zones.push(zone);
                }));
            }
            return Promise.resolve(zones);
        });
    }
    saveFloor(defautZoneID, node) {
        return __awaiter(this, void 0, void 0, function* () {
            let name = this.currentFloor.id;
            if (this.currentFloor.name !== '') {
                name = this.currentFloor.name;
            }
            const layerFloor = yield this.getLayerByName('FLOOR');
            const sweepsInfo = Object.values(this.sweeps);
            const sweepsForFloor = sweepsInfo.filter((sweepInfo) => sweepInfo.floorInfo.id === this.currentFloor.id);
            console.log('current floor', this.currentFloor);
            console.log('sweeps for floor', sweepsForFloor.length);
            const sweepIDs = sweepsForFloor.map((sweep) => sweep.uuid);
            const zone = yield this.createZone(`Étage ${name} - ${node.metadata}`, layerFloor.id, null, defautZoneID, sweepIDs, node, JSON.stringify({ matterportFloorSequence: this.currentFloor.sequence }));
            // TODO link to scans
            const base64 = yield this.sdk.Renderer.takeScreenShot({
                width: 4096,
                height: 2048,
            });
            const spaceIDshort = this.spaceID.slice(0, 8);
            yield uploadBase64Image(base64, null, `visits/${this.modelID}/plans/`, `plan_floor_${this.currentFloor.id}_${spaceIDshort}`);
            // create Plan object
            const plan = {
                name: `plan_floor_${this.currentFloor.id}`,
                annexe: `visits/${this.modelID}/plans/plan_floor_${this.currentFloor.id}_${spaceIDshort}.jpeg`,
                zoneID: zone.id,
                spaceID: this.spaceID,
                isCurrentForZone: true,
                isModified: false,
                isImportedMatterport: true,
            };
            yield this.planService.createPlan(plan);
            // console.log("floor saved");
            return Promise.resolve(zone);
        });
    }
    abandon() {
        setTimeout(() => {
            console.log('abandonning import');
            localStorage.removeItem('visitInImport');
            this.stop = true;
            this.removeFrame();
        }, 500);
    }
    removeFrame() {
        if (this.currentFrame) {
            this.currentFrame.remove();
        }
    }
    cleanLocalStorage() {
        localStorage.removeItem('indexScanLoad');
        localStorage.removeItem('visitInImport');
    }
    getLayerByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const mission = this.userService.currentMission(this.spaceID);
            const currentOrgId = mission.organisationID;
            const layers = yield this.layerService.getLayerByNameForOrganisation(name, currentOrgId);
            if (layers.length > 0) {
                return layers[0];
            }
            // create then
            return this.layerService.createLayerForOrganisation(name, currentOrgId);
        });
    }
}
MatterportImportService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MatterportImportService, deps: [{ token: NavigationService }, { token: ZoneService }, { token: ViewerService }, { token: LayerService }, { token: BaseUserService }, { token: PlanService }], target: i0.ɵɵFactoryTarget.Injectable });
MatterportImportService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MatterportImportService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: MatterportImportService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: NavigationService }, { type: ZoneService }, { type: ViewerService }, { type: LayerService }, { type: BaseUserService }, { type: PlanService }]; } });

class Object3DService {
    constructor(apiInjected, userService, navigatorService, zoneChangeService, filterService) {
        this.userService = userService;
        this.navigatorService = navigatorService;
        this.zoneChangeService = zoneChangeService;
        this.filterService = filterService;
        this.objects3DUpdated = new Subject();
        this.currentObjects3D = {
            space: [],
            zone: []
        };
        // bad name!
        // currentObjects3D: {
        //   space: Object3D[];
        //   zonesMap: Map<string, Object3D[]>;
        // } = {
        //   space: [],
        //   zonesMap: new Map(),
        // };
        this.updateDone = new Subject();
        /** Null means we do not apply a filter, empty array ([]), means we that we hide all object3D */
        this.object3DDomainFilter = null;
        this.updating = new Subject();
        this.currentlyUpdating = false;
        this.deleteObservable = new Subject();
        this.createObservable = new Subject();
        this.updateObservable = new Subject();
        this.isMuseumUser = false;
        this.isUpdating = false;
        this.destroy$ = new Subject();
        this.API = apiInjected;
        // this.isMuseumUser = this.userService.hasOnlyMuseumRole(); // Not used yet!
        this.objects3DUpdated.subscribe((list) => {
            this.currentObjects3D = list;
        });
        this.zoneChangeService.zoneChange.subscribe((zone) => {
            this.currentSpaceID = this.navigatorService.currentSpaceID;
            if (!this.currentSpaceID) {
                this.objects3DUpdated.next({ space: [], zone: null });
                this.zoneIDFilter = null;
            }
            else if (zone.id !== this.zoneIDFilter && !this.userService.isMuseumUser(this.currentSpaceID)) {
                this.zoneIDFilter = zone.id;
                this.initObjects3D();
            }
        });
        this.updateDone.subscribe(() => {
            if (this.currentSpaceID) {
                this.initObjects3D().catch(e => console.log(e));
            }
        });
    }
    getObjects3DBySpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const list = [];
            if (this.API.__proto__.hasOwnProperty('Objects3DBySpace')) {
                const objects = yield this.API.__proto__.Objects3DBySpace(spaceID);
                if (objects) {
                    for (const object of objects.items) {
                        const zoneObject = Object.assign({}, object);
                        list.push(zoneObject);
                    }
                }
                return list;
            }
            else {
                throw new Error('objects3DBySpace not implemented');
            }
        });
    }
    initObjects3D() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.currentSpaceID) {
                return;
            }
            this.updating.next(true);
            this.isUpdating = true;
            const object3DList = yield this.getObjects3DBySpace(this.currentSpaceID);
            if (object3DList.length > 0) {
                let filteredObjects3D = [...object3DList];
                this.currentObjects3D.zone = filteredObjects3D; // not sorted!
                filteredObjects3D =
                    yield this.filterService.filterObjectsForCurrentUserInSpace(filteredObjects3D, this.currentSpaceID);
                this.currentObjects3D.space = filteredObjects3D;
                if (this.zoneIDFilter) {
                    filteredObjects3D = yield this.filterService.filterObjectsForZone(filteredObjects3D, this.zoneIDFilter);
                }
                this.currentObjects3D.zone = filteredObjects3D;
                this.objects3DUpdated.next(this.currentObjects3D);
            }
            else {
                this.objects3DUpdated.next({ space: [], zone: [] }); // for lateral menu
            }
            this.updating.next(false);
            this.isUpdating = false;
        });
    }
    getSelectedObject3D() {
        return this.selectedObject3D;
    }
    setSelectedObject3D(selected) {
        this.selectedObject3D = selected;
    }
    // THE FOLLOWING LOGIC IS EQUIP. SPECIFIC
    // initSubscriptions() {
    //   if (!this.isMuseumUser) {
    //     this.navigatorService.zoneChange
    //       .pipe(takeUntil(this.destroy$))
    //       .subscribe((zone) => {
    //         if (!zone || !this.navigatorService.currentSpaceID) {
    //           this.currentSpaceID = this.navigatorService.currentSpaceID;
    //           this.objects3DUpdated.next({space: [], zone: null});
    //           this.zoneIDFilter = null;
    //           this.currentObjects3D = {
    //             space: [],
    //             zonesMap: new Map(),
    //           };
    //           return;
    //         }
    //         if (zone.id !== this.zoneIDFilter) {
    //           this.zoneIDFilter = zone.id;
    //           this.currentZone = zone;
    //           if (this.currentSpaceID === this.navigatorService.currentSpaceID) {
    //             // same space,  only zone update
    //             // console.log(
    //             //     "going to update equips for zone (same space)",
    //             //     zone,
    //             // );
    //
    //             this.updateObjects3DForZone();
    //           } else {
    //             this.currentSpaceID = this.navigatorService.currentSpaceID;
    //             // console.log(
    //             //     "going to init equips for zone for new space",
    //             //     this.currentSpaceID,
    //             // );
    //             this.initObjects3D().catch(e => console.log(e));
    //           }
    //         }
    //       });
    //
    //     this.deleteObservable
    //       .pipe(takeUntil(this.destroy$))
    //       .subscribe((object3D) => {
    //         if (this.currentSpaceID) {
    //           this.updateDueToDelete(object3D);
    //         }
    //       });
    //
    //     this.createObservable
    //       .pipe(takeUntil(this.destroy$))
    //       .subscribe((object3D) => {
    //         if (this.currentSpaceID) {
    //           this.updateDueToCreate(object3D);
    //         }
    //       });
    //
    //     this.updateObservable
    //       .pipe(takeUntil(this.destroy$))
    //       .subscribe((object3D) => {
    //         if (this.currentSpaceID) {
    //           this.updateDueToObject3DUpdated(object3D);
    //         }
    //       });
    //   }
    // }
    updateDueToDelete(deletedObject3D) {
        // console.log("update due to delete", deletedObject3D);
        const obj = this.currentObjects3D.space.find((_equip) => _equip.id === deletedObject3D.id);
        if (obj) {
            const index = this.currentObjects3D.space.indexOf(obj);
            this.currentObjects3D.space.splice(index, 1);
        }
        // THE FOLLOWING LOGIC IS EQUIP. SPECIFIC
        // for (const zone of this.currentObjects3D.zonesMap.keys()) {
        //   const equipToDelete = this.currentObjects3D.zonesMap
        //     .get(zone)
        //     .find((_equip) => _equip.id === deletedObject3D.id);
        //   if (equipToDelete) {
        //     const index = this.currentObjects3D.zonesMap
        //       .get(zone)
        //       .indexOf(equipToDelete);
        //     this.currentObjects3D.zonesMap.get(zone).splice(index, 1);
        //   }
        // }
        this.objects3DUpdated.next({
            space: this.currentObjects3D.space,
            zone: this.currentObjects3D.zone,
            // THE FOLLOWING LOGIC IS EQUIP. SPECIFIC
            // zone: this.currentObjects3D.zonesMap.get(this.zoneIDFilter),
        }); // for lateral menu
    }
    updateDueToCreate(createdObj3D) {
        this.currentObjects3D.space.unshift(createdObj3D);
        this.currentObjects3D.zone.unshift(createdObj3D);
        // this.currentObjects3D.zonesMap
        //   .get(this.zoneIDFilter)
        //   .unshift(createdEquip);
        this.objects3DUpdated.next({
            space: this.currentObjects3D.space,
            zone: this.currentObjects3D.zone,
            // THE FOLLOWING LOGIC IS EQUIP. SPECIFIC
            // zone: this.currentObjects3D.zonesMap.get(this.zoneIDFilter),
        }); // for lateral menu
    }
    // THE FOLLOWING LOGIC IS EQUIP. SPECIFIC
    // Not implemented since not used yet!
    // updateDueToObject3DUpdated(updatedObject3D: Object3D) {
    //   const obj = this.currentObjects3D.space.find(
    //     (_equip) => _equip.id === updatedObject3D.id
    //   );
    //   if (obj) {
    //     const index = this.currentObjects3D.space.indexOf(obj);
    //     // Not used yet!
    //     // if (this.isArchived(obj)) {
    //     //   // we remove archived equipment
    //     //   this.currentObjects3D.space.splice(index, 1);
    //     // } else {
    //     this.currentObjects3D.space.splice(index, 1, updatedObject3D);
    //     // }
    //   }
    //   for (const zone of this.currentObjects3D.zonesMap.keys()) {
    //     const equipToUpd = this.currentObjects3D.zonesMap
    //       .get(zone)
    //       .find((_equip) => _equip.id === updatedObject3D.id);
    //     if (equipToUpd) {
    //       const index = this.currentObjects3D.zonesMap
    //         .get(zone)
    //         .indexOf(equipToUpd);
    //       // Not used yet!
    //       // if (this.isArchived(obj)) {
    //       //   this.currentObjects3D.zonesMap.get(zone).splice(index, 1);
    //       // } else {
    //       this.currentObjects3D.zonesMap
    //         .get(zone)
    //         .splice(index, 1, updatedObject3D);
    //       // }
    //     }
    //   }
    //   this.objects3DUpdated.next({
    //     space: this.currentObjects3D.space,
    //     zone: this.currentObjects3D.zonesMap.get(this.zoneIDFilter),
    //   }); // for lateral menu
    // }
    // THE FOLLOWING LOGIC IS EQUIP. SPECIFIC
    // Not implemented since not used yet!
    // async updateObjects3DForZone() {
    //   this.updating.next(true);
    //   let filteredObjects3D: Object3D[] = [];
    //   if (this.currentObjects3D.space.length > 0) {
    //     if (
    //       this.zoneIDFilter &&
    //       this.currentObjects3D.zonesMap.has(this.zoneIDFilter)
    //     ) {
    //       filteredObjects3D = this.currentObjects3D.zonesMap.get(this.zoneIDFilter);
    //     } else {
    //       filteredObjects3D = (await this.filterService.filterObjectsForZone(
    //         this.currentObjects3D.space,
    //         this.zoneIDFilter,
    //         this.currentZone
    //       )) as Object3D[];
    //
    //       this.currentObjects3D.zonesMap.set(this.zoneIDFilter, [
    //         ...filteredObjects3D,
    //       ]);
    //     }
    //     // Not implemented yet!
    //     // if (this.object3DDomainFilter) {
    //     //   filteredObjects3D = this.filterService.filterObjects3DByDomainList(
    //     //     filteredObjects3D,
    //     //     this.object3DDomainFilter
    //     //   );
    //     // }
    //     // Not used for objects now!
    //     // this.objects3DTags.next(filteredObjects3D); // adding tags only for the current zone
    //     this.objects3DUpdated.next({
    //       space: this.currentObjects3D.space,
    //       zone: filteredObjects3D,
    //     }); // for lateral menu
    //   } else {
    //     this.objects3DUpdated.next({space: [], zone: []}); // for lateral menu
    //   }
    //   this.updating.next(false);
    // }
    /**
     * Not implemented yet! May be usefull for the future (filter 3D objects for a given authorized user: example libs of objects)
     * @param objectId
     */
    // async getObjects3DBySpaceForUser(spaceID: string): Promise<Object3D[]> {
    //   const missionForLocation = this.userService.currentMission(spaceID);
    //   const list = [];
    //   if (missionForLocation && missionForLocation.objectId) {
    //     const allowedObject3D = await this.getObject3D(missionForLocation.objectId);
    //     allowedObject3D.virtual = this.zoneIsVirtual(allowedObject3D);
    //     if (!allowedObject3D.parent) {
    //       // the whole building is authorized
    //       return this.getObjects3DBySpace(spaceID);
    //     }
    //     list.push(allowedObject3D);
    //     // allow all children zones of an allowed parent
    //     const children = (await this.API.__proto__.objects3DByObject3D(allowedObject3D.id)).items;
    //     if (children.length > 0) {
    //       for (const child of children) {
    //         const childObject3D = { ...child } as Object3D;
    //         childObject3D.virtual = this.zoneIsVirtual(child);
    //         list.push(childObject3D);
    //       }
    //     }
    //     // allow the parent Floor of the allowed zone
    //     if (allowedObject3D.parent.layer && allowedObject3D.parent.layer.name === "FLOOR") {
    //       list.push(allowedObject3D.parent);
    //     }
    //   } else {
    //     return this.getObjects3DBySpace(spaceID);
    //   }
    //   return list;
    // }
    deleteObject3D(objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteObject3D({ id: objectId });
        });
    }
    create(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateObject3D(input);
        });
    }
    updateObject3D(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateObject3D(input);
        });
    }
    /** Basic CRUD operations */
    readObject3D(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetObject3D(id);
        });
    }
    adaptObject3D(object3D) {
        return __awaiter(this, void 0, void 0, function* () {
            // Not required here!
            return object3D;
        });
    }
    updateObject3DWithEvent(object3D, event) {
        return __awaiter(this, void 0, void 0, function* () {
            const receivedObject3D = yield this.updateObject3D(object3D);
            if (receivedObject3D) {
                console.log("Updated object3D :");
                console.log(receivedObject3D);
                // Not sent currently: ask if needed...
                // if (event) {
                //   await this.addEventToObject3D(receivedObject3D, event);
                // }
                this.updateDone.next(true);
            }
            return receivedObject3D;
        });
    }
}
Object3DService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: Object3DService, deps: [{ token: 'currentAPIService' }, { token: BaseUserService }, { token: NavigatorService }, { token: ZoneChangeService }, { token: FilterService }], target: i0.ɵɵFactoryTarget.Injectable });
Object3DService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: Object3DService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: Object3DService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }, { type: BaseUserService }, { type: NavigatorService }, { type: ZoneChangeService }, { type: FilterService }];
    } });

class OrganisationService {
    constructor(apiInjected) {
        this.smarterPlanID = "6e28201f-4679-4c29-9d2d-8a325f57cee9";
        this.API = apiInjected;
    }
    getPropertiesForOrganisation(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            const org = yield this.API.__proto__.GetOrganisation({ id: orgID });
            if (org) {
                return org.properties.items;
            }
            return [];
        });
    }
    getOrganisationByToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const orgs = yield this.API.__proto__.OrganisationsByToken(token);
            if (orgs.items.length > 0) {
                const org = orgs.items[0];
                return this.tokenIsExpiredForOrg(org) ? null : org;
            }
            return null;
        });
    }
    tokenIsExpiredForOrg(org) {
        const expirationDate = new Date(org.tokenExpiresAt);
        const diffTime = expirationDate.getTime() - Date.now();
        return diffTime < 0;
    }
    softDeteleOrg(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateOrganisation({
                id: orgID,
                deletedAt: Date.now(),
            });
        });
    }
    updateOrganisation(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateOrganisation(input);
        });
    }
    deleteOrganisation(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteOrganisation({ id: orgID });
        });
    }
    createOrganisation(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateOrganisation(input);
        });
    }
    getOrganisation(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetOrganisation({ id: orgID });
        });
    }
    listOrganisations() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ListOrganisations().then((orgs) => orgs.items);
        });
    }
    getOrganisationForSpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            const properties = yield this.API.__proto__.ListProperties({
                spaceID: { eq: spaceID },
            });
            let orgs = properties.items.map((property) => property.organisation);
            if (orgs.length === 1) {
                return orgs[0];
            }
            orgs = orgs.filter((org) => org.id !== this.smarterPlanID);
            return orgs.length > 0 ? orgs[0] : null;
        });
    }
}
OrganisationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: OrganisationService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
OrganisationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: OrganisationService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: OrganisationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class DomainService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    getGenericDomainsAndForOrganisation(organisationID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.ListDomains().then((domains) => {
                return domains.items.filter((dom) => {
                    return (dom.organisationID === organisationID || !dom.organisationID);
                });
            });
        });
    }
    getGenericDomainsAndForOrgAndOrderedOrg(orgID, orderedOrgID = null) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: Change this (UUID can change depending on DB)
            if (orgID === "6e28201f-4679-4c29-9d2d-8a325f57cee9") {
                // I am SmarterPlan, i can see all
                return this.API.__proto__.ListDomains().then((response) => response.items);
            }
            const currentOrgDomains = yield this.getGenericDomainsAndForOrganisation(orgID);
            if (!orderedOrgID || orgID === orderedOrgID) {
                return currentOrgDomains;
            }
            const orderedOrgDomains = yield this.getGenericDomainsAndForOrganisation(orderedOrgID);
            const merged = [...currentOrgDomains, ...orderedOrgDomains];
            return filterUniqueArrayByID(merged);
        });
    }
    getDomainsForOrgExcludingTypes(types, organisationID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getGenericDomainsAndForOrganisation(organisationID).then((domains) => {
                return domains.filter((dom) => !types.includes(dom.type));
            });
        });
    }
    getDomain(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetDomain(id);
        });
    }
    updateDomain(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateDomain(input);
        });
    }
    deleteDomain(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteDomain({ id });
        });
    }
    getRootDomains(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            const allDomains = yield this.getGenericDomainsAndForOrganisation(orgID);
            const root = allDomains.filter((dom) => !dom.parentID);
            return root.sort((a, b) => a.name.localeCompare(b.name));
        });
    }
    createDomain(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateDomain(input);
        });
    }
    getDomainsForOrgForType(type, organisationID, orderedOrg = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getGenericDomainsAndForOrgAndOrderedOrg(organisationID, orderedOrg).then((domains) => {
                return domains.filter((dom) => dom.type === type);
            });
        });
    }
    getParentDomainsForOrgAndOrderedOrgForType(type, organisationID, orderedOrg = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getGenericDomainsAndForOrgAndOrderedOrg(organisationID, orderedOrg).then((domains) => {
                return domains.filter((dom) => dom.type === type && !dom.parentID);
            });
        });
    }
    getDomainsForMissionsForOrg(orgID) {
        return __awaiter(this, void 0, void 0, function* () {
            const domains = yield this.getDomainsForOrgExcludingTypes([DomainType.BOOKING, DomainType.FEATURE, DomainType.MISSION], orgID);
            return domains.filter((dom) => !dom.parentID);
        });
    }
}
DomainService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DomainService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
DomainService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DomainService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: DomainService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

class TemplateService {
    constructor(apiInjected) {
        this.API = apiInjected;
    }
    // --CRUD---
    create(template) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.CreateVisitTemplate(template);
        });
    }
    update(template) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.UpdateVisitTemplate(template);
        });
    }
    detele(templateID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.DeleteVisitTemplate({ id: templateID });
        });
    }
    softDelete(templateID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.update({ id: templateID, deletedAt: Date.now() });
        });
    }
    get(templateID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.GetVisitTemplate(templateID);
        });
    }
    getTemplatesBySpace(spaceID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.TemplatesBySpace(spaceID).then((response) => response.items);
        });
    }
    getTemplatesByZone(zoneID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.API.__proto__.TemplatesByZone(zoneID).then((response) => response.items);
        });
    }
}
TemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TemplateService, deps: [{ token: 'currentAPIService' }], target: i0.ɵɵFactoryTarget.Injectable });
TemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TemplateService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.7", ngImport: i0, type: TemplateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root",
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['currentAPIService']
                    }] }];
    } });

function floatValidator() {
    return (control) => {
        const regex = /^[+-]?([0-9]*[.])?[0-9]+$/;
        if (control.value && control.value !== '') {
            return !regex.test(control.value) ? { number: control.value } : null;
        }
        else {
            return null;
        }
    };
}

/*
 * Public API Surface of ngx-smarterplan-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AffectationService, AvatarComponent, BaseLateralTabService, BaseTagService, BaseUserService, BaseVisibilityService, CameraMode, CaptureService, CaptureViewer, CommentService, CommentType, Config, ContentService, CsvExportComponent, DomainService, DomainType, DurationToStringPipe, EmailStatus, EquipmentService, EventService, EventStatus, EventType, FeatureService, FeatureType, FilterService, HashtagFromIdPipe, HashtagService, InterventionService, InventoryStatus, LayerService, LevelStatus, LoaderComponent, Locale, LocaleService, MatterportImportService, MatterportService, MattertagActionMode, MattertagData, MeasurementService, MenuBarComponent, MissionService, NavigationService, NavigatorService, NgxSmarterplanCoreModule, NgxSmarterplanCoreService, NodeService, Object3DService, OperationService, OrganisationService, PaymentStatus, PlanService, PoiService, PoiType, ProfileEntity, ProfileService, ProfileStatus, PropertyService, PropertyType, RoleStatus, SafeUrlPipe, SearchBarComponent, SearchObjectType, SearchService, SpModule, SpaceService, SpaceStatus, StatusEquipment, SupportModalComponent, SupportService, TagAction, TemplateService, TicketPriority, TicketStatus, TicketType, TicketsService, TimeDateToLocalStringPipe, TypeNote, UsernameFromIdPipe, ValidatorsService, ViewerInteractions, ViewerService, VisitService, ZoneChangeService, ZoneService, arraysContainSameElements, checkElementById, convertTimestampToLocalZone, dateHasExpired, dateTimeToLocalString, deleteFromS3, downloadBlob, downloadEquipmentDocument, downloadFile, downloadFileAsObject, durationToString, emailValidator, enumToArray, filterUniqueArrayByID, floatValidator, getBufferForFileFromS3, getCoefficientsForImage, getDistanceBetweenTwoPoints, getHighestLevelForMissions, getHighestRoleForMissions, getLevelsBelow, getLocaleLong, getLocaleShort, getMetaForImage, getRolesBelowForManager, getSignedFile, getSignedImageUrlForEquipment, getSignedImageUrlForProfile, getSignedImageUrlForSpace, getSpaceIDFromUrl, getVisitUrl, isEmptyObject, listFilesInFolder, mean, noEmptyValidator, numberToDateString, openDocument, openModalForVisitSwitch, poiTypeToString, removeAllFilesFromFolderS3, removeNullKeysFromObject, showScanPointsOnPlanInDiv, shuffleArray, sortAlphabeticallyOnName, stringLocaleToEnum, stringToLowercaseNoSpaces, styleButton, textValidator, translateDatePeriod, uploadBase64Image, uploadFileToS3, uploadJsonToS3, validEmail, wait, waitUntil };
